/**
 * QuickDraw by RocVar Studio — Application v7
 * Fichier d'entrée généré par build.js — ne pas éditer.
 */
const App = (() => {
// ═══ app-config.js ═══
  // ── Config ────────────────────────────────────────────────
  let GRID=20, gridSnap=true, gridVisible=true, snapLabels=false;

  // ── Propriétés projet / dessin ────────────────────────────
  // Valeurs lues par renderer, commitWire, onDrop, drawText, etc.
  let PROJ = {
    // Fils
    wireColor:    '#3b9eff',
    wireWidth:    1.8,
    // Bus
    busColor:     '#3b9eff',
    busWidth:     1.8,
    // N° de fil
    numColor:     '#3b9eff',
    numBgColor:   'rgba(12,14,22,.92)',
    numBorderColor:'rgba(59,158,255,.35)',
    numSize:      9,
    numBold:      false,
    numShow:      true,
    // Renvois de folio
    xrefSize:     6,
    // Symboles
    symColor:     '#3b9eff',
    labelColor:   '#9098c8',
    refColor:     '#4dd278',
    fieldColor:   '#6b7494',
    labelOffY:    -18,
    refOffY:      10,
    // Nœuds (junctions)
    junctionColor:'#3b9eff',
    junctionRadius: 4,
    // Texte libre
    textColor:    '#dde1ed',
    textSize:     13,
    // Tensions – palette éditable (surcharge de la palette hardcodée du renderer)
    voltColors: {
      '400V':'#ff6b35','415V':'#ff6b35',
      '230V':'#ffaa00','240V':'#ffaa00',
      '120V':'#ffcc44','110V':'#ffcc44',
      '48V':'#c8f560','24V':'#4dd278',
      '12V':'#3bffcc','5V':'#3bd4ff',
      '3.3V':'#3b9eff','0V':'#888888','GND':'#888888','VCC':'#f06dff'
    },
    conflictAlphaMax: 0.40,
    conflictBlink:    true,
    // Nommage automatique
    autoName:       false,
    nameUseFolio:   true,
    nameFolioSep:   '',
    nameUseType:    true,
    nameUseInst:    true,
    nameDigits:     2,
    nameSuffix:     '',
    nameScope:      'folio',   // 'folio' | 'global'
    _nameCounters:  {},        // { 'folio:type' | 'global:type' } → count
  };

  // ── Folio ─────────────────────────────────────────────────
  let folio={num:1,wireStart:1,wireStep:1,wireAuto:true,wireCounter:1,
    project:'',title:'',ref:'',rev:'A',author:'',checker:'',
    date:'',company:'CBI',note:''};

  // ── Zone impression ───────────────────────────────────────
  let printZone={x:0,y:0,w:1587,h:915,format:'A3L',show:true};

  // ── Repère orthogonal (lettres / chiffres autour de la zone d'impression) ──
  let refGrid={show:false, cols:20, rows:9, thickness:15}; // thickness en unités monde

  // Applique un format papier à printZone (et recalcule les dimensions en px-monde)
  // cartoucheH en mm (optionnel, utilise le cartouche actif sinon)
  function applyFormatToPrintZone(formatKey, opts) {
    opts = opts || {};
    const TB_FORMATS = {
      A4P:{w:210,h:297}, A4L:{w:297,h:210},
      A3P:{w:297,h:420}, A3L:{w:420,h:297},
      A2P:{w:420,h:594}, A2L:{w:594,h:420},
      A1P:{w:594,h:841}, A1L:{w:841,h:594},
      A0P:{w:841,h:1189},A0L:{w:1189,h:841},
    };
    const MM_PX = 3.7795275591;
    const fmt = TB_FORMATS[formatKey] || TB_FORMATS.A3L;
    // Hauteur du cartouche en mm (depuis le modèle actif ou valeur par défaut)
    const tbData = TitleBlock.getActiveTB();
    const cartH  = opts.cartoucheH != null ? opts.cartoucheH
                 : (tbData && !tbData.isCover ? (tbData.cartoucheH || 55) : 0);
    // Zone d'impression = page entière MOINS la hauteur du cartouche
    printZone.format = formatKey;
    printZone.w = Math.round(fmt.w * MM_PX);
    printZone.h = Math.round((fmt.h - cartH) * MM_PX);
    // Garder l'origine (ne pas déplacer le schéma)
    if (opts.resetOrigin) { printZone.x = 0; printZone.y = 0; }
  }

  // TitleBlock chargé depuis public/js/titleblock.js




// ═══ app-state.js ═══
  // ── Schéma ────────────────────────────────────────────────
  // elements : symboles déposés
  // wires    : fils/bus
  // texts    : textes libres
  // shapes   : formes géométriques libres (ligne, rect, cercle, poly, arc)


  let state={elements:[],wires:[],texts:[],shapes:[],junctions:[],images:[]};
  let _symbols={};   // id → symbol def

  // ── Projet courant ────────────────────────────────────────
  let currentProject=null;   // objet projet chargé (inclut titleblock_default/cover)
  let currentFolioId=null;   // id du folio ouvert dans ce projet
  let projectFolios=[];      // liste ordonnée des folios du projet
  let isReadOnly=false;      // vrai si accès en lecture seule

  // ── Sélection ─────────────────────────────────────────────
  let selected={type:null,id:null};
  let multiSel=new Set();
  let rubberBand=null;
  let hovered=null;

  // ── Vue ───────────────────────────────────────────────────
  let view={zoom:1,panX:80,panY:60};
  let currentTool='select';
  // Rôles des symboles builtins (contact/bobine)
  // Clipboard cross-folio (localStorage pour persister entre folios/sessions)
  const _CLIP_KEY = 'qd_clipboard_v1';
  function _saveClip(data){ try{localStorage.setItem(_CLIP_KEY,JSON.stringify(data));}catch(e){} }
  function _loadClip(){ try{const d=localStorage.getItem(_CLIP_KEY);return d?JSON.parse(d):null;}catch(e){return null;} }

  const _BUILTIN_COILS    = new Set(['b_bobine']);
  const _BUILTIN_CONTACTS = new Set(['b_contact_no','b_contact_nf','b_contact_tempo','b_relais_th']);
  function _symRole(sym) {
    if(!sym) return null;
    if(sym.elementRole) return sym.elementRole; // défini dans l'éditeur
    if(_BUILTIN_COILS.has(sym.id))    return 'coil';
    if(_BUILTIN_CONTACTS.has(sym.id)) return 'contact';
    return null;
  }

  let measureIP = null;        // mesure active { p1, p2, frozen, p1Snap, snapActive }
  let _measures = [];          // mesures figées { p1, p2, color, id }
  const _MEASURE_COLORS = ['#f5a623','#4ade80','#60a5fa','#f472b6','#a78bfa','#fb923c','#34d399'];
  let _measureColorIdx = 0;
  // Config unité : { unit:'px'|'mm'|'cm'|'in', scale:1 } — 1px = scale unités
  let _measureCfg = { unit:'px', scale:1 };
  let wireIP=null;    // fil en cours {points,isBus}
  let shapeIP=null;   // forme en cours {tool, pts[]}
  let cursorWorld={x:0,y:0};
  let drag={active:false,ids:[],startMouse:null,startPositions:{}};
  let _drawingBcastT=0; // throttle broadcast dessin en cours
  // Drag d'un sous-élément : label, ref ou numéro de fil
  let subdrag={active:false,type:null,obj:null,startMouse:null,startOff:null};
  let pan={active:false,startMouse:null,startPan:null};
  let _snapGuides=[];  // guides d'alignement visuels pendant le drag
  let history=[],histIdx=-1;
  // ── Historique de navigation folio ────────────────────────
  let _folioHistory=[];   // [folioId, ...]
  let _folioHistIdx=-1;
  let _folioNavBusy=false; // vrai pendant back/forward pour ne pas re-pusher
  let schemaId=null;
  let currentUser=null;
  let autoSave=true;  // sauvegarde automatique (activée par défaut)
  let currentShareId=null;
  let canvas,ctx;

  // ── Mode édition cartouche ────────────────────────────────
  let _cartoucheEditMode = false;
  let _cartoucheEditWhich = null;   // 'default'|'cover'|'folio'
  let _cartoucheEditBackup = null;  // sauvegarde de l'état folio avant édition
  let _cartoucheOrigData = null;    // données cartouche originales (pour annulation)

  // ── Todo ──────────────────────────────────────────────────
  let todos=[];  // [{id,text,done}]


// ═══ app-livesync.js ═══
// ══════════════════════════════════════════════════════════
// LIVE SYNC — SSE (partie du App IIFE)
// ══════════════════════════════════════════════════════════

const LiveSync = (() => {
  let _es = null;         // EventSource
  let _projectId = null;
  let _sessionId = null;   // ID unique par connexion SSE
  let _currentFolioId = null;
  let _pointerMode = false;       // mode pointeur à distance (admin uniquement)
  let _pointerModeListener = null;
  let _peers = {};         // userId → { name, cursor, drags, drawing, folioId, pointerMode }
  let _myUserId = null;    // userId de la session locale
  let _peerMeasures = {};  // userId → [{p1,p2,frozen,color}] mesures en cours des peers
  let _applying = false;  // garde contre re-broadcast
  let _lastBroadcast = 0;
  let _cursorThrottle = null;
  const CURSOR_INTERVAL = 50; // ms

  // Palette de couleurs pour les curseurs distants
  const PEER_COLORS = ['#f87171','#fb923c','#facc15','#4ade80','#22d3ee','#818cf8','#e879f9','#f472b6'];
  let _colorIdx = 0;
  function _peerColor(uid) {
    if (!_peers[uid]) return '#fff';
    if (!_peers[uid].color) _peers[uid].color = PEER_COLORS[_colorIdx++ % PEER_COLORS.length];
    return _peers[uid].color;
  }

  let _retryCount = 0;
  const _MAX_RETRY = 5;

  // Nettoyer le partage WebRTC en cours quand l'utilisateur quitte la page
  // (sinon la bannière "Vous partagez votre écran" du navigateur reste affichée
  // et l'admin ne sait pas que la session est morte).
  if (typeof window !== 'undefined') {
    const _onUnload = () => { try { _rtcCleanup && _rtcCleanup(true); } catch {} };
    window.addEventListener('pagehide', _onUnload);
    window.addEventListener('beforeunload', _onUnload);
  }

  function connect(projectId) {
    disconnect();
    _projectId = projectId;
    _retryCount = 0;
    _openSSE(projectId);
    // Récupérer notre userId pour filtrer nos propres messages dans les peers
    if (!_myUserId) {
      fetch('/api/auth/me', { credentials:'include' })
        .then(r=>r.ok?r.json():null)
        .then(u=>{ if(u?.id) _myUserId=String(u.id); })
        .catch(()=>{});
    }
    canvas.addEventListener('mousemove', _onMouseMove);
  }

  function _openSSE(projectId) {
    fetch(`/api/live/${projectId}`, { method: 'HEAD', credentials: 'include' })
      .then(r => {
        if (r.status === 404) {
          console.warn('[LiveSync] Route /api/live/ introuvable — redéployez index.js et redémarrez Node');
          _projectId = null;
          return;
        }
        _startSSE(projectId);
      })
      .catch(() => { _projectId = null; });
  }

  function _startSSE(projectId) {
    _sessionId = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    _myUserId = null;
    _es = new EventSource(`/api/live/${projectId}?sessionId=${encodeURIComponent(_sessionId)}`, { withCredentials: true });
    _es.onmessage = _onMessage;
    _es.onopen = () => { _retryCount = 0; };
    _es.onerror = () => {
      if (!_projectId) return;
      if (_es) { _es.close(); _es = null; }
      if (_retryCount >= _MAX_RETRY) {
        console.warn('[LiveSync] SSE: trop de déconnexions — vérifiez la config nginx (proxy_buffering off)');
        _projectId = null;
        const li = document.getElementById('live-indicator');
        if (li) { li.style.display = 'none'; }
        return;
      }
      const delay = Math.min(5000 * Math.pow(1.8, _retryCount), 30000);
      _retryCount++;
      console.info(`[LiveSync] Reconnexion dans ${Math.round(delay/1000)}s (tentative ${_retryCount}/${_MAX_RETRY})`);
      const li = document.getElementById('live-indicator');
      if (li) li.style.cssText += ';opacity:0.4';
      setTimeout(() => {
        if (!_projectId) return;
        if (li) li.style.cssText = li.style.cssText.replace(';opacity:0.4','');
        _openSSE(_projectId);
      }, delay);
    };
  }

  function disconnect() {
    if (_es) { _es.close(); _es = null; }
    _projectId = null;
    _peers = {};
    canvas.removeEventListener('mousemove', _onMouseMove);
    if (_pointerModeListener) document.removeEventListener('mousemove', _pointerModeListener);
    _pointerModeListener = null;
    _renderPeers();
  }

  function _onMouseMove(e) {
    if (!_projectId) return;
    if (_cursorThrottle) return;
    _cursorThrottle = setTimeout(() => {
      _cursorThrottle = null;
      const r = canvas.getBoundingClientRect();
      const sx = e.clientX - r.left, sy = e.clientY - r.top;
      const { x, y } = s2w(sx, sy);
      _broadcast({ type: 'cursor', x, y, folioId: _currentFolioId });
    }, CURSOR_INTERVAL);
  }

  function _makePointerListener() {
    return function(e) {
      if (!_projectId || !_pointerMode) return;
      if (_cursorThrottle) return;
      _cursorThrottle = setTimeout(() => {
        _cursorThrottle = null;
        const _pr = canvas.getBoundingClientRect();
        const _psx = e.clientX - _pr.left, _psy = e.clientY - _pr.top;
        const _inCanvas = _psx >= 0 && _psy >= 0 && _psx <= _pr.width && _psy <= _pr.height;
        const _pw = _inCanvas ? s2w(_psx, _psy) : null;
        _broadcast({
          type: 'cursor',
          x: _pw ? _pw.x : 0,
          y: _pw ? _pw.y : 0,
          inCanvas: _inCanvas,
          cx: _inCanvas ? 0 : e.clientX,
          cy: _inCanvas ? 0 : e.clientY,
          sw: window.innerWidth,
          sh: window.innerHeight,
          pointerMode: true,
          folioId: _currentFolioId
        });
      }, CURSOR_INTERVAL);
    };
  }

  function _onMessage(e) {
    let msg;
    try { msg = JSON.parse(e.data); } catch { return; }

    if (msg.type === 'peers') {
      _peers = {};
      msg.users.forEach(u => {
        const uid = String(u.id);
        _peers[uid] = { name: u.name, sessionId: u.sessionId };
      });
      _renderPeers();
      return;
    }
    if (msg.type === 'presence') {
      const uid = String(msg.user.id);
      if (msg.action === 'join') {
        _peers[uid] = { name: msg.user.name, sessionId: msg.user.sessionId, lastSeen: Date.now() };
        setStatus(`👤 ${msg.user.name} a rejoint le folio`);
      } else {
        delete _peers[uid];
        setStatus(`👤 ${msg.user.name} a quitté le folio`);
      }
      _renderPeers();
      return;
    }
    if (msg.type === 'cursor') {
      const csid = String(msg.senderId);
      if (!_peers[csid]) _peers[csid] = { name: msg.senderName };
      if (msg.folioId && _currentFolioId && msg.folioId !== _currentFolioId) {
        _peers[csid].cursor = null; _peers[csid].drags = null; _peers[csid].drawing = null;
        const _el = document.querySelector(`#peer-cursors-overlay [data-sid="${csid}"]`);
        if (_el) _el.remove();
      } else {
        _peers[csid].cursor = { x: msg.x, y: msg.y, cx: msg.cx, cy: msg.cy };
        _peers[csid].pointerMode = !!msg.pointerMode;
      }
      _peers[csid].folioId = msg.folioId || null;
      _peers[csid].name = msg.senderName;
      render();
      return;
    }
    if (msg.type === 'drag_move') {
      const csid = String(msg.senderId);
      if (!_peers[csid]) _peers[csid] = { name: msg.senderName };
      if (msg.folioId && _currentFolioId && msg.folioId !== _currentFolioId) { _peers[csid].drags = null; return; }
      _peers[csid].lastSeen = Date.now();
      _peers[csid].drags = msg.items;
      _peers[csid].name = msg.senderName;
      render();
      return;
    }
    if (msg.type === 'drag_end') {
      const csid = msg._fromSession || String(msg.senderId);
      if (_peers[csid]) { _peers[csid].drags = null; }
      render();
      return;
    }
    if (msg.type === 'titleblock_update') {
      if(msg.folioId && msg.folioId === currentFolioId) {
        folio.titleblock = msg.titleblock;
        folio.titleblockType = msg.titleblockType || 'custom';
      } else if(!msg.folioId) {
        if(msg.titleblockType === 'cover') {
          if(currentProject) currentProject.titleblock_cover = msg.titleblock;
        } else {
          if(currentProject) currentProject.titleblock_default = msg.titleblock;
        }
      }
      render();
      return;
    }

    if (msg.type === 'measure_update') {
      const uid = String(msg.senderId);
      if (!_peerMeasures[uid]) _peerMeasures[uid] = [];
      _peerMeasures[uid] = _peerMeasures[uid].filter(m=>m.frozen);
      if (msg.measure && (!msg.folioId || msg.folioId === _currentFolioId)) {
        _peerMeasures[uid].push(msg.measure);
      }
      render(); return;
    }
    if (msg.type === 'measure_frozen') {
      const uid = String(msg.senderId);
      if (!_peerMeasures[uid]) _peerMeasures[uid] = [];
      if (msg.measure && (!msg.folioId || msg.folioId === _currentFolioId)) {
        _peerMeasures[uid] = _peerMeasures[uid].filter(m=>m.frozen);
        _peerMeasures[uid].push({...msg.measure,frozen:true});
      }
      render(); return;
    }
    if (msg.type === 'measure_clear') {
      const uid = String(msg.senderId);
      delete _peerMeasures[uid];
      render(); return;
    }

    if (msg.type === 'drawing_update') {
      const csid = String(msg.senderId);
      if (!_peers[csid]) _peers[csid] = { name: msg.senderName };
      if (msg.folioId && _currentFolioId && msg.folioId !== _currentFolioId) { _peers[csid].drawing = null; return; }
      _peers[csid].drawing = msg.drawing || null;
      _peers[csid].name = msg.senderName;
      render();
      return;
    }
    if (msg.type === 'pointer_mode') {
      const csid = String(msg.senderId);
      if (!_peers[csid]) _peers[csid] = { name: msg.senderName };
      if (!msg.active) {
        _peers[csid].pointerMode = false;
        _peers[csid].cursor = null;
        const _oel = document.querySelector(`#peer-cursors-overlay [data-sid="${csid}"]`);
        if (_oel) _oel.remove();
        render();
      }
      return;
    }
    if (msg.type === 'todos_updated') {
      if (Array.isArray(msg.todos)) {
        todos = msg.todos;
        renderTodoList();
      }
      return;
    }
    if (msg.type === 'symbols_updated') {
      reloadSymbols().then(() => { buildLibrary(); render(); });
      return;
    }
    if (msg.type === 'delta') {
      _applyDelta(msg);
      return;
    }
    if (msg.type === 'webrtc_request')  { _rtcHandleRequest(msg);  return; }
    if (msg.type === 'webrtc_decline')  { _rtcHandleDecline(msg);  return; }
    if (msg.type === 'webrtc_offer')    { _rtcHandleOffer(msg);    return; }
    if (msg.type === 'webrtc_answer')   { _rtcHandleAnswer(msg);   return; }
    if (msg.type === 'webrtc_ice')      { _rtcHandleIce(msg);      return; }
    if (msg.type === 'webrtc_stop')     { _rtcHandleStop(msg);     return; }
    if (msg.type === 'guide_pointer')   { _guideHandlePointer(msg); return; }
  }

  function _applyDelta(msg) {
    if (msg.delta && msg.delta.folioId && _currentFolioId && msg.delta.folioId !== _currentFolioId) return;
    _applying = true;
    try {
      const d = msg.delta;
      if (d.elements)  state.elements  = d.elements;
      if (d.wires)     state.wires     = d.wires;
      if (d.texts)     state.texts     = d.texts;
      if (d.shapes)    state.shapes    = d.shapes;
      if (d.junctions) state.junctions = d.junctions;
      if (d.images)    state.images    = d.images;
      if (d.measures !== undefined) _measures = d.measures || [];
      markVoltageDirty();
      const unknownSym = (state.elements||[]).some(el => el.symId && !_symbols[el.symId]);
      if (unknownSym) {
        reloadSymbols().then(() => { buildLibrary(); render(); updateProps(); });
      } else {
        render();
        updateProps();
      }
    } finally {
      _applying = false;
    }
  }

  function broadcast(delta) {
    if (_applying || !_projectId) return;
    const now = Date.now();
    if (now - _lastBroadcast < 30) return;
    _lastBroadcast = now;
    _broadcast({ type: 'delta', delta });
  }

  function _broadcast(msg) {
    if (!_projectId) return;
    fetch(`/api/live/${_projectId}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...msg, _sessionId })
    }).then(r => r.json()).then(d => {
      if (!_myUserId && d?.userId) _myUserId = d.userId;
    }).catch(() => {});
  }

  function _renderPeers() {
    const bar = document.getElementById('live-peers-bar');
    if (!bar) return;
    bar.innerHTML = '';
    const seen = new Set();
    let n = 0;
    for (const [sid, p] of Object.entries(_peers)) {
      const key = (p.name||'?').toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      const col = _peerColor(sid);
      const chip = document.createElement('div');
      chip.className = 'live-peer-chip';
      chip.title = p.name;
      chip.innerHTML =
        `<span class="live-peer-avatar" style="background:${col}">${(p.name||'?')[0].toUpperCase()}</span>` +
        `<span class="live-peer-name">${p.name||'?'}</span>`;
      bar.appendChild(chip);
      n++;
    }
    const countEl = document.getElementById('live-peers-count');
    if (countEl) countEl.textContent = n ? `${n}` : '';
    const section = document.getElementById('live-peers-section');
    if (section) section.style.display = n ? '' : 'none';
  }

  function getPeerDrags() {
    const result = {};
    for (const [sid, p] of Object.entries(_peers)) {
      if (sid === _sessionId || (_myUserId && sid === String(_myUserId))) continue;
      if (p.drags && p.drags.length) {
        result[sid] = { name: p.name, color: _peerColor(sid), items: p.drags };
      }
    }
    return result;
  }

  function _updatePeerCursorDom() {
    let overlay = document.getElementById('peer-cursors-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'peer-cursors-overlay';
      overlay.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden;';
      document.body.appendChild(overlay);
    }
    const active = new Set(Object.keys(_peers).filter(sid => _peers[sid].pointerMode));
    [...overlay.children].forEach(el => {
      if (!active.has(el.dataset.sid)) el.remove();
    });
    for (const [sid, p] of Object.entries(_peers)) {
      if (sid === _sessionId || (_myUserId && sid === String(_myUserId))) continue;
      if (!p.cursor || !p.pointerMode || p.cursor.cx == null) continue;
      const col = _peerColor(sid);
      const _sw = p.cursor.sw || window.innerWidth;
      const _sh = p.cursor.sh || window.innerHeight;
      let px, py;
      if (p.cursor.inCanvas) {
        const _cr3 = canvas.getBoundingClientRect();
        const _ws = w2s(p.cursor.x, p.cursor.y);
        px = _cr3.left + _ws.sx;
        py = _cr3.top  + _ws.sy;
      } else {
        px = (p.cursor.cx / _sw) * window.innerWidth;
        py = (p.cursor.cy / _sh) * window.innerHeight;
      }
      let el = overlay.querySelector(`[data-sid="${CSS.escape(sid)}"]`);
      if (!el) {
        el = document.createElement('div');
        el.dataset.sid = sid;
        el.style.cssText = 'position:absolute;pointer-events:none;transition:left .04s linear,top .04s linear;';
        el.innerHTML =
          `<svg width="18" height="22" viewBox="0 0 18 22" style="display:block;filter:drop-shadow(0 1px 3px rgba(0,0,0,.5))">` +
          `<path d="M0 0L0 14L3.5 10.5L6 15L7.5 14.5L5 9.5L9 9.5Z" fill="${col}" stroke="#111" stroke-width="0.8"/>` +
          `</svg>` +
          `<span style="position:absolute;left:14px;top:14px;background:${col};color:#111;font:700 10px monospace;` +
          `padding:1px 5px;border-radius:3px;white-space:nowrap;box-shadow:0 1px 4px rgba(0,0,0,.4)">${p.name||'?'}</span>`;
        overlay.appendChild(el);
      } else {
        el.querySelector('path').setAttribute('fill', col);
        el.querySelector('span').textContent = p.name || '?';
        el.querySelector('span').style.background = col;
      }
      el.style.left = px + 'px';
      el.style.top  = py + 'px';
    }
  }

  function drawPeerCursors(ctx) {
    const _now = Date.now();
    for (const uid of Object.keys(_peers)) {
      if (_peers[uid].lastSeen && _now - _peers[uid].lastSeen > 60000) delete _peers[uid];
    }
    for (const [uid, p] of Object.entries(_peers)) {
      if (uid === _sessionId || (_myUserId && uid === String(_myUserId))) continue;
      const col = _peerColor(uid);

      if (p.cursor && !p.pointerMode) {
        const { x, y } = p.cursor;
        ctx.save();
        ctx.translate(x, y);
        ctx.scale(1/view.zoom, 1/view.zoom);
        ctx.beginPath();
        ctx.moveTo(0,0); ctx.lineTo(0,14); ctx.lineTo(3.5,10.5);
        ctx.lineTo(6,15); ctx.lineTo(7.5,14.5); ctx.lineTo(5,9.5);
        ctx.lineTo(9,9.5); ctx.closePath();
        ctx.fillStyle=col; ctx.fill();
        ctx.strokeStyle='#111'; ctx.lineWidth=0.8; ctx.stroke();
        ctx.font='bold 11px monospace';
        ctx.fillStyle=col; ctx.textBaseline='top';
        ctx.fillText(p.name, 11, 14);
        ctx.restore();
      }

      if (p.drags && p.drags.length) {
        for (const item of p.drags) {
          if (item.type === 'element') {
            const sym = _symbols[item.symId];
            if (sym) {
              ctx.save();
              ctx.globalAlpha = 0.55;
              const ghostEl = {
                x: item.x, y: item.y,
                w: item.w || sym.width || 60,
                h: item.h || sym.height || 40,
                rotation: item.rotation || 0,
                labelOffX: 0, labelOffY: -18,
                refOffX: 0,   refOffY: 10,
              };
              Renderer.drawSymbol(ctx, sym, ghostEl, false, false, false, 0);
              ctx.restore();
              ctx.save();
              ctx.globalAlpha = 0.75;
              ctx.strokeStyle = col;
              ctx.lineWidth = 2 / view.zoom;
              ctx.setLineDash([4/view.zoom, 3/view.zoom]);
              ctx.strokeRect(item.x, item.y, ghostEl.w, ghostEl.h);
              ctx.setLineDash([]);
              ctx.globalAlpha = 0.9;
              ctx.font = `bold ${10/view.zoom}px monospace`;
              ctx.textBaseline = 'bottom';
              ctx.fillStyle = col;
              ctx.fillText(p.name, item.x, item.y - 3/view.zoom);
              ctx.restore();
            } else {
              ctx.save();
              ctx.globalAlpha = 0.45;
              const w = item.w || 60, h = item.h || 40;
              ctx.strokeStyle = col;
              ctx.lineWidth = 2 / view.zoom;
              ctx.setLineDash([4/view.zoom, 3/view.zoom]);
              ctx.strokeRect(item.x, item.y, w, h);
              ctx.setLineDash([]);
              ctx.fillStyle = col;
              ctx.globalAlpha = 0.10;
              ctx.fillRect(item.x, item.y, w, h);
              ctx.globalAlpha = 0.7;
              ctx.font = `bold ${10/view.zoom}px monospace`;
              ctx.textBaseline = 'bottom';
              ctx.fillStyle = col;
              ctx.fillText(p.name, item.x, item.y - 3/view.zoom);
              ctx.restore();
            }
          } else if (item.type === 'wire' && item.pts) {
            ctx.save();
            ctx.globalAlpha = 0.65;
            const wireObj = { points: item.pts, color: item.color, width: item.width, isBus: item.isBus };
            Renderer.drawWire(ctx, wireObj, false, null, false, 0);
            ctx.strokeStyle = col;
            ctx.lineWidth = (item.width || 1.8) / view.zoom + 2 / view.zoom;
            ctx.setLineDash([5/view.zoom, 3/view.zoom]);
            ctx.beginPath();
            item.pts.forEach((p,i) => i===0 ? ctx.moveTo(p.x,p.y) : ctx.lineTo(p.x,p.y));
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.restore();
          } else if (item.type === 'text' && item.x != null) {
            ctx.save();
            ctx.globalAlpha = 0.65;
            Renderer.drawText(ctx, { x:item.x, y:item.y, text:item.text||'', size:item.size, color:item.color, angle:item.angle||0 }, false);
            ctx.strokeStyle = col;
            ctx.lineWidth = 1.5 / view.zoom;
            ctx.setLineDash([3/view.zoom, 2/view.zoom]);
            const tw = ctx.measureText(item.text||'').width;
            ctx.strokeRect(item.x - 2, item.y - 2, tw + 4, (item.size||13) + 4);
            ctx.setLineDash([]);
            ctx.restore();
          } else if (item.type === 'shape' && item._sh) {
            ctx.save();
            ctx.globalAlpha = 0.65;
            Renderer.drawShape(ctx, item._sh, false);
            ctx.globalAlpha = 0.55;
            ctx.strokeStyle = col;
            ctx.lineWidth = 2 / view.zoom;
            ctx.setLineDash([4/view.zoom, 3/view.zoom]);
            ctx.beginPath();
            const sh = item._sh;
            if (sh.t === 'rect') {
              ctx.rect(sh.x, sh.y, sh.w, sh.h);
            } else if (sh.t === 'circle') {
              ctx.arc(sh.cx, sh.cy, sh.r, 0, Math.PI*2);
            } else if (sh.t === 'arc') {
              ctx.arc(sh.cx, sh.cy, sh.r, sh.a1||0, sh.a2||Math.PI);
            } else if ((sh.t === 'line' || sh.t === 'poly') && sh.pts?.length) {
              ctx.moveTo(sh.pts[0].x, sh.pts[0].y);
              sh.pts.slice(1).forEach(p => ctx.lineTo(p.x, p.y));
              if (sh.closed) ctx.closePath();
            }
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.restore();
          } else if (item.type === 'image' && item.x != null) {
            ctx.save();
            ctx.globalAlpha = 0.55;
            ctx.strokeStyle = col;
            ctx.lineWidth = 2 / view.zoom;
            ctx.setLineDash([4/view.zoom, 3/view.zoom]);
            ctx.strokeRect(item.x, item.y, item.w || 80, item.h || 60);
            ctx.setLineDash([]);
            ctx.fillStyle = col;
            ctx.globalAlpha = 0.08;
            ctx.fillRect(item.x, item.y, item.w || 80, item.h || 60);
            ctx.globalAlpha = 0.7;
            ctx.font = `bold ${10/view.zoom}px monospace`;
            ctx.fillStyle = col;
            ctx.textBaseline = 'bottom';
            ctx.fillText(p.name, item.x, item.y - 3/view.zoom);
            ctx.restore();
          }
        }
      }
    }
  }

  function broadcastSymbolsUpdated() {
    _broadcast({ type: 'symbols_updated' });
  }
  function _broadcastDrag(msg) {
    _broadcast({ type: 'drag_move', ...msg, folioId: _currentFolioId });
  }
  function broadcastDragEnd() {
    _broadcast({ type: 'drag_end' });
  }
  function broadcastTodos(todos) {
    _broadcast({ type: 'todos_updated', todos });
  }
  function broadcastDrawing(drawing) {
    _broadcast({ type: 'drawing_update', drawing, folioId: _currentFolioId });
  }
  function setFolioId(id) { _currentFolioId = id; }

  function enablePointerMode() {
    if (_pointerMode) return;
    _pointerMode = true;
    _pointerModeListener = _makePointerListener();
    document.addEventListener('mousemove', _pointerModeListener);
    _broadcast({ type: 'pointer_mode', active: true });
  }

  function disablePointerMode() {
    if (!_pointerMode) return;
    _pointerMode = false;
    if (_pointerModeListener) {
      document.removeEventListener('mousemove', _pointerModeListener);
      _pointerModeListener = null;
    }
    _broadcast({ type: 'pointer_mode', active: false });
  }

  // ══════════════════════════════════════════════════════════
  // WebRTC — visualisation d'écran distant + pointeur de guidage
  // ══════════════════════════════════════════════════════════
  // STUN-only : suffisant en LAN et derrière la plupart des NAT. Pour
  // les NAT symétriques (4G, certains corporate), ajouter un TURN via
  // window.QD_RTC_ICE = [{ urls:'turn:...', username, credential }, ...].
  function _rtcConfig() {
    const base = [{ urls: 'stun:stun.l.google.com:19302' }, { urls: 'stun:stun1.l.google.com:19302' }];
    const extra = Array.isArray(window.QD_RTC_ICE) ? window.QD_RTC_ICE : [];
    return { iceServers: [...base, ...extra] };
  }

  let _rtcPc = null;
  let _rtcRole = null;             // 'sender' (utilisateur) ou 'receiver' (admin)
  let _rtcRemoteSession = null;    // sessionId du pair distant
  let _rtcLocalStream = null;      // côté sender
  let _rtcOnRemoteStream = null;   // callback admin → reçoit MediaStream
  let _rtcOnEnd = null;            // callback fin de session (les deux côtés)
  let _rtcPendingIce = [];         // ICE reçus avant setRemoteDescription
  let _guidePointerEl = null;
  let _guideHideTimer = null;

  function _rtcCleanup(notifyPeer) {
    if (notifyPeer && _rtcRemoteSession) {
      _broadcast({ type: 'webrtc_stop', targetSession: _rtcRemoteSession });
    }
    if (_rtcLocalStream) {
      try { _rtcLocalStream.getTracks().forEach(t => t.stop()); } catch {}
    }
    _rtcLocalStream = null;
    if (_rtcPc) {
      try { _rtcPc.close(); } catch {}
    }
    _rtcPc = null;
    _rtcPendingIce = [];
    // Retirer la bannière "X voit votre écran" + curseur de guidage côté sender.
    // Sans ça, cliquer "Arrêter" coupe le flux mais laisse la bannière à l'écran.
    _guideHideBanner();
    _guideHidePointer();
    const cb = _rtcOnEnd;
    _rtcRole = null;
    _rtcRemoteSession = null;
    _rtcOnRemoteStream = null;
    _rtcOnEnd = null;
    if (cb) { try { cb(); } catch {} }
  }

  function _rtcMakePc(targetSession) {
    const pc = new RTCPeerConnection(_rtcConfig());
    pc.onicecandidate = (e) => {
      if (e.candidate) {
        _broadcast({ type: 'webrtc_ice', candidate: e.candidate.toJSON(), targetSession });
      }
    };
    pc.onconnectionstatechange = () => {
      if (pc.connectionState === 'failed' || pc.connectionState === 'closed' || pc.connectionState === 'disconnected') {
        if (pc.connectionState === 'failed') _rtcCleanup(true);
      }
    };
    pc.ontrack = (e) => {
      if (_rtcRole === 'receiver' && _rtcOnRemoteStream && e.streams[0]) {
        _rtcOnRemoteStream(e.streams[0]);
      }
    };
    return pc;
  }

  async function _rtcDrainIce() {
    if (!_rtcPc || !_rtcPendingIce.length) return;
    const pending = _rtcPendingIce; _rtcPendingIce = [];
    for (const c of pending) {
      try { await _rtcPc.addIceCandidate(c); } catch (err) { console.warn('[LiveSync] addIceCandidate failed', err); }
    }
  }

  // ── Côté admin (receiver) ──
  // Demander à un pair de partager son écran.
  // onRemoteStream(MediaStream) : callback avec le flux reçu (à brancher sur <video>)
  // onEnd() : appelé quand la session se termine
  function requestScreenView(targetSession, onRemoteStream, onEnd) {
    if (_rtcPc) _rtcCleanup(true);
    if (!targetSession) return false;
    _rtcRole = 'receiver';
    _rtcRemoteSession = targetSession;
    _rtcOnRemoteStream = onRemoteStream || null;
    _rtcOnEnd = onEnd || null;
    _broadcast({ type: 'webrtc_request', targetSession });
    return true;
  }

  function stopScreenView() {
    if (_rtcPc || _rtcRemoteSession) _rtcCleanup(true);
  }

  // Coord normalisées 0-1 par rapport à la vidéo affichée
  function broadcastGuidePointer(rx, ry, visible) {
    if (_rtcRole !== 'receiver' || !_rtcRemoteSession) return;
    _broadcast({ type: 'guide_pointer', rx, ry, visible: visible !== false, targetSession: _rtcRemoteSession });
  }

  // ── Handlers signaling ──
  async function _rtcHandleRequest(msg) {
    // Côté sender : un admin demande à voir notre écran
    const senderSid = msg._fromSession;
    const askerName = msg.senderName || 'Un admin';
    const ok = await _rtcAskUserConsent(askerName);
    if (!ok) {
      _broadcast({ type: 'webrtc_decline', targetSession: senderSid });
      return;
    }
    let stream;
    try {
      stream = await navigator.mediaDevices.getDisplayMedia({
        video: { frameRate: { ideal: 15, max: 30 } },
        audio: false,
        // Aide Chrome à proposer l'onglet courant en premier (le pointeur
        // de guidage est précis dans ce cas)
        preferCurrentTab: true,
        selfBrowserSurface: 'include'
      });
    } catch (err) {
      _broadcast({ type: 'webrtc_decline', targetSession: senderSid });
      return;
    }
    _rtcRole = 'sender';
    _rtcRemoteSession = senderSid;
    _rtcLocalStream = stream;
    _rtcPc = _rtcMakePc(senderSid);
    stream.getTracks().forEach(t => {
      t.addEventListener('ended', () => _rtcCleanup(true));
      _rtcPc.addTrack(t, stream);
    });
    const offer = await _rtcPc.createOffer();
    await _rtcPc.setLocalDescription(offer);
    _broadcast({ type: 'webrtc_offer', sdp: _rtcPc.localDescription, targetSession: senderSid });
    _guideShowBanner(askerName);
  }

  function _rtcHandleDecline(msg) {
    if (_rtcRole !== 'receiver') return;
    if (typeof setStatus === 'function') setStatus('🚫 Partage d\'écran refusé');
    _rtcCleanup(false);
  }

  async function _rtcHandleOffer(msg) {
    // Côté receiver (admin)
    if (_rtcRole !== 'receiver') return;
    const senderSid = msg._fromSession;
    _rtcRemoteSession = senderSid;
    _rtcPc = _rtcMakePc(senderSid);
    try {
      await _rtcPc.setRemoteDescription(msg.sdp);
      await _rtcDrainIce();
      const answer = await _rtcPc.createAnswer();
      await _rtcPc.setLocalDescription(answer);
      _broadcast({ type: 'webrtc_answer', sdp: _rtcPc.localDescription, targetSession: senderSid });
    } catch (err) {
      console.warn('[LiveSync] webrtc offer error', err);
      _rtcCleanup(true);
    }
  }

  async function _rtcHandleAnswer(msg) {
    if (_rtcRole !== 'sender' || !_rtcPc) return;
    try {
      await _rtcPc.setRemoteDescription(msg.sdp);
      await _rtcDrainIce();
    } catch (err) { console.warn('[LiveSync] webrtc answer error', err); }
  }

  async function _rtcHandleIce(msg) {
    if (!msg.candidate) return;
    if (!_rtcPc || !_rtcPc.remoteDescription) {
      _rtcPendingIce.push(msg.candidate);
      return;
    }
    try { await _rtcPc.addIceCandidate(msg.candidate); }
    catch (err) { console.warn('[LiveSync] addIceCandidate', err); }
  }

  function _rtcHandleStop(msg) {
    _guideHideBanner();
    _guideHidePointer();
    _rtcCleanup(false);
  }

  // ── Consentement utilisateur côté sender ──
  function _rtcAskUserConsent(askerName) {
    return new Promise((resolve) => {
      const wrap = document.createElement('div');
      wrap.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:99998;display:flex;align-items:center;justify-content:center;font-family:var(--font,sans-serif)';
      wrap.innerHTML =
        `<div style="background:var(--panel,#1a1f26);border:1px solid var(--border2,#333);border-radius:10px;padding:22px 26px;max-width:420px;box-shadow:0 20px 60px rgba(0,0,0,.6)">` +
          `<div style="font-size:14px;font-weight:700;color:var(--text,#eee);margin-bottom:8px">🖥 Partage d'écran demandé</div>` +
          `<div style="font-size:12px;color:var(--text2,#bbb);line-height:1.6;margin-bottom:18px"><b>${(askerName||'Un administrateur').replace(/</g,'&lt;')}</b> souhaite voir votre écran pour vous guider.<br><span style="color:var(--text3,#888);font-size:11px">Vous pourrez choisir quel onglet/fenêtre partager.</span></div>` +
          `<div style="display:flex;gap:8px;justify-content:flex-end">` +
            `<button id="qd-rtc-no" style="font-size:11px;padding:7px 14px;background:none;border:1px solid var(--border2,#444);color:var(--text2,#bbb);border-radius:5px;cursor:pointer">Refuser</button>` +
            `<button id="qd-rtc-yes" style="font-size:11px;padding:7px 14px;background:#4ade80;border:1px solid #4ade80;color:#0a0a0a;border-radius:5px;cursor:pointer;font-weight:700">Accepter</button>` +
          `</div>` +
        `</div>`;
      document.body.appendChild(wrap);
      const cleanup = (ok) => { try { wrap.remove(); } catch {} resolve(ok); };
      wrap.querySelector('#qd-rtc-yes').onclick = () => cleanup(true);
      wrap.querySelector('#qd-rtc-no').onclick  = () => cleanup(false);
    });
  }

  // ── Pointeur de guidage côté sender ──
  // Bannière "Un admin vous guide" + curseur overlay piloté à distance
  function _guideShowBanner(askerName) {
    let b = document.getElementById('qd-guide-banner');
    if (!b) {
      b = document.createElement('div');
      b.id = 'qd-guide-banner';
      b.style.cssText = 'position:fixed;top:12px;left:50%;transform:translateX(-50%);background:rgba(74,222,128,.95);color:#0a0a0a;padding:8px 16px;border-radius:6px;font:700 12px var(--font,sans-serif);box-shadow:0 4px 12px rgba(0,0,0,.4);z-index:99997;display:flex;align-items:center;gap:10px';
      b.innerHTML = `<span>🖥 <span id="qd-guide-name"></span> voit votre écran</span><button id="qd-guide-stop" style="background:#0a0a0a;color:#4ade80;border:none;padding:3px 10px;border-radius:4px;font-size:10px;cursor:pointer;font-weight:700">Arrêter</button>`;
      document.body.appendChild(b);
      b.querySelector('#qd-guide-stop').onclick = () => _rtcCleanup(true);
    }
    b.querySelector('#qd-guide-name').textContent = askerName || 'Un admin';
    b.style.display = 'flex';
  }
  function _guideHideBanner() {
    const b = document.getElementById('qd-guide-banner');
    if (b) b.remove();
  }

  function _guideHandlePointer(msg) {
    if (_rtcRole !== 'sender') return;
    if (msg.visible === false) { _guideHidePointer(); return; }
    let el = _guidePointerEl;
    if (!el) {
      el = document.createElement('div');
      el.id = 'qd-guide-pointer';
      el.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;pointer-events:none;z-index:99999;transition:transform .04s linear';
      el.innerHTML =
        `<svg width="28" height="34" viewBox="0 0 28 34" style="display:block;filter:drop-shadow(0 2px 5px rgba(0,0,0,.6))">` +
          `<path d="M0 0L0 22L5.5 16.5L9.5 24L12 23L8 15L14 15Z" fill="#4ade80" stroke="#0a0a0a" stroke-width="1.2"/>` +
        `</svg>` +
        `<span style="position:absolute;left:22px;top:22px;background:#4ade80;color:#0a0a0a;font:700 11px var(--font,sans-serif);padding:2px 8px;border-radius:4px;white-space:nowrap;box-shadow:0 2px 6px rgba(0,0,0,.5)">${(msg.senderName||'admin').replace(/</g,'&lt;')}</span>`;
      document.body.appendChild(el);
      _guidePointerEl = el;
    }
    const x = (msg.rx || 0) * window.innerWidth;
    const y = (msg.ry || 0) * window.innerHeight;
    el.style.transform = `translate(${x}px, ${y}px)`;
    if (_guideHideTimer) clearTimeout(_guideHideTimer);
    _guideHideTimer = setTimeout(_guideHidePointer, 4000);
  }
  function _guideHidePointer() {
    if (_guideHideTimer) { clearTimeout(_guideHideTimer); _guideHideTimer = null; }
    if (_guidePointerEl) { try { _guidePointerEl.remove(); } catch {} _guidePointerEl = null; }
  }

  return { connect, disconnect, broadcast, broadcastSymbolsUpdated, broadcastTodos, broadcastDrawing, drawPeerCursors, _updatePeerCursorDom, getPeerDrags, _broadcastDrag, broadcastDragEnd, _getPeers: () => _peers, _peerColor, _sessionId: () => _sessionId, setFolioId, enablePointerMode, disablePointerMode, _isPointerMode: () => _pointerMode, getPeerMeasures: () => _peerMeasures, requestScreenView, stopScreenView, broadcastGuidePointer, _isScreenSharing: () => !!_rtcPc };
})();

// Exposer LiveSync sur window pour titleblock.js (chargé hors IIFE)
window.LiveSync = LiveSync;

// ═══ app-init.js ═══
  // ─────────────────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────────────────
  // Paramètres URL
  let urlProject = null;
  let urlFolio   = null;

  async function init() {
    const params = new URLSearchParams(window.location.search);
    urlProject = params.get('project');
    urlFolio   = params.get('folio');

    try {
      const res=await fetch('/api/auth/me',{credentials:'include'});
      if(!res.ok){window.location.href='/login.html';return;}
      currentUser=await res.json();
    }catch{window.location.href='/login.html';return;}

    document.getElementById('user-name').textContent=currentUser.name;
    const _isAdminRole=currentUser.clientRole==='admin'||currentUser.role==='admin'||currentUser.globalRole==='superadmin';
    const _isSuperAdmin=currentUser.globalRole==='superadmin';
    document.getElementById('user-role').textContent=_isSuperAdmin?'SUPERADMIN':_isAdminRole?'ADMIN':'';
    if(_isAdminRole||_isSuperAdmin){const _bd=document.getElementById('btn-admin-dash');if(_bd)_bd.style.display='';}
    const _ddun=document.getElementById('dd-uname');if(_ddun)_ddun.textContent=currentUser.name;
    const _ddur=document.getElementById('dd-urole');
    if(_ddur)_ddur.textContent=_isSuperAdmin?'Super Administrateur':_isAdminRole?'Administrateur':'Utilisateur';
    // Afficher le nom du client actif si disponible
    if(currentUser.activeClientId){
      fetch('/api/clients/'+currentUser.activeClientId,{credentials:'include',method:'GET'})
        .then(r=>r.ok?r.json():null).then(c=>{
          if(c){const _cn=document.getElementById('user-role');
            if(_cn&&_isSuperAdmin)_cn.textContent='SUPERADMIN · '+c.name;}
        }).catch(()=>{});
    }
    const _st=localStorage.getItem('qd-theme');if(_st)_applyTheme(_st);

    canvas=document.getElementById('canvas');
    ctx=canvas.getContext('2d');
    resize();
    window.addEventListener('resize',resize);

    await loadUserSettings();
    folio.date=folio.date||new Date().toISOString().slice(0,10);
    document.getElementById('cart-date').value=folio.date;

    await reloadSymbols();
    buildLibrary();
    bindEvents();
    bindToolbar();
    bindModals();
    SymbolEditor.init();
    loadTodos();
    renderTodoList();
    saveHistory();
    render();
    updateFolioOverlay();

    // ── Charger le projet/folio depuis l'URL ─────────────────
    if (urlProject) {
      await openProject(urlProject, urlFolio);
      // Mettre à jour le lien Import DXF avec le contexte courant
      updateDxfImportLink();
    } else {
      // Pas de projet dans l'URL → retour à la liste des projets
      window.location.href = '/projects.html';
      return;
    }

    _initLogPanel();
    setStatus('Prêt — Bienvenue '+currentUser.name);
  }

  // Exposer pour SymbolEditor
  window.App={ reloadSymbols, buildLibrary, saveSchema,
    get _symbols(){return _symbols;},
    get folio(){return folio;},
    get currentProject(){return currentProject;},
    get currentFolioId(){return currentFolioId;},
    get currentUser(){return currentUser;},
    get schemaId(){return schemaId;},
    get projectFolios(){return projectFolios;},
    get printZone(){return printZone;},
    get PROJ(){return PROJ;},
    get GRID(){return GRID;},
    setStatus, applyFormatToPrintZone,
    enterCartoucheEdit, exitCartoucheEdit,
    get cartoucheEditMode(){return _cartoucheEditMode;} };

  function resize(){
    const wrap=document.getElementById('canvas-wrap');
    canvas.width=wrap.clientWidth; canvas.height=wrap.clientHeight;
    render();
  }

  // ── Settings profil ───────────────────────────────────────
  async function loadUserSettings(){
    try{
      const res=await fetch('/api/auth/settings',{credentials:'include'});
      if(!res.ok)return;
      const s=await res.json();
      if(s.autoSave!==undefined){autoSave=!!s.autoSave;}
      if(s.printZone)Object.assign(printZone,s.printZone);
      if(s.refGrid)Object.assign(refGrid,s.refGrid);
      if(s.titleblock) folio.titleblock=s.titleblock;
      // Recalculer les dimensions si le format est connu
      if(printZone.format) applyFormatToPrintZone(printZone.format);
      if(s.grid){GRID=s.grid.size||20;gridSnap=s.grid.snap!==false;gridVisible=s.grid.visible!==false;snapLabels=s.grid.snapLabels||false;}
      if(s.todos&&Array.isArray(s.todos))todos=s.todos;
      if(s.proj)Object.assign(PROJ,s.proj,{voltColors:Object.assign({},PROJ.voltColors,s.proj?.voltColors)});
      window._PROJ = PROJ;
      _syncAutoSaveUI();
      const _gm=document.getElementById('grid-main');if(_gm)_gm.value=GRID;
      const _gr=document.getElementById('grid-main-range');if(_gr)_gr.value=GRID;
      const _gv2=document.getElementById('grid-main-val');if(_gv2)_gv2.textContent=GRID+'px';
      const _gs=document.getElementById('grid-snap');if(_gs)_gs.checked=gridSnap;
      const _gv=document.getElementById('grid-visible');if(_gv)_gv.checked=gridVisible;
      const _gl=document.getElementById('grid-snap-labels');if(_gl)_gl.checked=snapLabels;
    }catch(e){console.warn('Settings load error:',e);}
  }
  async function saveUserSettings(){
    try{
      await fetch('/api/auth/settings',{method:'PUT',credentials:'include',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({printZone,refGrid,grid:{size:GRID,snap:gridSnap,visible:gridVisible,snapLabels},todos,proj:PROJ,autoSave,titleblock:(folio&&folio.titleblock)||null})});
    }catch(e){console.warn('Settings save error:',e);}
  }

  // ── Symboles ──────────────────────────────────────────────
  async function reloadSymbols(broadcast=false){
    const res=await fetch('/api/symbols',{credentials:'include'});
    const list=await res.json();
    _symbols={};
    list.forEach(s=>_symbols[s.id]=s);
    populateCatList();
    if(broadcast) LiveSync.broadcastSymbolsUpdated();
  }
  function populateCatList(){
    const cats=[...new Set(Object.values(_symbols).map(s=>s.category))];
    const dl=document.getElementById('cat-list');
    if(dl)dl.innerHTML=cats.map(c=>`<option value="${c}">`).join('');
  }

  // ── Bibliothèque ──────────────────────────────────────────
  function buildLibrary(filter=''){
    const lib=document.getElementById('sym-library');
    lib.innerHTML='';
    const cats={};
    Object.values(_symbols).forEach(sym=>{
      if(filter&&!sym.name.toLowerCase().includes(filter.toLowerCase())&&
         !sym.category.toLowerCase().includes(filter.toLowerCase()))return;
      (cats[sym.category]=cats[sym.category]||[]).push(sym);
    });
    Object.entries(cats).sort(([a],[b])=>a.localeCompare(b)).forEach(([cat,items])=>{
      const catEl=document.createElement('div');catEl.className='sym-cat';
      const hdr=document.createElement('div');hdr.className='sym-cat-hdr';
      hdr.innerHTML=`<span>${cat}</span><span class="arrow">▾</span>`;
      catEl.appendChild(hdr);
      const grid=document.createElement('div');grid.className='sym-cat-items';
      catEl.appendChild(grid);
      hdr.onclick=()=>{hdr.classList.toggle('closed');grid.classList.toggle('hidden');};
      items.sort((a,b)=>a.name.localeCompare(b.name)).forEach(sym=>{
        const item=document.createElement('div');
        item.className='sym-item'+(sym.builtin?'':' custom');
        item.draggable=true;
        item.title=sym.name+(sym.builtin?' [IEC]':' [custom]');
        const pw=56,ph=40,c=document.createElement('canvas');c.width=pw;c.height=ph;
        const c2=c.getContext('2d');c2.fillStyle='#191d27';c2.fillRect(0,0,pw,ph);
        const sc=Math.min((pw-8)/sym.width,(ph-8)/sym.height);
        drawSymPreview(c2,sym,(pw-sym.width*sc)/2,(ph-sym.height*sc)/2,sym.width*sc,sym.height*sc,sym.builtin?'#3b9eff':'#4dff91');
        item.appendChild(c);
        const lbl=document.createElement('div');lbl.className='sym-item-label';lbl.textContent=sym.name;
        item.appendChild(lbl);
        item.addEventListener('dragstart',e=>e.dataTransfer.setData('sym-id',sym.id));
        grid.appendChild(item);
      });
      lib.appendChild(catEl);
    });
  }


// ═══ app-library.js ═══
  // ── Modal Gestion Bibliothèque ────────────────────────────
  // ── Gestion bibliothèque (onglet admin) ─────────────────
  const admsymSel = new Set();

  function admsymSelUpdate() {
    const bar = document.getElementById('admsym-action-bar');
    const cnt = document.getElementById('admsym-sel-count');
    if (!bar) return;
    bar.style.display = admsymSel.size > 0 ? '' : 'none';
    if (cnt) cnt.textContent = `${admsymSel.size} sélectionné${admsymSel.size > 1 ? 's' : ''}`;
    document.querySelectorAll('.admsym-item[data-sym-id]').forEach(el => {
      el.classList.toggle('lib-selected', admsymSel.has(el.dataset.symId));
    });
    document.querySelectorAll('.admsym-cat-chk').forEach(chk => {
      const syms = chk._catSyms || [];
      const all = syms.length > 0 && syms.every(s => admsymSel.has(s.id));
      const some = syms.some(s => admsymSel.has(s.id));
      chk.checked = all; chk.indeterminate = some && !all;
    });
  }

  function buildAdmsymGrid() {
    const q = (document.getElementById('admsym-search')?.value || '').toLowerCase();
    const catF = document.getElementById('admsym-filter-cat')?.value || '';
    const typeF = document.getElementById('admsym-filter-type')?.value || '';

    const list = Object.values(_symbols).filter(sym => {
      if (q && !sym.name.toLowerCase().includes(q) && !sym.category.toLowerCase().includes(q)) return false;
      if (catF && sym.category !== catF) return false;
      if (typeF === 'builtin' && !sym.builtin) return false;
      if (typeF === 'custom' && sym.builtin) return false;
      return true;
    });

    const grid = document.getElementById('admsym-grid');
    const countEl = document.getElementById('admsym-count');
    if (!grid) return;
    grid.innerHTML = '';
    if (countEl) countEl.textContent = `${list.length} symbole${list.length > 1 ? 's' : ''}`;

    if (!list.length) {
      grid.innerHTML = '<div style="color:var(--text3);font-size:12px;padding:30px;text-align:center">Aucun symbole trouvé</div>';
      return;
    }

    const cats = {};
    list.forEach(sym => (cats[sym.category] = cats[sym.category] || []).push(sym));

    Object.entries(cats).sort(([a],[b]) => a.localeCompare(b)).forEach(([cat, items]) => {
      // En-tête catégorie
      const hdr = document.createElement('div');
      hdr.style.cssText = 'display:flex;align-items:center;gap:8px;padding:8px 2px 5px;border-bottom:1px solid var(--border2);margin-bottom:6px;margin-top:12px;user-select:none';

      const chk = document.createElement('input'); chk.type = 'checkbox';
      chk.className = 'admsym-cat-chk';
      chk.style.cssText = 'accent-color:var(--accent);cursor:pointer;flex-shrink:0';
      chk.title = `Sélectionner toute la catégorie "${cat}"`;
      chk._catSyms = items;
      chk.addEventListener('change', () => {
        if (chk.checked) items.forEach(s => admsymSel.add(s.id));
        else items.forEach(s => admsymSel.delete(s.id));
        admsymSelUpdate();
      });

      const title = document.createElement('span');
      title.style.cssText = 'font-size:10px;font-weight:700;color:var(--text2);text-transform:uppercase;letter-spacing:.8px;flex:1';
      title.textContent = `${cat}  (${items.length})`;
      hdr.appendChild(chk); hdr.appendChild(title);
      grid.appendChild(hdr);

      // Grille
      const row = document.createElement('div');
      row.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(100px,1fr));gap:6px;margin-bottom:2px';

      items.sort((a,b) => a.name.localeCompare(b.name)).forEach(sym => {
        const canEdit = currentUser.role === 'admin' || (!sym.builtin && sym.created_by === currentUser.id);
        const item = document.createElement('div');
        item.className = 'admsym-item' + (admsymSel.has(sym.id) ? ' lib-selected' : '');
        item.dataset.symId = sym.id;
        item.style.cssText = `background:var(--panel2);border:1px solid ${sym.builtin ? 'rgba(59,158,255,.3)' : 'rgba(77,255,145,.2)'};border-radius:5px;padding:8px 4px 5px;display:flex;flex-direction:column;align-items:center;gap:3px;cursor:pointer;user-select:none;transition:all .12s;position:relative`;
        item.title = `${sym.name} — ${sym.builtin ? 'IEC intégré' : 'Personnalisé'}
Clic : sélectionner | Double-clic : éditer`;

        const pw = 72, ph = 50, c = document.createElement('canvas'); c.width = pw; c.height = ph;
        const c2 = c.getContext('2d'); c2.fillStyle = '#191d27'; c2.fillRect(0,0,pw,ph);
        const sc = Math.min((pw-8)/sym.width, (ph-8)/sym.height);
        drawSymPreview(c2, sym, (pw-sym.width*sc)/2, (ph-sym.height*sc)/2, sym.width*sc, sym.height*sc, sym.builtin ? '#3b9eff' : '#4dff91');
        item.appendChild(c);

        const lbl = document.createElement('div');
        lbl.style.cssText = 'font-size:9px;color:var(--text);text-align:center;line-height:1.3;word-break:break-word;max-width:100%';
        lbl.textContent = sym.name; item.appendChild(lbl);

        const badge = document.createElement('div');
        badge.style.cssText = `font-size:8px;font-weight:700;padding:1px 4px;border-radius:2px;${sym.builtin ? 'background:rgba(59,158,255,.15);color:var(--accent)' : 'background:rgba(77,255,145,.1);color:#4dff91'}`;
        badge.textContent = sym.builtin ? 'IEC' : 'Custom'; item.appendChild(badge);

        // Pastille public/privé cliquable (symboles personnalisés éditables uniquement)
        if (canEdit && !sym.builtin) {
          const pub = document.createElement('div');
          const setPubStyle = () => {
            pub.style.cssText = `position:absolute;top:4px;left:4px;font-size:8px;font-weight:700;padding:1px 4px;border-radius:2px;cursor:pointer;${sym.isPublic ? 'background:rgba(255,193,7,.18);color:#ffc107' : 'background:rgba(255,255,255,.06);color:var(--text3)'}`;
            pub.textContent = sym.isPublic ? '🌐 Public' : 'Privé';
            pub.title = sym.isPublic ? 'Symbole public (visible dans la recherche). Cliquer pour rendre privé.' : 'Symbole privé. Cliquer pour le rendre public.';
          };
          setPubStyle();
          pub.addEventListener('click', async (e) => {
            e.stopPropagation();
            try {
              const r = await fetch(`/api/symbols/${sym.id}/visibility`, {
                method: 'PATCH', credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ isPublic: !sym.isPublic }),
              });
              if (!r.ok) { setStatus('✗ Échec changement visibilité'); return; }
              sym.isPublic = !sym.isPublic; if (_symbols[sym.id]) _symbols[sym.id].isPublic = sym.isPublic;
              setPubStyle();
              setStatus(sym.isPublic ? '✓ Symbole rendu public' : '✓ Symbole rendu privé');
            } catch (err) { setStatus('✗ ' + err.message); }
          });
          item.appendChild(pub);
        }

        // Clic = sélection
        item.addEventListener('click', () => {
          clearTimeout(item._ct);
          item._ct = setTimeout(() => {
            if (admsymSel.has(sym.id)) admsymSel.delete(sym.id); else admsymSel.add(sym.id);
            admsymSelUpdate();
          }, 200);
        });
        // Double-clic = éditer
        if (canEdit) item.addEventListener('dblclick', () => {
          clearTimeout(item._ct);
          SymbolEditor.open(sym, async () => {
            await reloadSymbols(true); buildLibrary(document.getElementById('sym-search').value); buildAdmsymGrid();
          }, _symbols);
        });

        // Hover style
        item.addEventListener('mouseenter', () => { if (!admsymSel.has(sym.id)) item.style.borderColor = sym.builtin ? 'var(--accent)' : '#4dff91'; item.style.background = 'var(--panel3)'; });
        item.addEventListener('mouseleave', () => { if (!admsymSel.has(sym.id)) item.style.borderColor = sym.builtin ? 'rgba(59,158,255,.3)' : 'rgba(77,255,145,.2)'; item.style.background = 'var(--panel2)'; });

        row.appendChild(item);
      });
      grid.appendChild(row);
    });
  }

  function initAdmsymTab() {
    // Remplir filtre catégories
    const catSel = document.getElementById('admsym-filter-cat');
    if (catSel) {
      const cats = [...new Set(Object.values(_symbols).map(s => s.category))].sort();
      catSel.innerHTML = '<option value="">Toutes catégories</option>' + cats.map(c => `<option value="${esc(c)}">${esc(c)}</option>`).join('');
    }
    admsymSel.clear(); admsymSelUpdate();
    buildAdmsymGrid();

    // Filtres
    ['admsym-search','admsym-filter-cat','admsym-filter-type'].forEach(id => {
      document.getElementById(id)?.addEventListener('input', buildAdmsymGrid);
      document.getElementById(id)?.addEventListener('change', buildAdmsymGrid);
    });

    // Désélectionner tout
    document.getElementById('admsym-btn-desel')?.addEventListener('click', () => {
      admsymSel.clear(); admsymSelUpdate();
    });

    // Supprimer la sélection
    document.getElementById('admsym-btn-del')?.addEventListener('click', async () => {
      if (!admsymSel.size) return;
      const ids = [...admsymSel];
      const names = ids.map(id => _symbols[id]?.name || id).join(', ');
      if (!await showConfirm(`Supprimer ${ids.length} symbole(s) ?\n\n${names}\n\nCette action est irréversible.`)) return;
      let ok = 0, fail = 0, blocked = [];
      for (const id of ids) {
        const res = await fetch(`/api/symbols/${id}`, { method: 'DELETE', credentials: 'include' });
        if (res.ok) { ok++; continue; }
        if (res.status === 409) {
          // Symbole en cours d'utilisation : on bloque et on liste les folios concernés
          let data = {}; try { data = await res.json(); } catch (_) {}
          const folios = (data.folios || []).map(f => `• ${f.projectName || 'Projet'} › ${f.folioName || f.folioId}`);
          blocked.push(`"${_symbols[id]?.name || id}" utilisé dans ${data.count || folios.length} folio(s)` + (folios.length ? `\n${folios.slice(0, 8).join('\n')}` + (folios.length > 8 ? `\n…(+${folios.length - 8})` : '') : ''));
        } else { fail++; }
      }
      admsymSel.clear();
      await reloadSymbols(true); buildLibrary(document.getElementById('sym-search').value); buildAdmsymGrid();
      setStatus(`✓ ${ok} supprimé(s)${fail ? ` · ${fail} échec(s)` : ''}${blocked.length ? ` · ${blocked.length} bloqué(s)` : ''}`);
      if (blocked.length) await showConfirm(`Suppression impossible — symbole(s) en cours d'utilisation :\n\n${blocked.join('\n\n')}\n\nRetirez-les des folios concernés avant de les supprimer.`).catch(() => {});
    });

    // Passer en IEC
    document.getElementById('admsym-btn-iec')?.addEventListener('click', async () => {
      if (!admsymSel.size) return;
      const ids = [...admsymSel];
      const names = ids.map(id => _symbols[id]?.name || id).join(', ');
      if (!await showConfirm(`Passer ${ids.length} symbole(s) en IEC intégré ?\n\n${names}\n\nIls seront marqués builtin (admin uniquement pour les modifier).`)) return;
      let ok = 0, fail = 0;
      for (const id of ids) {
        const sym = _symbols[id]; if (!sym) continue;
        const res = await fetch(`/api/symbols/${id}`, {
          method: 'PUT', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...sym, builtin: true, paths: sym.paths, pins: sym.pins || [], fields: sym.fields || [] })
        });
        if (res.ok) ok++; else fail++;
      }
      admsymSel.clear();
      await reloadSymbols(true); buildLibrary(document.getElementById('sym-search').value); buildAdmsymGrid();
      setStatus(`✓ ${ok} passé(s) en IEC${fail ? ` · ${fail} échec(s)` : ''}`);
    });
  }

  let _admsymTabInited = false;

  function drawSymPreview(c2,sym,ex,ey,ew,eh,col){
    const scX=ew/sym.width,scY=eh/sym.height;
    (sym.paths||[]).forEach(p=>{
      c2.beginPath();c2.strokeStyle=col;c2.fillStyle=col;
      c2.lineWidth=(p.thick||1.5)*Math.min(scX,scY);c2.lineCap='round';c2.lineJoin='round';
      if(p.dash)c2.setLineDash(p.dash.map(v=>v*scX));else c2.setLineDash([]);
      switch(p.t){
        case 'L':if(!p.pts?.length)break;c2.moveTo(ex+p.pts[0].x*scX,ey+p.pts[0].y*scY);p.pts.slice(1).forEach(pt=>c2.lineTo(ex+pt.x*scX,ey+pt.y*scY));c2.stroke();break;
        case 'R':c2.strokeRect(ex+p.x*scX,ey+p.y*scY,p.w*scX,p.h*scY);break;
        case 'C':{const r=(p.r*scX+p.r*scY)/2;c2.arc(ex+p.cx*scX,ey+p.cy*scY,r,0,Math.PI*2);if(p.fill)c2.fill();else c2.stroke();break;}
        case 'A':{const r=(p.r*scX+p.r*scY)/2;c2.arc(ex+p.cx*scX,ey+p.cy*scY,r,p.a1??0,p.a2??Math.PI);c2.stroke();break;}
        case 'T':{const sz=(p.size||10)*Math.min(scX,scY);c2.font=`${sz}px monospace`;c2.textAlign=p.align||'left';c2.textBaseline='middle';c2.fillStyle=col;c2.fillText(p.text,ex+p.x*scX,ey+p.y*scY);break;}
      }c2.setLineDash([]);
    });
    (sym.pins||[]).forEach(pin=>{c2.beginPath();c2.arc(ex+pin.x*ew,ey+pin.y*eh,1.5,0,Math.PI*2);c2.fillStyle='#ff6340';c2.fill();});
  }

  // ─────────────────────────────────────────────────────────
  // RENDU PRINCIPAL
  // ─────────────────────────────────────────────────────────
  // ── Placer les numéros de fil sans chevauchement, distance max 10px au fil ──
  function _adjustWireNumOffsets() {
    const _P = window._PROJ || {};
    if (_P.numShow === false) return;
    const nSz  = _P.numSize || 9;
    const charW = nSz * 0.62;
    const boxH  = nSz + 5;
    const boxPad = 3;
    const MAX_PERP = 10; // distance max perpendiculaire au fil

    // ── distance point → segment ────────────────────────────────────────
    function distPtSeg(px, py, ax, ay, bx, by) {
      const dx=bx-ax, dy=by-ay, len2=dx*dx+dy*dy;
      if (len2===0) return Math.hypot(px-ax, py-ay);
      const t=Math.max(0,Math.min(1,((px-ax)*dx+(py-ay)*dy)/len2));
      return Math.hypot(px-(ax+t*dx), py-(ay+t*dy));
    }

    // ── bbox monde du numéro (position monde cx,cy, angle segAngle) ─────
    // Retourne les 4 coins du rectangle
    function numCorners(cx, cy, tw, angle) {
      const hw = tw/2 + boxPad, hh = boxH/2;
      const cos = Math.cos(angle), sin = Math.sin(angle);
      const corners = [[-hw,-hh],[hw,-hh],[hw,hh],[-hw,hh]];
      return corners.map(([lx,ly]) => ({
        x: cx + lx*cos - ly*sin,
        y: cy + lx*sin + ly*cos
      }));
    }

    // ── un côté de rect touche-t-il un segment de fil ? ─────────────────
    function segSeg(ax,ay,bx,by,cx,cy,dx,dy){
      const d=(bx-ax)*(dy-cy)-(by-ay)*(dx-cx);
      if(Math.abs(d)<1e-10) return false;
      const t=((cx-ax)*(dy-cy)-(cy-ay)*(dx-cx))/d;
      const u=((cx-ax)*(by-ay)-(cy-ay)*(bx-ax))/d;
      return t>=-0.01&&t<=1.01&&u>=-0.01&&u<=1.01;
    }
    function cornersHitSeg(corners, p1, p2) {
      for (let i=0;i<4;i++) {
        const a=corners[i], b=corners[(i+1)%4];
        if(segSeg(a.x,a.y,b.x,b.y,p1.x,p1.y,p2.x,p2.y)) return true;
      }
      // point de fil dans le rect (convexe) ?
      function ptInConvex(px,py,pts){
        for(let i=0;i<pts.length;i++){
          const a=pts[i],b=pts[(i+1)%pts.length];
          if((b.x-a.x)*(py-a.y)-(b.y-a.y)*(px-a.x)<0) return false;
        }
        return true;
      }
      return ptInConvex(p1.x,p1.y,corners)||ptInConvex(p2.x,p2.y,corners);
    }

    function bboxHitsAnyWire(cx, cy, tw, angle, skipWireId) {
      const corners = numCorners(cx, cy, tw, angle);
      for (const w of state.wires) {
        if (w.id === skipWireId) continue;
        const pts = w.points;
        for (let i=0;i<pts.length-1;i++) {
          if (cornersHitSeg(corners, pts[i], pts[i+1])) return true;
        }
      }
      return false;
    }

    // ── Déduplication : masquer les numéros redondants sur fils connectés ──
    // Construire les groupes de fils connectés ayant le même numéro
    const _numGroups = {}; // num → [ [wireIds connectés] ]
    const _wireById = {};
    for (const w of state.wires) { _wireById[w.id] = w; w._numHidden = false; }
    // Adjacence simplifiée par extrémités proches (TOL=10)
    const _adjNum = {};
    for (const w of state.wires) _adjNum[w.id] = new Set();
    for (let i = 0; i < state.wires.length; i++) {
      const a = state.wires[i]; if (!a.num) continue;
      const aE = [a.points[0], a.points[a.points.length-1]];
      for (let j = i+1; j < state.wires.length; j++) {
        const b = state.wires[j]; if (b.num !== a.num) continue;
        const bE = [b.points[0], b.points[b.points.length-1]];
        for (const ap of aE) for (const bp of bE) {
          if (Math.hypot(ap.x-bp.x, ap.y-bp.y) < 12) {
            _adjNum[a.id].add(b.id); _adjNum[b.id].add(a.id);
          }
        }
      }
    }
    // BFS pour grouper
    const _visited = new Set();
    for (const w of state.wires) {
      if (!w.num || _visited.has(w.id)) continue;
      const group = []; const q = [w.id]; _visited.add(w.id);
      while (q.length) {
        const cur = q.shift(); group.push(cur);
        for (const nid of (_adjNum[cur] || [])) {
          if (!_visited.has(nid)) { _visited.add(nid); q.push(nid); }
        }
      }
      if (group.length > 1) {
        // Préférer le fil marqué numOwner (déplacé manuellement), sinon le plus long
        let bestId = null;
        for (const gid of group) {
          const gw = _wireById[gid]; if (gw && gw.numOwner) { bestId = gid; break; }
        }
        if (!bestId) {
          bestId = group[0]; let bestLen = 0;
          for (const gid of group) {
            const gw = _wireById[gid]; if (!gw) continue;
            let len = 0;
            for (let k = 0; k < gw.points.length-1; k++) {
              len += Math.hypot(gw.points[k+1].x-gw.points[k].x, gw.points[k+1].y-gw.points[k].y);
            }
            if (len > bestLen) { bestLen = len; bestId = gid; }
          }
        }
        for (const gid of group) {
          if (gid !== bestId) _wireById[gid]._numHidden = true;
        }
      }
    }

    for (const wire of state.wires) {
      if (!wire.num || wire._numHidden) { wire._numAdjX=undefined; wire._numAdjY=undefined; continue; }
      const pts = wire.points;
      const midIdx = Math.max(0, Math.floor((pts.length-1)/2));
      const p1 = pts[midIdx], p2 = pts[Math.min(midIdx+1, pts.length-1)];
      const mx = (p1.x+p2.x)/2, my = (p1.y+p2.y)/2;

      // Angle du segment (normalisé -90° .. +90°)
      let segAngle = wire.numAngle !== undefined
        ? wire.numAngle * Math.PI / 180
        : Math.atan2(p2.y-p1.y, p2.x-p1.x);
      if (segAngle >  Math.PI/2) segAngle -= Math.PI;
      if (segAngle < -Math.PI/2) segAngle += Math.PI;

      const baseOffX = wire.numOffX || 0;
      const baseOffY = wire.numOffY !== undefined ? wire.numOffY : -10;
      const tw = wire.num.length * charW;

      // Vecteur perpendiculaire (espace monde) au fil
      const perpX = -Math.sin(segAngle); // unitaire ⊥ au fil
      const perpY =  Math.cos(segAngle);

      // Position monde du numéro depuis offsets locaux (espace segment)
      const cosA = Math.cos(segAngle), sinA = Math.sin(segAngle);
      function localToWorld(lx, ly) {
        return {
          x: mx + lx*cosA - ly*sinA,
          y: my + lx*sinA + ly*cosA
        };
      }

      // Essayer les positions candidates par ordre de préférence :
      // d'abord la position manuelle/par défaut, puis alterner ±perp dans la limite de 10px
      const candidates = [];
      // Positions perpendiculaires candidates (en unités monde perpendiculaires)
      const perpSteps = [0, -MAX_PERP, MAX_PERP, -MAX_PERP/2, MAX_PERP/2];
      // Décalages parallèles (le long du fil) pour débloquer si rien ne marche
      const paraSteps = [0, 8, -8, 16, -16];

      for (const para of paraSteps) {
        for (const perp of perpSteps) {
          // Convertir en offsets locaux
          const lx = baseOffX + para;
          // perp en espace monde → composante Y locale
          // En espace local du segment, Y est la direction perpendiculaire
          const ly = baseOffY + perp;
          // Contrainte : |ly| ≤ MAX_PERP (distance perpendiculaire au fil)
          if (Math.abs(ly) > MAX_PERP + 1) continue;
          candidates.push({lx, ly});
        }
      }
      // Toujours inclure la position naturelle en premier
      candidates.unshift({lx: baseOffX, ly: baseOffY > MAX_PERP ? MAX_PERP : (baseOffY < -MAX_PERP ? -MAX_PERP : baseOffY)});

      let chosen = {lx: baseOffX, ly: Math.max(-MAX_PERP, Math.min(MAX_PERP, baseOffY))};
      for (const {lx, ly} of candidates) {
        const wpos = localToWorld(lx, ly);
        if (!bboxHitsAnyWire(wpos.x, wpos.y, tw, segAngle, wire.id)) {
          chosen = {lx, ly};
          break;
        }
      }
      wire._numAdjX = chosen.lx;
      wire._numAdjY = chosen.ly;
    }
  }


  // LiveSync défini dans app-livesync.js (inclus dans l'IIFE)


  // ── Rendu des ghosts de drag des pairs ────────────────────────────────
  // Dessine les tracés en cours (wireIP / shapeIP) des autres utilisateurs
  function _drawPeerDrawings(ctx) {
    for (const [sid, p] of Object.entries(LiveSync._getPeers())) {
      // Pas de filtre ici — _getPeers() provient de LiveSync qui gère déjà le filtre
      if (!p.drawing) continue;
      const col = LiveSync._peerColor(sid);
      const d = p.drawing;

      ctx.save();
      ctx.globalAlpha = 0.70;

      if (d.tool === 'wire' || d.tool === 'bus') {
        // ── Fil / bus en cours ───────────────────────────────────────
        Renderer.drawWireInProgress(ctx, d.pts, d.pts[d.pts.length-1], d.tool==='bus');
        // Surlignage coloré pair
        ctx.globalAlpha = 0.5;
        ctx.strokeStyle = col;
        ctx.lineWidth = (d.tool==='bus' ? 3 : 1.8) / view.zoom + 1.5/view.zoom;
        ctx.setLineDash([6/view.zoom, 3/view.zoom]);
        ctx.beginPath();
        d.pts.forEach((p,i) => i===0 ? ctx.moveTo(p.x,p.y) : ctx.lineTo(p.x,p.y));
        ctx.stroke();
        ctx.setLineDash([]);
      } else if (d.tool === 'rect' && d.pts && d.pts.length >= 1) {
        // ── Rectangle en cours ───────────────────────────────────────
        const p0 = d.pts[0], cur = d.cursor || d.pts[d.pts.length-1];
        const x=Math.min(p0.x,cur.x), y=Math.min(p0.y,cur.y);
        const w=Math.abs(cur.x-p0.x)||2, h=Math.abs(cur.y-p0.y)||2;
        ctx.strokeStyle = col; ctx.lineWidth = (d.thick||1.5)/view.zoom;
        ctx.setLineDash([4/view.zoom,3/view.zoom]);
        ctx.strokeRect(x, y, w, h);
        if (d.fill) { ctx.fillStyle=col; ctx.globalAlpha=0.12; ctx.fillRect(x,y,w,h); }
        ctx.setLineDash([]);
      } else if (d.tool === 'circle' && d.pts && d.pts.length >= 1) {
        // ── Cercle en cours ──────────────────────────────────────────
        const p0=d.pts[0], cur=d.cursor||d.pts[d.pts.length-1];
        const r=Math.hypot(cur.x-p0.x, cur.y-p0.y)||2;
        ctx.strokeStyle = col; ctx.lineWidth = (d.thick||1.5)/view.zoom;
        ctx.setLineDash([4/view.zoom,3/view.zoom]);
        ctx.beginPath(); ctx.arc(p0.x,p0.y,r,0,Math.PI*2); ctx.stroke();
        if (d.fill) { ctx.fillStyle=col; ctx.globalAlpha=0.10; ctx.fill(); }
        ctx.setLineDash([]);
      } else if (d.tool === 'arc' && d.pts && d.pts.length >= 1) {
        // ── Arc en cours ─────────────────────────────────────────────
        const p0=d.pts[0], cur=d.cursor||d.pts[d.pts.length-1];
        if (d.pts.length === 1) {
          // Phase 1 : rayon
          ctx.strokeStyle = col; ctx.lineWidth = 1/view.zoom;
          ctx.setLineDash([3/view.zoom,2/view.zoom]);
          ctx.beginPath(); ctx.moveTo(p0.x,p0.y); ctx.lineTo(cur.x,cur.y); ctx.stroke();
        } else {
          const r=d.pts[1].r||Math.hypot(d.pts[1].x-p0.x,d.pts[1].y-p0.y)||2;
          const a1=d.pts[1].a1||0;
          const a2=Math.atan2(cur.y-p0.y, cur.x-p0.x);
          ctx.strokeStyle = col; ctx.lineWidth = (d.thick||1.5)/view.zoom;
          ctx.setLineDash([4/view.zoom,3/view.zoom]);
          ctx.beginPath(); ctx.arc(p0.x,p0.y,r,a1,a2); ctx.stroke();
        }
        ctx.setLineDash([]);
      } else if ((d.tool === 'line' || d.tool === 'poly') && d.pts && d.pts.length >= 1) {
        // ── Ligne / polygone en cours ────────────────────────────────
        const cur = d.cursor || d.pts[d.pts.length-1];
        ctx.strokeStyle = col; ctx.lineWidth = (d.thick||1.5)/view.zoom;
        ctx.lineCap='round'; ctx.lineJoin='round';
        ctx.setLineDash([4/view.zoom,3/view.zoom]);
        ctx.beginPath();
        d.pts.forEach((pt,i) => i===0 ? ctx.moveTo(pt.x,pt.y) : ctx.lineTo(pt.x,pt.y));
        ctx.lineTo(cur.x, cur.y); // segment vers curseur courant
        ctx.stroke();
        ctx.setLineDash([]);
      }

      // Étiquette nom du pair au curseur
      const lastPt = d.cursor || (d.pts && d.pts[d.pts.length-1]);
      if (lastPt) {
        ctx.globalAlpha = 0.85;
        ctx.font = `bold ${10/view.zoom}px monospace`;
        ctx.fillStyle = col;
        ctx.textBaseline = 'bottom';
        ctx.fillText(p.name, lastPt.x + 6/view.zoom, lastPt.y - 4/view.zoom);
      }

      ctx.restore();
    }
  }

  function _drawPeerDragGhosts(ctx) {
    const drags = LiveSync.getPeerDrags();
    if (!Object.keys(drags).length) return;

    for (const [sid, pd] of Object.entries(drags)) {
      const col = pd.color;
      ctx.save();
      ctx.globalAlpha = 0.45;

      for (const item of pd.items) {
        if (item.type === 'element') {
          // Dessiner le symbole ghost (outline coloré + fond léger)
          // item.x,y = coin supérieur gauche (identique à el.x,y dans drawSymbol)
          const sym = _symbols[item.symId];
          const w = item.w || (sym ? sym.width : 60) || 60, h = item.h || (sym ? sym.height : 60) || 60;
          // Cadre ghost — coin supérieur gauche = item.x, item.y
          ctx.strokeStyle = col;
          ctx.lineWidth = 1.5 / view.zoom;
          ctx.setLineDash([4 / view.zoom, 3 / view.zoom]);
          ctx.strokeRect(item.x, item.y, w, h);
          ctx.fillStyle = col + '14';
          ctx.fillRect(item.x, item.y, w, h);
          ctx.setLineDash([]);
          // Nom du pair au-dessus
          ctx.fillStyle = col;
          ctx.font = `600 ${10 / view.zoom}px 'JetBrains Mono', monospace`;
          ctx.textAlign = 'left';
          ctx.textBaseline = 'bottom';
          ctx.fillText(pd.name, item.x, item.y - 3 / view.zoom);
        } else if (item.type === 'wire' && item.pts && item.pts.length >= 2) {
          ctx.strokeStyle = col;
          ctx.lineWidth = 2 / view.zoom;
          ctx.setLineDash([5 / view.zoom, 3 / view.zoom]);
          ctx.beginPath();
          ctx.moveTo(item.pts[0].x, item.pts[0].y);
          for (let i = 1; i < item.pts.length; i++) ctx.lineTo(item.pts[i].x, item.pts[i].y);
          ctx.stroke();
          ctx.setLineDash([]);
        } else if ((item.type === 'text' || item.type === 'image' || item.type === 'shape') && item.x != null) {
          ctx.strokeStyle = col;
          ctx.lineWidth = 1.5 / view.zoom;
          ctx.setLineDash([4 / view.zoom, 3 / view.zoom]);
          ctx.strokeRect(item.x - 20, item.y - 12, 40, 24);
          ctx.setLineDash([]);
        }
      }
      ctx.restore();
    }
  }

  // ── Rendu du repère orthogonal (lettres/chiffres autour de la zone d'impression) ──
  function _drawRefGrid(ctx){
    const pz = printZone;
    const t  = refGrid.thickness || 15;      // épaisseur de la bande de repère
    const nc = refGrid.cols || 20;            // nombre de colonnes (chiffres)
    const nr = refGrid.rows || 9;             // nombre de lignes (lettres)
    const cw = pz.w / nc;                     // largeur d'une case colonne
    const rh = pz.h / nr;                     // hauteur d'une case ligne
    const x0 = pz.x, y0 = pz.y;
    const x1 = pz.x + pz.w, y1 = pz.y + pz.h;

    ctx.save();
    ctx.strokeStyle = '#6b7494';
    ctx.fillStyle   = '#0d1117';
    ctx.lineWidth   = 0.5;
    ctx.font        = `bold ${Math.min(t*0.7, cw*0.5, rh*0.5)}px "JetBrains Mono",monospace`;
    ctx.textAlign   = 'center';
    ctx.textBaseline= 'middle';

    // ── Bandes horizontales (haut et bas — chiffres) ─────────
    // Haut
    ctx.fillStyle='rgba(13,17,23,.85)';
    ctx.fillRect(x0, y0-t, pz.w, t);
    ctx.strokeRect(x0, y0-t, pz.w, t);
    // Bas
    ctx.fillRect(x0, y1, pz.w, t);
    ctx.strokeRect(x0, y1, pz.w, t);

    ctx.fillStyle='#8b95b8';
    for(let c=0; c<nc; c++){
      const cx = x0 + c*cw + cw/2;
      const label = String(c+1);
      // Haut
      ctx.fillText(label, cx, y0 - t/2);
      // Bas
      ctx.fillText(label, cx, y1 + t/2);
      // Séparateurs verticaux
      if(c>0){
        ctx.beginPath();
        ctx.moveTo(x0 + c*cw, y0-t); ctx.lineTo(x0 + c*cw, y0);
        ctx.moveTo(x0 + c*cw, y1);   ctx.lineTo(x0 + c*cw, y1+t);
        ctx.stroke();
      }
    }

    // ── Bandes verticales (gauche et droite — lettres) ───────
    ctx.fillStyle='rgba(13,17,23,.85)';
    // Gauche
    ctx.fillRect(x0-t, y0, t, pz.h);
    ctx.strokeRect(x0-t, y0, t, pz.h);
    // Droite
    ctx.fillRect(x1, y0, t, pz.h);
    ctx.strokeRect(x1, y0, t, pz.h);

    ctx.fillStyle='#8b95b8';
    for(let r=0; r<nr; r++){
      const cy = y0 + r*rh + rh/2;
      const letter = String.fromCharCode(65 + r); // A, B, C...
      // Gauche
      ctx.fillText(letter, x0 - t/2, cy);
      // Droite
      ctx.fillText(letter, x1 + t/2, cy);
      // Séparateurs horizontaux
      if(r>0){
        ctx.beginPath();
        ctx.moveTo(x0-t, y0 + r*rh); ctx.lineTo(x0, y0 + r*rh);
        ctx.moveTo(x1,   y0 + r*rh); ctx.lineTo(x1+t, y0 + r*rh);
        ctx.stroke();
      }
    }

    // ── 4 coins (carrés vides) ───────────────────────────────
    ctx.fillStyle='rgba(13,17,23,.85)';
    ctx.fillRect(x0-t, y0-t, t, t); ctx.strokeRect(x0-t, y0-t, t, t);
    ctx.fillRect(x1,   y0-t, t, t); ctx.strokeRect(x1,   y0-t, t, t);
    ctx.fillRect(x0-t, y1,   t, t); ctx.strokeRect(x0-t, y1,   t, t);
    ctx.fillRect(x1,   y1,   t, t); ctx.strokeRect(x1,   y1,   t, t);

    ctx.restore();
  }

  function render(){
    window._appRender = render;
    // Recalcul de la carte de tensions si l'état a changé
    if (_voltageDirty) computeVoltages();

    ctx.clearRect(0,0,canvas.width,canvas.height);
    if(gridVisible)Renderer.drawGrid(ctx,canvas,{x:view.panX,y:view.panY},view.zoom,GRID);

    ctx.save();
    ctx.translate(view.panX,view.panY);
    ctx.scale(view.zoom,view.zoom);

    // Cartouche — toujours rendu si disponible (indépendant de printZone.show)
    if(!_cartoucheEditMode && printZone.withCartouche!==false){
      const _tbData=TitleBlock.getActiveTB();
      if(_tbData) TitleBlock.drawOnCanvas(ctx,_tbData,false);
    }

    // Zone impression (contour + label)
    if(_cartoucheEditMode){
      ctx.strokeStyle='#1a3a6b';ctx.lineWidth=2/view.zoom;ctx.setLineDash([]);
      ctx.strokeRect(printZone.x,printZone.y,printZone.w,printZone.h);
    } else if(printZone.show){
      ctx.strokeStyle='rgba(255,179,64,.55)';ctx.lineWidth=1/view.zoom;ctx.setLineDash([6/view.zoom,3/view.zoom]);
      ctx.strokeRect(printZone.x,printZone.y,printZone.w,printZone.h);ctx.setLineDash([]);
      ctx.fillStyle='rgba(255,179,64,.03)';ctx.fillRect(printZone.x,printZone.y,printZone.w,printZone.h);
      ctx.fillStyle='rgba(255,179,64,.6)';ctx.font=`${10/view.zoom}px monospace`;ctx.textBaseline='top';
      ctx.fillText(`Zone impression ${printZone.w}×${printZone.h}`,printZone.x+4/view.zoom,printZone.y+4/view.zoom);
    }

    // ── Repère orthogonal (lettres/chiffres) ────────────────────
    if(refGrid.show && printZone.w>0 && printZone.h>0){
      _drawRefGrid(ctx);
    }

    // Ghosts de drag des autres utilisateurs (live)
    _drawPeerDragGhosts(ctx);

    // Tracés en cours des autres utilisateurs (live)
    _drawPeerDrawings(ctx);

    // Curseurs des autres utilisateurs (live — DOM overlay)
    LiveSync.drawPeerCursors(ctx);
    LiveSync._updatePeerCursorDom();

    // Rubber-band
    if(rubberBand){
      const rb=rubberBandWorld();
      if(rb&&rb.w!==0&&rb.h!==0){
        ctx.strokeStyle='rgba(59,158,255,.75)';ctx.lineWidth=1/view.zoom;ctx.setLineDash([4/view.zoom,2/view.zoom]);
        const x=Math.min(rb.x,rb.x+rb.w),y=Math.min(rb.y,rb.y+rb.h),w=Math.abs(rb.w),h=Math.abs(rb.h);
        ctx.strokeRect(x,y,w,h);ctx.setLineDash([]);
        ctx.fillStyle='rgba(59,158,255,.06)';ctx.fillRect(x,y,w,h);
      }
    }

    // Guides d'alignement snap (pendant un drag)
    if(_snapGuides.length){
      ctx.save();
      ctx.strokeStyle='rgba(255,80,80,.75)';
      ctx.lineWidth=0.6/view.zoom;
      ctx.setLineDash([5/view.zoom,3/view.zoom]);
      _snapGuides.forEach(g=>{
        ctx.beginPath();
        if(g.type==='v'){ctx.moveTo(g.x,-1e5);ctx.lineTo(g.x,1e5);}
        else{ctx.moveTo(-1e5,g.y);ctx.lineTo(1e5,g.y);}
        ctx.stroke();
      });
      ctx.setLineDash([]);
      ctx.restore();
    }

    // Formes géométriques
    state.shapes.forEach(sh=>{
      drawShape(ctx,sh,isInMultiSel('shape',sh.id)||isSel('shape',sh.id));
      // Halo pulse pour les shapes en _blink (highlight temporaire)
      if(sh._blink){
        ctx.save();
        ctx.strokeStyle='rgba(255,179,64,'+(_blinkAlpha*2.5).toFixed(2)+')';
        ctx.lineWidth=(sh.thick||1.5)+12;
        ctx.setLineDash([]);
        ctx.beginPath();
        if(sh.t==='rect'||sh.t==='textbox')ctx.rect(sh.x,sh.y,sh.w,sh.h);
        else if(sh.t==='circle')ctx.arc(sh.cx,sh.cy,sh.r,0,Math.PI*2);
        else if(sh.pts?.length){ctx.moveTo(sh.pts[0].x,sh.pts[0].y);sh.pts.slice(1).forEach(p=>ctx.lineTo(p.x,p.y));}
        ctx.stroke();
        ctx.restore();
      }
    });
    // Continuer l'animation si un shape est en blink
    if(state.shapes.some(sh=>sh._blink)) requestAnimationFrame(()=>render());
    // Poignées de resize sur la forme sélectionnée (sélection unique)
    if(selected.type==='shape' && multiSel.size<=1 && Renderer.drawShapeHandles){
      const selSh=state.shapes.find(s=>s.id===selected.id);
      if(selSh) Renderer.drawShapeHandles(ctx, selSh);
    }
    // Forme en cours
    if(shapeIP)drawShapeIP(ctx,shapeIP,cursorWorld);

    // Fils — pré-calcul des offsets Y de numéros pour éviter les collisions
    if(!_cartoucheEditMode){
    _adjustWireNumOffsets();
    const _hlActive = _xrefHighlight && _xrefHighlight.until > Date.now();
    state.wires.forEach(w => {
      const wSel = isInMultiSel('wire',w.id)||isSel('wire',w.id);
      const hl = _hlActive && w.id === _xrefHighlight.wireId;
      Renderer.drawWire(ctx, w, wSel, _voltageMap[w.id]||null,
        _conflictWires.has(w.id)||_conflictNumWires.has(w.id), _blinkAlpha, hl);
    });
    // Continuer l'animation de clignotement xref
    if (_hlActive) requestAnimationFrame(() => render());
    if(wireIP)Renderer.drawWireInProgress(ctx,wireIP.points,cursorWorld,wireIP.isBus);
    }
    // Mesures figées (multi-mesures)
    _measures.forEach(m => drawMeasure(ctx, m, m.color));
    // Mesure en cours
    if(measureIP) drawMeasure(ctx, measureIP);
    // Mesures des peers
    const _pm = LiveSync.getPeerMeasures();
    for(const [uid, measures] of Object.entries(_pm)){
      const col = LiveSync._peerColor(uid);
      measures.forEach(m => drawMeasure(ctx, {...m, color:col}));
    }

    // Nœuds de connexion (junctions)
    if(!_cartoucheEditMode)
    (state.junctions||[]).forEach(j=>{
      const jSel = isSel('junction',j.x+','+j.y) || isInMultiSel('junction',j.x+','+j.y);
      const r = PROJ.junctionRadius||4;
      if(jSel){
        ctx.beginPath();ctx.arc(j.x,j.y,r+4,0,Math.PI*2);
        ctx.fillStyle='rgba(59,158,255,.25)';ctx.fill();
        ctx.strokeStyle='rgba(59,158,255,.8)';ctx.lineWidth=1.5;ctx.stroke();
      }
      ctx.beginPath();ctx.arc(j.x,j.y,r,0,Math.PI*2);
      ctx.fillStyle=jSel?'#ffb340':PROJ.junctionColor;ctx.fill();
    });

    // Symboles
    if(!_cartoucheEditMode)
    state.elements.forEach(el=>{
      const sym=_symbols[el.symId];if(!sym)return;
      Renderer.drawSymbol(ctx,sym,el,isInMultiSel('element',el.id)||isSel('element',el.id),hovered===el.id,
        _conflictEls.has(el.id), _blinkAlpha);
      // Halo de clignotement BOM (navigation depuis la nomenclature)
      // Petit indicateur de liaison sur les contacts liés (icône cliquable, pas de référence supplémentaire)
      if(el.coilRef) {
        const _bw = el.w||sym.width||60, _bh = el.h||sym.height||40;
        const _bx = el.x + _bw/2;
        const _by = el.y + _bh + 4/view.zoom;
        ctx.save();
        ctx.font = `bold ${Math.max(7, 8/view.zoom)}px 'JetBrains Mono',monospace`;
        const _bt = '⛓';
        const _btw = ctx.measureText(_bt).width;
        const _bpad = 2.5/view.zoom;
        ctx.fillStyle = 'rgba(245,166,35,.12)';
        ctx.strokeStyle = 'rgba(245,166,35,.4)';
        ctx.lineWidth = 0.6/view.zoom;
        const _brx = _bx - _btw/2 - _bpad, _bry = _by - _bpad;
        ctx.beginPath();
        ctx.roundRect?.(_brx, _bry, _btw + _bpad*2, Math.max(7,8/view.zoom) + _bpad*2, 2/view.zoom);
        ctx.fill(); ctx.stroke();
        ctx.fillStyle = '#f5a623';
        ctx.textAlign = 'center'; ctx.textBaseline = 'top';
        ctx.fillText(_bt, _bx, _by);
        ctx.restore();
      }

      if(el._blink){
        const ew=el.w||sym.width||60, eh=el.h||sym.height||40;
        // el.x,y = coin supérieur gauche (même système que drawSymbol)
        const ex=el.x, ey=el.y;
        const pad=6/view.zoom;
        ctx.save();
        ctx.strokeStyle='#f5a623';
        ctx.lineWidth=3/view.zoom;
        ctx.shadowColor='#f5a623';
        ctx.shadowBlur=14/view.zoom;
        ctx.strokeRect(ex-pad, ey-pad, ew+pad*2, eh+pad*2);
        ctx.shadowBlur=0;
        ctx.fillStyle='rgba(245,166,35,.10)';
        ctx.fillRect(ex-pad, ey-pad, ew+pad*2, eh+pad*2);
        ctx.restore();
      }
    });

    // Textes
    state.texts.forEach(t=>Renderer.drawText(ctx,t,isInMultiSel('text',t.id)||isSel('text',t.id)));
    (state.images||[]).forEach(img=>Renderer.drawImage(ctx,img,isInMultiSel('image',img.id)||isSel('image',img.id)));

    // Fantôme du placement de fonction
    if (_funcPlacement) _drawFuncPreview(ctx);

    ctx.restore();
    Renderer.renderMinimap(document.getElementById('minimap'),state,{panX:view.panX,panY:view.panY,zoom:view.zoom,w:canvas.width,h:canvas.height});
  }

  // ── Dessin formes libres ───────────────────────────────────
  // ── Styles de trait ───────────────────────────────────────────
  // stroke: { style:'solid'|'dash-fine'|'dash-med'|'dash-large'|'dot'|'axis'|'stripe-bw'|'stripe-col',
  //           color2:'#hex' (pour stripe) }
  const STROKE_STYLES = {
    'solid':       { label:'Continu',         icon:'───' },
    'dash-fine':   { label:'Pointillé fin',   icon:'╌╌╌' },
    'dash-med':    { label:'Tiret moyen',     icon:'┄┄┄' },
    'dash-large':  { label:'Tiret large',     icon:'╍╍╍' },
    'dot':         { label:'Points',          icon:'···' },
    'axis':        { label:'Axe (-.-.)',      icon:'─·─' },
    'stripe-bw':   { label:'Rayure N&B',      icon:'▓░▓' },
    'stripe-col':  { label:'Rayure bicolore', icon:'▓▒▓' },
  };

  function getLineDash(style, thick) {
    const t = thick || 1.5;
    switch(style) {
      case 'dash-fine':  return [t*2,   t*2];
      case 'dash-med':   return [t*4,   t*2];
      case 'dash-large': return [t*8,   t*3];
      case 'dot':        return [t*0.5, t*2.5];
      case 'axis':       return [t*6,   t*2, t*1, t*2];
      default:           return [];
    }
  }

  function drawShape(ctx, sh, isSel) {
    if(sh.t==='group'){
      if(isSel){
        const bb=groupBBox(sh);
        ctx.save();ctx.strokeStyle='rgba(255,179,64,.5)';ctx.lineWidth=1.5;ctx.setLineDash([4,3]);
        ctx.strokeRect(bb.x-4,bb.y-4,bb.w+8,bb.h+8);ctx.setLineDash([]);ctx.restore();
      }
      sh.children.forEach(child=>drawShape(ctx,child,false));
      return;
    }

    const col   = sh.color  || '#3b9eff';
    const col2  = sh.color2 || '#ffffff';
    const thick = sh.thick  || 1.5;
    const style = sh.stroke || 'solid';
    const isStripe = style==='stripe-bw'||style==='stripe-col';

    ctx.save();
    // Rotation pour textbox
    const _tbAngle = (sh.t === 'textbox' && sh.angle) ? sh.angle * Math.PI / 180 : 0;
    if (_tbAngle) {
      const cx = sh.x + sh.w / 2, cy = sh.y + sh.h / 2;
      ctx.translate(cx, cy);
      ctx.rotate(_tbAngle);
      ctx.translate(-cx, -cy);
    }
    ctx.lineWidth   = thick;
    ctx.lineCap     = 'round';
    ctx.lineJoin    = 'round';

    // Halo de sélection
    if(isSel){
      ctx.strokeStyle='rgba(255,179,64,.25)';
      ctx.lineWidth=thick+10;
      ctx.setLineDash([]);
      _drawShapeGeom(ctx,sh);ctx.stroke();
      ctx.lineWidth=thick;
    }

    if(isStripe){
      // Passe 1 : trait plein couleur principale
      ctx.strokeStyle = isSel?'#ffb340':col;
      ctx.fillStyle   = isSel?'rgba(255,179,64,.18)':(sh.fill?col:'transparent');
      ctx.setLineDash([]);
      _drawShapeGeom(ctx,sh);
      if(sh.fill&&(sh.t==='rect'||sh.t==='textbox'||sh.t==='circle'||sh.t==='poly'))ctx.fill();
      ctx.stroke();
      // Passe 2 : tirets couleur secondaire par-dessus
      const c2 = style==='stripe-bw'?'#ffffff':col2;
      ctx.strokeStyle = c2;
      ctx.setLineDash([thick*3, thick*3]);
      _drawShapeGeom(ctx,sh);ctx.stroke();
    } else {
      ctx.strokeStyle = isSel?'#ffb340':col;
      ctx.fillStyle   = isSel?'rgba(255,179,64,.18)':(sh.fill?col:'transparent');
      ctx.setLineDash(getLineDash(style, thick));
      _drawShapeGeom(ctx,sh);
      if(sh.fill&&(sh.t==='rect'||sh.t==='textbox'||sh.t==='circle'||sh.t==='poly'))ctx.fill();
      ctx.stroke();
    }

    // ── Zone de texte (textbox) ──────────────────────────────
    if (sh.t === 'textbox') {
      ctx.save();
      const pad = sh.padding || 4;
      const noBorder = style === 'none';
      if (sh.fill) { ctx.fillStyle = col || 'rgba(255,255,255,.05)'; ctx.fillRect(sh.x, sh.y, sh.w, sh.h); }
      if (!noBorder || isSel) {
        ctx.strokeStyle = isSel ? '#ffb340' : col;
        ctx.lineWidth = sh.thick || 0.5;
        ctx.setLineDash(noBorder ? [3, 3] : getLineDash(style, sh.thick || 0.5));
        ctx.globalAlpha = noBorder ? 0.3 : 1;
        ctx.strokeRect(sh.x, sh.y, sh.w, sh.h);
        ctx.globalAlpha = 1;
        ctx.setLineDash([]);
      }
      if (sh.text) {
        const tc = sh.textColor || col || '#dde1ed';
        const fs = sh.fontSize || 11;
        ctx.fillStyle = tc;
        ctx.font = `${fs}px "JetBrains Mono",monospace`;
        ctx.textBaseline = 'top';
        ctx.textAlign = sh.align || 'left';
        const maxW = sh.w - pad * 2;
        const lineH = fs * 1.3;
        // Word-wrap
        const paragraphs = sh.text.split('\n');
        const lines = [];
        for (const para of paragraphs) {
          if (!para) { lines.push(''); continue; }
          const words = para.split(/\s+/);
          let line = '';
          for (const word of words) {
            const test = line ? line + ' ' + word : word;
            if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = word; }
            else line = test;
          }
          lines.push(line);
        }
        const totalH = lines.length * lineH;
        let startY = sh.y + pad;
        if (sh.valign === 'middle') startY = sh.y + (sh.h - totalH) / 2;
        else if (sh.valign === 'bottom') startY = sh.y + sh.h - totalH - pad;
        let textX = sh.x + pad;
        if (sh.align === 'center') textX = sh.x + sh.w / 2;
        else if (sh.align === 'right') textX = sh.x + sh.w - pad;
        ctx.save();
        ctx.beginPath(); ctx.rect(sh.x, sh.y, sh.w, sh.h); ctx.clip();
        lines.forEach((line, i) => { ctx.fillText(line, textX, startY + i * lineH); });
        ctx.restore();
      }
      ctx.restore();
    }

    ctx.setLineDash([]);
    ctx.restore();
  }
  function groupBBox(sh){
    let x0=Infinity,y0=Infinity,x1=-Infinity,y1=-Infinity;
    sh.children.forEach(child=>{
      const bb=getObjBBox('shape',child);
      x0=Math.min(x0,bb.x);y0=Math.min(y0,bb.y);
      x1=Math.max(x1,bb.x+bb.w);y1=Math.max(y1,bb.y+bb.h);
    });
    return{x:x0,y:y0,w:x1-x0,h:y1-y0};
  }
  function _drawShapeGeom(ctx,sh){
    ctx.beginPath();
    if(sh.t==='line'||sh.t==='poly'){
      if(!sh.pts?.length)return;
      ctx.moveTo(sh.pts[0].x,sh.pts[0].y);sh.pts.slice(1).forEach(p=>ctx.lineTo(p.x,p.y));
      if(sh.closed)ctx.closePath();
    }else if(sh.t==='rect'||sh.t==='textbox'){
      ctx.rect(sh.x,sh.y,sh.w,sh.h);
    }else if(sh.t==='circle'){
      ctx.arc(sh.cx,sh.cy,sh.r,0,Math.PI*2);
    }else if(sh.t==='arc'){
      ctx.arc(sh.cx,sh.cy,sh.r,sh.a1||0,sh.a2||Math.PI);
    }
  }

  // ── Outil mesure : rendu canvas ────────────────────────────────────────
  // ── Conversion valeur selon unité ──────────────────────────────────────
  function _measureConvert(px) {
    const {unit, scale} = _measureCfg;
    const v = px * scale;
    switch(unit) {
      case 'mm': return {v, label: v < 10 ? v.toFixed(2) : v.toFixed(1), suffix:'mm'};
      case 'cm': return {v: v/10, label: (v/10).toFixed(2), suffix:'cm'};
      case 'in': return {v: v/25.4, label: (v/25.4).toFixed(3), suffix:'″'};
      default:   return {v, label: px < 10 ? px.toFixed(2) : Math.round(px).toString(), suffix:'px'};
    }
  }

  function _measureFormat(px) {
    const {label, suffix} = _measureConvert(px);
    return label + suffix;
  }

  // ── Flèche de cotation (style technique) ────────────────────────────────
  function _drawArrow(ctx, x1,y1, x2,y2, col, Z) {
    const dx=x2-x1, dy=y2-y1, len=Math.hypot(dx,dy)||1;
    const ux=dx/len, uy=dy/len;
    const aw=6/Z, ah=3/Z;
    // Corps de la flèche
    ctx.beginPath(); ctx.moveTo(x1,y1); ctx.lineTo(x2,y2);
    ctx.strokeStyle=col; ctx.lineWidth=1/Z; ctx.stroke();
    // Pointe départ
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x1+ux*aw+uy*ah, y1+uy*aw-ux*ah);
    ctx.lineTo(x1+ux*aw-uy*ah, y1+uy*aw+ux*ah);
    ctx.closePath(); ctx.fillStyle=col; ctx.fill();
    // Pointe arrivée
    ctx.beginPath();
    ctx.moveTo(x2, y2);
    ctx.lineTo(x2-ux*aw+uy*ah, y2-uy*aw-ux*ah);
    ctx.lineTo(x2-ux*aw-uy*ah, y2-uy*aw+ux*ah);
    ctx.closePath(); ctx.fill();
  }

  // ── Cote style technique ─────────────────────────────────────────────────
  // _drawCoteFixed : cote avec offset absolu horizontal (pour ΔY vertical)
  // side = +1 → décale à droite, -1 → décale à gauche
  function _drawCoteFixed(ctx, a, b, side, valPx, col, Z, prefix) {
    const off = side * 32 / Z;  // décalage horizontal fixe
    const ax=a.x+off, ay=a.y, bx=b.x+off, by=b.y;
    // Lignes de rappel
    const ext=4/Z;
    ctx.strokeStyle='rgba(150,150,150,.4)'; ctx.lineWidth=0.6/Z; ctx.setLineDash([2/Z,2/Z]);
    ctx.beginPath(); ctx.moveTo(a.x+side*ext,a.y); ctx.lineTo(ax+side*ext,ay); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(b.x+side*ext,b.y); ctx.lineTo(bx+side*ext,by); ctx.stroke();
    ctx.setLineDash([]);
    // Flèche double
    _drawArrow(ctx, ax,ay, bx,by, col, Z);
    // Label au milieu
    const mx=(ax+bx)/2, my=(ay+by)/2;
    const fmtVal=`${prefix}: ${_measureFormat(valPx)}`;
    const fs=Math.max(9,Math.min(13,10/Z));
    ctx.font=`bold ${fs}px 'JetBrains Mono',monospace`;
    const tw=ctx.measureText(fmtVal).width;
    const pad=3/Z;
    ctx.fillStyle='rgba(10,14,32,.88)';
    ctx.fillRect(mx-tw/2-pad,my-fs/2-pad,tw+pad*2,fs+pad*2);
    ctx.fillStyle=col; ctx.textAlign='center'; ctx.textBaseline='middle';
    ctx.fillText(fmtVal,mx,my);
  }

  function _drawCote(ctx, a, b, side, valPx, col, Z, prefix, isHyp) {
    const mx=(a.x+b.x)/2, my=(a.y+b.y)/2;
    const dx=b.x-a.x, dy=b.y-a.y;
    const len=Math.hypot(dx,dy)||1;
    const nx=-dy/len, ny=dx/len;
    const off=(side===0?0:side*32)/Z;
    const tx=mx+nx*off, ty=my+ny*off;
    // Lignes de rappel (si décalé)
    if(Math.abs(off)>0.5){
      const ext=4/Z;
      ctx.strokeStyle='rgba(150,150,150,.4)'; ctx.lineWidth=0.6/Z; ctx.setLineDash([2/Z,2/Z]);
      ctx.beginPath(); ctx.moveTo(a.x+nx*(ext),a.y+ny*(ext)); ctx.lineTo(a.x+nx*(off+ext),a.y+ny*(off+ext)); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(b.x+nx*(ext),b.y+ny*(ext)); ctx.lineTo(b.x+nx*(off+ext),b.y+ny*(off+ext)); ctx.stroke();
      ctx.setLineDash([]);
    }
    // Double flèche sur la ligne de cote
    const la={x:a.x+nx*off, y:a.y+ny*off}, lb={x:b.x+nx*off, y:b.y+ny*off};
    _drawArrow(ctx, la.x,la.y, lb.x,lb.y, col, Z);
    // Label
    const fmtVal = prefix ? `${prefix}: ${_measureFormat(valPx)}` : isHyp ? `↗ ${_measureFormat(valPx)}` : _measureFormat(valPx);
    const fs=Math.max(9,Math.min(13,10/Z));
    ctx.font=`bold ${fs}px 'JetBrains Mono',monospace`;
    const tw=ctx.measureText(fmtVal).width;
    const pad=3/Z;
    ctx.fillStyle='rgba(10,14,32,.88)';
    ctx.fillRect(tx-tw/2-pad, ty-fs/2-pad, tw+pad*2, fs+pad*2);
    ctx.fillStyle=col; ctx.textAlign='center'; ctx.textBaseline='middle';
    ctx.fillText(fmtVal, tx, ty);
  }

  function drawMeasure(ctx, m, colOverride) {
    if (!m || !m.p1 || !m.p2) return;
    const {p1, p2} = m;
    const dx=p2.x-p1.x, dy=p2.y-p1.y;
    const dist=Math.hypot(dx,dy);
    const adx=Math.abs(dx), ady=Math.abs(dy);
    const isH=ady<0.5, isV=adx<0.5;
    const Z=view.zoom;
    const col=colOverride||m.color||'#f5a623';
    const colX='#4ade80', colY='#60a5fa';
    const angleRad=Math.atan2(dy,dx);
    const angleDeg=((angleRad*180/Math.PI)+360)%360;

    ctx.save();

    // Ligne principale (tiretée)
    ctx.beginPath(); ctx.moveTo(p1.x,p1.y); ctx.lineTo(p2.x,p2.y);
    ctx.strokeStyle=col+'99'; ctx.lineWidth=1/Z;
    ctx.setLineDash([5/Z,3/Z]); ctx.stroke(); ctx.setLineDash([]);

    // Points magnétiques
    [[p1,!!m.p1Snap],[p2,m.snapActive&&!m.frozen]].forEach(([p,snapping])=>{
      const r=snapping?7/Z:4/Z;
      if(snapping){
        ctx.beginPath(); ctx.arc(p.x,p.y,11/Z,0,Math.PI*2);
        ctx.strokeStyle='rgba(245,166,35,.35)'; ctx.lineWidth=1.5/Z; ctx.stroke();
      }
      ctx.beginPath(); ctx.arc(p.x,p.y,r,0,Math.PI*2);
      ctx.fillStyle=snapping?'#fff':col; ctx.fill();
      ctx.strokeStyle=col; ctx.lineWidth=1.5/Z; ctx.stroke();
      if(snapping){
        ctx.strokeStyle='rgba(245,166,35,.7)'; ctx.lineWidth=1/Z;
        const c=5/Z;
        ctx.beginPath(); ctx.moveTo(p.x-c,p.y); ctx.lineTo(p.x+c,p.y); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(p.x,p.y-c); ctx.lineTo(p.x,p.y+c); ctx.stroke();
      }
    });

    if(isH){
      _drawCote(ctx,p1,p2,0,adx,col,Z);
    } else if(isV){
      _drawCote(ctx,p1,p2,0,ady,col,Z);
    } else {
      const px={x:p2.x,y:p1.y};
      const sx=p1.x<p2.x?1:-1, sy=p1.y<p2.y?1:-1;
      // Lignes auxiliaires ΔX / ΔY
      ctx.beginPath(); ctx.moveTo(p1.x,p1.y); ctx.lineTo(px.x,px.y);
      ctx.strokeStyle=colX+'88'; ctx.lineWidth=0.8/Z; ctx.setLineDash([3/Z,2/Z]); ctx.stroke(); ctx.setLineDash([]);
      ctx.beginPath(); ctx.moveTo(px.x,px.y); ctx.lineTo(p2.x,p2.y);
      ctx.strokeStyle=colY+'88'; ctx.lineWidth=0.8/Z; ctx.setLineDash([3/Z,2/Z]); ctx.stroke(); ctx.setLineDash([]);
      // Angle droit
      const sq=7/Z;
      ctx.strokeStyle='rgba(200,200,200,.4)'; ctx.lineWidth=0.7/Z;
      ctx.strokeRect(px.x-sx*sq,px.y-sy*sq,sx*sq,sy*sq);
      // Cotes avec flèches
      // ΔX : décalé vers l'extérieur (haut si p1 en haut, bas sinon)
      _drawCote(ctx,p1,px,sy*-1,adx,colX,Z,'ΔX');
      // ΔY : décalé vers l'extérieur (droite si p2 à droite, gauche sinon)
      //      offset x2 pour éviter le chevauchement avec la ligne principale
      _drawCoteFixed(ctx,px,p2,sx,ady,colY,Z,'ΔY');
      _drawCote(ctx,p1,p2,0,dist,col,Z,null,true);
      // Angle
      const angLabel=`${angleDeg.toFixed(1)}°`;
      const arc_r=20/Z;
      ctx.beginPath(); ctx.arc(p1.x,p1.y,arc_r,0,angleRad,angleRad<0);
      ctx.strokeStyle=col+'aa'; ctx.lineWidth=0.8/Z; ctx.stroke();
      const angMx=p1.x+Math.cos(angleRad/2)*arc_r*1.6, angMy=p1.y+Math.sin(angleRad/2)*arc_r*1.6;
      const fs2=Math.max(8,10/Z);
      ctx.font=`${fs2}px 'JetBrains Mono',monospace`;
      const tw2=ctx.measureText(angLabel).width;
      const pad2=2/Z;
      ctx.fillStyle='rgba(10,14,32,.8)';
      ctx.fillRect(angMx-tw2/2-pad2,angMy-fs2/2-pad2,tw2+pad2*2,fs2+pad2*2);
      ctx.fillStyle=col+'dd'; ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillText(angLabel,angMx,angMy);
    }
    ctx.restore();
  }

  function drawShapeIP(ctx,ip,cur){
    ctx.save();
    ctx.strokeStyle='rgba(59,158,255,.7)';ctx.lineWidth=ip.thick||1.5;
    ctx.lineCap='round';ctx.lineJoin='round';ctx.setLineDash([6/view.zoom,3/view.zoom]);
    ctx.beginPath();
    const pts=ip.pts;
    if(ip.tool==='line'||ip.tool==='poly'){
      if(pts.length){ctx.moveTo(pts[0].x,pts[0].y);pts.slice(1).forEach(p=>ctx.lineTo(p.x,p.y));ctx.lineTo(cur.x,cur.y);}
    }else if(ip.tool==='rect'&&pts.length){
      ctx.rect(pts[0].x,pts[0].y,cur.x-pts[0].x,cur.y-pts[0].y);
    }else if(ip.tool==='circle'&&pts.length){
      const r=Math.hypot(cur.x-pts[0].x,cur.y-pts[0].y);ctx.arc(pts[0].x,pts[0].y,r||1,0,Math.PI*2);
    }else if(ip.tool==='arc'){
      if(pts.length===1){const r=Math.hypot(cur.x-pts[0].x,cur.y-pts[0].y);ctx.arc(pts[0].x,pts[0].y,r||1,0,Math.PI*2);}
      else if(pts.length>=2){const a2=Math.atan2(cur.y-pts[0].y,cur.x-pts[0].x);ctx.arc(pts[0].x,pts[0].y,pts[1].r||1,pts[1].a1||0,a2);}
    }
    ctx.stroke();ctx.setLineDash([]);
    // Points posés
    pts.forEach(p=>{if(p.x!==undefined){ctx.fillStyle='rgba(59,158,255,.9)';ctx.beginPath();ctx.arc(p.x,p.y,4/view.zoom,0,Math.PI*2);ctx.fill();}});
    ctx.restore();
  }

  // ─────────────────────────────────────────────────────────
  // SÉLECTION
  // ─────────────────────────────────────────────────────────
  function selKey(type,id){return`${type}:${id}`;}
  function isInMultiSel(type,id){return multiSel.has(selKey(type,id));}
  function isSel(type,id){return selected.type===type&&selected.id===id;}
  function clearMultiSel(){multiSel.clear();selected={type:null,id:null};}
  function addToMultiSel(type,id){multiSel.add(selKey(type,id));selected={type,id};}
  function setOnlySel(type,id){multiSel.clear();selected={type,id};if(id)multiSel.add(selKey(type,id));}

  function rubberBandWorld(){
    if(!rubberBand)return null;
    const{sx,sy,ex,ey}=rubberBand;
    const p1=s2w(Math.min(sx,ex),Math.min(sy,ey));
    const p2=s2w(Math.max(sx,ex),Math.max(sy,ey));
    return{x:p1.x,y:p1.y,w:p2.x-p1.x,h:p2.y-p1.y};
  }
  function selectInRubberBand(){
    const rb=rubberBandWorld();if(!rb)return;
    multiSel.clear();
    const inBox=(x,y)=>x>=rb.x&&x<=rb.x+rb.w&&y>=rb.y&&y<=rb.y+rb.h;
    state.elements.forEach(el=>{if(inBox(el.x+el.w/2,el.y+el.h/2))multiSel.add(selKey('element',el.id));});
    state.wires.forEach(w=>{if(w.points.some(p=>inBox(p.x,p.y)))multiSel.add(selKey('wire',w.id));});
    state.texts.forEach(t=>{
      if(t.locked)return;
      if(t.w>0&&t.h>0){if(inBox(t.x+t.w/2,t.y+t.h/2))multiSel.add(selKey('text',t.id));}
      else{if(inBox(t.x,t.y))multiSel.add(selKey('text',t.id));}
    });
    (state.images||[]).forEach(img=>{if(inBox(img.x+img.w/2,img.y+img.h/2))multiSel.add(selKey('image',img.id));});
    state.shapes.forEach(sh=>{
      if(sh.locked)return;
      if(sh.t==='rect'||sh.t==='textbox'){if(inBox(sh.x+sh.w/2,sh.y+sh.h/2))multiSel.add(selKey('shape',sh.id));}
      else if(sh.t==='circle'||sh.t==='arc'){if(inBox(sh.cx,sh.cy))multiSel.add(selKey('shape',sh.id));}
      else if(sh.pts?.length){if(sh.pts.some(p=>inBox(p.x,p.y)))multiSel.add(selKey('shape',sh.id));}
    });
    if(multiSel.size===1){const[t,id]=[...multiSel][0].split(':');selected={type:t,id};}
    else selected={type:null,id:null};
  }

  // ─────────────────────────────────────────────────────────
  // HIT & COORDS
  // ─────────────────────────────────────────────────────────
  function s2w(sx,sy){return{x:(sx-view.panX)/view.zoom,y:(sy-view.panY)/view.zoom};}
  function w2s(wx,wy){return{sx:wx*view.zoom+view.panX,sy:wy*view.zoom+view.panY};}
  function snapW(v){return gridSnap?Math.round(v/GRID)*GRID:v;}
  function snapWxy(wx,wy){return{x:snapW(wx),y:snapW(wy)};}
  function hitEl(wx,wy){for(let i=state.elements.length-1;i>=0;i--){const e=state.elements[i];if(wx>=e.x-6&&wx<=e.x+e.w+6&&wy>=e.y-6&&wy<=e.y+e.h+6)return e;}return null;}
  function hitWire(wx,wy){const tol=7/view.zoom;for(let i=state.wires.length-1;i>=0;i--){const w=state.wires[i];for(let j=0;j<w.points.length-1;j++)if(distSeg({x:wx,y:wy},w.points[j],w.points[j+1])<tol)return w;}return null;}
  function hitText(wx,wy){for(let i=state.texts.length-1;i>=0;i--){const t=state.texts[i];if(t.locked)continue;const angle=(t.angle||0)*Math.PI/180;
    const dx=wx-t.x,dy=wy-t.y;const lx=angle?dx*Math.cos(-angle)-dy*Math.sin(-angle):dx;const ly=angle?dx*Math.sin(-angle)+dy*Math.cos(-angle):dy;
    if(t.w>0&&t.h>0){if(lx>=-2&&lx<=t.w+2&&ly>=-2&&ly<=t.h+2)return t;}
    else{ctx.font=`${t.size||13}px monospace`;const tw=ctx.measureText(t.text).width;const th=(t.size||13)+4;if(lx>=-2&&lx<=tw+2&&ly>=-2&&ly<=th)return t;}}return null;}
  function hitShape(wx,wy){const tol=8/view.zoom;for(let i=state.shapes.length-1;i>=0;i--){const sh=state.shapes[i];if(sh.locked)continue;if(shapeHit(sh,wx,wy,tol))return sh;}return null;}
  function hitImage(wx,wy){for(let i=(state.images||[]).length-1;i>=0;i--){const img=state.images[i];if(wx>=img.x&&wx<=img.x+img.w&&wy>=img.y&&wy<=img.y+img.h)return img;}return null;}
  function hitJunction(wx,wy){
    const tol=Math.max(PROJ.junctionRadius||4, 7/view.zoom)+2;
    return (state.junctions||[]).find(j=>Math.hypot(j.x-wx,j.y-wy)<tol)||null;
  }
  function shapeHit(sh,wx,wy,tol){
    if(sh.t==='group') return sh.children.some(c=>shapeHit(c,wx,wy,tol));
    if(sh.t==='rect'||sh.t==='textbox'){
      let lx=wx,ly=wy;
      if(sh.t==='textbox'&&sh.angle){
        const rad=sh.angle*Math.PI/180,cx=sh.x+sh.w/2,cy=sh.y+sh.h/2;
        const dx=wx-cx,dy=wy-cy;
        lx=cx+dx*Math.cos(-rad)-dy*Math.sin(-rad);
        ly=cy+dx*Math.sin(-rad)+dy*Math.cos(-rad);
      }
      return lx>=sh.x-tol&&lx<=sh.x+sh.w+tol&&ly>=sh.y-tol&&ly<=sh.y+sh.h+tol;
    }
    if(sh.t==='circle')return Math.abs(Math.hypot(wx-sh.cx,wy-sh.cy)-sh.r)<tol;
    if(sh.t==='arc')return Math.abs(Math.hypot(wx-sh.cx,wy-sh.cy)-sh.r)<tol;
    if(sh.pts?.length>=2){for(let j=0;j<sh.pts.length-1;j++)if(distSeg({x:wx,y:wy},sh.pts[j],sh.pts[j+1])<tol)return true;}
    return false;
  }


// ═══ app-voltage.js ═══
  // ═══════════════════════════════════════════════════════════════
  // MOTEUR DE TENSION — propagation par graphe, détection conflits
  // ═══════════════════════════════════════════════════════════════
  //
  // Modèle de données :
  //   - Symbole : voltages = { pwr_in:'230V', pwr_out:'24V', ctrl:'24V' }
  //               (champs remplis dans le panneau propriétés)
  //   - Fil     : voltage = '24V' | null
  //               voltageConflict = true | false
  //   - Élément : voltageConflict = true | false
  //
  // Algorithme :
  //   1. Construire le graphe de connectivité (pins ↔ fils ↔ pins)
  //   2. Collecter les "sources" : pins de symboles ayant une tension configurée
  //   3. BFS depuis chaque source : propager la tension sur les fils connectés
  //   4. Détecter les conflits : nœud recevant 2 tensions différentes non nulles
  //   5. Stocker le résultat dans voltageMap (wireid → tension) et conflictSet

  // Résultats courants (recalculés à chaque render si dirty)
  let _voltageMap    = {};  // wireId → string (ex: '24V')
  let _conflictWires    = new Set(); // wireId en conflit tension
  let _conflictEls      = new Set(); // elementId en conflit tension
  let _conflictNumWires = new Set(); // wireId dont le numéro est dupliqué
  let _conflictDetails  = [];        // [{wireId, wireNum, voltageA, voltageB, sourceA, sourceB}]
  let _voltageDirty  = true;
  let _legendVisible = false; // légende tension activée/désactivée

  // Animation clignotante : opacité oscillante pour les conflits
  let _blinkAlpha = 0.25;
  let _blinkDir   = 1;
  let _blinkRaf   = null;
  function _startBlink() {
    if (_blinkRaf) return;
    function step() {
      _blinkAlpha += _blinkDir * 0.04;
      const _bmax = PROJ.conflictAlphaMax || 0.4;
      if (_blinkAlpha >= _bmax) { _blinkAlpha = _bmax; _blinkDir = -1; }
      if (_blinkAlpha <= 0.08) { _blinkAlpha = 0.08; _blinkDir = 1; }
      _blinkRaf = requestAnimationFrame(step);
      if (_conflictWires.size > 0 || _conflictEls.size > 0 || _conflictNumWires.size > 0) render();
    }
    _blinkRaf = requestAnimationFrame(step);
  }
  function _stopBlink() {
    if (_blinkRaf) { cancelAnimationFrame(_blinkRaf); _blinkRaf = null; }
  }

  // Normaliser une tension (ex: '24v' → '24V', ' 230 V ' → '230V')
  function _normVoltage(v) {
    if (!v) return null;
    const s = String(v).trim().replace(/\s+/g, '').toUpperCase();
    return s || null;
  }

  // Retourner les tensions déclarées sur un symbole selon les types de ses pins
  // Clé de résultat : 'pinIndex' pour mono-pôle, 'pinIndex:poleIndex' pour multi-pôle
  // Priorité : pin:NomPin:poleIndex > pin:NomPin > catégorie (pwr_in/pwr_out/ctrl)
  function _symVoltages(el) {
    const sym = _symbols[el.symId];
    if (!sym) return {};
    const v = el.voltages || {};
    const poles = el.poles || [];
    const isMP = ['contact','breaker','terminal'].includes(sym?.elementRole) && poles.length > 1;
    const nPoles = isMP ? poles.length : 1;
    const result = {}; // 'pinIndex:poleIndex' → voltage

    for (let pi = 0; pi < nPoles; pi++) {
      (sym.pins || []).forEach((pin, i) => {
        const t = pin.type || 'default';
        const conductor = pin.conductor || '';
        // 1. Tension spécifique à ce pin + ce pôle
        let volt = _normVoltage(v['pin:' + pin.name + ':' + pi]);
        // 2. Tension spécifique à ce pin (tous pôles)
        if (!volt) volt = _normVoltage(v['pin:' + pin.name]);
        // 3. Fallback : tension par catégorie
        if (!volt) {
          if (t === 'power-in')  volt = _normVoltage(v.pwr_in);
          if (t === 'power-out') volt = _normVoltage(v.pwr_out);
          if (t === 'ctrl')      volt = _normVoltage(v.ctrl);
        }
        // 4. Auto-adaptation selon le type de conducteur défini sur le pin
        // Si le pin est déclaré comme neutre ou terre, forcer 0V
        // (priorité plus basse que les valeurs explicites par pin)
        if (!_normVoltage(v['pin:' + pin.name + ':' + pi]) && !_normVoltage(v['pin:' + pin.name])) {
          if (conductor === 'neutral' || conductor === 'pe') volt = '0V';
        }
        const key = i + ':' + pi;
        if (volt) result[key] = volt;
      });
    }
    return result;
  }

  // Trouver le fil dont une extrémité touche un point (avec tolérance)
  function _wiresAtPoint(x, y, tol) {
    const out = [];
    for (const w of state.wires) {
      const pts = w.points;
      if (Math.hypot(pts[0].x - x, pts[0].y - y) < tol ||
          Math.hypot(pts[pts.length-1].x - x, pts[pts.length-1].y - y) < tol) {
        out.push(w);
      }
      // T-junction : point intérieur
      for (let i = 1; i < pts.length - 1; i++) {
        if (Math.hypot(pts[i].x - x, pts[i].y - y) < tol) { out.push(w); break; }
      }
    }
    return out;
  }

  // Calcul simplifié des tensions d'un folio distant (pour propagation cross-folio)
  function _computeRemoteVoltages(data, tol) {
    const wires = data.wires || [];
    const elements = data.elements || [];
    if (!wires.length) return {};

    // Adjacence par extrémités sur segments
    const adj = {};
    for (const w of wires) adj[w.id] = new Set();
    function onSeg(px, py, wire) {
      for (let i = 0; i < wire.points.length - 1; i++) {
        const a = wire.points[i], b = wire.points[i + 1];
        const dx = b.x - a.x, dy = b.y - a.y, l2 = dx * dx + dy * dy;
        if (l2 === 0) { if (Math.hypot(px - a.x, py - a.y) < tol) return true; continue; }
        const t = Math.max(0, Math.min(1, ((px - a.x) * dx + (py - a.y) * dy) / l2));
        if (Math.hypot(px - (a.x + t * dx), py - (a.y + t * dy)) < tol) return true;
      }
      return false;
    }
    for (let i = 0; i < wires.length; i++) {
      const a = wires[i], aE = [a.points[0], a.points[a.points.length - 1]];
      for (let j = i + 1; j < wires.length; j++) {
        const b = wires[j], bE = [b.points[0], b.points[b.points.length - 1]];
        let c = false;
        for (const p of aE) { if (onSeg(p.x, p.y, b)) { c = true; break; } }
        if (!c) for (const p of bE) { if (onSeg(p.x, p.y, a)) { c = true; break; } }
        if (c) { adj[a.id].add(b.id); adj[b.id].add(a.id); }
      }
    }
    // Jonctions
    if (data.junctions) {
      for (const j of data.junctions) {
        const at = wires.filter(w => onSeg(j.x, j.y, w));
        for (let i = 0; i < at.length; i++) for (let k = i + 1; k < at.length; k++) {
          adj[at[i].id].add(at[k].id); adj[at[k].id].add(at[i].id);
        }
      }
    }
    // Sources
    const rSources = [];
    for (const el of elements) {
      const sym = _symbols[el.symId];
      if (!sym) continue;
      const pv = _symVoltages(el);
      const rAllPins = Renderer.getAllPins(el, sym);
      rAllPins.forEach(({pin, poleIndex}) => {
        const i = (sym.pins || []).indexOf(pin);
        const vKey = i + ':' + (poleIndex || 0);
        if (i < 0 || !pv[vKey]) return;
        const [px, py] = Renderer.getPinWorld(el, sym, pin, poleIndex);
        for (const w of wires) {
          const pts = w.points;
          if (Math.hypot(pts[0].x - px, pts[0].y - py) < tol ||
              Math.hypot(pts[pts.length - 1].x - px, pts[pts.length - 1].y - py) < tol) {
            rSources.push({ wireId: w.id, voltage: pv[vKey] });
          }
        }
      });
    }
    // Sources directes sur les fils distants
    for (const w of wires) {
      if (w.voltage) rSources.push({ wireId: w.id, voltage: w.voltage });
    }
    // BFS
    const vm = {};
    for (const s of rSources) { if (vm[s.wireId] === undefined) vm[s.wireId] = s.voltage; }
    const q = [...rSources];
    let h = 0;
    while (h < q.length) {
      const { wireId, voltage } = q[h++];
      for (const nid of (adj[wireId] || [])) {
        if (vm[nid] === undefined) { vm[nid] = voltage; q.push({ wireId: nid, voltage }); }
      }
    }
    return vm;
  }

  // Recalculer toute la carte de tensions
  function computeVoltages() {
    _voltageDirty = false;
    _voltageMap    = {};
    _conflictWires    = new Set();
    _conflictEls      = new Set();
    _conflictNumWires = new Set();
    _conflictDetails  = [];

    const TOL = 10; // px monde

    // ── Construire la liste de connexions fil↔fil par point commun ──────
    // adjacency : wireId → Set<wireId>
    // Connexion = extrémité d'un fil touche un point ou segment d'un autre fil
    // OU deux fils partagent une jonction (connexion fil/bus via nœud)
    const adj = {};
    for (const w of state.wires) adj[w.id] = new Set();

    // Helper : vérifie si un point est sur un segment de fil (pas juste sur un point discret)
    function _ptOnWireSegment(px, py, wire, tol) {
      const pts = wire.points;
      for (let i = 0; i < pts.length - 1; i++) {
        const a = pts[i], b = pts[i + 1];
        const dx = b.x - a.x, dy = b.y - a.y;
        const len2 = dx * dx + dy * dy;
        if (len2 === 0) { if (Math.hypot(px - a.x, py - a.y) < tol) return true; continue; }
        const t = Math.max(0, Math.min(1, ((px - a.x) * dx + (py - a.y) * dy) / len2));
        const dist = Math.hypot(px - (a.x + t * dx), py - (a.y + t * dy));
        if (dist < tol) return true;
      }
      return false;
    }

    for (let i = 0; i < state.wires.length; i++) {
      const a = state.wires[i];
      const aEnds = [a.points[0], a.points[a.points.length - 1]];
      for (let j = i + 1; j < state.wires.length; j++) {
        const b = state.wires[j];
        const bEnds = [b.points[0], b.points[b.points.length - 1]];
        let connected = false;
        // Extrémité de a sur un segment de b ?
        for (const ap of aEnds) {
          if (_ptOnWireSegment(ap.x, ap.y, b, TOL)) { connected = true; break; }
        }
        // Extrémité de b sur un segment de a ?
        if (!connected) {
          for (const bp of bEnds) {
            if (_ptOnWireSegment(bp.x, bp.y, a, TOL)) { connected = true; break; }
          }
        }
        if (connected) { adj[a.id].add(b.id); adj[b.id].add(a.id); }
      }
    }

    // Connexions via jonctions : si 2 fils passent par la même jonction, ils sont connectés
    if (state.junctions) {
      for (const j of state.junctions) {
        const atJunction = state.wires.filter(w => _ptOnWireSegment(j.x, j.y, w, TOL));
        for (let i = 0; i < atJunction.length; i++) {
          for (let k = i + 1; k < atJunction.length; k++) {
            adj[atJunction[i].id].add(atJunction[k].id);
            adj[atJunction[k].id].add(atJunction[i].id);
          }
        }
      }
    }

    // ── Broches passantes : connecter les fils PAR PÔLE (pas entre pôles) ──
    // Pour un contacteur multi-pôle, chaque pôle relie ses propres pins
    // (entrée ↔ sortie du même pôle) mais pas avec les autres pôles.
    for (const el of state.elements) {
      const sym = _symbols[el.symId];
      if (!sym) continue;
      const allPinsP = Renderer.getAllPins(el, sym);
      // Grouper les fils par pôle
      const wiresByPole = {}; // poleIndex → [wireId]
      allPinsP.forEach(({pin, poleIndex}) => {
        if ((pin.type || 'default') !== 'passthrough') return;
        const [px, py] = Renderer.getPinWorld(el, sym, pin, poleIndex);
        const touching = _wiresAtPoint(px, py, TOL);
        const pi = poleIndex || 0;
        if (!wiresByPole[pi]) wiresByPole[pi] = [];
        for (const w of touching) wiresByPole[pi].push(w.id);
      });
      // Relier les fils au sein de chaque pôle (pas entre pôles)
      for (const poleWires of Object.values(wiresByPole)) {
        for (let i = 0; i < poleWires.length; i++) {
          for (let j = i + 1; j < poleWires.length; j++) {
            if (poleWires[i] !== poleWires[j]) {
              adj[poleWires[i]].add(poleWires[j]);
              adj[poleWires[j]].add(poleWires[i]);
            }
          }
        }
      }

      // ── Traversée par pôle : relier power-in ↔ power-out du même pôle ──
      // Un contacteur/disjoncteur fermé propage la tension de l'entrée vers la sortie
      // sur chaque pôle indépendamment
      const poles = el.poles || [];
      const isMP = ['contact','breaker','terminal'].includes(sym?.elementRole) && poles.length > 1;
      if (isMP || sym?.isConsumer) {
        const nPoles = isMP ? poles.length : 1;
        for (let pi = 0; pi < nPoles; pi++) {
          const poleWires = [];
          allPinsP.forEach(({pin, poleIndex}) => {
            const t = pin.type || 'default';
            if (t !== 'power-in' && t !== 'power-out') return;
            if ((poleIndex || 0) !== pi) return;
            const [px, py] = Renderer.getPinWorld(el, sym, pin, poleIndex);
            const touching = _wiresAtPoint(px, py, TOL);
            for (const w of touching) poleWires.push(w.id);
          });
          // Relier tous les fils power de ce pôle entre eux
          for (let i = 0; i < poleWires.length; i++) {
            for (let j = i + 1; j < poleWires.length; j++) {
              if (poleWires[i] !== poleWires[j]) {
                adj[poleWires[i]].add(poleWires[j]);
                adj[poleWires[j]].add(poleWires[i]);
              }
            }
          }
        }
      }
    }

    // ── Sources : pins de symboles avec tension définie ──────────────────
    // source = { wireId, voltage, origin }
    const sources = [];
    const _voltageOrigin = {}; // wireId → { elRef, elName, voltage }
    for (const el of state.elements) {
      const sym = _symbols[el.symId];
      if (!sym) continue;
      const pinVolts = _symVoltages(el);
      const allPins = Renderer.getAllPins(el, sym);
      const elLabel = el.ref || el.tag || sym.name || el.symId;
      allPins.forEach(({pin, poleIndex}) => {
        const i = (sym.pins || []).indexOf(pin);
        const vKey = i + ':' + (poleIndex || 0);
        if (i < 0 || !pinVolts[vKey]) return;
        const [px, py] = Renderer.getPinWorld(el, sym, pin, poleIndex);
        const touching = _wiresAtPoint(px, py, TOL);
        const origin = { elRef: elLabel, elName: sym.name || '', voltage: pinVolts[vKey], pinName: pin.name || '' };
        for (const w of touching) {
          sources.push({ wireId: w.id, voltage: pinVolts[vKey], origin });
        }
      });
    }

    // ── Sources directes : fils/bus avec tension déclarée ────────────────
    for (const w of state.wires) {
      if (w.voltage) {
        const origin = { elRef: 'Fil ' + (w.num || w.id.slice(0,6)), elName: 'fil direct', voltage: w.voltage, pinName: '' };
        sources.push({ wireId: w.id, voltage: w.voltage, origin });
      }
    }

    // ── Sources cross-folio : tensions des fils ayant le même numéro sur d'autres folios
    if (typeof projectFolios !== 'undefined' && typeof currentFolioId !== 'undefined') {
      const localNumToWires = {};
      for (const w of state.wires) {
        if (!w.num) continue;
        if (!localNumToWires[w.num]) localNumToWires[w.num] = [];
        localNumToWires[w.num].push(w.id);
      }
      for (const f of (projectFolios || [])) {
        if (f.id === currentFolioId) continue;
        const d = f._cachedData;
        if (!d || !d.wires || !d.elements) continue;
        // Mini-propagation BFS sur le folio distant pour calculer ses tensions
        const rVoltMap = _computeRemoteVoltages(d, TOL);
        // Importer les tensions des fils distants ayant le même numéro
        for (const rw of d.wires) {
          if (!rw.num || !localNumToWires[rw.num]) continue;
          const rv = rVoltMap[rw.id];
          if (!rv) continue;
          const origin = { elRef: 'Folio ' + (f.name || f.id), elName: 'cross-folio', voltage: rv, pinName: 'fil n°' + rw.num };
          for (const localId of localNumToWires[rw.num]) {
            sources.push({ wireId: localId, voltage: rv, origin });
          }
        }
      }
    }

    // ── BFS propagation ──────────────────────────────────────────────────
    // On propage depuis chaque source ; conflits si deux sources différentes
    // atteignent le même fil
    const queue = [...sources];
    for (const src of sources) {
      if (_voltageMap[src.wireId] === undefined) {
        _voltageMap[src.wireId] = src.voltage;
        if (src.origin) _voltageOrigin[src.wireId] = src.origin;
      } else if (_voltageMap[src.wireId] !== src.voltage) {
        _conflictWires.add(src.wireId);
        const w = state.wires.find(x => x.id === src.wireId);
        _conflictDetails.push({
          wireId: src.wireId, wireNum: w?.num || '',
          voltageA: _voltageMap[src.wireId], voltageB: src.voltage,
          sourceA: _voltageOrigin[src.wireId] || null, sourceB: src.origin || null
        });
      }
    }

    let head = 0;
    while (head < queue.length) {
      const { wireId, voltage, origin } = queue[head++];
      for (const neighborId of (adj[wireId] || [])) {
        if (_voltageMap[neighborId] === undefined) {
          _voltageMap[neighborId] = voltage;
          if (origin) _voltageOrigin[neighborId] = origin;
          queue.push({ wireId: neighborId, voltage, origin });
        } else if (_voltageMap[neighborId] !== voltage) {
          _conflictWires.add(neighborId);
          _conflictWires.add(wireId);
          const w = state.wires.find(x => x.id === neighborId);
          _conflictDetails.push({
            wireId: neighborId, wireNum: w?.num || '',
            voltageA: _voltageMap[neighborId], voltageB: voltage,
            sourceA: _voltageOrigin[neighborId] || null, sourceB: origin || null
          });
        }
      }
    }

    // ── Conflits sur les symboles ────────────────────────────────────────
    // Un élément est en conflit si un de ses pins DÉCLARE une tension
    // ET que le fil connecté porte une tension DIFFÉRENTE.
    // Les pins passantes ou sans tension déclarée ne génèrent pas de conflit.
    for (const el of state.elements) {
      const sym = _symbols[el.symId];
      if (!sym) continue;
      const pinVolts = _symVoltages(el);
      const hasDeclared = Object.keys(pinVolts).length > 0;
      if (!hasDeclared) continue;
      let elConflict = false;
      const elLabel = el.ref || el.tag || sym.name || el.symId;
      const allPinsC = Renderer.getAllPins(el, sym);
      allPinsC.forEach(({pin, poleIndex}) => {
        const i = (sym.pins || []).indexOf(pin);
        const vKey = i + ':' + (poleIndex || 0);
        if (i < 0 || !pinVolts[vKey]) return;
        const [px, py] = Renderer.getPinWorld(el, sym, pin, poleIndex);
        const touching = _wiresAtPoint(px, py, TOL);
        for (const w of touching) {
          const wv = _voltageMap[w.id];
          if (!wv) continue;
          if (pinVolts[vKey] !== wv) {
            elConflict = true;
            _conflictWires.add(w.id);
            _conflictDetails.push({
              wireId: w.id, wireNum: w.num || '',
              voltageA: wv, voltageB: pinVolts[vKey],
              sourceA: _voltageOrigin[w.id] || null,
              sourceB: { elRef: elLabel, elName: sym.name || '', voltage: pinVolts[vKey], pinName: pin.name || '' }
            });
          }
        }
      });
      if (elConflict) _conflictEls.add(el.id);
    }

    // ── Détecter les numéros de fil dupliqués (en tenant compte des groupes connexes) ──
    // Construire les groupes de fils connectés (BFS sur adj +
    // traversée à travers les symboles de catégorie "Connexions" / borniers)
    const _wireGroup = {}; // wireId → groupId (int)
    let _gid = 0;
    const _visited = new Set();
    for (const w of state.wires) {
      if (_visited.has(w.id)) continue;
      const grp = _gid++;
      const queue2 = [w.id];
      _visited.add(w.id);
      while (queue2.length) {
        const cur = queue2.shift();
        _wireGroup[cur] = grp;
        // Voisins directs (fils connectés)
        for (const nid of (adj[cur] || [])) {
          if (!_visited.has(nid)) { _visited.add(nid); queue2.push(nid); }
        }
        // Traversée à travers les symboles de type Connexions (borniers)
        const curWire = state.wires.find(x => x.id === cur);
        if (!curWire) continue;
        const curPts = curWire.points;
        for (const el of state.elements) {
          const sym = _symbols[el.symId];
          if (!sym) continue;
          // Seuls les borniers (catégorie Connexions) propagent le numéro
          if (!(sym.category||'').toLowerCase().includes('connexion')) continue;
          // Vérifier si ce fil touche une pin du symbole
          const allPinsG = Renderer.getAllPins(el, sym);
          let touchesSym = false;
          for (const {pin, poleIndex} of allPinsG) {
            const [px,py] = Renderer.getPinWorld(el,sym,pin,poleIndex);
            for (const pt of curPts) {
              if (Math.hypot(pt.x-px,pt.y-py) < TOL) { touchesSym=true; break; }
            }
            if (touchesSym) break;
          }
          if (!touchesSym) continue;
          // Ce symbole est touché : trouver les autres fils connectés à ses pins
          for (const {pin:pin2, poleIndex:pi2} of allPinsG) {
            const [px2,py2] = Renderer.getPinWorld(el,sym,pin2,pi2);
            for (const w2 of state.wires) {
              if (_visited.has(w2.id)) continue;
              for (const pt2 of w2.points) {
                if (Math.hypot(pt2.x-px2,pt2.y-py2) < TOL) {
                  _visited.add(w2.id); queue2.push(w2.id); break;
                }
              }
            }
          }
        }
      }
    }
    // Numéro → Map<groupId, [wireId]>
    const _numGroups = {}; // num → { groupId: [wireId] }
    for (const w of state.wires) {
      const n = (w.num||'').trim();
      if (!n) continue;
      const grp = _wireGroup[w.id] ?? -1;
      if (!_numGroups[n]) _numGroups[n] = {};
      if (!_numGroups[n][grp]) _numGroups[n][grp] = [];
      _numGroups[n][grp].push(w.id);
    }
    // Erreur uniquement si le même numéro apparaît dans 2+ groupes distincts
    for (const [n, groups] of Object.entries(_numGroups)) {
      const keys = Object.keys(groups);
      if (keys.length > 1) {
        for (const ids of Object.values(groups)) ids.forEach(id => _conflictNumWires.add(id));
      }
    }

    // Démarrer / arrêter l'animation
    const _anyConflict = _conflictWires.size > 0 || _conflictEls.size > 0 || _conflictNumWires.size > 0;
    if (_anyConflict && PROJ.conflictBlink !== false) _startBlink();
    else _stopBlink();

    // Bandeau d'alerte
    _updateErrorBanner();

    // Mettre à jour la légende flottante
    buildVoltageLegend();
  }

  // Marquer les tensions comme à recalculer (appelé après chaque modification d'état)
  function markVoltageDirty() { _voltageDirty = true; }

  // ── Bandeau d'alerte erreurs ─────────────────────────────────────────
  function _updateErrorBanner() {
    let banner = document.getElementById('qd-error-banner');
    const msgs = [];
    if (_conflictNumWires.size > 0)
      msgs.push('⚠ Plusieurs fils ou bus ont le même numéro de fil !');
    if (_conflictWires.size > 0 || _conflictEls.size > 0)
      msgs.push('⚠ Conflit de tension détecté sur le réseau !');

    if (!msgs.length) {
      if (banner) banner.remove();
      return;
    }
    // Le bandeau flotte dans la zone canvas, centré horizontalement sur le canvas
    const canvasEl = document.getElementById('canvas');
    const canvasRect = canvasEl ? canvasEl.getBoundingClientRect() : null;
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'qd-error-banner';
      banner.style.cssText = [
        'position:fixed',
        'z-index:8000','display:flex','flex-direction:column','align-items:center','gap:3px',
        'pointer-events:none',
      ].join(';');
      document.body.appendChild(banner);
    }
    if (canvasRect) {
      banner.style.left  = (canvasRect.left + canvasRect.width/2) + 'px';
      banner.style.top   = (canvasRect.top + 14) + 'px';
      banner.style.transform = 'translateX(-50%)';
    } else {
      banner.style.left = '50%'; banner.style.top = '64px'; banner.style.transform = 'translateX(-50%)';
    }
    const hasVoltageConflict = _conflictWires.size > 0 || _conflictEls.size > 0;
    banner.innerHTML = msgs.map((m, idx) => {
      const isVC = idx === msgs.length - 1 && hasVoltageConflict;
      return `<div class="${isVC ? 'qd-err-clickable' : ''}" style="background:rgba(180,30,30,.93);color:#fff;font:700 11px/1 'JetBrains Mono',monospace;`+
        `padding:6px 20px;border-radius:4px;box-shadow:0 2px 12px rgba(0,0,0,.6);`+
        `letter-spacing:.3px;white-space:nowrap;border:1px solid rgba(255,100,100,.4);`+
        `pointer-events:auto;${isVC ? 'cursor:pointer;text-decoration:underline;text-underline-offset:3px' : ''}">${m}</div>`;
    }).join('');
    if (hasVoltageConflict) {
      const el = banner.querySelector('.qd-err-clickable');
      if (el) el.addEventListener('click', () => { populateVoltageConflictModal(); openModal('modal-voltage-conflict'); });
    }
  }

  // ── Légende tensions flottante ────────────────────────────────
  function buildVoltageLegend() {
    const el = document.getElementById('voltage-legend');
    if (!el) return;
    if (!_legendVisible) { el.style.display = 'none'; return; }

    // Collecter toutes les tensions présentes sur les fils + conflits
    const voltages = new Set(Object.values(_voltageMap).filter(Boolean));
    const hasConflict = _conflictWires.size > 0 || _conflictEls.size > 0;

    if (!voltages.size && !hasConflict) { el.style.display = 'none'; return; }

    el.style.display = 'block';

    // Trier : tensions numériques décroissantes, puis alphabétiques
    const sorted = [...voltages].sort((a, b) => {
      const na = parseFloat(a), nb = parseFloat(b);
      if (!isNaN(na) && !isNaN(nb)) return nb - na;
      if (!isNaN(na)) return -1;
      if (!isNaN(nb)) return 1;
      return a.localeCompare(b);
    });

    const rows = sorted.map(v => {
      const col = _voltageColorPublic(v);
      return `<tr>
        <td><span class="vleg-swatch" style="background:${col}"></span></td>
        <td class="vleg-val">${v}</td>
      </tr>`;
    });

    if (hasConflict) {
      rows.push(`<tr class="vleg-conflict">
        <td><span class="vleg-swatch" style="background:#ff3c3c;animation:vleg-blink 1s ease-in-out infinite"></span></td>
        <td class="vleg-val" style="color:#ff3c3c">⚠ Conflit</td>
      </tr>`);
    }

    el.innerHTML = `
      <div class="vleg-header">
        <span>⚡ Tensions</span>
        <button class="vleg-close" onclick="document.getElementById('voltage-legend').style.display='none';document.getElementById('btn-voltage-legend').classList.remove('active');_legendVisible=false" title="Fermer">✕</button>
      </div>
      <table class="vleg-table">${rows.join('')}</table>`;
  }

  // Exposer _voltageColorPublic pour la légende (alias de la fn du renderer)
  function _voltageColorPublic(v) {
    if (!v) return '#3b9eff';
    const FIXED = {
      '400V':'#ff6b35','415V':'#ff6b35','230V':'#ffaa00','240V':'#ffaa00',
      '120V':'#ffcc44','110V':'#ffcc44','48V':'#c8f560','24V':'#4dd278',
      '12V':'#3bffcc','5V':'#3bd4ff','3.3V':'#3b9eff','0V':'#888','GND':'#888','VCC':'#f06dff'
    };
    const key = v.toUpperCase().replace(/\s+/g,'');
    if (FIXED[key]) return FIXED[key];
    let h = 0;
    for (let i = 0; i < v.length; i++) h = (h * 31 + v.charCodeAt(i)) & 0xffff;
    return `hsl(${h % 360},80%,60%)`;
  }

  function populateVoltageConflictModal() {
    const container = document.getElementById('voltage-conflict-content');
    if (!container) return;

    // Dédoublonner par paire wireId+voltages
    const seen = new Set();
    const unique = [];
    for (const d of _conflictDetails) {
      const key = d.wireId + ':' + [d.voltageA, d.voltageB].sort().join('/');
      if (seen.has(key)) continue;
      seen.add(key);
      unique.push(d);
    }

    if (!unique.length) {
      container.innerHTML = '<div style="padding:20px;text-align:center;color:var(--text2)">Aucun conflit de tension détecté.</div>';
      return;
    }

    const rows = unique.map((d, i) => {
      const srcA = d.sourceA ? `<strong>${_esc(d.sourceA.elRef)}</strong>` + (d.sourceA.pinName ? ` <span style="color:var(--text2)">(${_esc(d.sourceA.pinName)})</span>` : '') : '<span style="color:var(--text2)">inconnu</span>';
      const srcB = d.sourceB ? `<strong>${_esc(d.sourceB.elRef)}</strong>` + (d.sourceB.pinName ? ` <span style="color:var(--text2)">(${_esc(d.sourceB.pinName)})</span>` : '') : '<span style="color:var(--text2)">inconnu</span>';
      const wireLabel = d.wireNum ? `Fil n°${_esc(d.wireNum)}` : `Fil ${d.wireId.slice(0,8)}`;
      const colA = _voltageColorPublic(d.voltageA);
      const colB = _voltageColorPublic(d.voltageB);
      return `<tr>
        <td style="padding:6px 10px;border-bottom:1px solid var(--border2)">${i + 1}</td>
        <td style="padding:6px 10px;border-bottom:1px solid var(--border2)">${wireLabel}</td>
        <td style="padding:6px 10px;border-bottom:1px solid var(--border2)">
          <span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:${colA};margin-right:4px;vertical-align:middle"></span>${_esc(d.voltageA)} <span style="color:var(--text2);font-size:10px">(A)</span>
          <span style="color:var(--text2);margin:0 4px">vs</span>
          <span style="display:inline-block;width:10px;height:10px;border-radius:2px;background:${colB};margin-right:4px;vertical-align:middle"></span>${_esc(d.voltageB)} <span style="color:var(--text2);font-size:10px">(B)</span>
        </td>
        <td style="padding:6px 10px;border-bottom:1px solid var(--border2)">${srcA}</td>
        <td style="padding:6px 10px;border-bottom:1px solid var(--border2)">${srcB}</td>
      </tr>`;
    });

    container.innerHTML = `
      <div style="padding:12px 16px;font-size:11px;color:var(--text2);background:rgba(255,60,60,.06);border-bottom:1px solid var(--border2);line-height:1.6">
        Deux sources de tensions différentes arrivent sur le même réseau de fils.<br>
        Vérifiez les tensions déclarées sur les éléments ci-dessous et corrigez la configuration.
      </div>
      <div style="overflow-x:auto">
        <table style="width:100%;border-collapse:collapse;font-size:11px">
          <thead>
            <tr style="background:var(--panel2);text-align:left">
              <th style="padding:6px 10px;border-bottom:1px solid var(--border2);color:var(--text2);font-weight:600">#</th>
              <th style="padding:6px 10px;border-bottom:1px solid var(--border2);color:var(--text2);font-weight:600">Fil</th>
              <th style="padding:6px 10px;border-bottom:1px solid var(--border2);color:var(--text2);font-weight:600">Tensions en conflit</th>
              <th style="padding:6px 10px;border-bottom:1px solid var(--border2);color:var(--text2);font-weight:600">Source A</th>
              <th style="padding:6px 10px;border-bottom:1px solid var(--border2);color:var(--text2);font-weight:600">Source B</th>
            </tr>
          </thead>
          <tbody>${rows.join('')}</tbody>
        </table>
      </div>`;
  }

  function _esc(s) {
    if (!s) return '';
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function toggleVoltageLegend() {
    _legendVisible = !_legendVisible;
    markVoltageDirty();
    render();
    document.getElementById('btn-voltage-legend')?.classList.toggle('active', _legendVisible);
  }


// ═══ app-wires.js ═══
  // ── Utilitaires fils ─────────────────────────────────────────
  const WIRE_TOL = 8; // tolérance snap fil-à-fil (px monde)

  function wireEndpointAt(x, y, excludeId) {
    for (const w of state.wires) {
      if (w.id === excludeId) continue;
      const pts = w.points;
      if (Math.hypot(pts[0].x-x, pts[0].y-y) < WIRE_TOL) return {wire:w, end:'start', pt:pts[0]};
      if (Math.hypot(pts[pts.length-1].x-x, pts[pts.length-1].y-y) < WIRE_TOL) return {wire:w, end:'end', pt:pts[pts.length-1]};
    }
    return null;
  }

  // Point sur segment intérieur d'un fil (pas ses bouts)
  function wireSegmentAt(x, y, excludeId) {
    for (const w of state.wires) {
      if (w.id === excludeId) continue;
      const pts = w.points;
      for (let i = 0; i < pts.length-1; i++) {
        if (distSeg({x,y}, pts[i], pts[i+1]) < WIRE_TOL) {
          const atStart = Math.hypot(x-pts[0].x, y-pts[0].y) < WIRE_TOL;
          const atEnd   = Math.hypot(x-pts[pts.length-1].x, y-pts[pts.length-1].y) < WIRE_TOL;
          if (!atStart && !atEnd) return {wire:w, segIdx:i};
        }
      }
    }
    return null;
  }

  // Deux segments sont-ils colinéaires (même axe H ou V) ?
  function collinear(a1, a2, b1, b2) {
    const hA = Math.abs(a2.y-a1.y)<1, hB = Math.abs(b2.y-b1.y)<1;
    const vA = Math.abs(a2.x-a1.x)<1, vB = Math.abs(b2.x-b1.x)<1;
    if (hA && hB) return Math.abs(a1.y-b1.y)<1;
    if (vA && vB) return Math.abs(a1.x-b1.x)<1;
    return false;
  }

  // Après avoir posé un fil, tenter de le fusionner avec ses voisins bout-à-bout
  function mergeWires(newWire) {
    let changed = true;
    while (changed) {
      changed = false;
      for (const w of state.wires) {
        if (w.id === newWire.id || w.isBus !== newWire.isBus) continue;
        const nPts = newWire.points, wPts = w.points;
        const nFirst = nPts[0], nLast = nPts[nPts.length-1];
        const wFirst = wPts[0], wLast = wPts[wPts.length-1];

        // Cas : fin de newWire touche début de w
        if (Math.hypot(nLast.x-wFirst.x, nLast.y-wFirst.y) < WIRE_TOL) {
          if (collinear(nPts[nPts.length-2]||nFirst, nLast, wFirst, wPts[1]||wLast)) {
            // Fusionner : nPts + wPts[1..] (supprimer le point commun)
            newWire.points = [...nPts.slice(0,-1), ...wPts];
            state.wires = state.wires.filter(x => x.id !== w.id);
            changed = true; break;
          }
        }
        // Cas : début de newWire touche fin de w
        if (Math.hypot(nFirst.x-wLast.x, nFirst.y-wLast.y) < WIRE_TOL) {
          if (collinear(wPts[wPts.length-2]||wFirst, wLast, nFirst, nPts[1]||nLast)) {
            newWire.points = [...wPts.slice(0,-1), ...nPts];
            state.wires = state.wires.filter(x => x.id !== w.id);
            changed = true; break;
          }
        }
        // Cas : fin de newWire touche fin de w
        if (Math.hypot(nLast.x-wLast.x, nLast.y-wLast.y) < WIRE_TOL) {
          if (collinear(nPts[nPts.length-2]||nFirst, nLast, wLast, wPts[wPts.length-2]||wFirst)) {
            newWire.points = [...nPts.slice(0,-1), ...[...wPts].reverse()];
            state.wires = state.wires.filter(x => x.id !== w.id);
            changed = true; break;
          }
        }
        // Cas : début de newWire touche début de w
        if (Math.hypot(nFirst.x-wFirst.x, nFirst.y-wFirst.y) < WIRE_TOL) {
          if (collinear(nPts[1]||nLast, nFirst, wFirst, wPts[1]||wLast)) {
            newWire.points = [...[...nPts].reverse().slice(0,-1), ...wPts];
            state.wires = state.wires.filter(x => x.id !== w.id);
            changed = true; break;
          }
        }
      }
    }
  }

  // Couper un fil existant en deux à un point (pour T-junction)
  function splitWireAt(wire, x, y) {
    // Ne jamais couper un bus
    if (wire.isBus) { addJunction(x, y); return; }
    const pts = wire.points;
    for (let i = 0; i < pts.length-1; i++) {
      if (distSeg({x,y}, pts[i], pts[i+1]) < WIRE_TOL) {
        const atStart = Math.hypot(x-pts[0].x, y-pts[0].y) < WIRE_TOL;
        const atEnd   = Math.hypot(x-pts[pts.length-1].x, y-pts[pts.length-1].y) < WIRE_TOL;
        if (atStart || atEnd) return; // pas de découpe aux bouts
        // Créer deux fils
        const snap = {x: Math.round(x/GRID)*GRID, y: Math.round(y/GRID)*GRID};
        const w1pts = [...pts.slice(0, i+1), snap];
        const w2pts = [snap, ...pts.slice(i+1)];
        if (w1pts.length >= 2 && w2pts.length >= 2) {
          state.wires = state.wires.filter(w => w.id !== wire.id);
          state.wires.push({id:uid(), points:w1pts, color:wire.color, width:wire.width, isBus:wire.isBus, num:wire.num});
          state.wires.push({id:uid(), points:w2pts, color:wire.color, width:wire.width, isBus:wire.isBus, num:wire.num});
        }
        return;
      }
    }
  }

  function addJunction(x, y) {
    if (!state.junctions) state.junctions = [];
    if (!state.junctions.some(j => Math.hypot(j.x-x,j.y-y)<3))
      state.junctions.push({x, y});
  }

  function cleanJunctions() {
    if (!state.junctions) return;
    state.junctions = state.junctions.filter(j => {
      let endpointCount = 0; // fils dont une extrémité est à ce point
      let segmentCount = 0;  // fils dont un segment passe par ce point (sans s'y terminer)
      for (const w of state.wires) {
        const pts = w.points;
        const atEnd = Math.hypot(pts[0].x-j.x,pts[0].y-j.y)<3 ||
                      Math.hypot(pts[pts.length-1].x-j.x,pts[pts.length-1].y-j.y)<3;
        if (atEnd) { endpointCount++; continue; }
        for (let i=0;i<pts.length-1;i++) {
          if (distSeg(j, pts[i], pts[i+1]) < 3) { segmentCount++; break; }
        }
      }
      // Garder la jonction si une extrémité touche un segment (connexion T)
      // ou si ≥3 extrémités se rejoignent
      return endpointCount >= 3 || (endpointCount >= 1 && segmentCount >= 1);
    });
  }


  // ── Valider et poser un fil ─────────────────────────────────
  function commitWirePoints(pts, isBus, resumedNum) {
    if (pts.length < 2) return;
    // Dédoublonner
    const clean = pts.filter((p,i) => i===0 || p.x!==pts[i-1].x || p.y!==pts[i-1].y);
    if (clean.length < 2) return;

    // ── Connexions aux extrémités ────────────────────────────
    // Un fil qui se TERMINE sur un bus → jonction (connexion)
    // Un fil qui CROISE un bus sans s'y terminer → rien (pas de connexion)
    // Un bus n'est jamais coupé
    // Un fil non-bus est coupé normalement
    const p0 = clean[0], pN = clean[clean.length-1];
    const seg0 = wireSegmentAt(p0.x, p0.y, null);
    const segN = wireSegmentAt(pN.x, pN.y, null);
    if (seg0) {
      if (seg0.wire.isBus) { addJunction(p0.x, p0.y); }
      else { splitWireAt(seg0.wire, p0.x, p0.y); }
    }
    if (segN && (!seg0 || segN.wire.id !== seg0.wire.id)) {
      if (segN.wire.isBus) { addJunction(pN.x, pN.y); }
      else { splitWireAt(segN.wire, pN.x, pN.y); }
    }

    // ── Numéro de fil ────────────────────────────────────────
    let num = '';
    if (resumedNum) {
      num = resumedNum;
    } else if (folio.wireAuto) {
      const ep0 = wireEndpointAt(p0.x,p0.y,null) || wireSegmentAt(p0.x,p0.y,null);
      const epN = wireEndpointAt(pN.x,pN.y,null) || wireSegmentAt(pN.x,pN.y,null);
      num = (ep0?.wire?.num) || (epN?.wire?.num) || nextWireNum();
    }

    // ── Créer le fil ─────────────────────────────────────────
    const newWire = {id:uid(), points:clean, color:isBus?PROJ.busColor:PROJ.wireColor, width:isBus?PROJ.busWidth:PROJ.wireWidth, isBus:!!isBus, num};
    state.wires.push(newWire);

    // ── Fusionner avec fils voisins colinéaires ───────────────
    mergeWires(newWire);

    // ── Nœuds aux jonctions T ────────────────────────────────
    // Un nœud est ajouté uniquement quand une EXTRÉMITÉ de fil touche un autre fil/bus
    // Un simple croisement géométrique (milieu de fil sur milieu de bus) ne crée PAS de jonction
    for (const pt of [newWire.points[0], newWire.points[newWire.points.length-1]]) {
      // Compter les fils dont une EXTRÉMITÉ est à ce point
      let endpointCount = 0;
      let segmentCount = 0;
      for (const w of state.wires) {
        const wPts = w.points;
        const atEnd = Math.hypot(wPts[0].x-pt.x,wPts[0].y-pt.y)<3 ||
                      Math.hypot(wPts[wPts.length-1].x-pt.x,wPts[wPts.length-1].y-pt.y)<3;
        if (atEnd) { endpointCount++; continue; }
        // Ce fil passe par ce point mais ne s'y termine pas (croisement)
        for (let i=0;i<wPts.length-1;i++) {
          if (distSeg(pt, wPts[i], wPts[i+1]) < 3) { segmentCount++; break; }
        }
      }
      // Jonction si ≥2 extrémités se rejoignent, OU si une extrémité touche un segment (T)
      if (endpointCount >= 3 || (endpointCount >= 1 && segmentCount >= 1)) {
        addJunction(pt.x, pt.y);
      }
    }
    cleanJunctions();
    saveHistory('Poser fil'); // snapshot après création du fil
    updateStatus();
    scheduleAutoXrefs();
  }

  function distSeg(p,a,b){const dx=b.x-a.x,dy=b.y-a.y;if(!dx&&!dy)return Math.hypot(p.x-a.x,p.y-a.y);const t=Math.max(0,Math.min(1,((p.x-a.x)*dx+(p.y-a.y)*dy)/(dx*dx+dy*dy)));return Math.hypot(p.x-(a.x+t*dx),p.y-(a.y+t*dy));}
  function hitLabel(el,wx,wy){if(!el.label)return false;const pos=Renderer.getLabelPos(el).label;ctx.font='bold 11px monospace';const tw=ctx.measureText(el.label).width;const tol=10/view.zoom;return Math.abs(wx-pos.x)<tw/2+tol&&Math.abs(wy-pos.y)<10+tol;}
  function hitRef(el,wx,wy){if(!el.ref)return false;const pos=Renderer.getLabelPos(el).ref;ctx.font='9px monospace';const tw=ctx.measureText(el.ref).width;const tol=10/view.zoom;return Math.abs(wx-pos.x)<tw/2+tol&&Math.abs(wy-pos.y)<8+tol;}
  function hitWireNum(wire,wx,wy){if(!wire.num)return false;const pos=Renderer.getWireNumPos(wire);if(!pos)return false;const tol=12/view.zoom;return Math.abs(wx-pos.x)<16+tol&&Math.abs(wy-pos.y)<8+tol;}
  function nearestPin(wx,wy){
    const tol=16/view.zoom;
    // 1. Pins des symboles (multi-pôle inclus)
    for(const el of state.elements){
      const sym=_symbols[el.symId];if(!sym?.pins)continue;
      const allPins = Renderer.getAllPins(el, sym);
      for(const {pin, poleIndex} of allPins){
        const[px,py]=Renderer.getPinWorld(el,sym,pin,poleIndex);
        if(Math.hypot(wx-px,wy-py)<tol)return{x:px,y:py};
      }
    }
    // 2. Extrémités de fils
    for(const w of state.wires){
      const pts=w.points;
      if(Math.hypot(wx-pts[0].x,wy-pts[0].y)<tol)return{x:pts[0].x,y:pts[0].y};
      const last=pts[pts.length-1];
      if(Math.hypot(wx-last.x,wy-last.y)<tol)return{x:last.x,y:last.y};
    }
    // 3. En mode mesure : centres de symboles aussi
    if(currentTool==='measure'){
      for(const el of state.elements){
        const sym=_symbols[el.symId];if(!sym)continue;
        const cx=el.x+(el.w||sym.width||60)/2, cy=el.y+(el.h||sym.height||40)/2;
        if(Math.hypot(wx-cx,wy-cy)<tol)return{x:cx,y:cy};
      }
    }
    return null;
  }
  function getById(type,id){
    if(type==='element')return state.elements.find(e=>e.id===id);
    if(type==='wire')return state.wires.find(w=>w.id===id);
    if(type==='text')return state.texts.find(t=>t.id===id);
    if(type==='image')return (state.images||[]).find(img=>img.id===id);
    if(type==='shape')return state.shapes.find(s=>s.id===id);
  }

  // ── Groupe de fils connectés avec même numéro (BFS) ─────
  function getWireGroup(wire) {
    if (!wire.num) return [wire];
    const num = wire.num;
    const adj = {};
    const wires = state.wires.filter(w => w.num === num);
    for (const w of wires) adj[w.id] = new Set();
    for (let i = 0; i < wires.length; i++) {
      const a = wires[i];
      const aE = [a.points[0], a.points[a.points.length-1]];
      for (let j = i+1; j < wires.length; j++) {
        const b = wires[j];
        const bE = [b.points[0], b.points[b.points.length-1]];
        for (const ap of aE) for (const bp of bE) {
          if (Math.hypot(ap.x-bp.x, ap.y-bp.y) < 12) {
            adj[a.id].add(b.id); adj[b.id].add(a.id);
          }
        }
      }
    }
    const visited = new Set([wire.id]);
    const q = [wire.id];
    while (q.length) {
      const cur = q.shift();
      for (const nid of (adj[cur] || [])) {
        if (!visited.has(nid)) { visited.add(nid); q.push(nid); }
      }
    }
    return wires.filter(w => visited.has(w.id));
  }

  // Point le plus proche sur un ensemble de fils
  function closestPointOnWireGroup(group, mx, my) {
    let best = null;
    for (const w of group) {
      const pts = w.points;
      for (let i = 0; i < pts.length-1; i++) {
        const a = pts[i], b = pts[i+1];
        const dx = b.x-a.x, dy = b.y-a.y;
        const len2 = dx*dx+dy*dy;
        let t = len2 ? Math.max(0, Math.min(1, ((mx-a.x)*dx+(my-a.y)*dy)/len2)) : 0;
        const px = a.x+t*dx, py = a.y+t*dy;
        const d = Math.hypot(mx-px, my-py);
        if (!best || d < best.dist) {
          best = {wire:w, x:px, y:py, dist:d, segIdx:i};
        }
      }
    }
    return best;
  }

  // ─────────────────────────────────────────────────────────

// ═══ app-editor.js ═══
  // ÉVÉNEMENTS CANVAS
  // ─────────────────────────────────────────────────────────
  function bindEvents(){
    canvas.addEventListener('mousedown',onDown);
    canvas.addEventListener('mousemove',onMove);
    canvas.addEventListener('mouseup',onUp);
    canvas.addEventListener('dblclick',onDbl);
    canvas.addEventListener('wheel',onWheel,{passive:false});
    canvas.addEventListener('contextmenu',onCtx);
    canvas.addEventListener('dragover',e=>e.preventDefault());
    canvas.addEventListener('drop',onDrop);
    canvas.addEventListener('mouseleave',()=>{ if(hovered){hovered=null;render();} });
    document.addEventListener('keydown',onKey);
    document.addEventListener('paste',onPasteImage);
    document.addEventListener('click',e=>{if(!document.getElementById('ctx-menu').contains(e.target))hideCtx();});
  }

  function onPasteImage(e){
    const items=e.clipboardData&&e.clipboardData.items;
    if(!items)return;
    let imageFile=null;
    for(let i=0;i<items.length;i++){
      if(items[i].type.startsWith('image/')){imageFile=items[i].getAsFile();break;}
    }
    if(!imageFile)return;
    e.preventDefault();
    const reader=new FileReader();
    reader.onload=ev=>{
      const src=ev.target.result;
      const imgEl=new Image();
      imgEl.onload=()=>{
        const naturalW=imgEl.naturalWidth||200, naturalH=imgEl.naturalHeight||200;
        const maxW=400;
        const w=Math.min(naturalW,maxW);
        const h=Math.round(w*naturalH/Math.max(naturalW,1));
        const cx=canvas.width/2, cy=canvas.height/2;
        const wx=(cx-view.panX)/view.zoom, wy=(cy-view.panY)/view.zoom;
        const x=snapW(wx-w/2), y=snapW(wy-h/2);
        if(!state.images)state.images=[];
        const img={id:uid(),x,y,w,h,src,opacity:1};
        state.images.push(img);
        setOnlySel('image',img.id);
        saveHistory('Coller image');
        render();updateProps();updateStatus();
        setStatus('📋 Image collée depuis le presse-papier');
      };
      imgEl.src=src;
    };
    reader.readAsDataURL(imageFile);
  }

  function cp(e){const r=canvas.getBoundingClientRect();return{sx:e.clientX-r.left,sy:e.clientY-r.top};}

  // Outils de dessin de schéma (formes libres)
  const DRAW_TOOLS=['line','rect','circle','poly','arc','textbox'];
  function isDrawTool(){return DRAW_TOOLS.includes(currentTool);}

  function onDown(e){
    hideCtx();
    const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
    const{x:snx,y:sny}=snapWxy(wx,wy);

    // Pan
    if(e.altKey||e.button===1){pan.active=true;pan.startMouse={x:e.clientX,y:e.clientY};pan.startPan={x:view.panX,y:view.panY};canvas.classList.add('pan-active');return;}

    // ── Placement de fonction (clic = valider) ──────────
    if(_funcPlacement && e.button===0){ _commitFuncPlacement(); return; }

    // ── Fil / Bus ─────────────────────────────────────────
    if(currentTool==='wire'||currentTool==='bus'){
      if(e.button!==0)return;
      const snap=nearestPin(wx,wy)||{x:snx,y:sny};
      if(!wireIP){
        // ── Reprendre un fil existant par son extrémité ──────
        const existing=wireEndpointAt(snap.x, snap.y, null);
        if(existing){
          // Reprendre ce fil : on repart depuis son extrémité
          const w=existing.wire;
          const pts=w.points;
          // Retirer le fil du state et continuer son tracé
          state.wires=state.wires.filter(x=>x.id!==w.id);
          if(existing.end==='end'){
            wireIP={points:[...pts],isBus:w.isBus,resumedFrom:w,resumedNum:w.num};
          } else {
            // Reprendre depuis le début : inverser les points
            wireIP={points:[...pts].reverse(),isBus:w.isBus,resumedFrom:w,resumedNum:w.num};
          }
          render();return;
        }
        wireIP={points:[snap],isBus:currentTool==='bus'};
      }else{
        const last=wireIP.points[wireIP.points.length-1];
        wireIP.points.push({x:snap.x,y:last.y});
        wireIP.points.push({x:snap.x,y:snap.y});
        // Auto-terminer si on snap sur un pin ou une extrémité de fil
        const onPin=nearestPin(wx,wy);
        const onWireEnd=wireEndpointAt(snap.x,snap.y,null);
        const onWireSeg=wireSegmentAt(snap.x,snap.y,null);
        if(onPin||onWireEnd||onWireSeg){
          // Commit immédiat
          const pts=wireIP.points.filter((p,i)=>i===0||p.x!==wireIP.points[i-1].x||p.y!==wireIP.points[i-1].y);
          if(pts.length>=2){
            commitWirePoints(pts, wireIP.isBus, wireIP.resumedNum||null);
          }
          wireIP=null;
        }
      }
      render();return;
    }

    // ── Texte ─────────────────────────────────────────────
    if(currentTool==='text'){
      if(e.button!==0)return;
      const txt=prompt('Texte :');
      if(txt){state.texts.push({id:uid(),x:snx,y:sny,text:txt,size:PROJ.textSize,color:PROJ.textColor});saveHistory('Ajouter texte');render();updateStatus();}
      return;
    }

    if(currentTool==='image'){
      if(e.button!==0)return;
      if(_pendingImageData){ placeImage(wx,wy); }
      else { pickImageFile(); }
      return;
    }

    // ── Simulateur ────────────────────────────────────────
    if(currentTool==='simulate'){
      if(e.button!==0)return;
      const el=hitEl(wx,wy);
      if(el){
        const sym=_symbols[el.symId];
        if(!sym)return;
        const role=sym.elementRole||'';
        // Basculer l'état actif/repos
        if(['contact','breaker','coil','button','terminal'].includes(role)){
          el.simActive=!el.simActive;
          // Propagation : bobine/bouton → contacts liés
          if(role==='coil'||role==='button'){
            _simPropagate(el);
          }
          render();
          setStatus(`${el.label||sym.name} → ${el.simActive?'ACTIF':'REPOS'}`);
        } else {
          setStatus(`${sym.name} : pas de simulation pour ce type`);
        }
      }
      return;
    }

    // ── Outil mesure ──────────────────────────────────────
    if(currentTool==='measure'){
      if(e.button!==0)return;
      const _msnap=nearestPin(wx,wy)||{x:snx,y:sny};
      if(!measureIP||measureIP.frozen){
        // Nouvelle mesure
        measureIP={p1:_msnap,p2:_msnap,frozen:false,p1Snap:!!nearestPin(wx,wy),
          color:_MEASURE_COLORS[_measureColorIdx%_MEASURE_COLORS.length]};
      } else {
        // Figer et archiver
        measureIP.p2=_msnap;measureIP.frozen=true;
        const archived={...measureIP,id:'m'+Date.now()};
        _measures.push(archived);
        _measureColorIdx++;
        _updateMeasureStatus(archived);
        // Broadcaster la mesure figée
        LiveSync.broadcast({type:'measure_frozen',measure:archived,folioId:currentFolioId});
        measureIP=null; // prêt pour une nouvelle
      }
      render();return;
    }

    // ── Formes libres ─────────────────────────────────────
    if(isDrawTool()){
      if(e.button!==0)return;
      const color=document.getElementById('draw-color').value||'#3b9eff';
      const thick=parseFloat(document.getElementById('draw-thick').value)||1.5;
      const fill=document.getElementById('draw-fill').checked;

      if(!shapeIP){
        // Démarrer
        shapeIP={tool:currentTool,pts:[{x:snx,y:sny}],color,thick,fill};
      }else{
        // Ajouter un point (ligne/poly)
        if(currentTool==='poly'||currentTool==='line'){
          shapeIP.pts.push({x:snx,y:sny});
        }else if(currentTool==='rect'||currentTool==='circle'||currentTool==='textbox'){
          // 2 points → commit
          shapeIP.pts.push({x:snx,y:sny});
          commitShapeIP();
        }else if(currentTool==='arc'){
          if(shapeIP.pts.length===1){
            const r=Math.hypot(snx-shapeIP.pts[0].x,sny-shapeIP.pts[0].y);
            const a1=Math.atan2(sny-shapeIP.pts[0].y,snx-shapeIP.pts[0].x);
            shapeIP.pts.push({r,a1,x:snx,y:sny});// push pour la coord du rayon
          }else{
            // troisième clic : fin
            shapeIP.pts.push({x:snx,y:sny});commitShapeIP();
          }
        }
      }
      render();return;
    }

    // ── Sélection ─────────────────────────────────────────
    if(currentTool==='select'){
      const junc=hitJunction(wx,wy);
      if(junc&&!e.shiftKey){
        const jkey=junc.x+','+junc.y;
        setOnlySel('junction',jkey);
        render();updateProps();return;
      }
      const el=hitEl(wx,wy),wire=hitWire(wx,wy),txt=hitText(wx,wy),sh=hitShape(wx,wy),imgObj=hitImage(wx,wy);
      const hitObj=el||wire||txt||sh||imgObj;

      // ── Poignée d'extrémité de fil (allonger / continuer) ──────────────
      if(!e.shiftKey && selected.id && selected.type==='wire' && multiSel.size<=1){
        const selWire=getSel();
        if(selWire){
          const hIdx=Renderer.getWireEndpointHandle(selWire,wx,wy,view.zoom);
          if(hIdx!==null){
            subdrag={active:true,type:'wire-endpoint',obj:selWire,ptIdx:hIdx,
              startMouse:{x:wx,y:wy},origPt:{...selWire.points[hIdx]},moved:false};
            canvas.style.cursor='crosshair';
            return;
          }
        }
      }

      // ── Resize poignée de coin (élément symbole uniquement, sélection unique) ──
      if(!e.shiftKey && selected.id && selected.type==='element' && multiSel.size<=1){
        const selObj=getSel();
        if(selObj){
          const dir=Renderer.getResizeHandle(selObj, wx, wy, view.zoom);
          if(dir){
            subdrag={active:true,type:'resize',obj:selObj,dir,
              startMouse:{x:wx,y:wy},
              startBox:{x:selObj.x,y:selObj.y,w:selObj.w,h:selObj.h}};
            const cursors={nw:'nw-resize',ne:'ne-resize',sw:'sw-resize',se:'se-resize',n:'n-resize',s:'s-resize',e:'e-resize',w:'w-resize'};
            canvas.style.cursor=cursors[dir]||'nwse-resize';
            return;
          }
        }
      }
      // ── Resize poignée de forme (shape) ──
      if(!e.shiftKey && selected.id && selected.type==='shape' && multiSel.size<=1){
        const selObj=getSel();
        if(selObj && Renderer.getShapeResizeHandle){
          const dir=Renderer.getShapeResizeHandle(selObj, wx, wy, view.zoom);
          if(dir){
            const startData = (selObj.t==='rect'||selObj.t==='textbox') ? {x:selObj.x,y:selObj.y,w:selObj.w,h:selObj.h}
              : selObj.t==='circle' ? {cx:selObj.cx,cy:selObj.cy,r:selObj.r}
              : selObj.t==='arc' ? {cx:selObj.cx,cy:selObj.cy,r:selObj.r,a1:selObj.a1,a2:selObj.a2}
              : selObj.pts ? {pts:JSON.parse(JSON.stringify(selObj.pts))}
              : null;
            if(startData){
              subdrag={active:true,type:'shapeResize',obj:selObj,dir,
                startMouse:{x:wx,y:wy},startData};
              const curMap={nw:'nw-resize',ne:'ne-resize',sw:'sw-resize',se:'se-resize',n:'n-resize',s:'s-resize',e:'e-resize',w:'w-resize'};
              canvas.style.cursor=dir.startsWith('pt:')?'crosshair':curMap[dir]||'move';
              return;
            }
          }
        }
      }

      // ── Resize poignée de texte (zone) ──
      if(!e.shiftKey && selected.id && selected.type==='text' && multiSel.size<=1){
        const selObj=getSel();
        if(selObj && selObj.w && selObj.h && Renderer.getTextResizeHandle){
          const dir=Renderer.getTextResizeHandle(selObj, wx, wy, view.zoom);
          if(dir){
            subdrag={active:true,type:'textResize',obj:selObj,dir,
              startMouse:{x:wx,y:wy},startData:{w:selObj.w,h:selObj.h}};
            canvas.style.cursor='se-resize';
            return;
          }
        }
      }

      // ── Drag sous-élément (label/ref/numéro de fil) ───────
      if(!e.shiftKey&&selected.id){
        const selObj=getSel();
        if(selected.type==='element'&&selObj){
          if(hitLabel(selObj,wx,wy)){
            subdrag={active:true,type:'label',obj:selObj,startMouse:{x:wx,y:wy},startOff:{x:selObj.labelOffX||0,y:selObj.labelOffY||-18}};
            canvas.style.cursor='move';render();return;
          }
          if(hitRef(selObj,wx,wy)){
            subdrag={active:true,type:'ref',obj:selObj,startMouse:{x:wx,y:wy},startOff:{x:selObj.refOffX||0,y:selObj.refOffY||10}};
            canvas.style.cursor='move';render();return;
          }
        }
        if(selected.type==='wire'&&selObj&&hitWireNum(selObj,wx,wy)){
          const wg=getWireGroup(selObj);
          subdrag={active:true,type:'wirenum',obj:selObj,startMouse:{x:wx,y:wy},startOff:{x:selObj.numOffX||0,y:selObj.numOffY||-10},wireGroup:wg,targetWire:selObj};
          canvas.style.cursor='move';render();return;
        }
      }

      if(hitObj){
        const type=el?'element':wire?'wire':txt?'text':imgObj?'image':'shape';
        const key=selKey(type,hitObj.id);
        if(e.shiftKey){if(multiSel.has(key))multiSel.delete(key);else multiSel.add(key);selected={type,id:hitObj.id};}
        else{if(!multiSel.has(key))setOnlySel(type,hitObj.id);}
        // Démarrer drag
        drag.active=true;drag.startMouse={x:wx,y:wy};drag.ids=[...multiSel];drag.startPositions={};
        drag.ids.forEach(k=>{const[t,id]=k.split(':');const o=getById(t,id);if(o)drag.startPositions[k]=getDragPos(t,o);});
        // Pour les éléments, capturer les fils connectés + leurs points d'origine complets
        drag.ids.forEach(k=>{
          const[t,id]=k.split(':');
          if(t!=='element')return;
          const el=getById(t,id);if(!el)return;
          const sym=_symbols[el.symId];if(!sym?.pins)return;
          const pinConns=[];
          Renderer.getAllPins(el,sym).forEach(({pin,poleIndex})=>{
            const[px,py]=Renderer.getPinWorld(el,sym,pin,poleIndex);
            state.wires.forEach(w=>{
              const pts=w.points;
              const atStart=Math.hypot(pts[0].x-px,pts[0].y-py)<WIRE_TOL;
              const atEnd=Math.hypot(pts[pts.length-1].x-px,pts[pts.length-1].y-py)<WIRE_TOL;
              if(atStart||atEnd){
                pinConns.push({
                  wireId:w.id,
                  end:atStart?'start':'end',
                  pinOrigX:px, pinOrigY:py,
                  // Copie profonde des points d'origine du fil
                  origPts: JSON.parse(JSON.stringify(pts))
                });
              }
            });
          });
          if(pinConns.length) drag.startPositions[k]._pinPositions=pinConns;
        });
      }else{
        if(!e.shiftKey)clearMultiSel();
        rubberBand={sx,sy,ex:sx,ey:sy};
      }
      render();updateProps();
    }
  }

  function getDragPos(type,o){
    if(type==='element')return{x:o.x,y:o.y};
    if(type==='text')return{x:o.x,y:o.y};
    if(type==='image')return{x:o.x,y:o.y};
    if(type==='shape'){
      if(o.t==='group')return{anchor:JSON.parse(JSON.stringify(groupBBox(o)))};
      if(o.t==='rect'||o.t==='textbox')return{x:o.x,y:o.y};
      if(o.t==='circle'||o.t==='arc')return{x:o.cx,y:o.cy};
      if(o.pts)return{pts:JSON.parse(JSON.stringify(o.pts))};
    }
    if(type==='wire')return{pts:JSON.parse(JSON.stringify(o.points))};
    return{x:0,y:0};
  }

  // Nettoyer un fil : supprimer doublons, colinéaires, retours en arrière
  function _cleanWirePoints(pts) {
    if (!pts || pts.length < 2) return pts;
    // 1. Supprimer doublons consécutifs
    let clean = [pts[0]];
    for (let i = 1; i < pts.length; i++) {
      if (pts[i].x !== clean[clean.length-1].x || pts[i].y !== clean[clean.length-1].y)
        clean.push(pts[i]);
    }
    // 2. Supprimer les points colinéaires (3 points sur la même ligne H ou V)
    let changed = true;
    while (changed) {
      changed = false;
      const next = [clean[0]];
      for (let i = 1; i < clean.length - 1; i++) {
        const prev = next[next.length-1], cur = clean[i], nxt = clean[i+1];
        // Colinéaire horizontal (même Y pour les 3)
        if (prev.y === cur.y && cur.y === nxt.y) { changed = true; continue; }
        // Colinéaire vertical (même X pour les 3)
        if (prev.x === cur.x && cur.x === nxt.x) { changed = true; continue; }
        next.push(cur);
      }
      if (clean.length > 1) next.push(clean[clean.length-1]);
      clean = next;
    }
    if (clean.length < 2 && pts.length >= 2) clean = [pts[0], pts[pts.length-1]];
    return clean;
  }

  function applyDragDelta(type,o,sp,dx,dy){
    if(type==='element'){
      o.x=snapW(sp.x+dx);o.y=snapW(sp.y+dy);
      // ── Fils élastiques : déplacer l'extrémité + ajuster le segment adjacent ─
      if(sp._pinPositions){
        sp._pinPositions.forEach(({wireId,end,pinOrigX,pinOrigY,origPts})=>{
          const w=state.wires.find(w=>w.id===wireId);
          if(!w||!origPts)return;
          // Si le fil est aussi dans la sélection (draggé en même temps), ne pas appliquer l'élastique
          if(drag.ids.includes(selKey('wire',wireId)))return;
          const newPx=snapW(pinOrigX+dx), newPy=snapW(pinOrigY+dy);
          // Copie fraîche des points d'origine
          let pts=origPts.map(p=>({...p}));

          if(end==='start' && pts.length>=2){
            pts[0]={x:newPx,y:newPy};
            if(pts.length===2){
              // Fil à 2 points : ne PAS toucher l'autre extrémité (potentiellement connectée)
              // Insérer un coude intermédiaire pour maintenir l'orthogonalité
              const far=pts[1]; // l'autre bout — on ne le bouge pas
              if(newPx!==far.x && newPy!==far.y){
                // Pas aligné → insérer un coude (horizontal d'abord)
                pts.splice(1,0,{x:newPx,y:far.y});
              }
            } else {
              // 3+ points : ajuster pts[1] sans toucher le reste
              if(origPts[0].x===origPts[1].x) pts[1]={x:newPx, y:pts[1].y};
              else if(origPts[0].y===origPts[1].y) pts[1]={x:pts[1].x, y:newPy};
            }
          } else if(end==='end' && pts.length>=2){
            const last=pts.length-1;
            pts[last]={x:newPx,y:newPy};
            if(pts.length===2){
              // Fil à 2 points : ne PAS toucher l'autre extrémité
              const far=pts[0];
              if(newPx!==far.x && newPy!==far.y){
                pts.splice(1,0,{x:far.x,y:newPy});
              }
            } else {
              // 3+ points : ajuster l'avant-dernier sans toucher le début
              if(origPts[last].x===origPts[last-1].x) pts[last-1]={x:newPx, y:pts[last-1].y};
              else if(origPts[last].y===origPts[last-1].y) pts[last-1]={x:pts[last-1].x, y:newPy};
            }
          } else {
            pts[0]={x:newPx,y:newPy};
          }

          // Nettoyer le fil : supprimer doublons, points colinéaires, retours en arrière
          w.points = _cleanWirePoints(pts);
        });
      }
    }
    else if(type==='text'){o.x=snapW(sp.x+dx);o.y=snapW(sp.y+dy);}
    else if(type==='image'){o.x=snapW(sp.x+dx);o.y=snapW(sp.y+dy);}
    else if(type==='shape'){
      if(o.t==='group'&&sp.anchor){
        // Déplacer tous les enfants du groupe
        const adx=snapW(sp.anchor.x+dx)-sp.anchor.x, ady=snapW(sp.anchor.y+dy)-sp.anchor.y;
        function moveChild(c,ddx,ddy){
          if(c.t==='rect'||c.t==='textbox'){c.x+=ddx;c.y+=ddy;}
          else if(c.t==='circle'||c.t==='arc'){c.cx+=ddx;c.cy+=ddy;}
          else if(c.pts)c.pts=c.pts.map(p=>({...p,x:p.x+ddx,y:p.y+ddy}));
          else if(c.t==='group')c.children.forEach(gc=>moveChild(gc,ddx,ddy));
        }
        // Reset position from saved anchor
        const curBB=groupBBox(o);
        const realDx=snapW(sp.anchor.x+dx)-curBB.x, realDy=snapW(sp.anchor.y+dy)-curBB.y;
        o.children.forEach(c=>moveChild(c,realDx,realDy));
      }
      else if(o.t==='rect'||o.t==='textbox'){o.x=snapW(sp.x+dx);o.y=snapW(sp.y+dy);}
      else if(o.t==='circle'||o.t==='arc'){o.cx=snapW(sp.x+dx);o.cy=snapW(sp.y+dy);}
      else if(o.pts&&sp.pts){o.pts=sp.pts.map(p=>({...p,x:snapW(p.x+dx),y:snapW(p.y+dy)}));}
    }
    else if(type==='wire'&&sp.pts){o.points=sp.pts.map(p=>({x:snapW(p.x+dx),y:snapW(p.y+dy)}));}
  }

  function onMove(e){
    const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
    const{x:snx,y:sny}=snapWxy(wx,wy);
    if(!_cartoucheEditMode) document.getElementById('sb-cursor').textContent=`${Math.round(snx)}, ${Math.round(sny)}`;

    if(pan.active){view.panX=pan.startPan.x+(e.clientX-pan.startMouse.x);view.panY=pan.startPan.y+(e.clientY-pan.startMouse.y);render();return;}

    if(rubberBand){rubberBand.ex=sx;rubberBand.ey=sy;render();return;}

    // Subdrag : déplacer label / ref / numéro de fil
    if(subdrag.active){
      let dx=wx-subdrag.startMouse.x, dy=wy-subdrag.startMouse.y;
      const o=subdrag.obj;
      const sn=v=>snapLabels?Math.round(v/GRID)*GRID:Math.round(v);
      if(subdrag.type==='wire-endpoint'){
        const pt=subdrag.obj.points[subdrag.ptIdx];
        pt.x=snapW(wx); pt.y=snapW(wy);
        subdrag.moved=true;
        render();return;
      } else if(subdrag.type==='resize'){
        const b=subdrag.startBox;
        const dir=subdrag.dir;
        const proportional = e.shiftKey || (o._lockAspect===true);
        const origRatio = b.w / Math.max(b.h, 1);
        const minS = Math.max(GRID, 10);
        let nx=b.x, ny=b.y, nw=b.w, nh=b.h;
        // Coins (resize 2D)
        if(dir==='se'){ nw=Math.max(minS,b.w+dx); nh=Math.max(minS,b.h+dy); }
        else if(dir==='sw'){ const rw=Math.max(minS,b.w-dx); nx=b.x+b.w-rw; nw=rw; nh=Math.max(minS,b.h+dy); }
        else if(dir==='ne'){ nw=Math.max(minS,b.w+dx); const rh=Math.max(minS,b.h-dy); ny=b.y+b.h-rh; nh=rh; }
        else if(dir==='nw'){ const rw=Math.max(minS,b.w-dx); nx=b.x+b.w-rw; nw=rw; const rh=Math.max(minS,b.h-dy); ny=b.y+b.h-rh; nh=rh; }
        // Bords (resize 1D — horizontal ou vertical uniquement)
        else if(dir==='e'){ nw=Math.max(minS,b.w+dx); }
        else if(dir==='w'){ const rw=Math.max(minS,b.w-dx); nx=b.x+b.w-rw; nw=rw; }
        else if(dir==='s'){ nh=Math.max(minS,b.h+dy); }
        else if(dir==='n'){ const rh=Math.max(minS,b.h-dy); ny=b.y+b.h-rh; nh=rh; }
        if(proportional && (dir==='se'||dir==='sw'||dir==='ne'||dir==='nw')){
          if(dir==='se'||dir==='sw') nh=Math.round(nw/origRatio);
          else if(dir==='ne'||dir==='nw'){ nh=Math.round(nw/origRatio); ny=b.y+b.h-nh; }
        }
        o.x=Math.round(nx); o.y=Math.round(ny);
        o.w=Math.max(minS,Math.round(nw)); o.h=Math.max(minS,Math.round(nh));
        const piW=document.getElementById('pe-sym-w'), piH=document.getElementById('pe-sym-h');
        if(piW)piW.value=o.w; if(piH)piH.value=o.h;
      }else if(subdrag.type==='shapeResize'){
        const d=subdrag.startData, dir=subdrag.dir;
        const minS=Math.max(GRID,4);
        if(o.t==='rect'||o.t==='textbox'){
          if(o.t==='textbox'&&o.angle){
            const rad=-(o.angle)*Math.PI/180;
            const ldx=dx*Math.cos(rad)-dy*Math.sin(rad);
            const ldy=dx*Math.sin(rad)+dy*Math.cos(rad);
            dx=ldx;dy=ldy;
          }
          let nx=d.x,ny=d.y,nw=d.w,nh=d.h;
          if(dir==='se'){nw=Math.max(minS,d.w+dx);nh=Math.max(minS,d.h+dy);}
          else if(dir==='sw'){const rw=Math.max(minS,d.w-dx);nx=d.x+d.w-rw;nw=rw;nh=Math.max(minS,d.h+dy);}
          else if(dir==='ne'){nw=Math.max(minS,d.w+dx);const rh=Math.max(minS,d.h-dy);ny=d.y+d.h-rh;nh=rh;}
          else if(dir==='nw'){const rw=Math.max(minS,d.w-dx);nx=d.x+d.w-rw;nw=rw;const rh=Math.max(minS,d.h-dy);ny=d.y+d.h-rh;nh=rh;}
          else if(dir==='e'){nw=Math.max(minS,d.w+dx);}
          else if(dir==='w'){const rw=Math.max(minS,d.w-dx);nx=d.x+d.w-rw;nw=rw;}
          else if(dir==='s'){nh=Math.max(minS,d.h+dy);}
          else if(dir==='n'){const rh=Math.max(minS,d.h-dy);ny=d.y+d.h-rh;nh=rh;}
          o.x=sn(nx);o.y=sn(ny);o.w=Math.max(minS,sn(nw));o.h=Math.max(minS,sn(nh));
        }else if(o.t==='circle'){
          // Directions cardinales → changer le rayon
          const newR=Math.max(minS,Math.round(
            dir==='e'?d.r+dx : dir==='w'?d.r-dx : dir==='s'?d.r+dy : d.r-dy
          ));
          o.r=newR;
        }else if(o.t==='arc'){
          if(dir==='arcRadius'){
            o.r=Math.max(minS,Math.round(Math.hypot(wx-o.cx,wy-o.cy)));
          }else if(dir==='arcStart'){
            o.a1=Math.atan2(wy-o.cy,wx-o.cx);
          }else if(dir==='arcEnd'){
            o.a2=Math.atan2(wy-o.cy,wx-o.cx);
          }
        }else if((o.t==='line'||o.t==='poly')&&dir.startsWith('pt:')){
          const idx=parseInt(dir.split(':')[1]);
          if(o.pts&&o.pts[idx]){o.pts[idx]={x:sn(wx),y:sn(wy)};}
        }
        render();return;
      }else if(subdrag.type==='textResize'){
        const d=subdrag.startData;
        let ldx=dx, ldy=dy;
        if(o.angle){
          const rad=-(o.angle)*Math.PI/180;
          ldx=dx*Math.cos(rad)-dy*Math.sin(rad);
          ldy=dx*Math.sin(rad)+dy*Math.cos(rad);
        }
        o.w=Math.max(GRID,sn(d.w+ldx));o.h=Math.max(GRID,sn(d.h+ldy));
        render();return;
      }else if(subdrag.type==='label'){
        o.labelOffX=sn(subdrag.startOff.x+dx);
        o.labelOffY=sn(subdrag.startOff.y+dy);
        const lox=document.getElementById('pi-lox'),loy=document.getElementById('pi-loy');
        if(lox)lox.value=o.labelOffX;if(loy)loy.value=o.labelOffY;
      }else if(subdrag.type==='ref'){
        o.refOffX=sn(subdrag.startOff.x+dx);
        o.refOffY=sn(subdrag.startOff.y+dy);
        const rox=document.getElementById('pi-rox'),roy=document.getElementById('pi-roy');
        if(rox)rox.value=o.refOffX;if(roy)roy.value=o.refOffY;
      }else if(subdrag.type==='wirenum'){
        const group=subdrag.wireGroup;
        if(group&&group.length>1){
          // Projeter la souris sur le groupe de fils connectés
          const closest=closestPointOnWireGroup(group,wx,wy);
          if(closest){
            const tw=closest.wire;
            const pts=tw.points;
            const midIdx=Math.max(0,Math.floor((pts.length-1)/2));
            const p1=pts[midIdx],p2=pts[Math.min(midIdx+1,pts.length-1)];
            const mx2=(p1.x+p2.x)/2, my2=(p1.y+p2.y)/2;
            // Calculer l'offset par rapport au milieu du fil cible
            tw.numOffX=sn(closest.x-mx2);
            tw.numOffY=sn(closest.y-my2-10);
            // Mettre à jour le fil cible
            if(subdrag.targetWire!==tw){
              // Transférer : cacher l'ancien, montrer le nouveau
              subdrag.targetWire._numHidden=true;
              tw._numHidden=false;
              tw.numOwner=true;
              subdrag.targetWire.numOwner=false;
              subdrag.targetWire=tw;
              subdrag.obj=tw;
            }
            const nox=document.getElementById('pw-nox'),noy=document.getElementById('pw-noy');
            if(nox)nox.value=tw.numOffX;if(noy)noy.value=tw.numOffY;
          }
        }else{
          o.numOffX=sn(subdrag.startOff.x+dx);
          o.numOffY=sn(subdrag.startOff.y+dy);
          const nox=document.getElementById('pw-nox'),noy=document.getElementById('pw-noy');
          if(nox)nox.value=o.numOffX;if(noy)noy.value=o.numOffY;
        }
      }
      render();return;
    }
    if(drag.active&&drag.ids.length){
      const dx=wx-drag.startMouse.x,dy=wy-drag.startMouse.y;
      drag.ids.forEach(k=>{const[t,id]=k.split(':');const o=getById(t,id);const sp=drag.startPositions[k];if(o&&sp)applyDragDelta(t,o,sp,dx,dy);});
      // Broadcaster la position live du drag aux autres clients
      const now=Date.now();
      if(!drag._lastBcast||now-drag._lastBcast>30){
        drag._lastBcast=now;
        const items=drag.ids.map(k=>{
          const[t,id]=k.split(':');const o=getById(t,id);
          if(!o)return null;
          if(t==='element') return {id,type:t,x:o.x,y:o.y,symId:o.symId,w:o.w,h:o.h,rotation:o.rotation||0};
          if(t==='wire')    return {id,type:t,pts:o.points,color:o.color,width:o.width};
          if(t==='text')    return {id,type:t,x:o.x,y:o.y,text:o.text,size:o.size,color:o.color,angle:o.angle||0};
          if(t==='shape')   return {id,type:t,_sh:Object.assign({},o)}; // objet complet
          if(t==='image')   return {id,type:t,x:o.x,y:o.y,w:o.w,h:o.h,src:o.src};
          return null;
        }).filter(Boolean);
        LiveSync._broadcastDrag({items});
      }
      _computeSnapGuides();
      render();return;
    }

    // Survol : cursor adaptatif selon ce qui est sous le pointeur
    if(currentTool==='select'){
      const selObj=getSel();
      let onSub=false;
      if(selected.id&&selected.type==='element'&&selObj){onSub=hitLabel(selObj,wx,wy)||hitRef(selObj,wx,wy);}
      if(selected.id&&selected.type==='wire'&&selObj){onSub=hitWireNum(selObj,wx,wy);}
      // Cursor sur poignée d'extrémité de fil
      if(selected.id&&selected.type==='wire'&&selObj&&multiSel.size<=1){
        const hIdx=Renderer.getWireEndpointHandle(selObj,wx,wy,view.zoom);
        if(hIdx!==null){canvas.style.cursor='crosshair';return;}
      }
      // Cursor sur poignée de resize (coins orange)
      if(selected.id&&selected.type==='element'&&selObj&&multiSel.size<=1){
        const dir=Renderer.getResizeHandle(selObj,wx,wy,view.zoom);
        if(dir){const c={nw:'nw-resize',ne:'ne-resize',sw:'sw-resize',se:'se-resize',n:'n-resize',s:'s-resize',e:'e-resize',w:'w-resize'};canvas.style.cursor=c[dir];return;}
      }
      // Cursor sur poignée de resize de forme (shape)
      if(selected.id&&selected.type==='shape'&&selObj&&multiSel.size<=1&&Renderer.getShapeResizeHandle){
        const sdir=Renderer.getShapeResizeHandle(selObj,wx,wy,view.zoom);
        if(sdir){
          const c={nw:'nw-resize',ne:'ne-resize',sw:'sw-resize',se:'se-resize',n:'n-resize',s:'s-resize',e:'e-resize',w:'w-resize'};
          canvas.style.cursor=sdir.startsWith('pt:')?'crosshair':sdir.startsWith('arc')?'crosshair':c[sdir]||'move';return;
        }
      }
      const overAny=onSub||hitText(wx,wy)||hitEl(wx,wy)||hitWire(wx,wy)||hitShape(wx,wy)||hitImage(wx,wy);
      canvas.style.cursor=overAny?'move':'';
    }

    if(currentTool==='measure'&&measureIP&&!measureIP.frozen){
      const _ms2=nearestPin(wx,wy)||{x:wx,y:wy};
      measureIP.p2=_ms2;
      measureIP.snapActive=!!nearestPin(wx,wy);
      _updateMeasureStatus(measureIP);
      // Broadcaster la mesure en cours aux peers
      LiveSync.broadcast({type:'measure_update',
        measure:{p1:measureIP.p1,p2:measureIP.p2,frozen:false,color:measureIP.color},
        folioId:currentFolioId});
      render();return;
    }
    const prev=hovered;const el=hitEl(wx,wy);hovered=el?el.id:null;
    if(hovered!==prev)render();
    const snap=nearestPin(wx,wy)||{x:snx,y:sny};
    cursorWorld=snap;
    if(_funcPlacement) render();
    if(wireIP||shapeIP){
      render();
      // Broadcaster le tracé en cours aux pairs
      const now=Date.now();
      if(!_drawingBcastT||now-_drawingBcastT>40){
        _drawingBcastT=now;
        if(wireIP){
          LiveSync.broadcastDrawing({
            tool: wireIP.isBus?'bus':'wire',
            pts: [...wireIP.points, {x:snap.x,y:snap.y}]
          });
        } else if(shapeIP){
          LiveSync.broadcastDrawing({
            tool: shapeIP.tool,
            pts: shapeIP.pts,
            cursor: {x:snap.x,y:snap.y},
            color: shapeIP.color,
            thick: shapeIP.thick,
            fill: shapeIP.fill
          });
        }
      }
    } else if(_drawingBcastT){
      // Plus rien en cours : notifier les pairs
      _drawingBcastT=0;
      LiveSync.broadcastDrawing(null);
    }
  }

  function onUp(e){
    if(pan.active){pan.active=false;canvas.classList.remove('pan-active');}
    if(subdrag.active){
      if(subdrag.type==='wire-endpoint'){
        if(!subdrag.moved){
          // Clic sans drag → reprendre le tracé depuis cette extrémité
          // On utilise la même mécanique que wireEndpointAt / resumedFrom
          const w=subdrag.obj;
          const isStart=(subdrag.ptIdx===0);
          // Retirer le fil du state et le mettre en cours d'édition
          state.wires=state.wires.filter(x=>x.id!==w.id);
          const pts = isStart ? [...w.points].reverse() : [...w.points];
          wireIP={points:pts, isBus:w.isBus, resumedFrom:w, resumedNum:w.num,
                  color:w.color, width:w.width};
          subdrag.active=false;subdrag.type=null;canvas.style.cursor='';
          setTool(w.isBus?'bus':'wire');
          render();return;
        } else {
          saveHistory('Poser fil');
        }
      } else {
        // Finaliser le transfert de numéro si le fil cible a changé
        if(subdrag.type==='wirenum'&&subdrag.wireGroup&&subdrag.wireGroup.length>1){
          const tw=subdrag.targetWire;
          tw.numOwner=true;
          for(const gw of subdrag.wireGroup){
            if(gw.id!==tw.id) gw.numOwner=false;
          }
          // Mettre à jour la sélection sur le nouveau fil
          if(tw.id!==selected.id){
            selected={type:'wire',id:tw.id};
            multiSel.clear();multiSel.add('wire:'+tw.id);
          }
        }
        const histLabel = subdrag.type==='shapeResize'||subdrag.type==='textResize' ? 'Redimensionner' :
                          subdrag.type==='label'||subdrag.type==='ref' ? 'Déplacer étiquette' : 'Déplacer numéro fil';
        saveHistory(histLabel);
      }
      subdrag.active=false;subdrag.type=null;canvas.style.cursor='';updateProps();
    }
    if(drag.active){
      saveHistory('Déplacer');drag.active=false;drag.ids=[];
      _snapGuides=[];
      LiveSync.broadcastDragEnd();
      // Sur un folio implantation, synchroniser les positions des rails/goulottes déplacés
      // et clamper les éléments si l'option "borner à la grille" est active
      const _curPf=projectFolios.find(x=>x.id===currentFolioId);
      const _isImpl=_curPf?.data?.folio_type==='implantation'||_curPf?.folio_type==='implantation';
      if(_isImpl){
        if(_curPf?.data?.implantation?.clampToGrid||_curPf?.implantation?.clampToGrid){_clampImplantElementsToGrid();}
        _syncImplantShapesToCfg();
      }
    }
    if(rubberBand){
      const{sx,sy,ex,ey}=rubberBand;
      if(Math.abs(ex-sx)>6||Math.abs(ey-sy)>6)selectInRubberBand();
      rubberBand=null;render();updateProps();
    }
  }

  // ── Hit-test et navigation xref (renvoi de folio) ────────────────
  let _xrefHighlight = null; // {wireId, end:'start'|'end', until:timestamp}

  function _hitXref(wx, wy) {
    // Vérifie si un point monde est sur un renvoi de folio
    const TOL = 12 / view.zoom;
    for (const w of state.wires) {
      const pts = w.points;
      if (pts.length < 2) continue;
      if (w.xrefStart) {
        const p = pts[0];
        if (Math.hypot(wx - p.x, wy - p.y) < TOL + 40) return { wire: w, end: 'start', label: w.xrefStart };
      }
      if (w.xrefEnd) {
        const p = pts[pts.length - 1];
        if (Math.hypot(wx - p.x, wy - p.y) < TOL + 40) return { wire: w, end: 'end', label: w.xrefEnd };
      }
    }
    return null;
  }

  async function _navigateXref(hit) {
    // Extraire le numéro de folio depuis le label (ex: "F3" → folio_num 3)
    const m = hit.label.match(/^F([0-9]+(?:\.[0-9]+)?)/);
    if (!m) return;
    const targetNum = m[1];
    const targetFolio = projectFolios.find(f => String(f.folio_num) === targetNum);
    if (!targetFolio) return;
    const wireNum = hit.wire.num;
    // Sauvegarder et naviguer
    await saveSchema();
    await openFolio(targetFolio.id);
    // Trouver le fil avec le même numéro sur le folio cible et qui a un xref retour
    if (wireNum) {
      setTimeout(() => {
        for (const w of state.wires) {
          if (w.num !== wireNum) continue;
          // Trouver le xref qui pointe vers le folio d'origine
          if (w.xrefStart || w.xrefEnd) {
            _xrefHighlight = { wireId: w.id, until: Date.now() + 5000 };
            render();
            // Auto-clear après 5 secondes
            setTimeout(() => { _xrefHighlight = null; render(); }, 5000);
            return;
          }
        }
      }, 200);
    }
  }

  async function _navigateToDriver(driverId) {
    // Chercher le driver sur le folio courant
    let target = state.elements.find(el => el.id === driverId);
    if (target) {
      const sym = _symbols[target.symId];
      const cx = target.x + (target.w || sym?.width || 60) / 2;
      const cy = target.y + (target.h || sym?.height || 40) / 2;
      view.panX = canvas.width / 2 - cx * view.zoom;
      view.panY = canvas.height / 2 - cy * view.zoom;
      setOnlySel('element', target.id);
      state.elements.forEach(e => { delete e._blink; });
      target._blink = true; render(); updateProps();
      setTimeout(() => { const cur = getById('element', target.id); if (cur) delete cur._blink; render(); }, 3000);
      return;
    }
    // Chercher sur les autres folios
    await _ensureAllFoliosCached();
    for (const f of projectFolios) {
      if (f.id === currentFolioId || !f._cachedData) continue;
      const el = (f._cachedData.elements || []).find(e => e.id === driverId);
      if (el) {
        await saveSchema();
        await openFolio(f.id);
        setTimeout(() => {
          const t = state.elements.find(e => e.id === driverId);
          if (!t) return;
          const sym = _symbols[t.symId];
          const cx = t.x + (t.w || sym?.width || 60) / 2;
          const cy = t.y + (t.h || sym?.height || 40) / 2;
          view.panX = canvas.width / 2 - cx * view.zoom;
          view.panY = canvas.height / 2 - cy * view.zoom;
          setOnlySel('element', t.id);
          state.elements.forEach(e => { delete e._blink; });
          t._blink = true; render(); updateProps();
          setTimeout(() => { const cur = getById('element', t.id); if (cur) delete cur._blink; render(); }, 3000);
        }, 150);
        return;
      }
    }
  }

  function onDbl(e){
    // Clic sur un renvoi de folio → naviguer vers le folio cible
    if(!wireIP&&!shapeIP&&currentTool==='select'){
      const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
      const xrefHit = _hitXref(wx, wy);
      if(xrefHit){ e.preventDefault(); _navigateXref(xrefHit); return; }
    }
    // Double-clic sur un contact lié → naviguer vers le symbole driver
    if(!wireIP&&!shapeIP&&currentTool==='select'){
      const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
      const el=hitEl(wx,wy);
      if(el&&el.coilRef){
        e.preventDefault();
        _navigateToDriver(el.coilRef);
        return;
      }
    }
    // Édition inline de texte (dbl-clic en mode sélection)
    if(!wireIP&&!shapeIP&&currentTool==='select'){
      const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
      const txt=hitText(wx,wy);
      if(txt){
        e.preventDefault();
        if(txt.w>0&&txt.h>0){
          setOnlySel('text',txt.id);render();updateProps();
          setTimeout(()=>{const ta=document.getElementById('pt-text');if(ta){ta.focus();ta.select();}},50);
        }else{_startInlineTextEdit(txt);}
        return;
      }
      // Double-clic sur une textbox → sélectionner et focus le textarea de propriétés
      const shHit=hitShape(wx,wy);
      if(shHit && shHit.t==='textbox'){
        e.preventDefault();
        setOnlySel('shape',shHit.id);render();updateProps();
        setTimeout(()=>{const ta=document.getElementById('ptb-text');if(ta){ta.focus();ta.select();}},50);
        return;
      }
      // Double-clic sur un fil → popup pour changer le N° de fil
      const wireHit=hitWire(wx,wy);
      if(wireHit){
        e.preventDefault();
        setOnlySel('wire',wireHit.id);render();updateProps();
        _promptWireNum(wireHit);
        return;
      }
    }
    // Terminer fil
    if(wireIP&&wireIP.points.length>=1){
      const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
      const snap=nearestPin(wx,wy)||snapWxy(wx,wy);
      const last=wireIP.points[wireIP.points.length-1];
      if(snap.x!==last.x||snap.y!==last.y){wireIP.points.push({x:snap.x,y:last.y});wireIP.points.push(snap);}
      const pts=wireIP.points.filter((p,i)=>i===0||p.x!==wireIP.points[i-1].x||p.y!==wireIP.points[i-1].y);
      if(pts.length>=2){ commitWirePoints(pts, wireIP.isBus, wireIP.resumedNum||null); }
      wireIP=null;LiveSync.broadcastDrawing(null);render();return;
    }
    // Terminer poly/line
    if(shapeIP&&(shapeIP.tool==='poly'||shapeIP.tool==='line')&&shapeIP.pts.length>=2){
      const pts=[...shapeIP.pts];if(pts.length>1)pts.pop();// retirer le pt dupliqué du dblclick
      state.shapes.push({id:uid(),t:shapeIP.tool,pts,color:shapeIP.color,thick:shapeIP.thick,fill:shapeIP.fill});
      saveHistory('Dessiner forme');
      shapeIP=null;LiveSync.broadcastDrawing(null);render();updateStatus();return;
    }
  }

  function _startInlineTextEdit(t){
    // Retirer tout éditeur inline précédent
    document.getElementById('_inline-text-input')?.remove();
    setOnlySel('text',t.id);
    const r=canvas.getBoundingClientRect();
    const{sx,sy}=w2s(t.x,t.y);
    const fontSize=Math.max(10,Math.round((t.size||13)*view.zoom));
    const inp=document.createElement('input');
    inp.id='_inline-text-input';
    inp.type='text';
    inp.value=t.text;
    inp.style.cssText=[
      `position:fixed`,
      `left:${r.left+sx}px`,
      `top:${r.top+sy-4}px`,
      `font-size:${fontSize}px`,
      `font-family:monospace`,
      `background:var(--panel2,#1e2130)`,
      `color:var(--text,#e0e6f0)`,
      `border:1px solid var(--accent,#3b9eff)`,
      `border-radius:3px`,
      `padding:2px 6px`,
      `outline:none`,
      `z-index:2000`,
      `min-width:60px`,
      `transform:rotate(${t.angle||0}deg)`,
      `transform-origin:left top`
    ].join(';');
    document.body.appendChild(inp);
    inp.focus();inp.select();
    const commit=()=>{
      const val=inp.value;
      if(val!==t.text){t.text=val;saveHistory('Modifier texte');}
      inp.remove();render();updateProps();
    };
    const cancel=()=>{inp.remove();render();};
    inp.addEventListener('blur',commit);
    inp.addEventListener('keydown',e2=>{
      if(e2.key==='Enter'){e2.preventDefault();inp.removeEventListener('blur',commit);commit();}
      else if(e2.key==='Escape'){e2.preventDefault();inp.removeEventListener('blur',commit);cancel();}
    });
  }

  function _promptWireNum(wire){
    document.getElementById('_wire-num-input')?.remove();
    const midIdx=Math.floor(wire.points.length/2);
    const mp=wire.points[midIdx]||wire.points[0];
    const r=canvas.getBoundingClientRect();
    const{sx,sy}=w2s(mp.x+(wire.numOffX||0),mp.y+(wire.numOffY||-10));
    const fontSize=Math.max(10,Math.round(11*view.zoom));
    const inp=document.createElement('input');
    inp.id='_wire-num-input';
    inp.type='text';
    inp.value=wire.num||'';
    inp.placeholder='N° de fil';
    inp.style.cssText=[
      `position:fixed`,
      `left:${r.left+sx-30}px`,
      `top:${r.top+sy-12}px`,
      `font-size:${fontSize}px`,
      `font-family:monospace`,
      `background:var(--panel2,#1e2130)`,
      `color:var(--text,#e0e6f0)`,
      `border:1px solid var(--accent,#3b9eff)`,
      `border-radius:3px`,
      `padding:2px 6px`,
      `outline:none`,
      `z-index:2000`,
      `min-width:50px`,
      `width:80px`
    ].join(';');
    document.body.appendChild(inp);
    inp.focus();inp.select();
    const commit=()=>{
      const val=inp.value.trim();
      if(val!==wire.num){wire.num=val;saveHistory('Modifier N° de fil');scheduleAutoXrefs();}
      inp.remove();render();updateProps();
    };
    const cancel=()=>{inp.remove();render();};
    inp.addEventListener('blur',commit);
    inp.addEventListener('keydown',e2=>{
      if(e2.key==='Enter'){e2.preventDefault();inp.removeEventListener('blur',commit);commit();}
      else if(e2.key==='Escape'){e2.preventDefault();inp.removeEventListener('blur',commit);cancel();}
    });
  }

  function onCtx(e){
    e.preventDefault();
    // Annuler point de forme en cours
    if(shapeIP){
      if(shapeIP.pts.length>1)shapeIP.pts.pop();
      else shapeIP=null;
      render();return;
    }
    // Annuler point de fil en cours
    if(wireIP){
      if(wireIP.points.length>1)wireIP.points.pop();
      else wireIP=null;
      render();return;
    }
    const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
    const el=hitEl(wx,wy),wire=hitWire(wx,wy);
    if(el){if(!isInMultiSel('element',el.id))setOnlySel('element',el.id);render();updateProps();showCtx(e.clientX,e.clientY);}
    else if(wire){if(!isInMultiSel('wire',wire.id))setOnlySel('wire',wire.id);render();updateProps();showCtx(e.clientX,e.clientY);}
    else if(multiSel.size>0)showCtx(e.clientX,e.clientY);
  }

  function commitShapeIP(){
    if(!shapeIP)return;
    const{tool,pts,color,thick,fill}=shapeIP;
    const sh={id:uid(),t:tool,color,thick,fill};
    if(tool==='rect'&&pts.length>=2){sh.x=Math.min(pts[0].x,pts[1].x);sh.y=Math.min(pts[0].y,pts[1].y);sh.w=Math.abs(pts[1].x-pts[0].x)||4;sh.h=Math.abs(pts[1].y-pts[0].y)||4;}
    else if(tool==='circle'&&pts.length>=2){sh.cx=pts[0].x;sh.cy=pts[0].y;sh.r=Math.hypot(pts[1].x-pts[0].x,pts[1].y-pts[0].y)||4;}
    else if(tool==='arc'&&pts.length>=3){sh.cx=pts[0].x;sh.cy=pts[0].y;sh.r=pts[1].r||4;sh.a1=pts[1].a1||0;sh.a2=Math.atan2(pts[2].y-pts[0].y,pts[2].x-pts[0].x);}
    else if(tool==='textbox'&&pts.length>=2){
      sh.t='textbox';
      sh.x=Math.min(pts[0].x,pts[1].x); sh.y=Math.min(pts[0].y,pts[1].y);
      sh.w=Math.abs(pts[1].x-pts[0].x)||80; sh.h=Math.abs(pts[1].y-pts[0].y)||40;
      sh.text='Texte'; sh.fontSize=11; sh.textColor=color; sh.align='left'; sh.valign='top'; sh.padding=4;
    }
    else{shapeIP=null;return;}
    state.shapes.push(sh);shapeIP=null;saveHistory('Dessiner forme');updateStatus();
    // Sélectionner la forme créée (en particulier textbox pour éditer le texte)
    setOnlySel('shape',sh.id);render();updateProps();
    // Focus le textarea si c'est une textbox
    if(sh.t==='textbox') setTimeout(()=>{const ta=document.getElementById('ptb-text');if(ta){ta.focus();ta.select();}},50);
  }

  function onDrop(e){
    e.preventDefault();
    const symId=e.dataTransfer.getData('sym-id');if(!symId||!_symbols[symId])return;
    const sym=_symbols[symId];const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
    const _defLabelOffY = sym.defaultLabelOffY ?? PROJ.labelOffY;
    const _defRefOffY   = sym.defaultRefOffY   ?? PROJ.refOffY;
    const _defLabelOffX = sym.defaultLabelOffX ?? 0;
    const _defRefOffX   = sym.defaultRefOffX   ?? 0;
    const el={id:uid(),symId,x:snapW(wx-sym.width/2),y:snapW(wy-sym.height/2),w:sym.width,h:sym.height,rotation:0,flipH:false,color:PROJ.symColor,label:'',ref:'',labelOffX:_defLabelOffX,labelOffY:_defLabelOffY,refOffX:_defRefOffX,refOffY:_defRefOffY};
    // Puissance par défaut si consommateur
    if(sym.isConsumer) el.power = sym.defaultPower || 0;
    // Nommage automatique
    if(PROJ.autoName) el.label = _generateRef(sym);
    state.elements.push(el);
    saveHistory('Placer symbole'); // après modification → snapshot état avec symbole
    setOnlySel('element',el.id);render();updateProps();updateStatus();setStatus(sym.name+' déposé');
  }

  function onWheel(e){
    e.preventDefault();
    // Trackpad : scroll horizontal (2 doigts) ou Shift+scroll → pan X
    if(Math.abs(e.deltaX)>Math.abs(e.deltaY)){
      view.panX-=e.deltaX;render();return;
    }
    if(e.shiftKey){
      view.panX-=e.deltaY;render();return;
    }
    // Molette verticale → zoom centré sur le curseur
    const{sx,sy}=cp(e);const f=e.deltaY<0?1.12:0.89;
    const nz=Math.max(0.08,Math.min(8,view.zoom*f));
    view.panX=sx-(sx-view.panX)*(nz/view.zoom);view.panY=sy-(sy-view.panY)*(nz/view.zoom);
    view.zoom=nz;document.getElementById('zoom-val').textContent=Math.round(nz*100)+'%';render();
  }

  function onKey(e){
    if(e.target.tagName==='INPUT'||e.target.tagName==='TEXTAREA'||e.target.tagName==='SELECT')return;
    if(!document.getElementById('modal-sym-editor').classList.contains('hidden'))return;
    const k=e.key.toLowerCase();
    if(k==='s'&&!e.ctrlKey)setTool('select');
    else if(k==='m'&&!e.ctrlKey)setTool('measure');
    else if(k==='w'&&!e.ctrlKey&&!_cartoucheEditMode)setTool('wire');
    else if(k==='b'&&!_cartoucheEditMode)setTool('bus');
    else if(k==='t'&&!e.ctrlKey)setTool('text');
    else if(k==='l')setTool('line');
    else if(k==='r'&&!e.ctrlKey&&currentTool!=='select')setTool('rect');
    else if(k==='o')setTool('circle');
    else if(k==='p')setTool('poly');
    else if(k==='escape'){
      if(_cartoucheEditMode){exitCartoucheEdit(false);return;}
      if(_funcPlacement){ _cancelFuncPlacement(); return; }
      wireIP=null;shapeIP=null;
      if(measureIP){ measureIP=null; render(); return; } // 1er Escape : annule mesure en cours
      clearMultiSel();setTool('select');render();updateProps();
    }
    else if(k==='delete'||k==='backspace')delSelected();
    else if(k==='r'&&currentTool==='simulate')_simReset();
    else if(k==='r'&&currentTool==='select')rotateSelected();
    else if(k==='d'&&!e.ctrlKey)dupSelected();
    else if(e.ctrlKey&&k==='a'){e.preventDefault();selectAll();}
    else if(e.ctrlKey&&k==='z'){e.preventDefault();undo();}
    else if(e.ctrlKey&&(k==='y'||(e.shiftKey&&k==='z'))){e.preventDefault();redo();}
    else if(e.ctrlKey&&k==='s'){e.preventDefault();saveSchema();}
    else if(e.ctrlKey&&k==='c'){e.preventDefault();copySelected();}
    else if(e.ctrlKey&&k==='x'){e.preventDefault();cutSelected();}
    else if(e.ctrlKey&&k==='v'){
      const clip=_loadClip();
      if(clip&&clip.items?.length){e.preventDefault();pasteClip();}
    }
    else if(e.ctrlKey&&k==='f'){e.preventDefault();_openSearch();}
    else if(e.ctrlKey&&k==='n'){e.preventDefault();newSchema();}
    else if(e.ctrlKey&&e.key==='PageUp'){e.preventDefault();_folioBack();}
    else if(e.ctrlKey&&e.key==='PageDown'){e.preventDefault();_folioForward();}
    else if(e.key==='?'){e.preventDefault();openModal('modal-shortcuts');}
    else if(['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key)){
      if(selected.id||multiSel.size){
        e.preventDefault();
        const step=e.shiftKey?1:GRID;
        const dx=e.key==='ArrowLeft'?-step:e.key==='ArrowRight'?step:0;
        const dy=e.key==='ArrowUp'?-step:e.key==='ArrowDown'?step:0;
        const keys=multiSel.size>0?[...multiSel]:[selKey(selected.type,selected.id)];
        keys.forEach(key=>{
          const[t,id]=key.split(':');const o=getById(t,id);if(!o)return;
          const sp=JSON.parse(JSON.stringify(o));
          applyDragDelta(t,o,sp,dx,dy);
        });
        _scheduleArrowHistorySave();
        render();updateProps();
      }
    }
  }

  // Debounce pour ne sauvegarder qu'une fois après une série de touches flèches
  let _arrowSaveTimer=null;
  function _scheduleArrowHistorySave(){
    if(_arrowSaveTimer)clearTimeout(_arrowSaveTimer);
    _arrowSaveTimer=setTimeout(()=>{_arrowSaveTimer=null;saveHistory('Déplacer');},400);
  }

  function selectAll(){
    multiSel.clear();
    state.elements.forEach(el=>multiSel.add(selKey('element',el.id)));
    state.wires.forEach(w=>multiSel.add(selKey('wire',w.id)));
    state.texts.forEach(t=>multiSel.add(selKey('text',t.id)));
    (state.images||[]).forEach(img=>multiSel.add(selKey('image',img.id)));
    state.shapes.forEach(sh=>multiSel.add(selKey('shape',sh.id)));
    render();updateStatus();setStatus(`${multiSel.size} objets sélectionnés`);
  }

  // ─────────────────────────────────────────────────────────
  // OUTILS
  // ─────────────────────────────────────────────────────────
  function setTool(tool){
    currentTool=tool;wireIP=null;shapeIP=null;
    if(tool!=='measure') measureIP=null;
    // Afficher options mesure uniquement en mode mesure
    const _mo=document.getElementById('measure-opts');
    if(_mo) _mo.style.display=tool==='measure'?'flex':'none';
    document.querySelectorAll('.rb.tool,.tb-btn.tool').forEach(b=>b.classList.toggle('active',b.dataset.tool===tool));
    document.getElementById('mode-badge').textContent={select:'SÉLECTION',wire:'FIL',bus:'BUS',text:'TEXTE',line:'LIGNE',rect:'RECTANGLE',circle:'CERCLE',poly:'POLYGONE',arc:'ARC',image:'IMAGE',measure:'MESURE',simulate:'SIMULATION'}[tool]||tool.toUpperCase();
    canvas.className=tool+'-mode';
    setStatus({select:'S — Sélection (clic, Shift+clic, rubber-band)',wire:'W — Fil (clic G: point, clic D: annuler, dbl-clic: terminer)',bus:'B — Bus',text:'T — Texte',line:'L — Ligne (clic D: annuler, dbl-clic: terminer)',rect:'R — Rectangle',circle:'O — Cercle',poly:'P — Polygone (clic D: annuler, dbl-clic: terminer)',arc:'A — Arc (3 clics: centre, rayon, fin)',image:'I — Cliquer sur le canevas pour placer une image',measure:'M — Clic: 1er point. Déplacer: mesure live. Clic: figer. Échap: effacer.',simulate:'⚡ SIMULATION — Cliquer sur un symbole pour basculer repos/actif. R = réinitialiser.'}[tool]||'');
    if (tool === 'image') pickImageFile();
  }

  function _updateMeasureStatus(m) {
    if(!m||!m.p1||!m.p2) return;
    const dx=m.p2.x-m.p1.x, dy=m.p2.y-m.p1.y;
    const dist=Math.hypot(dx,dy), adx=Math.abs(dx), ady=Math.abs(dy);
    const isH=ady<0.5, isV=adx<0.5;
    const ang=((Math.atan2(dy,dx)*180/Math.PI)+360)%360;
    let msg;
    if(isH) msg=`📐 H: ${_measureFormat(adx)}`;
    else if(isV) msg=`📐 V: ${_measureFormat(ady)}`;
    else msg=`📐 ΔX: ${_measureFormat(adx)}  ΔY: ${_measureFormat(ady)}  ↗: ${_measureFormat(dist)}  ${ang.toFixed(1)}°`;
    setStatus(msg);
  }

  async function _ensureAllFoliosCached() {
    for (const f of projectFolios) {
      if (f.id === currentFolioId || f._cachedData) continue;
      try {
        const res = await fetch(`/api/schemas/${f.id}`, { credentials: 'include' });
        if (res.ok) { const schema = await res.json(); f._cachedData = schema.data || {}; }
      } catch {}
    }
  }

  // Collecte toutes les bobines et boutons (drivers) dans tous les folios du projet
  async function _getAllDrivers() {
    await _ensureAllFoliosCached();
    const drivers = [];
    // Folio courant
    for(const el of state.elements) {
      const sym = _symbols[el.symId];
      const role = _symRole(sym);
      if((role === 'coil' || role === 'button' || role === 'breaker') && el.label)
        drivers.push({ id:el.id, label:el.label, role, folioId:currentFolioId,
                     folioLabel:'F'+(projectFolios.find(f=>f.id===currentFolioId)?.folio_num||'?') });
    }
    // Autres folios
    for(const f of projectFolios) {
      if(f.id === currentFolioId) continue;
      const d = f._cachedData;
      if(!d) continue;
      for(const el of (d.elements||[])) {
        const sym = _symbols[el.symId];
        const role = _symRole(sym);
        if((role === 'coil' || role === 'button' || role === 'breaker') && el.label)
          drivers.push({ id:el.id, label:el.label, role, folioId:f.id,
                       folioLabel:'F'+(f.folio_num||'?') });
      }
    }
    return drivers;
  }
  // Rétrocompatibilité
  async function _getAllCoils() { return (await _getAllDrivers()).filter(d => d.role === 'coil'); }

  // Propage le label d'une bobine ou d'un bouton à tous ses contacts liés
  async function _propagateCoilLabel(coilId, newLabel) {
    // Folio courant
    for(const el of state.elements) {
      if(el.coilRef === coilId) { el.label = newLabel; }
    }
    await _ensureAllFoliosCached();
    // Autres folios
    for(const f of projectFolios) {
      if(f.id === currentFolioId || !f._cachedData) continue;
      let dirty = false;
      for(const el of (f._cachedData.elements||[])) {
        if(el.coilRef === coilId) { el.label = newLabel; dirty = true; }
      }
      // Sauvegarder le folio modifié
      if(dirty) {
        fetch(`/api/folios/${f.id}`, {
          method:'PUT', credentials:'include',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ name:f.name, data:f._cachedData })
        }).catch(()=>{});
      }
    }
  }

  function getSel(){if(!selected.id)return null;return getById(selected.type,selected.id);}

  // ── Simulateur : propagation bobine/bouton → contacts ────────────
  function _simPropagate(source) {
    if (!source.label) return;
    const label = source.label.trim();
    const active = !!source.simActive;
    // Trouver tous les contacts/disjoncteurs liés au même label
    state.elements.forEach(el => {
      if (el.id === source.id) return;
      const sym = _symbols[el.symId];
      if (!sym) return;
      const role = sym.elementRole || '';
      if (!['contact', 'breaker'].includes(role)) return;
      if ((el.label || '').trim() === label) {
        el.simActive = active;
      }
    });
  }

  // Réinitialiser tous les états de simulation
  function _simReset() {
    state.elements.forEach(el => { delete el.simActive; });
    render();
    setStatus('Simulation réinitialisée');
  }

  // Redimensionne l'élément multi-pôle selon le nombre de pôles (horizontal)
  function _applyPoles(el, sym) {
    const defaultPole = sym.elementRole === 'terminal' ? 'T' : (sym.contactSubType || 'NO');
    const poles = el.poles || [defaultPole];
    el.w = sym.width * poles.length;
    // Recalculer nbNO/nbNF pour compatibilité renderer
    el.nbNO = poles.filter(p => p === 'NO').length;
    el.nbNF = poles.filter(p => p === 'NF').length;
  }

  // ─────────────────────────────────────────────────────────
  // ACTIONS
  // ─────────────────────────────────────────────────────────
  // Retourne le point de connexion entre deux fils (extrémité commune) ou null
  function _wireConnectionPoint(wa, wb) {
    if (!wa || !wb) return null;
    const TOL = 8;
    const endpts = (w) => [w.points[0], w.points[w.points.length-1]];
    for (const pa of endpts(wa))
      for (const pb of endpts(wb))
        if (Math.hypot(pa.x-pb.x, pa.y-pb.y) < TOL) return pa;
    return null;
  }
  function _wiresConnected(wa, wb) { return !!_wireConnectionPoint(wa, wb); }

  // Fusionner deux fils qui se touchent par une extrémité
  function mergeWiresPair(wa, wb) {
    const cp = _wireConnectionPoint(wa, wb);
    if (!cp) return false;
    const TOL = 8;
    // Orienter wa : END sur cp
    const ptsA = [...wa.points];
    if (Math.hypot(ptsA[0].x-cp.x, ptsA[0].y-cp.y) < TOL) ptsA.reverse();
    // Orienter wb : START sur cp
    const ptsB = [...wb.points];
    if (Math.hypot(ptsB[ptsB.length-1].x-cp.x, ptsB[ptsB.length-1].y-cp.y) < TOL) ptsB.reverse();
    state.wires = state.wires.filter(w => w.id !== wa.id && w.id !== wb.id);
    const merged = [...ptsA, ...ptsB.slice(1)];
    state.wires.push({id:uid(), points:merged, color:wa.color||wb.color, width:wa.width||wb.width, isBus:wa.isBus||wb.isBus, num:wa.num||wb.num});
    cleanJunctions();
    return true;
  }

  function mergeWiresSelected() {
    const selWireIds = [...multiSel].filter(k=>k.startsWith('wire:')).map(k=>k.slice(5));
    if (selWireIds.length !== 2) return;
    const wa = state.wires.find(w=>w.id===selWireIds[0]);
    const wb = state.wires.find(w=>w.id===selWireIds[1]);
    if (!wa || !wb) return;
    saveHistory('Fusionner fils');
    if (mergeWiresPair(wa, wb)) {
      clearMultiSel(); render(); updateProps(); setStatus('Fils fusionnés');
    }
  }

  function _mergeWiresAtJunction(jx,jy){
    const TOL=8;
    // Un fil "touche" le nœud si une de ses extrémités est sur le nœud
    // OU si le nœud se trouve sur un de ses segments intérieurs
    function wireTouchesJunc(w){
      const pts=w.points;
      for(let i=0;i<pts.length;i++){
        if(Math.hypot(pts[i].x-jx,pts[i].y-jy)<TOL) return true;
      }
      return false;
    }
    // Extraire comment le fil arrive au nœud :
    //   'end'   → la dernière extrémité est sur le nœud
    //   'start' → la première extrémité est sur le nœud
    //   'mid'   → le nœud est dans un point intermédiaire (fil traversant)
    function wireArrival(w){
      const pts=w.points;
      if(Math.hypot(pts[pts.length-1].x-jx,pts[pts.length-1].y-jy)<TOL) return 'end';
      if(Math.hypot(pts[0].x-jx,pts[0].y-jy)<TOL) return 'start';
      return 'mid'; // point intermédiaire
    }
    const touching=state.wires.filter(wireTouchesJunc);
    // Compter les fils réellement terminaux au nœud (pas traversants)
    const terminals=touching.filter(w=>{
      const arr=wireArrival(w);
      return arr==='start'||arr==='end';
    });
    // Fusionner uniquement si exactement 2 fils se terminent au nœud
    // et qu'aucun fil ne le traverse
    const traversing=touching.filter(w=>wireArrival(w)==='mid');
    if(terminals.length===2&&traversing.length===0){
      const [wa,wb]=terminals;
      // Orienter wa : son END doit être sur le nœud
      const ptsA=[...wa.points];
      if(wireArrival(wa)==='start') ptsA.reverse();
      // Orienter wb : son START doit être sur le nœud
      const ptsB=[...wb.points];
      if(wireArrival(wb)==='end') ptsB.reverse();
      state.wires=state.wires.filter(w=>w.id!==wa.id&&w.id!==wb.id);
      // Dédoublonner le point commun
      const merged=[...ptsA,...ptsB.slice(1)];
      state.wires.push({id:uid(),points:merged,color:wa.color||wb.color,width:wa.width||wb.width,isBus:wa.isBus||wb.isBus,num:wa.num||wb.num});
    }
    // Sinon (1 seul, 3+, ou un fil traversant) : on retire juste le nœud
  }
  function delSelected(){
    if(!multiSel.size&&!selected.id)return;
    const toDel=multiSel.size>0?multiSel:new Set([selKey(selected.type,selected.id)]);
    const ids={element:new Set(),wire:new Set(),text:new Set(),shape:new Set(),image:new Set(),junction:new Set()};
    toDel.forEach(k=>{
      const colon=k.indexOf(':'); const t=k.slice(0,colon), id=k.slice(colon+1);
      if(ids[t])ids[t].add(id);
    });
    // Supprimer les nœuds sélectionnés et tenter la fusion de fils
    if(ids.junction.size){
      ids.junction.forEach(jkey=>{
        const [jx,jy]=[parseFloat(jkey.split(',')[0]),parseFloat(jkey.split(',')[1])];
        state.junctions=(state.junctions||[]).filter(j=>Math.hypot(j.x-jx,j.y-jy)>3);
        _mergeWiresAtJunction(jx,jy);
      });
    }
    state.elements=state.elements.filter(e=>!ids.element.has(e.id));
    state.wires=state.wires.filter(w=>!ids.wire.has(w.id));
    state.texts=state.texts.filter(t=>!ids.text.has(t.id));
    state.shapes=state.shapes.filter(s=>!ids.shape.has(s.id));
    state.images=(state.images||[]).filter(img=>!ids.image?.has(img.id));
    cleanJunctions();
    // Sur un folio implantation : synchroniser les suppressions
    // (si un rail/goulotte a été supprimé, retirer aussi de la config + régénérer
    // pour que les textes/hachures/dimensions associés disparaissent)
    const _curPf=projectFolios.find(x=>x.id===currentFolioId);
    const _isImpl=_curPf?.data?.folio_type==='implantation'||_curPf?.folio_type==='implantation';
    if(_isImpl) _cleanupImplantOrphans();
    saveHistory('Supprimer'); // après modification → snapshot état sans objets supprimés
    clearMultiSel();render();updateProps();updateStatus();setStatus(`${toDel.size} objet(s) supprimé(s)`);
  }
  function rotateSelected(){const el=state.elements.find(e=>e.id===selected.id);if(!el)return;el.rotation=((el.rotation||0)+90)%360;saveHistory('Pivoter');render();updateProps();}
  function flipSelected(){const el=state.elements.find(e=>e.id===selected.id);if(!el)return;el.flipH=!el.flipH;saveHistory('Retourner');render();}
  function copySelected(){
    if(!multiSel.size&&!selected.id)return;
    const keys=multiSel.size>0?[...multiSel]:[selKey(selected.type,selected.id)];
    const items=[];
    keys.forEach(k=>{
      const[t,id]=k.split(':');const o=getById(t,id);if(!o)return;
      items.push({t,obj:JSON.parse(JSON.stringify(o))});
    });
    if(!items.length)return;
    // Calculer le centre de la sélection pour le paste relatif
    let minX=Infinity,minY=Infinity;
    items.forEach(({t,obj})=>{const b=getObjBBox(t,obj);minX=Math.min(minX,b.x);minY=Math.min(minY,b.y);});
    _saveClip({items,originX:minX,originY:minY,ts:Date.now()});
    setStatus(`📋 ${items.length} objet(s) copié(s) — Ctrl+V pour coller (y compris sur un autre folio)`);
  }

  function cutSelected(){
    copySelected();
    delSelected();
  }

  // Incrémente la référence d'un élément : "KM1" → "KM2", "Q01" → "Q02"
  // takenRefs : Set des refs déjà utilisées (modifié en place pour les colles multiples)
  function _nextAvailableRef(ref, takenRefs){
    if(!ref)return ref;
    const m=ref.match(/^(.*?)(\d+)$/);
    if(!m)return ref; // pas de chiffre final → on ne touche pas
    const prefix=m[1], origStr=m[2];
    const zeroPad=origStr.startsWith('0'), padLen=origStr.length;
    // Trouver le numéro le plus élevé avec le même préfixe parmi les refs prises
    let maxNum=parseInt(origStr,10);
    for(const r of takenRefs){
      if(!r)continue;
      const rm=r.match(/^(.*?)(\d+)$/);
      if(rm&&rm[1]===prefix)maxNum=Math.max(maxNum,parseInt(rm[2],10));
    }
    const nextNum=maxNum+1;
    const nextStr=zeroPad?String(nextNum).padStart(padLen,'0'):String(nextNum);
    return prefix+nextStr;
  }

  function pasteClip(offsetX, offsetY){
    const clip=_loadClip();
    if(!clip||!clip.items?.length){setStatus('Presse-papier vide');return;}
    const dx=(offsetX!=null?offsetX:clip.originX+GRID*3)-clip.originX;
    const dy=(offsetY!=null?offsetY:clip.originY+GRID*3)-clip.originY;
    const newKeys=[];
    clip.items.forEach(({t,obj})=>{
      const c=JSON.parse(JSON.stringify(obj));
      c.id=uid();
      if(t==='element'||t==='image'||t==='text'){c.x+=dx;c.y+=dy;}
      else if(t==='wire')c.points=c.points.map(p=>({x:p.x+dx,y:p.y+dy}));
      else if(t==='shape'){
        if(c.t==='rect'||c.t==='textbox'){c.x+=dx;c.y+=dy;}
        else if(c.t==='circle'||c.t==='arc'){c.cx+=dx;c.cy+=dy;}
        else if(c.pts)c.pts=c.pts.map(p=>({x:p.x+dx,y:p.y+dy}));
      }
      // Auto-incrément de la référence : calculé avant le push pour que le Set
      // inclue les éléments déjà collés dans ce même Ctrl+V
      if(t==='element'&&c.ref){
        const takenRefs=new Set(state.elements.map(e=>e.ref).filter(Boolean));
        c.ref=_nextAvailableRef(c.ref,takenRefs);
      }
      if(t==='element')state.elements.push(c);
      else if(t==='wire')state.wires.push(c);
      else if(t==='text')state.texts.push(c);
      else if(t==='shape')state.shapes.push(c);
      else if(t==='image')state.images.push(c);
      newKeys.push(selKey(t,c.id));
    });
    // Sélectionner les objets collés
    multiSel.clear();newKeys.forEach(k=>multiSel.add(k));
    saveHistory('Coller');
    render();updateStatus();updateProps();
    setStatus(`📋 ${clip.items.length} objet(s) collé(s)`);
  }

  function dupSelected(){
    if(!multiSel.size&&!selected.id)return;
    const toDup=multiSel.size>0?[...multiSel]:[selKey(selected.type,selected.id)];
    toDup.forEach(k=>{const[t,id]=k.split(':');
      if(t==='element'){const el=getById(t,id);if(el){const c={...JSON.parse(JSON.stringify(el)),id:uid(),x:el.x+GRID*2,y:el.y+GRID*2};state.elements.push(c);}}
      if(t==='image'){const img=getById(t,id);if(img){const c={...JSON.parse(JSON.stringify(img)),id:uid(),x:img.x+GRID*2,y:img.y+GRID*2};state.images.push(c);}}
    });
    saveHistory('Dupliquer');
    render();updateStatus();
  }

  // ─────────────────────────────────────────────────────────
  // ALIGNEMENT MULTI-SÉLECTION
  // ─────────────────────────────────────────────────────────
  function getSelBBox(keys){
    // Retourne la bounding box de tous les objets sélectionnés
    let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
    keys.forEach(k=>{
      const[t,id]=k.split(':');const o=getById(t,id);if(!o)return;
      if(t==='element'){minX=Math.min(minX,o.x);minY=Math.min(minY,o.y);maxX=Math.max(maxX,o.x+o.w);maxY=Math.max(maxY,o.y+o.h);}
      else if(t==='text'){const tw=60;minX=Math.min(minX,o.x);minY=Math.min(minY,o.y);maxX=Math.max(maxX,o.x+tw);maxY=Math.max(maxY,o.y+(o.size||13));}
      else if(t==='shape'){
        if(o.t==='rect'||o.t==='textbox'){minX=Math.min(minX,o.x);minY=Math.min(minY,o.y);maxX=Math.max(maxX,o.x+o.w);maxY=Math.max(maxY,o.y+o.h);}
        else if(o.t==='circle'||o.t==='arc'){minX=Math.min(minX,o.cx-o.r);minY=Math.min(minY,o.cy-o.r);maxX=Math.max(maxX,o.cx+o.r);maxY=Math.max(maxY,o.cy+o.r);}
        else if(o.pts){o.pts.forEach(p=>{minX=Math.min(minX,p.x);minY=Math.min(minY,p.y);maxX=Math.max(maxX,p.x);maxY=Math.max(maxY,p.y);});}
      }
      else if(t==='wire'){o.points.forEach(p=>{minX=Math.min(minX,p.x);minY=Math.min(minY,p.y);maxX=Math.max(maxX,p.x);maxY=Math.max(maxY,p.y);});}
    });
    return{x:minX,y:minY,w:maxX-minX,h:maxY-minY,cx:(minX+maxX)/2,cy:(minY+maxY)/2};
  }

  function getObjBBox(t,o){
    if(t==='element')return{x:o.x,y:o.y,w:o.w,h:o.h};
    if(t==='image')return{x:o.x,y:o.y,w:o.w,h:o.h};
    if(t==='text'){return{x:o.x,y:o.y,w:o.w||60,h:o.h||(o.size||13)};}
    if(t==='shape'){
      if(o.t==='group'){const b=groupBBox(o);return{x:b.x,y:b.y,w:b.w,h:b.h};}
      if(o.t==='rect'||o.t==='textbox')return{x:o.x,y:o.y,w:o.w,h:o.h};
      if(o.t==='circle'||o.t==='arc')return{x:o.cx-o.r,y:o.cy-o.r,w:o.r*2,h:o.r*2};
      if(o.pts){let x0=Infinity,y0=Infinity,x1=-Infinity,y1=-Infinity;o.pts.forEach(p=>{x0=Math.min(x0,p.x);y0=Math.min(y0,p.y);x1=Math.max(x1,p.x);y1=Math.max(y1,p.y);});return{x:x0,y:y0,w:x1-x0,h:y1-y0};}
    }
    if(t==='wire'){let x0=Infinity,y0=Infinity,x1=-Infinity,y1=-Infinity;o.points.forEach(p=>{x0=Math.min(x0,p.x);y0=Math.min(y0,p.y);x1=Math.max(x1,p.x);y1=Math.max(y1,p.y);});return{x:x0,y:y0,w:x1-x0,h:y1-y0};}
    return{x:0,y:0,w:0,h:0};
  }

  function moveObjTo(t,o,nx,ny){
    // Déplace l'objet pour que son coin haut-gauche soit en (nx,ny)
    if(t==='element'){o.x=nx;o.y=ny;}
    if(t==='image'){o.x=nx;o.y=ny;}
    else if(t==='text'){o.x=nx;o.y=ny;}
    else if(t==='shape'){
      const bb=getObjBBox(t,o);const dx=nx-bb.x,dy=ny-bb.y;
      if(o.t==='rect'||o.t==='textbox'){o.x+=dx;o.y+=dy;}
      else if(o.t==='circle'||o.t==='arc'){o.cx+=dx;o.cy+=dy;}
      else if(o.pts)o.pts=o.pts.map(p=>({...p,x:p.x+dx,y:p.y+dy}));
    }
    else if(t==='wire'){
      const bb=getObjBBox(t,o);const dx=nx-bb.x,dy=ny-bb.y;
      o.points=o.points.map(p=>({x:p.x+dx,y:p.y+dy}));
    }
  }

  // dir: 'left'|'right'|'top'|'bottom'|'centerH'|'centerV'|'distH'|'distV'
  // ── Fusionner la sélection en un groupe ──────────────────────
  // ── Conversions fil ↔ trait ────────────────────────────────────
  function convertWireToShape(wire) {
    if(!wire||!wire.points?.length)return;
    saveHistory('Convertir en trait');
    const shape = {
      id: uid(),
      t: wire.points.length===2 ? 'line' : 'poly',
      pts: JSON.parse(JSON.stringify(wire.points)),
      color: wire.color || '#3b9eff',
      thick: wire.width || 1.8,
      fill: false,
      stroke: 'solid'
    };
    state.wires = state.wires.filter(w=>w.id!==wire.id);
    state.shapes.push(shape);
    setOnlySel('shape', shape.id);
    render(); updateStatus(); updateProps();
    setStatus('✓ Fil converti en trait');
  }

  function convertShapeToWire(shape) {
    if(!shape||!shape.pts?.length||(shape.t!=='line'&&shape.t!=='poly'))return;
    saveHistory('Convertir en fil');
    const wire = {
      id: uid(),
      points: JSON.parse(JSON.stringify(shape.pts)),
      color: shape.color || '#1a6ab0',
      width: shape.thick || 1.8,
      isBus: false
    };
    state.shapes = state.shapes.filter(s=>s.id!==shape.id);
    state.wires.push(wire);
    setOnlySel('wire', wire.id);
    render(); updateStatus(); updateProps();
    setStatus('✓ Trait converti en fil');
  }

  function mergeSelected(){
    const keys=[...multiSel];
    if(keys.length<2){setStatus('Sélectionnez au moins 2 objets à fusionner');return;}
    // Seules les shapes et les wires (convertis en shape poly) peuvent être fusionnés
    const children=[];
    const toRemove={wire:new Set(),shape:new Set(),text:new Set(),element:new Set()};
    for(const k of keys){
      const[t,id]=k.split(':');
      const o=getById(t,id);if(!o)continue;
      if(t==='shape'){
        children.push(JSON.parse(JSON.stringify(o)));
        toRemove.shape.add(id);
      } else if(t==='wire'){
        // Convertir le fil en shape poly
        children.push({id:uid(),t:'poly',pts:JSON.parse(JSON.stringify(o.points)),color:o.color||'#3b9eff',thick:o.width||1.8,fill:false});
        toRemove.wire.add(id);
      } else if(t==='text'){
        children.push(JSON.parse(JSON.stringify({...o,_origType:'text'})));
        toRemove.text.add(id);
      }
      // Les éléments (symboles) ne sont pas fusionnables
    }
    if(children.length<2){setStatus('Fusionnez des traits, formes ou textes');return;}
    state.shapes=state.shapes.filter(s=>!toRemove.shape.has(s.id));
    state.wires=state.wires.filter(w=>!toRemove.wire.has(w.id));
    state.texts=state.texts.filter(t=>!toRemove.text.has(t.id));
    const group={id:uid(),t:'group',children};
    state.shapes.push(group);
    saveHistory('Créer symbole');
    clearMultiSel();setOnlySel('shape',group.id);
    render();updateStatus();setStatus(`✓ ${children.length} objets fusionnés`);
  }

  // ── Décomposer un groupe ──────────────────────────────────────
  function unmergeSelected(){
    const o=getSel();
    if(!o||selected.type!=='shape'||o.t!=='group'){setStatus('Sélectionnez un groupe à décomposer');return;}
    state.shapes=state.shapes.filter(s=>s.id!==o.id);
    clearMultiSel();
    o.children.forEach(child=>{
      if(child._origType==='text'){
        const{_origType,...t}=child;
        state.texts.push(t);
        multiSel.add(selKey('text',t.id));
      } else {
        state.shapes.push(child);
        multiSel.add(selKey('shape',child.id));
      }
    });
    saveHistory('Dégrouper');
    render();updateStatus();setStatus(`✓ Groupe décomposé en ${o.children.length} objets`);
  }

  // ── Créer un symbole depuis la sélection ─────────────────────
  function selectionToSymbol(){
    const keys=[...multiSel];
    if(keys.length<1){setStatus('Sélectionnez des objets pour créer un symbole');return;}

    // Calculer la bounding box de la sélection
    let x0=Infinity,y0=Infinity,x1=-Infinity,y1=-Infinity;
    function expandBB(x,y){x0=Math.min(x0,x);y0=Math.min(y0,y);x1=Math.max(x1,x);y1=Math.max(y1,y);}

    keys.forEach(k=>{
      const[t,id]=k.split(':');const o=getById(t,id);if(!o)return;
      const bb=getObjBBox(t,o);
      expandBB(bb.x,bb.y);expandBB(bb.x+bb.w,bb.y+bb.h);
    });
    if(x0===Infinity){setStatus('Impossible de calculer la zone');return;}

    const W=Math.max(x1-x0,20), H=Math.max(y1-y0,20);
    // Convertir en coordonnées locales (0..W, 0..H)
    const lx=x=>(x-x0), ly=y=>(y-y0);

    const paths=[];

    // Aplatir un enfant de groupe récursivement
    function shapeToPath(sh){
      if(sh.t==='group'){sh.children.forEach(c=>shapeToPath(c));return;}
      if(sh.t==='line'||sh.t==='poly'){
        if(sh.pts?.length>=2) paths.push({t:'L',pts:sh.pts.map(p=>({x:lx(p.x),y:ly(p.y)})),thick:sh.thick||1.5,color:sh.color});
      } else if(sh.t==='rect'||sh.t==='textbox'){
        paths.push({t:'R',x:lx(sh.x),y:ly(sh.y),w:sh.w,h:sh.h,thick:sh.thick||1.5,fill:sh.fill||false,color:sh.color});
      } else if(sh.t==='circle'){
        paths.push({t:'C',cx:lx(sh.cx),cy:ly(sh.cy),r:sh.r,thick:sh.thick||1.5,fill:sh.fill||false,color:sh.color});
      } else if(sh.t==='arc'){
        paths.push({t:'A',cx:lx(sh.cx),cy:ly(sh.cy),r:sh.r,a1:sh.a1||0,a2:sh.a2||Math.PI,thick:sh.thick||1.5,color:sh.color});
      }
    }

    keys.forEach(k=>{
      const[t,id]=k.split(':');const o=getById(t,id);if(!o)return;
      if(t==='wire'&&o.points?.length>=2){
        paths.push({t:'L',pts:o.points.map(p=>({x:lx(p.x),y:ly(p.y)})),thick:o.width||1.8,color:o.color});
      } else if(t==='shape'){
        shapeToPath(o);
      } else if(t==='text'){
        paths.push({t:'T',x:lx(o.x),y:ly(o.y),text:o.text,size:o.size||13,color:o.color});
      }
      // éléments ignorés (symboles dans symboles non supporté)
    });

    if(!paths.length){setStatus('Aucune forme convertible sélectionnée');return;}

    // Construire l'objet symbole proto et ouvrir l'éditeur
    const proto={
      id: null, // nouveau
      name:'Nouveau symbole',
      category:'Personnalisé',
      width: Math.round(W),
      height: Math.round(H),
      paths,
      pins:[]
    };
    SymbolEditor.open(proto, async()=>{
      await reloadSymbols();
      buildLibrary(document.getElementById('sym-search').value);
      render();
    }, _symbols);
  }

  function alignSelected(dir){
    const keys=[...multiSel];if(keys.length<2)return;
    const bb=getSelBBox(keys);
    keys.forEach(k=>{
      const[t,id]=k.split(':');const o=getById(t,id);if(!o)return;
      const ob=getObjBBox(t,o);
      if(dir==='left')      moveObjTo(t,o,bb.x,ob.y);
      else if(dir==='right')moveObjTo(t,o,bb.x+bb.w-ob.w,ob.y);
      else if(dir==='top')  moveObjTo(t,o,ob.x,bb.y);
      else if(dir==='bottom')moveObjTo(t,o,ob.x,bb.y+bb.h-ob.h);
      else if(dir==='centerH')moveObjTo(t,o,bb.cx-ob.w/2,ob.y);
      else if(dir==='centerV')moveObjTo(t,o,ob.x,bb.cy-ob.h/2);
    });
    saveHistory('Aligner');
    render();
  }

  function distributeSelected(dir){
    const keys=[...multiSel];if(keys.length<3)return;
    // Trier par position
    const objs=keys.map(k=>{const[t,id]=k.split(':');const o=getById(t,id);return{t,o,bb:getObjBBox(t,o),k};});
    if(dir==='distH'){
      objs.sort((a,b)=>a.bb.x-b.bb.x);
      const first=objs[0].bb.x, last=objs[objs.length-1].bb.x+objs[objs.length-1].bb.w;
      const totalW=objs.reduce((s,a)=>s+a.bb.w,0);
      const gap=(last-first-totalW)/(objs.length-1);
      let cur=first;
      objs.forEach(({t,o,bb})=>{moveObjTo(t,o,cur,bb.y);cur+=bb.w+gap;});
    }else{
      objs.sort((a,b)=>a.bb.y-b.bb.y);
      const first=objs[0].bb.y, last=objs[objs.length-1].bb.y+objs[objs.length-1].bb.h;
      const totalH=objs.reduce((s,a)=>s+a.bb.h,0);
      const gap=(last-first-totalH)/(objs.length-1);
      let cur=first;
      objs.forEach(({t,o,bb})=>{moveObjTo(t,o,bb.x,cur);cur+=bb.h+gap;});
    }
    saveHistory('Distribuer');
    render();
  }
  // ─────────────────────────────────────────────────────────
  function saveHistory(label=''){const s=JSON.parse(JSON.stringify(state));history=history.slice(0,histIdx+1);history.push({state:s,label});histIdx=history.length-1;if(history.length>60){history.shift();histIdx--;} markVoltageDirty();_scheduleBroadcast();_updateUndoRedo();}
  let _broadcastTimer = null;
  let _autoSaveTimer  = null;
  function _scheduleBroadcast() {
    if (_broadcastTimer) clearTimeout(_broadcastTimer);
    _broadcastTimer = setTimeout(() => {
      _broadcastTimer = null;
      LiveSync.broadcast({
        folioId:   currentFolioId || schemaId,
        elements:  state.elements,
        wires:     state.wires,
        texts:     state.texts,
        shapes:    state.shapes,
        junctions: state.junctions,
        images:    state.images,
        measures:  _measures,
      });
    }, 50);
    // Sauvegarde automatique — debounce 2s après la dernière modification
    if (autoSave && !isReadOnly && !_cartoucheEditMode && (currentFolioId || schemaId)) {
      if (_autoSaveTimer) clearTimeout(_autoSaveTimer);
      _setAutoSaveIndicator('pending');
      _autoSaveTimer = setTimeout(async () => {
        _autoSaveTimer = null;
        _setAutoSaveIndicator('saving');
        await saveSchema();
        _setAutoSaveIndicator('saved');
      }, 2000);
    }
  }

  function _setAutoSaveIndicator(state) {
    const btn = document.getElementById('btn-save');
    const ind = document.getElementById('autosave-indicator');
    if (!ind) return;
    if (state === 'pending') {
      ind.textContent = '●'; ind.title = 'Modification non sauvegardée';
      ind.style.color = '#fb923c';
    } else if (state === 'saving') {
      ind.textContent = '↻'; ind.title = 'Sauvegarde…';
      ind.style.color = '#facc15';
    } else if (state === 'saved') {
      ind.textContent = '✓'; ind.title = 'Sauvegardé automatiquement';
      ind.style.color = '#4ade80';
      setTimeout(() => { if(ind) ind.textContent = ''; }, 3000);
    }
  }

  function _syncAutoSaveUI() {
    const sw = document.getElementById('autosave-switch');
    if (sw) sw.checked = autoSave;
    const btn = document.getElementById('btn-save');
    if (btn) btn.style.opacity = autoSave ? '0.5' : '1';
  }

  function toggleAutoSave(val) {
    autoSave = val;
    _syncAutoSaveUI();
    saveUserSettings();
    setStatus(autoSave ? '⚡ Sauvegarde automatique activée' : 'Sauvegarde automatique désactivée');
  }
  function _updateUndoRedo(){
    const can_undo = histIdx > 0;
    const can_redo = histIdx < history.length-1;
    const ub = document.getElementById('btn-undo');
    const rb = document.getElementById('btn-redo');
    const uc = document.getElementById('undo-count');
    const rc = document.getElementById('redo-count');
    const ucaret = document.getElementById('btn-undo-caret');
    const rcaret = document.getElementById('btn-redo-caret');
    if(ub){ ub.disabled=!can_undo; ub.title=can_undo&&history[histIdx].label?`Annuler : ${history[histIdx].label} (Ctrl+Z)`:'Annuler (Ctrl+Z)'; }
    if(rb){ rb.disabled=!can_redo; rb.title=can_redo&&history[histIdx+1].label?`Refaire : ${history[histIdx+1].label} (Ctrl+Y)`:'Refaire (Ctrl+Y)'; }
    if(uc){ uc.textContent=histIdx; uc.style.display=can_undo?'block':'none'; }
    if(rc){ const n=history.length-1-histIdx; rc.textContent=n; rc.style.display=can_redo?'block':'none'; }
    if(ucaret) ucaret.disabled=!can_undo;
    if(rcaret) rcaret.disabled=!can_redo;
    // rebuild dropdown contents
    _buildHistDrop('undo');
    _buildHistDrop('redo');
  }
  function _buildHistDrop(kind){
    const drop = document.getElementById(kind==='undo'?'undo-drop':'redo-drop');
    if(!drop) return;
    drop.innerHTML='';
    if(kind==='undo'){
      if(histIdx<=0){ drop.innerHTML='<div class="tb-hist-empty">Aucune action à annuler</div>'; return; }
      const hdr=document.createElement('div'); hdr.className='tb-dhead';
      hdr.innerHTML=`<span>Annuler (${histIdx})</span><small>Cliquer pour revenir à cet état</small>`;
      drop.appendChild(hdr);
      for(let i=histIdx;i>=1;i--){
        const btn=document.createElement('button'); btn.className='tb-hist-item';
        const lbl=history[i].label||'Action';
        btn.innerHTML=`<span class="hist-idx">${i}</span><span class="hist-label">↩ ${lbl}</span>`;
        btn.addEventListener('click',()=>{ _jumpHistory(i-1); _closeSplitMenus(); });
        drop.appendChild(btn);
      }
    } else {
      const remaining=history.length-1-histIdx;
      if(remaining<=0){ drop.innerHTML='<div class="tb-hist-empty">Aucune action à refaire</div>'; return; }
      const hdr=document.createElement('div'); hdr.className='tb-dhead';
      hdr.innerHTML=`<span>Refaire (${remaining})</span><small>Cliquer pour avancer à cet état</small>`;
      drop.appendChild(hdr);
      for(let i=histIdx+1;i<history.length;i++){
        const btn=document.createElement('button'); btn.className='tb-hist-item';
        const lbl=history[i].label||'Action';
        btn.innerHTML=`<span class="hist-idx">${i}</span><span class="hist-label">↪ ${lbl}</span>`;
        btn.addEventListener('click',()=>{ _jumpHistory(i); _closeSplitMenus(); });
        drop.appendChild(btn);
      }
    }
  }
  function _jumpHistory(idx){
    if(idx<0||idx>=history.length||idx===histIdx) return;
    histIdx=idx;
    state=JSON.parse(JSON.stringify(history[histIdx].state));
    markVoltageDirty();clearMultiSel();render();updateProps();updateStatus();_updateUndoRedo();
  }
  function _closeSplitMenus(){
    document.querySelectorAll('.tb-split.tbm-open').forEach(m=>m.classList.remove('tbm-open'));
    document.getElementById('tb-backdrop')?.remove();
  }
  function undo(){if(histIdx<=0)return;histIdx--;state=JSON.parse(JSON.stringify(history[histIdx].state));markVoltageDirty();clearMultiSel();render();updateProps();updateStatus();_updateUndoRedo();}
  function redo(){if(histIdx>=history.length-1)return;histIdx++;state=JSON.parse(JSON.stringify(history[histIdx].state));markVoltageDirty();clearMultiSel();render();updateProps();updateStatus();_updateUndoRedo();}

  // ─────────────────────────────────────────────────────────
  // VUE / ZOOM
  // ─────────────────────────────────────────────────────────
  function fitView(){
    let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
    state.elements.forEach(e=>{minX=Math.min(minX,e.x);minY=Math.min(minY,e.y);maxX=Math.max(maxX,e.x+e.w);maxY=Math.max(maxY,e.y+e.h);});
    state.wires.forEach(w=>w.points.forEach(p=>{minX=Math.min(minX,p.x);minY=Math.min(minY,p.y);maxX=Math.max(maxX,p.x);maxY=Math.max(maxY,p.y);}));
    (state.shapes||[]).forEach(sh=>{
      if(sh.t==='rect'||sh.t==='textbox'){minX=Math.min(minX,sh.x);minY=Math.min(minY,sh.y);maxX=Math.max(maxX,sh.x+sh.w);maxY=Math.max(maxY,sh.y+sh.h);}
      else if(sh.t==='circle'){minX=Math.min(minX,sh.cx-sh.r);minY=Math.min(minY,sh.cy-sh.r);maxX=Math.max(maxX,sh.cx+sh.r);maxY=Math.max(maxY,sh.cy+sh.r);}
      else if((sh.t==='line'||sh.t==='poly')&&sh.pts){sh.pts.forEach(p=>{minX=Math.min(minX,p.x);minY=Math.min(minY,p.y);maxX=Math.max(maxX,p.x);maxY=Math.max(maxY,p.y);});}
    });
    if(minX===Infinity){view={zoom:1,panX:80,panY:60};render();return;}
    const pad=80,scX=(canvas.width-pad*2)/Math.max(maxX-minX,100),scY=(canvas.height-pad*2)/Math.max(maxY-minY,100);
    view.zoom=Math.min(scX,scY,3);view.panX=pad-minX*view.zoom;view.panY=pad-minY*view.zoom;
    document.getElementById('zoom-val').textContent=Math.round(view.zoom*100)+'%';render();
  }

  // Active/désactive l'onglet Implantation du ribbon selon le type de folio
  function _toggleImplantRibbon(show) {
    const tab = document.getElementById('ribbon-tab-implantation');
    if (!tab) return;
    if (show) {
      tab.style.display = '';
      document.querySelectorAll('.ribbon-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      document.querySelectorAll('.ribbon-panel').forEach(p => p.classList.remove('active'));
      document.getElementById('rpanel-implantation')?.classList.add('active');
      const cb = document.getElementById('impl-clamp-grid');
      const cbMag = document.getElementById('impl-magnet');
      const pf = projectFolios.find(x => x.id === currentFolioId);
      const c = pf?.data?.implantation || pf?.implantation || {};
      if (cb) cb.checked = !!c.clampToGrid;
      if (cbMag) cbMag.checked = c.magnetism !== false; // default on
    } else {
      tab.style.display = 'none';
      if (tab.classList.contains('active')) {
        tab.classList.remove('active');
        document.querySelectorAll('.ribbon-panel').forEach(p => p.classList.remove('active'));
        document.querySelector('.ribbon-tab[data-ribbon="accueil"]')?.classList.add('active');
        document.getElementById('rpanel-accueil')?.classList.add('active');
      }
    }
  }

  // ─────────────────────────────────────────────────────────
  // SAUVEGARDE / OUVERTURE (folio seul ou dans un projet)
  // ─────────────────────────────────────────────────────────
  async function saveSchema(){
    if(_cartoucheEditMode){exitCartoucheEdit(true);return;}
    const name=document.getElementById('schema-name').value.trim()||'Sans titre';
    if(isReadOnly){setStatus('⚠ Lecture seule — modifications non sauvegardées');return;}
    try{
      // Conserver la config BOM/sommaire si folio spécial
      const _curPf=projectFolios.find(x=>x.id===currentFolioId);
      const _bomCfg=_curPf?.data?.bomConfig;
      const _isBom=!!_bomCfg || _curPf?.data?.folio_type==='bom' || _curPf?.folio_type==='bom';
      const _isSummary=_curPf?.data?.folio_type==='summary' || _curPf?.folio_type==='summary';
      const _isBornier=_curPf?.data?.folio_type==='bornier' || _curPf?.folio_type==='bornier';
      const _isImplant=_curPf?.data?.folio_type==='implantation' || _curPf?.folio_type==='implantation'
        || !!_curPf?.data?.implantation || !!_curPf?.implantation;
      // Exclure titleblock de l'objet folio pour éviter la duplication
      const {titleblock: _tbExclude, ..._folioClean} = folio;
      // Pour bornier : charger les réserves du serveur pour éviter d'écraser avec des données en mémoire périmées
      let _serverReserves;
      if(_isBornier && currentFolioId){
        try{const _sr=await fetch(`/api/folios/${currentFolioId}`,{credentials:'include'});
        if(_sr.ok){const _sd=await _sr.json();_serverReserves=(_sd.data||{}).reserves||[];}}catch(e){}}
      let data;
      if(_isSummary){
        data={elements:[],wires:[],texts:[],shapes:[],junctions:[],images:[],folio:_folioClean,
          folio_type:'summary'};
      } else if(_isBornier){
        data={elements:[],wires:[],texts:[],shapes:[],junctions:[],images:[],folio:_folioClean,
          folio_type:'bornier',bornierName:_curPf?.bornierName||_curPf?.data?.bornierName||'',
          reserves:_serverReserves||_curPf?.data?.reserves||[]};
      } else if(_isImplant){
        data={elements:state.elements,wires:state.wires,
          texts:(state.texts||[]).filter(t=>!t.id?.startsWith('__impl_')),
          shapes:(state.shapes||[]).filter(s=>!s.id?.startsWith('__impl_')),
          junctions:state.junctions||[],images:state.images||[],folio:_folioClean,
          folio_type:'implantation',
          implantation:_curPf?.data?.implantation||_curPf?.implantation||{},
          titleblock:folio.titleblock||null};
      } else if(_isBom){
        data={elements:[],wires:[],texts:[],shapes:[],junctions:[],images:[],folio:_folioClean,
          folio_type:'bom',bomConfig:_bomCfg,titleblock:folio.titleblock||null};
      } else {
        data={elements:state.elements,wires:state.wires,texts:state.texts,shapes:state.shapes||[],junctions:state.junctions||[],images:state.images||[],folio:_folioClean,titleblock:folio.titleblock||null};
        // Filet de sécurité : si le folio a un type connu en cache, ne le perd pas
        const _prevType=_curPf?.data?.folio_type||_curPf?.folio_type;
        if(_prevType) data.folio_type=_prevType;
        if(_curPf?.data?.implantation||_curPf?.implantation) data.implantation=_curPf?.data?.implantation||_curPf?.implantation;
        if(_curPf?.data?.bornierName||_curPf?.bornierName) data.bornierName=_curPf?.data?.bornierName||_curPf?.bornierName;
        if(_curPf?.data?.bomConfig) data.bomConfig=_curPf.data.bomConfig;
      }
      if(currentFolioId){
        // Sauvegarder dans un folio de projet
        // titleblock aussi au niveau racine pour que l'API le persiste séparément
        // N'envoyer titleblock que s'il y a une vraie surcharge folio
        // (null = pas de surcharge → utilise project.titleblock_default)
        await fetch(`/api/folios/${currentFolioId}`,{method:'PUT',credentials:'include',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({name,data,titleblock:folio.titleblock!==undefined?folio.titleblock:null})});
        // Mettre à jour le nom dans la liste des folios
        const fi=projectFolios.find(f=>f.id===currentFolioId);if(fi)fi.name=name;
        _invalidateThumb(currentFolioId);
        updateFolioNav();
        setStatus('✓ Folio "'+name+'" sauvegardé');
      } else if(schemaId){
        await fetch(`/api/schemas/${schemaId}`,{method:'PUT',credentials:'include',
          headers:{'Content-Type':'application/json'},body:JSON.stringify({name,data})});
        setStatus('✓ "'+name+'" sauvegardé');
      } else {
        const res=await fetch('/api/schemas',{method:'POST',credentials:'include',
          headers:{'Content-Type':'application/json'},body:JSON.stringify({name,data})});
        const saved=await res.json();schemaId=saved.id;
        setStatus('✓ "'+name+'" sauvegardé');
      }
    }catch(e){setStatus('❌ '+e.message);}
  }

  async function openFolio(id){
    if(_cartoucheEditMode) exitCartoucheEdit(false);
    // Nettoyer sélection, hover et blinks au changement de folio
    selected.type=null;selected.id=null;hovered=null;multiSel.clear();
    state.elements.forEach(e=>{delete e._blink;});
    state.wires.forEach(e=>{delete e._blink;});
    state.texts.forEach(e=>{delete e._blink;});
    try{
      const res=await fetch(`/api/folios/${id}`,{credentials:'include'});
      if(!res.ok){const d=await res.json();throw new Error(d.error||'Erreur');}
      const schema=await res.json();
      const d=schema.data||{};
      // Normaliser folio_type si data.implantation présent mais folio_type manquant
      // (fiabilise l'ouverture en cas de save incomplet)
      if(d.implantation && !d.folio_type) d.folio_type='implantation';
      state.elements=d.elements||[];state.wires=d.wires||[];state.junctions=d.junctions||[];
      state.texts=d.texts||[];state.shapes=d.shapes||[];state.images=d.images||[];
      if(d.folio){
        // Exclure titleblock de l'objet folio pour éviter la pollution
        const {titleblock: _tbInFolio, ..._folioData} = d.folio;
        Object.assign(folio, _folioData);
      }
      // grid supprimé du folio — géré par le profil utilisateur (loadUserSettings)
      // Priorité : schema.titleblock (niveau racine, source canonique)
      //          → data.titleblock (niveau data, rétrocompat.)
      //          → null si aucun (utiliser le cartouche projet par défaut)
      const _tb_loaded = schema.titleblock !== undefined ? schema.titleblock
                        : (d.titleblock !== undefined ? d.titleblock : null);
      folio.titleblock = _tb_loaded; // null = utilise project.titleblock_default
      if(d.folio?.titleblockType) folio.titleblockType = d.folio.titleblockType;

      currentFolioId=id;schemaId=null;
      // Historique de navigation
      if(!_folioNavBusy){
        _folioHistory=_folioHistory.slice(0,_folioHistIdx+1);
        _folioHistory.push(id);
        _folioHistIdx=_folioHistory.length-1;
        if(_folioHistory.length>50){_folioHistory.shift();_folioHistIdx--;}
      }
      _updateFolioNavBtns();
    LiveSync.setFolioId(id);
      isReadOnly=!schema.canWrite;
      if(currentProject?.id) {
        LiveSync.connect(currentProject.id);
        const li=document.getElementById('live-indicator');if(li)li.style.display='';
      }
      document.getElementById('schema-name').value=schema.name;
      // Sync folio num from schema
      if(schema.folio_num)folio.num=schema.folio_num;
      clearMultiSel();history=[];histIdx=-1;saveHistory();
      _resyncCounters();
      // Synchroniser la zone d'impression avec le cartouche actif
      if(printZone.format) applyFormatToPrintZone(printZone.format);
      render();updateProps();updateStatus();updateFolioOverlay();updateFolioNav();
      // Second render après un délai pour que les images (logo) soient chargées
      setTimeout(render, 500);
      updateDxfImportLink();
      // Mettre l'URL à jour sans recharger la page
      if(currentProject?.id){
        const u=new URL(window.location);
        u.searchParams.set('project',currentProject.id);
        u.searchParams.set('folio',id);
        window.history.replaceState({},'',u);
      }
      setTimeout(fitView,100);
      setStatus((isReadOnly?'👁 Lecture seule — ':'')+`Folio ${schema.folio_num||''} "${schema.name}" ouvert`);
      if(isReadOnly)document.getElementById('mode-badge').textContent='LECTURE SEULE';
      // Filet de sécurité : déduire folio_type depuis les données si manquant
      if(!d.folio_type){
        if(d.implantation) d.folio_type='implantation';
        else if(d.bornierName) d.folio_type='bornier';
        else if(d.bomConfig) d.folio_type='bom';
      }
      // Folio spéciaux : BOM, Sommaire, Bornier, Implantation
      if(d.folio_type==='summary'){
        const pf=projectFolios.find(x=>x.id===id);
        if(pf){pf.data=d;pf.folio_type='summary';}
        hideBomOverlay();hideBornierOverlay();hideImplantOverlay();_toggleImplantRibbon(false);
        await showSummaryOverlay();
      } else if(d.folio_type==='bornier'){
        const pf=projectFolios.find(x=>x.id===id);
        if(pf){pf.data=d;pf.folio_type='bornier';pf.bornierName=d.bornierName||pf.bornierName||'';}
        hideBomOverlay();hideSummaryOverlay();hideImplantOverlay();_toggleImplantRibbon(false);
        await showBornierOverlay();
      } else if(d.folio_type==='implantation'){
        const pf=projectFolios.find(x=>x.id===id);
        if(pf){pf.data=d;pf.folio_type='implantation';pf.implantation=d.implantation||{};}
        hideBomOverlay();hideSummaryOverlay();hideBornierOverlay();
        _toggleImplantRibbon(true);
        await showImplantOverlay();
      } else if(d.folio_type==='bom'||d.bomConfig){
        const pf=projectFolios.find(x=>x.id===id);
        if(pf){pf.data=d;pf.folio_type='bom';}
        hideSummaryOverlay();hideBornierOverlay();hideImplantOverlay();_toggleImplantRibbon(false);
        await showBomOverlay();
      } else {
        hideBomOverlay();hideSummaryOverlay();hideBornierOverlay();hideImplantOverlay();_toggleImplantRibbon(false);
        const pf=projectFolios.find(x=>x.id===id);
        if(pf)pf._cachedData=d;
      }
    }catch(e){showWarning('Erreur: '+e.message);}
  }

  async function openSchema(id){
    try{
      const res=await fetch(`/api/schemas/${id}`,{credentials:'include'});const schema=await res.json();
      const d=schema.data||{};
      state.elements=d.elements||[];state.wires=d.wires||[];state.texts=d.texts||[];state.shapes=d.shapes||[];state.junctions=d.junctions||[];state.images=d.images||[];
      if(d.folio){const {titleblock:_tbF2,..._fd2}=d.folio;Object.assign(folio,_fd2);}
      // grid supprimé du folio — géré par le profil utilisateur
      schemaId=id;currentFolioId=null;currentProject=null;projectFolios=[];
    LiveSync.setFolioId(id);
      document.getElementById('schema-name').value=schema.name;
      clearMultiSel();saveHistory();_resyncCounters();render();updateProps();updateStatus();updateFolioOverlay();
      closeModal('modal-schemas');setTimeout(fitView,100);setStatus('Schéma "'+schema.name+'" ouvert');
    }catch(e){showWarning('Erreur: '+e.message);}
  }

  async function newSchema(){
    if((state.elements.length||state.wires.length)&&!await showConfirm('Fermer et créer un nouveau schéma ?'))return;
    state={elements:[],wires:[],texts:[],shapes:[],junctions:[]};
    // Recharger les todos utilisateur si plus de projet
    if(!currentProject?.id){loadUserSettings().then(()=>renderTodoList());}
    schemaId=null;currentFolioId=null;currentProject=null;projectFolios=[];isReadOnly=false;
    LiveSync.disconnect();
    const _li=document.getElementById('live-indicator');if(_li)_li.style.display='none';
    folio={num:1,wireStart:1,wireStep:1,wireAuto:true,wireCounter:1,
      project:'',title:'',ref:'',rev:'A',author:'',checker:'',
      date:new Date().toISOString().slice(0,10),company:'CBI',note:''};
    document.getElementById('schema-name').value='Nouveau folio';
    clearMultiSel();history=[];histIdx=-1;saveHistory();
    render();updateProps();updateStatus();updateFolioOverlay();updateFolioNav();
  }

  // ─────────────────────────────────────────────────────────
  // FOLIO & FILS
  // ─────────────────────────────────────────────────────────
  function updateFolioOverlay(){
    document.getElementById('sb-folio').textContent=folio.num||'—';
    const el=document.getElementById('folio-overlay');
    if(folio.project||folio.title){el.classList.add('visible');el.textContent=`Folio ${folio.num}${folio.title?' — '+folio.title:''}${folio.project?' | '+folio.project:''}`;}
    else el.classList.remove('visible');
  }

  // Format : "N°folio.N°fil" → ex folio 10, fil 3 → "10.03"
  // ── Resynchroniser les compteurs après chargement d'un folio ───────────
  // wireCounter : reprend après le numéro de fil le plus élevé existant
  // _nameCounters : reconstruit depuis les labels des éléments placés
  function _resyncCounters() {
    // ── Compteur de fil ────────────────────────────────────────────────
    // Format numéro fil : "<folioNum>.<counter>" ex "1.03" → counter=3
    let maxCounter = (folio.wireStart || 1) - (folio.wireStep || 1);
    for (const w of state.wires) {
      const n = (w.num || '').trim();
      if (!n) continue;
      // Extraire la partie après le dernier '.'
      const parts = n.split('.');
      const numPart = parseInt(parts[parts.length - 1], 10);
      if (!isNaN(numPart) && numPart > maxCounter) maxCounter = numPart;
    }
    folio.wireCounter = maxCounter + (folio.wireStep || 1);

    // ── Compteurs de nommage automatique ──────────────────────────────
    // Reconstruire _nameCounters depuis les labels des éléments existants
    // Format label : [folioNum][sep][objType][instanceNum][suffix]
    // On lit directement les compteurs depuis les labels pour chaque type
    PROJ._nameCounters = PROJ._nameCounters || {};
    for (const el of state.elements) {
      const sym = _symbols[el.symId];
      if (!sym?.objType) continue;
      const objType = sym.objType.trim().toUpperCase();
      if (!objType) continue;
      const label = (el.label || '').trim();
      if (!label) continue;
      // Extraire le numéro d'instance : derniers chiffres consécutifs
      const m = label.match(/(\d+)\D*$/);
      if (!m) continue;
      const inst = parseInt(m[1], 10);
      if (isNaN(inst)) continue;
      const folioKey = PROJ.nameScope === 'global' ? 'global' : `f${folio.num}`;
      const counterKey = `${folioKey}:${objType}`;
      const cur = PROJ._nameCounters[counterKey] || 0;
      if (inst > cur) PROJ._nameCounters[counterKey] = inst;
    }
  }

  function nextWireNum(){
    const f=String(folio.num);
    const n=String(folio.wireCounter).padStart(2,'0');
    folio.wireCounter+=folio.wireStep||1;
    return f+'.'+n;
  }
  function renumberWires() {
    const TOL = 10;

    // ── Extrémité la plus en haut-à-gauche ───────────────────────────────
    function wireTopLeft(w) {
      if (!w.points || !w.points.length) return {x:0,y:0};
      const a = w.points[0], b = w.points[w.points.length - 1];
      if (a.y < b.y) return a;
      if (b.y < a.y) return b;
      return a.x <= b.x ? a : b;
    }

    // ── Construire l'adjacence (connexion directe point-à-point) ─────────
    const adj = {};
    for (const w of state.wires) adj[w.id] = new Set();
    for (let i = 0; i < state.wires.length; i++) {
      const a = state.wires[i];
      const aPts = [a.points[0], a.points[a.points.length-1]];
      for (let j = i+1; j < state.wires.length; j++) {
        const b = state.wires[j];
        const bPts = b.points;
        let conn = false;
        for (const ap of aPts) {
          for (const bp of bPts) {
            if (Math.hypot(ap.x-bp.x, ap.y-bp.y) < TOL) { conn=true; break; }
          }
          if (conn) break;
        }
        if (!conn) {
          const aAll = a.points;
          for (const bp of [b.points[0], b.points[b.points.length-1]]) {
            for (const ap of aAll) {
              if (Math.hypot(ap.x-bp.x, ap.y-bp.y) < TOL) { conn=true; break; }
            }
            if (conn) break;
          }
        }
        if (conn) { adj[a.id].add(b.id); adj[b.id].add(a.id); }
      }
    }

    // ── Groupes connexes (Union-Find simple via BFS) ──────────────────────
    const groupOf = {}; // wireId → groupId
    const groups  = {}; // groupId → [wireId]
    let gid = 0;
    for (const w of state.wires) {
      if (w.id in groupOf) continue;
      const id = gid++;
      groups[id] = [];
      const q = [w.id];
      while (q.length) {
        const cur = q.shift();
        if (cur in groupOf) continue;
        groupOf[cur] = id;
        groups[id].push(cur);
        for (const nb of adj[cur]) if (!(nb in groupOf)) q.push(nb);
      }
    }

    // ── Trier les fils par extrémité haut-à-gauche ───────────────────────
    const colTol = Math.max(40, (printZone.w || 1200) / 20);
    const sorted = [...state.wires].sort((a, b) => {
      const pa = wireTopLeft(a), pb = wireTopLeft(b);
      const colA = Math.round(pa.x / colTol), colB = Math.round(pb.x / colTol);
      if (colA !== colB) return colA - colB;
      return pa.y - pb.y;
    });

    // ── Assigner les numéros : un seul numéro par groupe connexe ─────────
    // Le représentant du groupe = premier fil rencontré dans l'ordre de tri
    folio.wireCounter = folio.wireStart || 1;
    const groupNum = {}; // groupId → numéro attribué
    for (const w of sorted) {
      const g = groupOf[w.id];
      if (!(g in groupNum)) {
        groupNum[g] = nextWireNum();
      }
      w.num = groupNum[g];
    }
    render();
    scheduleAutoXrefs();
  }

  // ── Renvois de folio automatiques ─────────────────────────────────────
  let _xrefTimer = null;
  function scheduleAutoXrefs() {
    if (_xrefTimer) clearTimeout(_xrefTimer);
    _xrefTimer = setTimeout(_autoXrefs, 400);
  }

  // Vérifie si un point est connecté (à un autre fil/bus, une broche, ou une jonction)
  // Détecte aussi les connexions sur un SEGMENT de fil/bus (pas seulement les sommets)
  function _isEndpointConnected(pt, wire, wires, elements, symbols) {
    const TOL = 5;
    const syms = symbols || _symbols;
    for (const w of wires) {
      if (w.id === wire.id) continue;
      // Vérifier les points discrets
      for (const p of w.points) {
        if (Math.hypot(p.x - pt.x, p.y - pt.y) < TOL) return true;
      }
      // Vérifier les segments (extrémité de fil sur un segment de bus/fil)
      const pts = w.points;
      for (let i = 0; i < pts.length - 1; i++) {
        const a = pts[i], b = pts[i + 1];
        const dx = b.x - a.x, dy = b.y - a.y;
        const len2 = dx * dx + dy * dy;
        if (len2 === 0) continue;
        const t = Math.max(0, Math.min(1, ((pt.x - a.x) * dx + (pt.y - a.y) * dy) / len2));
        const dist = Math.hypot(pt.x - (a.x + t * dx), pt.y - (a.y + t * dy));
        if (dist < TOL) return true;
      }
    }
    // Connecté à une broche de symbole ?
    for (const el of elements) {
      const sym = syms[el.symId];
      if (!sym || !sym.pins) continue;
      for (const {pin, poleIndex} of Renderer.getAllPins(el, sym)) {
        const [px, py] = Renderer.getPinWorld(el, sym, pin, poleIndex);
        if (Math.hypot(px - pt.x, py - pt.y) < TOL) return true;
      }
    }
    return false;
  }

  // Détermine les xrefs à placer sur un fil en fonction de ses extrémités libres
  // Règle : le xref ne va JAMAIS du côté connecté, TOUJOURS de l'autre bout
  // Si start connecté → xref possible uniquement sur end
  // Si end connecté → xref possible uniquement sur start
  // Si les deux libres → xref possible sur les deux
  // Si les deux connectés → pas de xref (fil complet)
  // Calcule la coordonnée du repère orthogonal (ex: "B12") pour un point monde
  function _getRefGridCoord(pt) {
    if (!refGrid.show || !printZone.w || !printZone.h) return '';
    const nc = refGrid.cols || 20, nr = refGrid.rows || 9;
    const col = Math.floor((pt.x - printZone.x) / (printZone.w / nc));
    const row = Math.floor((pt.y - printZone.y) / (printZone.h / nr));
    const letter = String.fromCharCode(65 + Math.max(0, Math.min(nr - 1, row)));
    const num = Math.max(1, Math.min(nc, col + 1));
    return letter + num;
  }

  function _resolveWireXrefs(wire, xrLower, xrUpper, wires, elements, symbols) {
    if (!wire.points || wire.points.length < 2) return { start: '', end: '' };
    const p0 = wire.points[0];
    const pN = wire.points[wire.points.length - 1];
    const startConn = _isEndpointConnected(p0, wire, wires, elements, symbols);
    const endConn = _isEndpointConnected(pN, wire, wires, elements, symbols);

    let wantStart = '', wantEnd = '';

    if (startConn && endConn) {
      // Fil complet, pas de renvoi
    } else if (startConn && !endConn) {
      wantEnd = xrLower || xrUpper;
    } else if (!startConn && endConn) {
      wantStart = xrLower || xrUpper;
    } else {
      wantStart = xrLower;
      wantEnd = xrUpper;
    }

    return { start: wantStart, end: wantEnd };
  }

  async function _autoXrefs() {
    if (!currentProject || !projectFolios.length) return;
    const curFolio = projectFolios.find(f => f.id === currentFolioId);
    if (!curFolio) return;
    const curNum = curFolio.folio_num;

    // Charger les données des autres folios si pas en cache
    const otherFolios = projectFolios.filter(f => f.id !== currentFolioId);
    for (const f of otherFolios) {
      if (!f._cachedData) {
        try {
          const res = await fetch(`/api/schemas/${f.id}`, { credentials: 'include' });
          if (res.ok) { const schema = await res.json(); f._cachedData = schema.data || {}; }
        } catch {}
      }
    }

    // Index global : wireNum → Map de folioNum → { folio_num, wire endpoints }
    const numToFolios = {};  // wireNum → Set<folioNum>
    const numToCoords = {};  // wireNum → Map<folioNum, {x,y} endpoint libre du fil>

    // Helper : trouver l'extrémité libre d'un fil dans un folio (pour la coordonnée du repère)
    function _findFreeEndpoint(wire, allWires, allElements) {
      if (!wire.points || wire.points.length < 2) return null;
      const p0 = wire.points[0], pN = wire.points[wire.points.length - 1];
      // Vérification simplifiée : si une extrémité est "libre" (pas connectée), c'est celle-là
      const startConn = _isEndpointConnected(p0, wire, allWires, allElements);
      const endConn = _isEndpointConnected(pN, wire, allWires, allElements);
      if (!startConn && endConn) return p0;
      if (startConn && !endConn) return pN;
      if (!startConn && !endConn) return p0; // les deux libres, prendre le début
      return pN; // les deux connectés, prendre la fin
    }

    // Indexer le folio courant
    for (const w of state.wires) {
      if (!w.num) continue;
      if (!numToFolios[w.num]) numToFolios[w.num] = new Set();
      numToFolios[w.num].add(curNum);
      const ep = _findFreeEndpoint(w, state.wires, state.elements);
      if (ep) {
        if (!numToCoords[w.num]) numToCoords[w.num] = {};
        numToCoords[w.num][curNum] = ep;
      }
    }
    // Indexer les autres folios
    for (const f of otherFolios) {
      const d = f._cachedData;
      if (!d || !d.wires) continue;
      for (const w of d.wires) {
        if (!w.num) continue;
        if (!numToFolios[w.num]) numToFolios[w.num] = new Set();
        numToFolios[w.num].add(f.folio_num);
        // Coordonnée de l'extrémité libre sur ce folio distant
        if (w.points && w.points.length >= 2) {
          const ep = _findFreeEndpoint(w, d.wires, d.elements || []);
          if (ep) {
            if (!numToCoords[w.num]) numToCoords[w.num] = {};
            numToCoords[w.num][f.folio_num] = ep;
          }
        }
      }
    }

    // Pour un numéro de fil et un folio, trouver le folio inférieur et supérieur les plus proches
    // + la coordonnée du repère sur le folio cible
    function findXrefs(wireNum, folioNum) {
      const all = numToFolios[wireNum];
      if (!all || all.size < 2) return { start: '', end: '' };
      const cur = parseFloat(folioNum) || 0;
      const sorted = [...all].sort((a, b) => (parseFloat(a)||0) - (parseFloat(b)||0));
      let lowerNum = null, upperNum = null;
      for (let i = sorted.length - 1; i >= 0; i--) {
        if ((parseFloat(sorted[i])||0) < cur) { lowerNum = sorted[i]; break; }
      }
      for (let i = 0; i < sorted.length; i++) {
        if ((parseFloat(sorted[i])||0) > cur) { upperNum = sorted[i]; break; }
      }
      let lower = lowerNum != null ? 'F' + lowerNum : '';
      let upper = upperNum != null ? 'F' + upperNum : '';
      // Enrichir avec la coordonnée du repère sur le folio CIBLE
      if (refGrid.show) {
        const coords = numToCoords[wireNum] || {};
        if (lower && coords[lowerNum]) lower += ' ' + _getRefGridCoord(coords[lowerNum]);
        if (upper && coords[upperNum]) upper += ' ' + _getRefGridCoord(coords[upperNum]);
      }
      return { start: lower, end: upper };
    }

    const isAuto = v => !v || /^F\d/.test(v); // xref auto ou vide (inclut "F3" et "F3 B12")

    // Mettre à jour les xrefs du folio courant
    let changed = false;
    for (const w of state.wires) {
      if (!w.num) {
        if (isAuto(w.xrefStart) && w.xrefStart) { w.xrefStart = ''; changed = true; }
        if (isAuto(w.xrefEnd) && w.xrefEnd) { w.xrefEnd = ''; changed = true; }
        continue;
      }
      const xr = findXrefs(w.num, curNum);
      const want = _resolveWireXrefs(w, xr.start, xr.end, state.wires, state.elements);

      if (isAuto(w.xrefStart) && w.xrefStart !== want.start) { w.xrefStart = want.start; changed = true; }
      if (isAuto(w.xrefEnd) && w.xrefEnd !== want.end) { w.xrefEnd = want.end; changed = true; }
    }

    // Mettre à jour les fils des autres folios
    const remoteSaves = new Set();
    for (const f of otherFolios) {
      const d = f._cachedData;
      if (!d || !d.wires) continue;
      const fWires = d.wires || [];
      const fElements = d.elements || [];
      let fChanged = false;
      for (const w of fWires) {
        if (!w.num) continue;
        const xr = findXrefs(w.num, f.folio_num);
        const want = _resolveWireXrefs(w, xr.start, xr.end, fWires, fElements);

        if (isAuto(w.xrefStart) && w.xrefStart !== want.start) { w.xrefStart = want.start; fChanged = true; }
        if (isAuto(w.xrefEnd) && w.xrefEnd !== want.end) { w.xrefEnd = want.end; fChanged = true; }
      }
      if (fChanged) remoteSaves.add(f.id);
    }

    // Sauvegarder les folios distants modifiés
    for (const fid of remoteSaves) {
      const f = otherFolios.find(x => x.id === fid);
      if (!f || !f._cachedData) continue;
      try {
        await fetch(`/api/schemas/${fid}`, {
          method: 'PUT', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ data: f._cachedData })
        });
      } catch {}
    }

    if (changed) render();
  }

  function updateWireNumPreview(){
    const f=parseInt(document.getElementById('wn-folio').value)||1;
    const s=parseInt(document.getElementById('wn-start').value)||1;
    const step=parseInt(document.getElementById('wn-step').value)||1;
    const fmt=n=>`${f}.${String(n).padStart(2,'0')}`;
    document.getElementById('wn-preview').textContent=`${fmt(s)},  ${fmt(s+step)},  ${fmt(s+step*2)}…`;
  }

  // ─────────────────────────────────────────────────────────
  // TODO LIST
  // ─────────────────────────────────────────────────────────
  function loadTodos(){/* déjà chargé depuis loadUserSettings */}

  async function saveTodos(){
    if(currentProject?.id){
      try{await fetch(`/api/projects/${currentProject.id}/todos`,{
        method:'PUT',credentials:'include',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(todos)});
        // Notifier les pairs connectés
        LiveSync.broadcastTodos(todos);
      }catch(e){/* silent fallback */ saveUserSettings();}
    } else {
      saveUserSettings();
    }
  }

  function renderTodoList(){
    const list=document.getElementById('todo-list');
    const footer=document.getElementById('todo-footer');
    const countEl=document.getElementById('todo-count');
    if(!list)return;
    const done=todos.filter(t=>t.done).length;
    countEl.textContent=todos.length?`${done}/${todos.length}`:' ';
    footer.textContent=todos.length?`${done} terminée${done>1?'s':''} sur ${todos.length}`:'';
    if(!todos.length){list.innerHTML='<div style="text-align:center;color:var(--text3);padding:20px 0;font-size:11px">Aucune note — ajoutez-en une !</div>';return;}
    list.innerHTML='';
    todos.forEach((todo,idx)=>{
      const item=document.createElement('div');
      item.className='todo-item'+(todo.done?' done':'');
      item.innerHTML=`
        <div class="todo-check" data-idx="${idx}">${todo.done?'✓':''}</div>
        <div class="todo-text" data-idx="${idx}">${escHTML(todo.text)}</div>
        <div class="todo-actions">
          <button class="todo-act-btn" data-edit="${idx}" title="Modifier">✏</button>
          <button class="todo-act-btn del" data-del="${idx}" title="Supprimer">✕</button>
        </div>`;
      // Toggle done
      item.querySelector('.todo-check').addEventListener('click',e=>{e.stopPropagation();todos[idx].done=!todos[idx].done;renderTodoList();saveTodos();});
      // Édition inline (double-clic sur le texte)
      item.querySelector('.todo-text').addEventListener('dblclick',e=>{
        e.stopPropagation();
        const span=e.currentTarget;
        const input=document.createElement('input');
        input.className='todo-edit-input';input.value=todos[idx].text;
        span.replaceWith(input);input.focus();input.select();
        const save=()=>{if(input.value.trim())todos[idx].text=input.value.trim();renderTodoList();saveTodos();};
        input.addEventListener('blur',save);
        input.addEventListener('keydown',e2=>{if(e2.key==='Enter')save();if(e2.key==='Escape'){renderTodoList();}});
      });
      item.querySelector('[data-del]').addEventListener('click',e=>{e.stopPropagation();todos.splice(idx,1);renderTodoList();saveTodos();});
      item.querySelector('[data-edit]').addEventListener('click',e=>{
        e.stopPropagation();
        const span=item.querySelector('.todo-text');
        const input=document.createElement('input');
        input.className='todo-edit-input';input.value=todos[idx].text;
        span.replaceWith(input);input.focus();input.select();
        const save=()=>{if(input.value.trim())todos[idx].text=input.value.trim();renderTodoList();saveTodos();};
        input.addEventListener('blur',save);
        input.addEventListener('keydown',e2=>{if(e2.key==='Enter')save();if(e2.key==='Escape')renderTodoList();});
      });
      list.appendChild(item);
    });
  }

  function bindTodoInput(){
    const inp=document.getElementById('todo-input');
    const btn=document.getElementById('todo-add-btn');
    if(!inp||!btn)return;
    const add=()=>{const txt=inp.value.trim();if(!txt)return;todos.push({id:uid(),text:txt,done:false});inp.value='';renderTodoList();saveTodos();};
    btn.addEventListener('click',add);
    inp.addEventListener('keydown',e=>{if(e.key==='Enter')add();});
  }

  // ─────────────────────────────────────────────────────────
  // PANNEAU PROPRIÉTÉS
  // ─────────────────────────────────────────────────────────
  // ── Outil Image ───────────────────────────────────────────
  let _pendingImageData = null;

  function pickImageFile() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/jpeg,image/png,image/gif,image/svg+xml,image/webp';
    input.onchange = e => {
      const file = e.target.files[0];
      if (!file) { setTool('select'); return; }
      const reader = new FileReader();
      reader.onload = ev => {
        const src = ev.target.result;
        const imgEl = new Image();
        imgEl.onload = () => {
          _pendingImageData = { src, naturalW: imgEl.naturalWidth||200, naturalH: imgEl.naturalHeight||200 };
          setStatus("Cliquer sur le canevas pour placer l'image — Échap pour annuler");
        };
        imgEl.src = src;
      };
      reader.readAsDataURL(file);
    };
    input.click();
  }

  function placeImage(wx, wy) {
    if (!_pendingImageData) return;
    const { src, naturalW, naturalH } = _pendingImageData;
    const maxW = 400;
    const w = Math.min(naturalW, maxW);
    const h = Math.round(w * naturalH / Math.max(naturalW, 1));
    const x = snapW(wx - w/2), y = snapW(wy - h/2);
    if (!state.images) state.images = [];
    const img = { id: uid(), x, y, w, h, src, opacity: 1 };
    state.images.push(img);
    _pendingImageData = null;
    setOnlySel('image', img.id);
    render(); updateProps(); updateStatus();
    setTool('select');
  }


  // ── Recherche dans le schéma ─────────────────────────────────────────
  function _openSearch(){
    const p=document.getElementById('search-palette');
    if(!p)return;
    p.style.display='block';
    const inp=document.getElementById('search-input');
    if(inp){inp.focus();inp.select();}
    _doSearch();
  }
  function _closeSearch(){
    const p=document.getElementById('search-palette');
    if(p)p.style.display='none';
  }

  function _doSearch(){
    const inp=document.getElementById('search-input');
    const q=(inp?.value||'').trim();
    const allFolios=document.getElementById('search-all-folios')?.checked;
    const matchCase=document.getElementById('search-match-case')?.checked;
    const res=document.getElementById('search-results');
    const status=document.getElementById('search-status');
    if(!res)return;

    if(!q){res.innerHTML='';if(status)status.textContent='';return;}

    const test=(str)=>{
      if(!str)return false;
      return matchCase?str.includes(q):str.toLowerCase().includes(q.toLowerCase());
    };
    const hl=(str)=>{
      if(!str)return '';
      const _qe=q.replace(/[$()*+.?[\\\]^{|}]/g,'\\$&'); const re=new RegExp('('+_qe+')','gi');
      return str.replace(re,'<mark>$1</mark>');
    };

    const results=[];
    // Folio courant
    const _currentFolioLabel='F'+(projectFolios.find(f=>f.id===currentFolioId)?.folio_num||'?');
    state.elements.forEach(el=>{
      const sym=_symbols[el.symId];
      if(test(el.label)||test(el.ref)||test(sym?.name)){
        results.push({type:'element',id:el.id,folioId:currentFolioId,
          folioLabel:_currentFolioLabel,
          label:el.label||sym?.name||'?',ref:el.ref,
          symName:sym?.name||el.symId, x:el.x,y:el.y,w:el.w,h:el.h});
      }
    });
    state.texts.forEach(t=>{
      if(test(t.text))results.push({type:'text',id:t.id,folioId:currentFolioId,
        folioLabel:_currentFolioLabel,label:t.text,x:t.x,y:t.y});
    });
    // Autres folios
    if(allFolios){
      projectFolios.filter(f=>f.id!==currentFolioId).forEach(f=>{
        const d=f._cachedData;if(!d)return;
        const fl='F'+(f.folio_num||'?');
        (d.elements||[]).forEach(el=>{
          const sym=_symbols[el.symId];
          if(test(el.label)||test(el.ref)||test(sym?.name)){
            results.push({type:'element',id:el.id,folioId:f.id,folioLabel:fl,
              label:el.label||sym?.name||'?',ref:el.ref,symName:sym?.name||el.symId,
              x:el.x,y:el.y,w:el.w,h:el.h});
          }
        });
      });
    }

    if(!results.length){
      res.innerHTML='<div style="text-align:center;color:var(--text3);padding:16px;font-size:11px">Aucun résultat</div>';
      if(status)status.textContent='';return;
    }

    res.innerHTML=results.slice(0,50).map((r,i)=>`
      <div class="search-result" data-idx="${i}">
        <span style="font-size:16px">${r.type==='element'?'⬡':'T'}</span>
        <span class="sr-label">${hl(r.label)}${r.ref?` <span style="color:var(--text3);font-weight:400">${hl(r.ref)}</span>`:''}</span>
        ${r.symName&&r.type==='element'?`<span class="sr-type">${hl(r.symName)}</span>`:''}
        <span class="sr-folio">${r.folioLabel}</span>
      </div>`).join('');

    if(status)status.textContent=`${results.length} résultat(s)${results.length>50?' (50 affichés)':''}`;

    // Clic sur résultat
    res.querySelectorAll('.search-result').forEach((el,i)=>{
      el.addEventListener('click',async ()=>{
        const r=results[i];
        _closeSearch();
        if(r.folioId&&r.folioId!==currentFolioId){
          await saveSchema();
          await openFolio(r.folioId);
        }
        // Centrer et sélectionner
        setTimeout(()=>{
          const cx=r.x+(r.w||60)/2, cy=r.y+(r.h||20)/2;
          view.panX=canvas.width/2-cx*view.zoom;
          view.panY=canvas.height/2-cy*view.zoom;
          if(r.type==='element'){
            selected={type:'element',id:r.id};
          } else {
            selected={type:'text',id:r.id};
          }
          render();updateProps();
          // Clignotement léger — nettoyer tous les blinks existants d'abord
          state.elements.forEach(e=>{delete e._blink;});
          state.wires.forEach(e=>{delete e._blink;});
          state.texts.forEach(e=>{delete e._blink;});
          const _el=getById(r.type,r.id);
          if(_el){
            _el._blink=true;render();
            const _blinkId=_el.id;
            setTimeout(()=>{
              // Nettoyer par id au cas où la référence a changé
              const cur=getById(r.type,_blinkId);
              if(cur) delete cur._blink;
              render();
            },3000);
          }
        },150);
      });
    });
  }

  function _doReplace(one=false){
    const q=(document.getElementById('search-input')?.value||'').trim();
    const status=document.getElementById('search-status');
    if(!q){if(status)status.textContent='Saisissez un terme à rechercher';return;}
    if(document.getElementById('search-all-folios')?.checked){
      if(status)status.textContent='⚠ Remplacement limité au folio courant';return;}
    const rep=document.getElementById('replace-input')?.value??'';
    const matchCase=document.getElementById('search-match-case')?.checked;
    const _repl=(str)=>{
      const qe=q.replace(/[$()*+.?[\\\]^{|}]/g,'\\$&');
      const flags=matchCase?(one?'':'g'):(one?'i':'gi');
      return str.replace(new RegExp(qe,flags),rep);
    };
    let count=0;
    for(const el of state.elements){
      if(one&&count>0)break;
      if(matchCase?el.label?.includes(q):el.label?.toLowerCase().includes(q.toLowerCase())){
        el.label=_repl(el.label);count++;}
      if(one&&count>0)break;
      if(matchCase?el.ref?.includes(q):el.ref?.toLowerCase().includes(q.toLowerCase())){
        el.ref=_repl(el.ref);count++;}
    }
    for(const t of state.texts){
      if(one&&count>0)break;
      if(matchCase?t.text?.includes(q):t.text?.toLowerCase().includes(q.toLowerCase())){
        t.text=_repl(t.text);count++;}
    }
    if(count>0){saveHistory('Remplacer');render();updateStatus();}
    if(status)status.textContent=count?`${count} remplacement(s) effectué(s)`:'Aucun résultat';
    _doSearch();
  }

  function updateProps(){
    const empty=document.getElementById('props-empty');
    const form=document.getElementById('props-form');
    const titleEl=document.getElementById('props-panel-title');
    const s=getSel();

    // Barre alignement flottante
    const _ab = document.getElementById('align-bar');
    if(_ab){
      _ab.style.display = multiSel.size>1 ? 'flex' : 'none';
      const _abc = document.getElementById('align-bar-count');
      if(_abc) _abc.textContent = `${multiSel.size} obj.`;
    }
    if(multiSel.size>1){
      empty.style.display='none';form.style.display='block';titleEl.textContent='Propriétés';
      const n=multiSel.size;
      const _mSelKeys=[...multiSel];
      const _mSelObjs=_mSelKeys.map(k=>{const[t,id]=k.split(':');return{type:t,obj:getById(t,id)};}).filter(o=>o.obj);
      const _mTypes=new Set(_mSelObjs.map(o=>o.type));
      const _mAllType=_mTypes.size===1?[..._mTypes][0]:null;
      const _mCval=(prop,def)=>{const vs=new Set(_mSelObjs.map(o=>{const v=o.obj[prop];return v!==undefined?v:def;}));return vs.size===1?[...vs][0]:null;};
      const _mApply=(prop,val)=>{_mSelObjs.forEach(o=>{o.obj[prop]=val;});render();};
      const _mTypeLabel={element:'éléments',wire:'fils',text:'textes',shape:'formes',image:'images'};
      const S={
        left:   `<svg viewBox="0 0 22 18" width="20" height="15"><line x1="3" y1="1" x2="3" y2="17" stroke="currentColor" stroke-width="1.8"/><rect x="3" y="3" width="11" height="4" rx="1" fill="currentColor" opacity=".75"/><rect x="3" y="11" width="16" height="4" rx="1" fill="currentColor" opacity=".75"/></svg>`,
        centerH:`<svg viewBox="0 0 22 18" width="20" height="15"><line x1="11" y1="1" x2="11" y2="17" stroke="currentColor" stroke-width="1.8"/><rect x="4" y="3" width="14" height="4" rx="1" fill="currentColor" opacity=".75"/><rect x="6" y="11" width="10" height="4" rx="1" fill="currentColor" opacity=".75"/></svg>`,
        right:  `<svg viewBox="0 0 22 18" width="20" height="15"><line x1="19" y1="1" x2="19" y2="17" stroke="currentColor" stroke-width="1.8"/><rect x="8" y="3" width="11" height="4" rx="1" fill="currentColor" opacity=".75"/><rect x="3" y="11" width="16" height="4" rx="1" fill="currentColor" opacity=".75"/></svg>`,
        top:    `<svg viewBox="0 0 22 18" width="20" height="15"><line x1="1" y1="2" x2="21" y2="2" stroke="currentColor" stroke-width="1.8"/><rect x="3" y="2" width="4" height="11" rx="1" fill="currentColor" opacity=".75"/><rect x="11" y="2" width="4" height="15" rx="1" fill="currentColor" opacity=".75"/></svg>`,
        centerV:`<svg viewBox="0 0 22 18" width="20" height="15"><line x1="1" y1="9" x2="21" y2="9" stroke="currentColor" stroke-width="1.8"/><rect x="3" y="3" width="4" height="12" rx="1" fill="currentColor" opacity=".75"/><rect x="11" y="1" width="4" height="16" rx="1" fill="currentColor" opacity=".75"/></svg>`,
        bottom: `<svg viewBox="0 0 22 18" width="20" height="15"><line x1="1" y1="16" x2="21" y2="16" stroke="currentColor" stroke-width="1.8"/><rect x="3" y="5" width="4" height="11" rx="1" fill="currentColor" opacity=".75"/><rect x="11" y="1" width="4" height="15" rx="1" fill="currentColor" opacity=".75"/></svg>`,
        distH:  `<svg viewBox="0 0 22 18" width="20" height="15"><rect x="1" y="5" width="4" height="8" rx="1" fill="currentColor" opacity=".75"/><rect x="9" y="6" width="4" height="6" rx="1" fill="currentColor" opacity=".75"/><rect x="17" y="4" width="4" height="10" rx="1" fill="currentColor" opacity=".75"/><line x1="5.5" y1="9" x2="8.5" y2="9" stroke="currentColor" stroke-width="1" stroke-dasharray="2,1.5"/><line x1="13.5" y1="9" x2="16.5" y2="9" stroke="currentColor" stroke-width="1" stroke-dasharray="2,1.5"/></svg>`,
        distV:  `<svg viewBox="0 0 22 18" width="20" height="15"><rect x="4" y="1" width="14" height="3" rx="1" fill="currentColor" opacity=".75"/><rect x="5" y="7" width="12" height="4" rx="1" fill="currentColor" opacity=".75"/><rect x="3" y="14" width="16" height="3" rx="1" fill="currentColor" opacity=".75"/><line x1="11" y1="4.5" x2="11" y2="6.5" stroke="currentColor" stroke-width="1" stroke-dasharray="2,1.5"/><line x1="11" y1="11.5" x2="11" y2="13.5" stroke="currentColor" stroke-width="1" stroke-dasharray="2,1.5"/></svg>`,
      };
      const ab=(d,tip)=>`<button class="prop-btn align-btn" data-align="${d}" title="${tip}" style="display:flex;align-items:center;justify-content:center;padding:6px 4px">${S[d]}</button>`;
      const db=(d,tip,lbl)=>`<button class="prop-btn align-btn" data-dist="${d}" title="${tip}" style="display:flex;align-items:center;justify-content:center;gap:5px;padding:5px 4px;font-size:10px">${S[d]} ${lbl}</button>`;

      let _mTypeProps='';
      if(_mAllType==='element'){
        const _rv=_mCval('rotation',0);const _fv=_mCval('flipH',false);const _pv=_mCval('power',0);
        _mTypeProps=`
        <div class="prop-group"><span class="prop-label">Rotation</span>
          <select class="prop-input" id="pm-rot">
            ${_rv===null?'<option value="" selected disabled>— Mixte —</option>':''}
            <option value="0" ${_rv===0?'selected':''}>0°</option>
            <option value="90" ${_rv===90?'selected':''}>90°</option>
            <option value="180" ${_rv===180?'selected':''}>180°</option>
            <option value="270" ${_rv===270?'selected':''}>270°</option>
          </select>
        </div>
        <div class="prop-group"><label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:11px;color:var(--text2)">
          <input type="checkbox" id="pm-fliph" ${_fv===true?'checked':''} ${_fv===null?'style="opacity:.5"':''}> Miroir horizontal</label>
        </div>
        <div class="prop-group"><span class="prop-label">Puissance (W)</span>
          <input class="prop-input" type="number" id="pm-power" value="${_pv!==null?_pv:''}" min="0" placeholder="${_pv===null?'Mixte':'0'}">
        </div>`;
      }else if(_mAllType==='wire'){
        const _wv=_mCval('width',1.8);const _vv=_mCval('voltage','');
        _mTypeProps=`
        <div class="prop-group"><span class="prop-label">Épaisseur</span>
          <input class="prop-input" type="number" id="pm-width" value="${_wv!==null?_wv:''}" min="0.5" max="8" step="0.5" placeholder="${_wv===null?'Mixte':''}">
        </div>
        <div class="prop-group"><span class="prop-label">⚡ Tension (source)</span>
          <input class="prop-input" id="pm-voltage" value="${_vv!==null?esc(_vv):''}" placeholder="${_vv===null?'Mixte':'ex: +24V'}">
        </div>`;
      }else if(_mAllType==='text'){
        const _sv=_mCval('size',13);const _av=_mCval('angle',0);
        _mTypeProps=`
        <div class="prop-group"><span class="prop-label">Taille</span>
          <input class="prop-input" type="number" id="pm-size" value="${_sv!==null?_sv:''}" min="8" max="72" placeholder="${_sv===null?'Mixte':''}">
        </div>
        <div class="prop-group"><span class="prop-label">Angle °</span>
          <div style="display:flex;align-items:center;gap:6px">
            <input class="prop-input" type="number" id="pm-angle" value="${_av!==null?_av:''}" min="-180" max="180" step="15" style="flex:1" placeholder="${_av===null?'Mixte':''}">
            <button class="prop-btn" id="pm-rot-ccw" title="−90°" style="padding:3px 7px">↺</button>
            <button class="prop-btn" id="pm-rot-cw" title="+90°" style="padding:3px 7px">↻</button>
          </div>
        </div>`;
      }else if(_mAllType==='shape'){
        const _stv=_mCval('stroke','solid');const _thv=_mCval('thick',1.5);const _fiv=_mCval('fill',false);
        _mTypeProps=`
        <div class="prop-group"><span class="prop-label">Style trait</span>
          <select class="prop-input" id="pm-stroke">
            ${_stv===null?'<option value="" selected disabled>— Mixte —</option>':''}
            <option value="none" ${_stv==='none'?'selected':''}>Aucun</option>
            <option value="solid" ${_stv==='solid'?'selected':''}>─── Continu</option>
            <option value="dash-fine" ${_stv==='dash-fine'?'selected':''}>╌╌╌ Pointillé fin</option>
            <option value="dash-med" ${_stv==='dash-med'?'selected':''}>┄┄┄ Tiret moyen</option>
            <option value="dash-large" ${_stv==='dash-large'?'selected':''}>╍╍╍ Tiret large</option>
            <option value="dot" ${_stv==='dot'?'selected':''}>··· Points</option>
            <option value="axis" ${_stv==='axis'?'selected':''}>─·─ Axe</option>
            <option value="stripe-bw" ${_stv==='stripe-bw'?'selected':''}>▓░ Rayure blanc</option>
            <option value="stripe-col" ${_stv==='stripe-col'?'selected':''}>▓▒ Rayure bicolore</option>
          </select>
        </div>
        <div class="prop-group"><span class="prop-label">Épaisseur</span>
          <input class="prop-input" type="number" id="pm-thick" value="${_thv!==null?_thv:''}" min="0.5" max="12" step="0.5" placeholder="${_thv===null?'Mixte':''}">
        </div>
        <div class="prop-group"><label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:11px;color:var(--text2)">
          <input type="checkbox" id="pm-fill" ${_fiv===true?'checked':''} ${_fiv===null?'style="opacity:.5"':''}> Remplir</label>
        </div>`;
      }else if(_mAllType==='image'){
        const _ov=_mCval('opacity',1);
        _mTypeProps=`
        <div class="prop-group"><span class="prop-label">Opacité</span>
          <div style="display:flex;align-items:center;gap:6px">
            <input type="range" id="pm-opacity" min="0.05" max="1" step="0.05" value="${_ov!==null?_ov:1}" style="flex:1">
            <span id="pm-opacity-val" style="font-size:10px;color:var(--text2);min-width:28px">${_ov!==null?Math.round(_ov*100)+'%':'—'}</span>
          </div>
        </div>`;
      }

      form.innerHTML=`<div style="padding:12px 14px">
        <div style="font-size:12px;color:var(--accent);margin-bottom:10px;text-align:center">⊹ ${n} ${_mAllType?_mTypeLabel[_mAllType]||'objets':'objets'} sélectionné${n>1?'s':''}</div>
        <div class="prop-group"><span class="prop-label">Alignement</span>
          <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:4px;margin-top:5px">
            ${ab('left','Aligner les bords gauches')}${ab('centerH','Centrer sur l\'axe vertical')}${ab('right','Aligner les bords droits')}
            ${ab('top','Aligner les bords hauts')}${ab('centerV','Centrer sur l\'axe horizontal')}${ab('bottom','Aligner les bords bas')}
          </div>
          <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:4px;margin-top:2px">
            <div style="font-size:8px;color:var(--text3);text-align:center">Gauche</div><div style="font-size:8px;color:var(--text3);text-align:center">Centre H</div><div style="font-size:8px;color:var(--text3);text-align:center">Droite</div>
            <div style="font-size:8px;color:var(--text3);text-align:center">Haut</div><div style="font-size:8px;color:var(--text3);text-align:center">Centre V</div><div style="font-size:8px;color:var(--text3);text-align:center">Bas</div>
          </div>
        </div>
        ${n>=3?`<div class="prop-group"><span class="prop-label">Distribution uniforme</span>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:4px;margin-top:5px">
            ${db('distH','Espacer uniformément horizontalement','Espac. H')}${db('distV','Espacer uniformément verticalement','Espac. V')}
          </div>
        </div>`:''}
        <div class="prop-group">
          <span class="prop-label">Couleur</span>
          <div style="display:flex;align-items:center;gap:8px;margin-top:5px">
            <input type="color" id="pa-multi-color" value="${(()=>{const cv=new Set();[...multiSel].forEach(k=>{const[t,id]=k.split(':');const o=getById(t,id);if(o?.color)cv.add(o.color);});return cv.size===1?[...cv][0]:'#3b9eff';})()}" style="width:36px;height:26px;border:1px solid var(--border2);border-radius:4px;background:none;cursor:pointer;padding:1px">
            <span id="pa-multi-color-hint" style="font-size:10px;color:var(--text3)">${(()=>{const cv=new Set();[...multiSel].forEach(k=>{const[t,id]=k.split(':');const o=getById(t,id);if(o?.color)cv.add(o.color);});return cv.size>1?'Couleurs mixtes':'';})()}</span>
          </div>
        </div>
        ${_mTypeProps}
        <div class="prop-group">
          <button class="prop-btn" id="pa-dup-multi" style="width:100%">⊕ Dupliquer</button>
          <button class="prop-btn danger" id="pa-del-multi" style="width:100%;margin-top:4px">✕ Supprimer</button>
        </div>
        <div style="font-size:9px;color:var(--text3);text-align:center;margin-top:4px">Shift+clic pour modifier la sélection</div>
      </div>`;
      form.querySelectorAll('[data-align]').forEach(btn=>btn.addEventListener('click',()=>{alignSelected(btn.dataset.align);updateProps();}));
      form.querySelectorAll('[data-dist]').forEach(btn=>btn.addEventListener('click',()=>{distributeSelected(btn.dataset.dist);updateProps();}));
      document.getElementById('pa-del-multi')?.addEventListener('click',delSelected);
      document.getElementById('pa-dup-multi')?.addEventListener('click',dupSelected);
      document.getElementById('pa-multi-color')?.addEventListener('input',e=>{
        const c=e.target.value;
        [...multiSel].forEach(k=>{const[t,id]=k.split(':');const o=getById(t,id);if(o&&'color'in o)o.color=c;});
        const hint=document.getElementById('pa-multi-color-hint');if(hint)hint.textContent='';
        render();
      });
      document.getElementById('pa-multi-color')?.addEventListener('change',()=>saveHistory('Modifier couleur'));
      if(_mAllType==='element'){
        document.getElementById('pm-rot')?.addEventListener('change',e=>{_mApply('rotation',parseInt(e.target.value));saveHistory('Modifier rotation');});
        document.getElementById('pm-fliph')?.addEventListener('change',e=>{_mApply('flipH',e.target.checked);saveHistory('Modifier miroir');});
        document.getElementById('pm-power')?.addEventListener('input',e=>{_mApply('power',parseInt(e.target.value)||0);});
        document.getElementById('pm-power')?.addEventListener('change',()=>saveHistory('Modifier puissance'));
      }else if(_mAllType==='wire'){
        document.getElementById('pm-width')?.addEventListener('input',e=>{_mApply('width',parseFloat(e.target.value)||1.8);});
        document.getElementById('pm-width')?.addEventListener('change',()=>saveHistory('Modifier épaisseur'));
        document.getElementById('pm-voltage')?.addEventListener('input',e=>{const v=e.target.value.trim();_mSelObjs.forEach(o=>{o.obj.voltage=v;});markVoltageDirty();render();});
        document.getElementById('pm-voltage')?.addEventListener('change',()=>saveHistory('Modifier tension'));
      }else if(_mAllType==='text'){
        document.getElementById('pm-size')?.addEventListener('input',e=>{_mApply('size',parseInt(e.target.value)||13);});
        document.getElementById('pm-size')?.addEventListener('change',()=>saveHistory('Modifier taille'));
        document.getElementById('pm-angle')?.addEventListener('input',e=>{_mApply('angle',parseInt(e.target.value)||0);});
        document.getElementById('pm-angle')?.addEventListener('change',()=>saveHistory('Modifier angle'));
        document.getElementById('pm-rot-ccw')?.addEventListener('click',()=>{_mSelObjs.forEach(o=>{o.obj.angle=((o.obj.angle||0)-90+360)%360;});render();saveHistory('Rotation -90°');updateProps();});
        document.getElementById('pm-rot-cw')?.addEventListener('click',()=>{_mSelObjs.forEach(o=>{o.obj.angle=((o.obj.angle||0)+90)%360;});render();saveHistory('Rotation +90°');updateProps();});
      }else if(_mAllType==='shape'){
        document.getElementById('pm-stroke')?.addEventListener('change',e=>{_mApply('stroke',e.target.value);saveHistory('Modifier style trait');});
        document.getElementById('pm-thick')?.addEventListener('input',e=>{_mApply('thick',parseFloat(e.target.value)||1.5);});
        document.getElementById('pm-thick')?.addEventListener('change',()=>saveHistory('Modifier épaisseur'));
        document.getElementById('pm-fill')?.addEventListener('change',e=>{_mApply('fill',e.target.checked);saveHistory('Modifier remplissage');});
      }else if(_mAllType==='image'){
        const _opEl=document.getElementById('pm-opacity');const _opVal=document.getElementById('pm-opacity-val');
        _opEl?.addEventListener('input',e=>{const v=parseFloat(e.target.value);_mApply('opacity',v);if(_opVal)_opVal.textContent=Math.round(v*100)+'%';});
        _opEl?.addEventListener('change',()=>saveHistory('Modifier opacité'));
      }
      return;
    }

    if(!s){
      if(_ab) _ab.style.display='none';
      empty.style.display='flex';form.style.display='none';titleEl.textContent='Notes & Todo';
      return;
    }
    empty.style.display='none';form.style.display='block';titleEl.textContent='Propriétés';
    let html='';

    if(selected.type==='element'){
      const sym=_symbols[s.symId];
      const canEditSym=currentUser.role==='admin'||(!sym?.builtin&&sym?.created_by===currentUser.id);
      const symFields = sym?.fields||[];
      const elProps = s.props||{};
      const poles = s.poles||[];
      const isMP = ['contact','breaker','terminal'].includes(sym?.elementRole) && poles.length > 1;

      function _renderFieldInput(f, fid, val) {
        const unit = f.unit ? ` <small style="color:var(--text3)">${esc(f.unit)}</small>` : '';
        if (f.type === 'number') return `<input class="prop-input prop-field" type="number" data-fid="${esc(fid)}" value="${esc(val)}" placeholder="${esc(f.default||'')}">`;
        if (f.type === 'select' && f.options) return `<select class="prop-input prop-field" data-fid="${esc(fid)}">
          <option value="">—</option>
          ${(f.options||'').split(',').map(o=>o.trim()).filter(Boolean).map(o=>`<option value="${esc(o)}"${val===o?' selected':''}>${esc(o)}</option>`).join('')}
        </select>`;
        if (f.type === 'textbox') return `<textarea class="prop-input prop-field" data-fid="${esc(fid)}" style="width:100%;min-height:48px;resize:vertical;font-family:var(--font);font-size:10px" placeholder="${esc(f.default||'')}">${esc(val)}</textarea>`;
        return `<input class="prop-input prop-field" type="text" data-fid="${esc(fid)}" value="${esc(val)}" placeholder="${esc(f.default||'')}">`;
      }

      const fieldsHtml = symFields.length ? `
        <div class="prop-group" style="padding-top:6px;border-top:1px solid var(--border2)">
          <span class="prop-label" style="font-size:10px;font-weight:700;letter-spacing:.5px;color:var(--accent)">⚙ Paramètres</span>
        </div>
        ${symFields.map(f=>{
          const val = elProps[f.id]!==undefined ? elProps[f.id] : (f.default||'');
          const unitHtml = f.unit ? ` <small style="color:var(--text3)">${esc(f.unit)}</small>` : '';
          let html = `<div class="prop-group"><span class="prop-label">${esc(f.name)}${unitHtml}</span>
            ${_renderFieldInput(f, f.id, val)}
          </div>`;
          // Pour les multi-pôles : ajouter un champ par pôle
          if (isMP) {
            html += poles.map((pole, pi) => {
              const poleKey = f.id + ':' + pi;
              const poleVal = elProps[poleKey] !== undefined ? elProps[poleKey] : '';
              return `<div class="prop-group" style="padding-left:12px">
                <span class="prop-label" style="font-size:9px;color:var(--text3)">↳ Pôle ${pi+1} (${pole})</span>
                ${_renderFieldInput(f, poleKey, poleVal)}
              </div>`;
            }).join('');
          }
          return html;
        }).join('')}
      ` : '';
      const _role = _symRole(sym);
      const _isLinked = _role==='contact' && !!s.coilRef;
      const _coilHeader = _role==='coil' ? `
        <div class="prop-group" style="background:rgba(59,158,255,.06);border:1px solid rgba(59,158,255,.2);border-radius:5px;padding:8px 10px;margin-bottom:4px">
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">
            <span>🔵</span><span style="font-size:10px;font-weight:700;color:var(--accent)">BOBINE</span>
          </div>
          <div style="font-size:10px;color:var(--text3)">Propagation automatique aux contacts liés.</div>
        </div>` : _role==='button' ? `
        <div class="prop-group" style="background:rgba(76,175,80,.06);border:1px solid rgba(76,175,80,.2);border-radius:5px;padding:8px 10px;margin-bottom:4px">
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">
            <span>🟢</span><span style="font-size:10px;font-weight:700;color:#4caf50">BOUTON</span>
          </div>
          <div style="font-size:10px;color:var(--text3)">Propagation automatique aux contacts liés.</div>
        </div>` : _role==='breaker' ? `
        <div class="prop-group" style="background:rgba(255,60,60,.06);border:1px solid rgba(255,60,60,.2);border-radius:5px;padding:8px 10px;margin-bottom:4px">
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">
            <span>🔴</span><span style="font-size:10px;font-weight:700;color:#ff3c3c">DISJONCTEUR</span>
          </div>
          <div style="font-size:10px;color:var(--text3)">Propagation automatique aux contacts liés.</div>
        </div>` : _role==='contact' ? `<div class="prop-group" style="background:rgba(245,166,35,.06);border:1px solid rgba(245,166,35,.2);border-radius:5px;padding:8px 10px;margin-bottom:4px">
            <div style="display:flex;align-items:center;gap:6px;margin-bottom:6px">
              <span>🔶</span><span style="font-size:10px;font-weight:700;color:#f5a623">CONTACT</span>
              ${s.coilRef?'<span style="font-size:9px;background:#f5a62322;color:#f5a623;border-radius:3px;padding:1px 6px">✓ Lié</span>':''}
            </div>
            <span class="prop-label" style="font-size:10px">Bobine / Bouton / Disjoncteur associé</span>
            <select class="prop-input" id="pi-coil-ref" style="width:100%;margin-top:3px">
              <option value="">Chargement…</option>
            </select>
            ${s.coilRef?'<div style="font-size:9px;color:#f5a623;opacity:.8;margin-top:4px">⚠ Désignation pilotée par la bobine/bouton/disjoncteur.</div>':''}
          </div>` : '';

      html=`${_coilHeader}<div class="prop-group"><span class="prop-label">Symbole</span><div style="font-size:11px;color:var(--text2)">${sym?.name||s.symId}</div></div>
      <div class="prop-group"><span class="prop-label">Désignation <small style="color:var(--text3)">(glisser sur canvas)</small></span><input class="prop-input" id="pi-label" value="${esc(s.label||'')}" ${_isLinked?'readonly style="opacity:.55;cursor:not-allowed" title="Pilotée par le driver associé"':''}></div>
      <div class="prop-group"><span class="prop-label" style="font-size:9px">Offset label X/Y&nbsp;&nbsp;Angle °</span><div style="display:flex;gap:4px">
        <input class="prop-input" type="number" id="pi-lox" value="${s.labelOffX||0}" style="flex:1" title="Décalage X">
        <input class="prop-input" type="number" id="pi-loy" value="${s.labelOffY||-18}" style="flex:1" title="Décalage Y">
        <input class="prop-input" type="number" id="pi-lang" value="${s.labelAngle||0}" style="flex:1;max-width:52px" title="Angle °" min="-180" max="180">
      </div></div>
      <div class="prop-group"><span class="prop-label">Référence <small style="color:var(--text3)">(glisser sur canvas)</small></span><input class="prop-input" id="pi-ref" value="${esc(s.ref||'')}"></div>
      <div class="prop-group"><span class="prop-label" style="font-size:9px">Offset ref. X/Y&nbsp;&nbsp;Angle °</span><div style="display:flex;gap:4px">
        <input class="prop-input" type="number" id="pi-rox" value="${s.refOffX||0}" style="flex:1" title="Décalage X">
        <input class="prop-input" type="number" id="pi-roy" value="${s.refOffY||10}" style="flex:1" title="Décalage Y">
        <input class="prop-input" type="number" id="pi-rang" value="${s.refAngle||0}" style="flex:1;max-width:52px" title="Angle °" min="-180" max="180">
      </div></div>
      ${(_role === 'contact' || _role === 'breaker' || _role === 'terminal') ? `
      <div class="prop-group" style="border-top:1px solid var(--border);padding-top:8px;margin-top:4px">
        ${_role === 'contact' ? '<span class="prop-label" style="color:var(--accent2);font-weight:600">🔶 Type de contact</span>' :
          _role === 'terminal' ? '<span class="prop-label" style="color:var(--accent3);font-weight:600">⊟ Duplication bornes</span>' :
          '<span class="prop-label" style="color:#ff3c3c;font-weight:600">🔴 Configuration disjoncteur</span>'}
        ${_role === 'contact' ? `<div style="display:flex;gap:6px;margin-top:4px">
          <label style="display:flex;align-items:center;gap:4px;font-size:11px;color:var(--text);cursor:pointer">
            <input type="radio" name="pi-contact-type" value="principal" ${s.contactType !== 'additif' ? 'checked' : ''} style="accent-color:var(--accent)">
            Principal
          </label>
          <label style="display:flex;align-items:center;gap:4px;font-size:11px;color:var(--text);cursor:pointer">
            <input type="radio" name="pi-contact-type" value="additif" ${s.contactType === 'additif' ? 'checked' : ''} style="accent-color:var(--accent)">
            Additif
          </label>
        </div>` : ''}
        <div style="margin-top:6px">
          <div style="font-size:9px;color:var(--text3);margin-bottom:3px">${_role === 'contact' ? 'Configuration des pôles (cliquer pour changer NO↔NF)' : _role === 'terminal' ? 'Nombre de bornes (duplication horizontale)' : 'Nombre de pôles'}</div>
          <div id="pi-poles-list" style="display:flex;flex-wrap:wrap;gap:3px;margin-bottom:4px">
          </div>
          <div style="display:flex;gap:4px">
            ${_role === 'contact' ? `
            <button id="pi-poles-add-no" class="btn-secondary" style="flex:1;font-size:9px;padding:3px 6px">+ NO</button>
            <button id="pi-poles-add-nf" class="btn-secondary" style="flex:1;font-size:9px;padding:3px 6px">+ NF</button>` :
            _role === 'terminal' ? `
            <button id="pi-poles-add-no" class="btn-secondary" style="flex:1;font-size:9px;padding:3px 6px">+ Borne</button>` : `
            <button id="pi-poles-add-no" class="btn-secondary" style="flex:1;font-size:9px;padding:3px 6px">+ Pôle</button>`}
            <button id="pi-poles-remove" class="btn-secondary" style="font-size:9px;padding:3px 6px;color:var(--accent2)">−</button>
          </div>
        </div>
      </div>` : ''}
      ${sym?.elementRole === 'terminal' ? `<div class="prop-group" style="border-top:1px solid var(--border);padding-top:8px;margin-top:4px">
        <span class="prop-label" style="color:var(--accent3);font-weight:600">⊡ Bornier</span>
        <div style="display:flex;gap:4px;margin-top:4px">
          <div style="flex:2">
            <div style="font-size:9px;color:var(--text3);margin-bottom:2px">Nom de bornier</div>
            <input class="prop-input" id="pi-bornier-name" placeholder="X1" value="${esc(s.bornierName||'')}">
          </div>
          <div style="flex:1">
            <div style="font-size:9px;color:var(--text3);margin-bottom:2px">Étage</div>
            <input class="prop-input" id="pi-bornier-etage" placeholder="1" value="${esc(s.bornierEtage||'')}">
          </div>
          <div style="flex:1">
            <div style="font-size:9px;color:var(--text3);margin-bottom:2px">N°</div>
            <input class="prop-input" id="pi-bornier-num" placeholder="1" value="${esc(s.bornierNum||'')}">
          </div>
        </div>
        <div style="display:flex;gap:4px;margin-top:6px">
          <div style="flex:1">
            <div style="font-size:9px;color:var(--text3);margin-bottom:2px">Pas (mm)</div>
            <input class="prop-input" id="pi-bornier-pitch" type="number" step="0.1" min="0" placeholder="5" value="${s.bornierPitch||''}">
          </div>
          <div style="flex:2">
            <div style="font-size:9px;color:var(--text3);margin-bottom:2px">Type</div>
            <select class="prop-input" id="pi-bornier-type" style="width:100%;background:var(--panel2);border:1px solid var(--border);color:var(--text);padding:3px 6px;border-radius:3px;font-family:var(--font);font-size:11px">
              <option value=""${!s.bornierType?' selected':''}>—</option>
              <option value="alim"${s.bornierType==='alim'?' selected':''}>Alimentation</option>
              <option value="conso"${s.bornierType==='conso'?' selected':''}>Consommateur</option>
              <option value="capteur"${s.bornierType==='capteur'?' selected':''}>Capteur</option>
              <option value="ctrl"${s.bornierType==='ctrl'?' selected':''}>Contrôle-Commande</option>
            </select>
          </div>
        </div>
      </div>` : ''}
      ${sym?.isConsumer ? `
      <div class="prop-group" style="border-top:1px solid var(--border);padding-top:8px;margin-top:4px">
        <span class="prop-label" style="color:#ffb340;font-weight:600">⚡ Consommateur</span>
        <div style="display:flex;align-items:center;gap:6px;margin-top:4px">
          <div style="font-size:9px;color:var(--text3)">Puissance (W)</div>
          <input class="prop-input" type="number" id="pi-power" value="${s.power||sym.defaultPower||0}" min="0" step="1" style="flex:1">
        </div>
      </div>` : ''}
      ${(symFields.length || (sym?.pins?.some(p=>['power-in','power-out','ctrl'].includes(p.type||'default')))) ? `
      <div class="prop-group" style="padding:0">
        <button id="pa-toggle-extra" style="width:100%;background:rgba(59,158,255,.07);border:1px solid rgba(59,158,255,.2);color:var(--accent);font-size:9px;font-family:var(--font);padding:4px 8px;border-radius:4px;cursor:pointer;text-align:left;display:flex;align-items:center;gap:5px">
          <span id="pa-toggle-extra-arrow" style="font-size:8px;transition:transform .15s">▶</span>
          <span id="pa-toggle-extra-label">Afficher les propriétés supplémentaires${symFields.length?' ('+symFields.length+' champ'+(symFields.length>1?'s':'')+')':''}</span>
        </button>
      </div>
      <div id="pa-extra-section" style="display:none">
      ${fieldsHtml}
      ` : ''}
      ${(()=>{
        // Panneau tensions : afficher uniquement les types de pin présents dans le symbole
        if(!sym?.pins?.length) return '';
        const hasPwrIn  = sym.pins.some(p=>(p.type||'default')==='power-in');
        const hasPwrOut = sym.pins.some(p=>(p.type||'default')==='power-out');
        const hasCtrl   = sym.pins.some(p=>(p.type||'default')==='ctrl');
        if(!hasPwrIn && !hasPwrOut && !hasCtrl) return '';
        const v = s.voltages||{};
        const vRow = (id,label,color,key) => `
          <div class="prop-group" style="margin:0">
            <span class="prop-label" style="font-size:9px;color:${color}">${label}</span>
            <div style="display:flex;align-items:center;gap:4px">
              <input class="prop-input pv-volt" id="${id}" data-vkey="${key}"
                value="${esc(v[key]||'')}" placeholder="ex: 230V"
                style="flex:1;border-left:2px solid ${color}">
              ${_voltageMap && Object.values(_voltageMap).length ?
                `<span style="font-size:9px;color:var(--text3);white-space:nowrap" title="Tension propagée sur les fils connectés">
                  ${(()=>{
                    // Trouver la tension propagée depuis ce pin
                    const sym2=_symbols[s.symId]; if(!sym2) return '';
                    const pins2=sym2.pins||[];
                    for(const pin of pins2){
                      if((pin.type||'default')!==({'pwr_in':'power-in','pwr_out':'power-out','ctrl':'ctrl'}[key]||'')) continue;
                      const [px,py]=Renderer.getPinWorld(s,sym2,pin);
                      const TOL=10;
                      for(const w of state.wires){
                        const pts=w.points;
                        if(pts.some(p=>Math.hypot(p.x-px,p.y-py)<TOL)){
                          const wv=_voltageMap[w.id];
                          if(wv) return `→ ${esc(wv)}`;
                        }
                      }
                    }
                    return '';
                  })()}
                </span>` : ''}
            </div>
          </div>`;
        return `
          <div class="prop-group" style="padding-top:6px;border-top:1px solid var(--border2)">
            <span class="prop-label" style="font-size:10px;font-weight:700;letter-spacing:.5px;color:#e8b84b">⚡ Tensions</span>
          </div>
          ${hasPwrIn  ? vRow('pv-pwr-in', '▼ Puissance entrée','#3b9eff','pwr_in')  : ''}
          ${hasPwrOut ? vRow('pv-pwr-out','▲ Puissance sortie','#ff9628','pwr_out') : ''}
          ${hasCtrl   ? vRow('pv-ctrl',   '◆ Commande / Signal','#4dd278','ctrl')   : ''}
          <details style="margin-top:4px">
            <summary style="font-size:9px;color:var(--text3);cursor:pointer;user-select:none">Détail par borne (phase/neutre)</summary>
            <div style="display:flex;flex-direction:column;gap:2px;margin-top:4px">
              ${(()=>{
                const _poles = s.poles || [];
                const _isMP = ['contact','breaker','terminal'].includes(sym?.elementRole) && _poles.length > 1;
                if (_isMP) {
                  // Multi-pôle : un champ par pin par pôle
                  return _poles.map((pole, pi) => {
                    return `<div style="font-size:8px;font-weight:600;color:var(--text3);margin-top:${pi?4:0}px">Pôle ${pi+1} (${pole})</div>`
                      + (sym.pins||[]).map(pin => {
                        const pinKey = 'pin:' + pin.name + ':' + pi;
                        const pinFallback = v['pin:' + pin.name] || '';
                        const pinVal = v[pinKey] || '';
                        const typeCol = {'power-in':'#3b9eff','power-out':'#ff9628','ctrl':'#4dd278'}[pin.type||'default'] || '#6b7494';
                        return `<div class="prop-group" style="margin:0;padding-left:8px">
                          <span class="prop-label" style="font-size:8px;color:${typeCol}">${esc(pin.name)}</span>
                          <input class="prop-input pv-volt" data-vkey="${esc(pinKey)}"
                            value="${esc(pinVal)}" placeholder="${pinFallback || 'ex: 230V'}"
                            style="flex:1;font-size:10px;border-left:2px solid ${typeCol}">
                        </div>`;
                      }).join('');
                  }).join('');
                } else {
                  // Mono-pôle : un champ par pin
                  return (sym.pins||[]).map(pin => {
                    const pinKey = 'pin:' + pin.name;
                    const pinVal = v[pinKey] || '';
                    const typeCol = {'power-in':'#3b9eff','power-out':'#ff9628','ctrl':'#4dd278'}[pin.type||'default'] || '#6b7494';
                    return `<div class="prop-group" style="margin:0">
                      <span class="prop-label" style="font-size:8px;color:${typeCol}">${esc(pin.name)}</span>
                      <input class="prop-input pv-volt" data-vkey="${esc(pinKey)}"
                        value="${esc(pinVal)}" placeholder="ex: 230V"
                        style="flex:1;font-size:10px;border-left:2px solid ${typeCol}">
                    </div>`;
                  }).join('');
                }
              })()}
            </div>
            <div style="font-size:8px;color:var(--text3);margin-top:4px;line-height:1.5">
              💡 Renseigner ici pour distinguer phase/neutre par pôle.<br>
              Ex: L=400V sur pôle 1, N=230V sur pôle 4.
            </div>
          </details>`;
      })()}
      </div><!-- /pa-extra-section -->
      <div class="prop-group"><span class="prop-label">Couleur</span><input class="prop-color" type="color" id="pi-color" value="${s.color||'#3b9eff'}"></div>
      <div class="prop-group"><span class="prop-label">Rotation</span><select class="prop-select" id="pi-rot">${[0,90,180,270].map(v=>`<option value="${v}"${s.rotation===v?' selected':''}>${v}°</option>`).join('')}</select></div>
      <div class="prop-group">
        <span class="prop-label">Taille <small style="color:var(--text3)">(px)</small></span>
        <div style="display:flex;align-items:center;gap:5px;margin-top:4px">
          <span style="font-size:9px;color:var(--text3)">L</span>
          <input class="prop-input" type="number" id="pe-sym-w" value="${Math.round(s.w)}" min="10" max="2000" style="width:64px" title="Largeur">
          <span style="font-size:9px;color:var(--text3)">H</span>
          <input class="prop-input" type="number" id="pe-sym-h" value="${Math.round(s.h)}" min="10" max="2000" style="width:64px" title="Hauteur">
          <label style="display:flex;align-items:center;gap:3px;cursor:pointer;font-size:9px;color:var(--text3)" title="Conserver les proportions">
            <input type="checkbox" id="pe-sym-lock" ${s._lockAspect===true?'checked':''}> ⛓
          </label>
        </div>
        <button class="prop-btn" id="pe-sym-reset" style="width:100%;margin-top:4px;font-size:10px" title="Revenir à la taille d'origine du symbole">↩ Taille originale</button>
      </div>
      <div class="prop-group"><span class="prop-label">Actions</span>
        <button class="prop-btn" id="pa-rot">↻ Pivoter 90°</button>
        <button class="prop-btn" id="pa-flip">↔ Miroir H</button>
        <button class="prop-btn" id="pa-dup">⊕ Dupliquer</button>
        ${canEditSym?`<button class="prop-btn" id="pa-edit-sym">✏ Éditer symbole</button>`:''}
        <button class="prop-btn danger" id="pa-del">✕ Supprimer</button>
      </div>`;
    }else if(selected.type==='wire'){
      html=`<div class="prop-group"><span class="prop-label">Type</span><div style="font-size:11px;color:var(--text2)">${s.isBus?'Bus':'Fil simple'}</div></div>
      ${(()=>{
        const wv = _voltageMap[s.id];
        const isConflict = _conflictWires.has(s.id);
        if(!wv && !isConflict) return '';
        const col = isConflict ? '#ff4444' : '#e8b84b';
        const icon = isConflict ? '⚠' : '⚡';
        const label = isConflict ? 'CONFLIT TENSION' : 'Tension propagée';
        return `<div class="prop-group"><span class="prop-label" style="color:${col}">${icon} ${label}</span>
          <div style="font-size:12px;font-weight:700;color:${col};padding:3px 6px;background:${col}1a;border-radius:4px;border-left:3px solid ${col}">${wv||'?'}</div></div>`;
      })()}
      <div class="prop-group"><span class="prop-label">N° de fil <small style="color:var(--text3)">(glisser sur canvas)</small></span><input class="prop-input" id="pw-num" value="${esc(s.num||'')}" placeholder="ex: 1.01"></div>
      <div class="prop-group"><span class="prop-label">⚡ Tension (source)</span><input class="prop-input" id="pw-voltage" value="${esc(s.voltage||'')}" placeholder="ex: +24V, 230VAC…"></div>
      <div class="prop-group"><span class="prop-label" style="font-size:9px">Offset N° X/Y&nbsp;&nbsp;Angle °</span><div style="display:flex;gap:4px">
        <input class="prop-input" type="number" id="pw-nox" value="${s.numOffX||0}" style="flex:1" title="Décalage X">
        <input class="prop-input" type="number" id="pw-noy" value="${s.numOffY||-10}" style="flex:1" title="Décalage Y">
        <input class="prop-input" type="number" id="pw-nang" value="${s.numAngle!==undefined?s.numAngle:''}" style="flex:1;max-width:52px" title="Angle manuel ° (vide = auto)" placeholder="auto" min="-180" max="180">
      </div></div>
      <div class="prop-group"><span class="prop-label">Couleur</span><input class="prop-color" type="color" id="pw-color" value="${s.color||'#3b9eff'}"></div>
      <div class="prop-group"><span class="prop-label">Épaisseur</span><input class="prop-input" type="number" id="pw-w" value="${s.width||1.8}" min="0.5" max="8" step="0.5"></div>
      <div class="prop-group"><span class="prop-label">↩ Renvoi folio (début)</span>
        <input class="prop-input" id="pw-xref-start" value="${esc(s.xrefStart||'')}" placeholder="ex: /10 ou →F10"></div>
      <div class="prop-group"><span class="prop-label">↪ Renvoi folio (fin)</span>
        <input class="prop-input" id="pw-xref-end" value="${esc(s.xrefEnd||'')}" placeholder="ex: /10 ou →F10"></div>
      <div class="prop-group">
        <button class="prop-btn" id="pa-wirenums">⌗ Numérotation fils</button>
        <button class="prop-btn" id="pa-wire-to-shape" title="Convertir en trait (forme dessin)">⇄ → Trait</button>
        <button class="prop-btn danger" id="pa-del">✕ Supprimer</button>
      </div>`;
    }else if(selected.type==='image'){
      titleEl.textContent='Image';
      html=`
      <div style="text-align:center;padding:8px 0;border-bottom:1px solid var(--border);margin-bottom:8px">
        <img src="${s.src}" style="max-width:100%;max-height:80px;border-radius:3px;border:1px solid var(--border2);object-fit:contain">
      </div>
      <div class="prop-group"><span class="prop-label">Largeur px</span>
        <div style="display:flex;align-items:center;gap:6px">
          <input class="prop-input" type="number" id="pi-w" value="${Math.round(s.w)}" min="10" max="4000" style="width:80px">
          <label style="display:flex;align-items:center;gap:4px;font-size:9px;color:var(--text3);cursor:pointer">
            <input type="checkbox" id="pi-lock" ${s._lockAspect!==false?'checked':''}> Prop.
          </label>
        </div>
      </div>
      <div class="prop-group"><span class="prop-label">Hauteur px</span>
        <input class="prop-input" type="number" id="pi-h" value="${Math.round(s.h)}" min="10" max="4000" style="width:80px">
      </div>
      <div class="prop-group"><span class="prop-label">Opacité</span>
        <div style="display:flex;align-items:center;gap:6px">
          <input type="range" id="pi-opacity" min="0.05" max="1" step="0.05" value="${s.opacity??1}" style="flex:1">
          <span id="pi-opacity-val" style="font-size:10px;color:var(--text2);min-width:28px">${Math.round((s.opacity??1)*100)}%</span>
        </div>
      </div>
      <div class="prop-group">
        <button class="prop-btn" id="pi-replace" style="width:100%">↩ Remplacer l'image</button>
      </div>
      <div class="prop-group"><button class="prop-btn danger" id="pa-del">✕ Supprimer</button></div>`;
    }else if(selected.type==='text'){
      html=`<div class="prop-group"><span class="prop-label">Texte</span>${s.w&&s.h?`<textarea class="prop-input" id="pt-text" style="width:100%;min-height:50px;resize:vertical;font-family:var(--font);font-size:10px">${esc(s.text||'')}</textarea>`:`<input class="prop-input" id="pt-text" value="${esc(s.text||'')}">`}</div>
      <div class="prop-group"><span class="prop-label">Taille</span><input class="prop-input" type="number" id="pt-size" value="${s.size||13}" min="8" max="72"></div>
      <div class="prop-group"><span class="prop-label">Angle °</span>
        <div style="display:flex;align-items:center;gap:6px">
          <input class="prop-input" type="number" id="pt-angle" value="${s.angle||0}" min="-180" max="180" step="15" style="width:70px">
          <button class="prop-btn" id="pt-rot-ccw" title="−90°" style="padding:3px 7px">↺</button>
          <button class="prop-btn" id="pt-rot-cw"  title="+90°" style="padding:3px 7px">↻</button>
        </div>
      </div>
      <div class="prop-group"><span class="prop-label">Couleur</span><input class="prop-color" type="color" id="pt-color" value="${s.color||'#dde1ed'}"></div>
      <div class="prop-group"><span class="prop-label">Zone de texte</span>
        <div style="display:flex;align-items:center;gap:6px">
          <label style="font-size:10px;color:var(--text2)">L</label><input class="prop-input" type="number" id="pt-zone-w" value="${s.w||0}" min="0" style="width:55px">
          <label style="font-size:10px;color:var(--text2)">H</label><input class="prop-input" type="number" id="pt-zone-h" value="${s.h||0}" min="0" style="width:55px">
        </div>
      </div>
      <div class="prop-group"><button class="prop-btn danger" id="pa-del">✕ Supprimer</button></div>`;
    }else if(selected.type==='shape' && (s.id?.match(/^__impl_rail_(?:\d+_)?\d+$/) || s.id?.match(/^__impl_goul_(?:\d+_)?\d+$/))){
      html = _renderImplantShapeProps(s);
    }else if(selected.type==='shape'){
      const strokeStyle = s.stroke||'solid';
      const isStripe = strokeStyle==='stripe-bw'||strokeStyle==='stripe-col';
      // Geometry fields per shape type
      let _geoHtml = '';
      if (s.t==='rect'||s.t==='textbox') {
        _geoHtml = `<div class="prop-group"><span class="prop-label">Géométrie</span>
          <div style="display:grid;grid-template-columns:auto 1fr auto 1fr;gap:4px 6px;align-items:center">
            <label style="font-size:10px;color:var(--text2)">X</label><input class="prop-input" type="number" id="psh-geo-x" value="${Math.round(s.x||0)}" step="1" style="width:100%">
            <label style="font-size:10px;color:var(--text2)">Y</label><input class="prop-input" type="number" id="psh-geo-y" value="${Math.round(s.y||0)}" step="1" style="width:100%">
            <label style="font-size:10px;color:var(--text2)">L</label><input class="prop-input" type="number" id="psh-geo-w" value="${Math.round(s.w||0)}" min="1" step="1" style="width:100%">
            <label style="font-size:10px;color:var(--text2)">H</label><input class="prop-input" type="number" id="psh-geo-h" value="${Math.round(s.h||0)}" min="1" step="1" style="width:100%">
          </div></div>`;
      } else if (s.t==='circle') {
        _geoHtml = `<div class="prop-group"><span class="prop-label">Géométrie</span>
          <div style="display:grid;grid-template-columns:auto 1fr auto 1fr;gap:4px 6px;align-items:center">
            <label style="font-size:10px;color:var(--text2)">CX</label><input class="prop-input" type="number" id="psh-geo-cx" value="${Math.round(s.cx||0)}" step="1" style="width:100%">
            <label style="font-size:10px;color:var(--text2)">CY</label><input class="prop-input" type="number" id="psh-geo-cy" value="${Math.round(s.cy||0)}" step="1" style="width:100%">
            <label style="font-size:10px;color:var(--text2)">R</label><input class="prop-input" type="number" id="psh-geo-r" value="${Math.round(s.r||0)}" min="1" step="1" style="width:100%">
            <span></span>
          </div></div>`;
      } else if (s.t==='arc') {
        _geoHtml = `<div class="prop-group"><span class="prop-label">Géométrie</span>
          <div style="display:grid;grid-template-columns:auto 1fr auto 1fr;gap:4px 6px;align-items:center">
            <label style="font-size:10px;color:var(--text2)">CX</label><input class="prop-input" type="number" id="psh-geo-cx" value="${Math.round(s.cx||0)}" step="1" style="width:100%">
            <label style="font-size:10px;color:var(--text2)">CY</label><input class="prop-input" type="number" id="psh-geo-cy" value="${Math.round(s.cy||0)}" step="1" style="width:100%">
            <label style="font-size:10px;color:var(--text2)">R</label><input class="prop-input" type="number" id="psh-geo-r" value="${Math.round(s.r||0)}" min="1" step="1" style="width:100%">
            <span></span>
            <label style="font-size:10px;color:var(--text2)">A1°</label><input class="prop-input" type="number" id="psh-geo-a1" value="${Math.round((s.a1||0)*180/Math.PI)}" step="5" style="width:100%">
            <label style="font-size:10px;color:var(--text2)">A2°</label><input class="prop-input" type="number" id="psh-geo-a2" value="${Math.round((s.a2||0)*180/Math.PI)}" step="5" style="width:100%">
          </div></div>`;
      } else if (s.t==='line'||s.t==='poly') {
        const _pts = s.pts||[];
        _geoHtml = `<div class="prop-group"><span class="prop-label">Points (${_pts.length})</span>
          <div style="display:flex;flex-direction:column;gap:3px;max-height:150px;overflow-y:auto">
          ${_pts.map((p,i)=>`<div style="display:flex;align-items:center;gap:4px">
            <span style="font-size:9px;color:var(--text3);min-width:18px">P${i+1}</span>
            <label style="font-size:10px;color:var(--text2)">X</label><input class="prop-input psh-pt-x" type="number" data-pi="${i}" value="${Math.round(p.x)}" step="1" style="width:55px">
            <label style="font-size:10px;color:var(--text2)">Y</label><input class="prop-input psh-pt-y" type="number" data-pi="${i}" value="${Math.round(p.y)}" step="1" style="width:55px">
          </div>`).join('')}
          </div></div>`;
      }
      html=`<div class="prop-group"><span class="prop-label">Type</span><div style="font-size:11px;color:var(--text2)">${{line:'Ligne',poly:'Polygone',rect:'Rectangle',circle:'Cercle',arc:'Arc',group:'Groupe',textbox:'Zone de texte'}[s.t]||s.t}</div></div>
      ${_geoHtml}
      <div class="prop-group"><span class="prop-label">Style trait</span>
        <select class="prop-input" id="psh-stroke" style="width:100%">
          <option value="none"       ${strokeStyle==='none'       ?'selected':''}>Aucun (pas de bordure)</option>
          <option value="solid"      ${strokeStyle==='solid'      ?'selected':''}>─── Continu</option>
          <option value="dash-fine"  ${strokeStyle==='dash-fine'  ?'selected':''}>╌╌╌ Pointillé fin</option>
          <option value="dash-med"   ${strokeStyle==='dash-med'   ?'selected':''}>┄┄┄ Tiret moyen</option>
          <option value="dash-large" ${strokeStyle==='dash-large' ?'selected':''}>╍╍╍ Tiret large</option>
          <option value="dot"        ${strokeStyle==='dot'        ?'selected':''}>··· Points</option>
          <option value="axis"       ${strokeStyle==='axis'       ?'selected':''}>─·─ Axe (trait-point)</option>
          <option value="stripe-bw"  ${strokeStyle==='stripe-bw'  ?'selected':''}>▓░ Rayure blanc</option>
          <option value="stripe-col" ${strokeStyle==='stripe-col' ?'selected':''}>▓▒ Rayure bicolore</option>
        </select>
      </div>
      <div class="prop-group"><span class="prop-label">Couleur</span><input class="prop-color" type="color" id="psh-color" value="${s.color||'#3b9eff'}"></div>
      <div class="prop-group" id="psh-color2-row" style="${isStripe&&strokeStyle==='stripe-col'?'':'display:none'}"><span class="prop-label">Couleur 2</span><input class="prop-color" type="color" id="psh-color2" value="${s.color2||'#ff4444'}"></div>
      <div class="prop-group"><span class="prop-label">Épaisseur</span><input class="prop-input" type="number" id="psh-thick" value="${s.thick||1.5}" min="0.5" max="12" step="0.5"></div>
      <div class="prop-group"><label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:11px;color:var(--text2)"><input type="checkbox" id="psh-fill" ${s.fill?'checked':''}> Remplir</label></div>
      ${(s.t==='line'||s.t==='poly')?`<div class="prop-group"><button class="prop-btn" id="pa-shape-to-wire" title="Convertir en fil électrique">⇄ → Fil</button></div>`:''}
      ${s.t==='textbox'?`
      <div class="prop-group"><span class="prop-label">Texte</span>
        <textarea class="prop-input" id="ptb-text" style="width:100%;min-height:60px;resize:vertical;font-family:var(--font);font-size:10px" placeholder="Texte multiligne…">${(s.text||'').replace(/</g,'&lt;')}</textarea>
      </div>
      <div class="prop-group"><span class="prop-label">Taille police</span>
        <input class="prop-input" type="number" id="ptb-fontsize" value="${s.fontSize||11}" min="5" max="60">
      </div>
      <div class="prop-group"><span class="prop-label">Couleur texte</span>
        <input class="prop-color" type="color" id="ptb-textcolor" value="${s.textColor||s.color||'#dde1ed'}">
      </div>
      <div class="prop-group"><span class="prop-label">Alignement H</span>
        <select class="prop-input" id="ptb-align">
          <option value="left" ${(s.align||'left')==='left'?'selected':''}>Gauche</option>
          <option value="center" ${s.align==='center'?'selected':''}>Centré</option>
          <option value="right" ${s.align==='right'?'selected':''}>Droite</option>
        </select>
      </div>
      <div class="prop-group"><span class="prop-label">Alignement V</span>
        <select class="prop-input" id="ptb-valign">
          <option value="top" ${(s.valign||'top')==='top'?'selected':''}>Haut</option>
          <option value="middle" ${s.valign==='middle'?'selected':''}>Milieu</option>
          <option value="bottom" ${s.valign==='bottom'?'selected':''}>Bas</option>
        </select>
      </div>
      <div class="prop-group"><span class="prop-label">Marge</span>
        <input class="prop-input" type="number" id="ptb-padding" value="${s.padding||4}" min="0" max="20">
      </div>
      <div class="prop-group"><span class="prop-label">Angle °</span>
        <div style="display:flex;align-items:center;gap:6px">
          <input class="prop-input" type="number" id="ptb-angle" value="${s.angle||0}" min="-180" max="180" step="15" style="width:70px">
          <button class="prop-btn" id="ptb-rot-ccw" title="−90°" style="padding:3px 7px">↺</button>
          <button class="prop-btn" id="ptb-rot-cw"  title="+90°" style="padding:3px 7px">↻</button>
        </div>
      </div>
      `:''}
      <div class="prop-group"><button class="prop-btn danger" id="pa-del">✕ Supprimer</button></div>`;
    }

    form.innerHTML=html;
    const bind=(id,fn)=>document.getElementById(id)?.addEventListener('input',fn);
    const on=(id,fn)=>document.getElementById(id)?.addEventListener('click',fn);

    // ── Bindings shape implantation (rail / goulotte) ────────────
    if(selected.type==='shape'){
      const mR=s.id?.match(/^__impl_rail_(?:(\d+)_)?(\d+)$/);
      const mG=s.id?.match(/^__impl_goul_(?:(\d+)_)?(\d+)$/);
      if(mR||mG) _bindImplantShapeProps(s, mR, mG);
    }

    if(selected.type==='element'){
      const sym = _symbols[s.symId];
      // Toggle propriétés supplémentaires
      const _paToggle = document.getElementById('pa-toggle-extra');
      const _paExtra  = document.getElementById('pa-extra-section');
      const _paArrow  = document.getElementById('pa-toggle-extra-arrow');
      const _paLabel  = document.getElementById('pa-toggle-extra-label');
      if(_paToggle && _paExtra){
        _paToggle.addEventListener('click', ()=>{
          const open = _paExtra.style.display === 'none';
          _paExtra.style.display = open ? 'block' : 'none';
          if(_paArrow) _paArrow.style.transform = open ? 'rotate(90deg)' : '';
          if(_paLabel && open) _paLabel.textContent = 'Masquer les propriétés supplémentaires';
          if(_paLabel && !open) _paLabel.textContent = `Afficher les propriétés supplémentaires`;
        });
      }
      // Liaison contact ↔ bobine — remplir le dropdown de manière async
      const _coilRefSelect = document.getElementById('pi-coil-ref');
      if (_coilRefSelect) {
        _getAllDrivers().then(_drivers => {
          if (!document.getElementById('pi-coil-ref')) return;
          const _opts = _drivers.map(c => {
            const icon = c.role === 'coil' ? '🔵' : c.role === 'breaker' ? '🔴' : '🟢';
            const typeLabel = c.role === 'coil' ? 'Bobine' : c.role === 'breaker' ? 'Disjoncteur' : 'Bouton';
            return `<option value="${esc(c.id)}" ${s.coilRef===c.id?'selected':''}>${icon} ${esc(c.label)} — ${typeLabel} (${esc(c.folioLabel)})</option>`;
          }).join('');
          _coilRefSelect.innerHTML = `<option value="">— Aucun (saisie manuelle)</option>${_opts}`;
        });
        _coilRefSelect.addEventListener('change', async e => {
          saveHistory('Modifier référence');
          const coilId = e.target.value;
          if(coilId) {
            s.coilRef = coilId;
            const _drivers = await _getAllDrivers();
            const coil = _drivers.find(c => c.id === coilId);
            if(coil) s.label = coil.label;
          } else {
            delete s.coilRef;
          }
          render(); updateProps();
        });
      }

      // Propagation automatique : quand le label d'une bobine change
      bind('pi-label', e => {
        s.label = e.target.value;
        // Si c'est une bobine ou un bouton → propager aux contacts liés
        if(_symRole(sym) === 'coil' || _symRole(sym) === 'button' || _symRole(sym) === 'breaker') {
          _propagateCoilLabel(s.id, e.target.value);
        }
        render();
      });
      bind('pi-ref',e=>{s.ref=e.target.value;render();});
      bind('pi-color',e=>{s.color=e.target.value;render();});
      bind('pi-lox',e=>{s.labelOffX=parseInt(e.target.value)||0;render();});
      bind('pi-loy',e=>{s.labelOffY=parseInt(e.target.value)||0;render();});
      bind('pi-lang',e=>{s.labelAngle=parseInt(e.target.value)||0;render();});
      bind('pi-rox',e=>{s.refOffX=parseInt(e.target.value)||0;render();});
      bind('pi-roy',e=>{s.refOffY=parseInt(e.target.value)||0;render();});
      bind('pi-rang',e=>{s.refAngle=parseInt(e.target.value)||0;render();});
      function _syncBornierLabel(){
        const parts=[s.bornierName,s.bornierEtage,s.bornierNum].filter(v=>v&&v.trim());
        if(parts.length){s.label=parts.join('-');const el=document.getElementById('pi-label');if(el)el.value=s.label;}
        render();
      }
      bind('pi-bornier-name', e=>{s.bornierName=e.target.value.trim();_syncBornierLabel();});
      bind('pi-bornier-etage',e=>{s.bornierEtage=e.target.value.trim();_syncBornierLabel();});
      bind('pi-bornier-num',  e=>{s.bornierNum=e.target.value.trim();_syncBornierLabel();});
      bind('pi-bornier-pitch',e=>{s.bornierPitch=parseFloat(e.target.value)||0;});
      bind('pi-bornier-type', e=>{s.bornierType=e.target.value;});
      // Type de contact (principal / additif)
      document.querySelectorAll('input[name="pi-contact-type"]').forEach(r => {
        r.addEventListener('change', e => { s.contactType = e.target.value; render(); });
      });
      // Configuration des pôles (liste éditable)
      function _renderPolesList() {
        const container = document.getElementById('pi-poles-list');
        if (!container) return;
        const role = _symRole(sym);
        const isBreaker = role === 'breaker';
        const isTerminal = role === 'terminal';
        const defaultPole = isTerminal ? 'T' : isBreaker ? 'P' : (sym.contactSubType || 'NO');
        if (!s.poles) s.poles = [defaultPole];
        const poles = s.poles;
        container.innerHTML = '';
        poles.forEach((p, i) => {
          const btn = document.createElement('span');
          if (isTerminal) {
            btn.textContent = `B${i+1}`;
            btn.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-width:28px;padding:2px 6px;border-radius:3px;font-size:10px;font-weight:700;user-select:none;border:1px solid;background:rgba(77,255,145,.12);color:var(--accent3);border-color:rgba(77,255,145,.3)';
          } else if (isBreaker) {
            btn.textContent = `P${i+1}`;
            btn.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-width:28px;padding:2px 6px;border-radius:3px;font-size:10px;font-weight:700;user-select:none;border:1px solid;background:rgba(255,60,60,.12);color:#ff3c3c;border-color:rgba(255,60,60,.3)';
          } else {
            btn.textContent = p;
            btn.style.cssText = `display:inline-flex;align-items:center;justify-content:center;min-width:28px;padding:2px 6px;border-radius:3px;font-size:10px;font-weight:700;cursor:pointer;user-select:none;border:1px solid;${
              p === 'NO' ? 'background:rgba(59,158,255,.12);color:#3b9eff;border-color:rgba(59,158,255,.3)' :
                           'background:rgba(255,99,64,.12);color:#ff6340;border-color:rgba(255,99,64,.3)'}`;
            btn.title = 'Cliquer pour basculer NO↔NF';
            btn.addEventListener('click', () => {
              poles[i] = poles[i] === 'NO' ? 'NF' : 'NO';
              s.poles = [...poles];
              _applyPoles(s, sym);
              _renderPolesList();
              render();
            });
          }
          container.appendChild(btn);
        });
      }
      _renderPolesList();
      document.getElementById('pi-poles-add-no')?.addEventListener('click', (e) => {
        e.stopPropagation(); e.preventDefault();
        const role = _symRole(sym);
        const isBreaker = role === 'breaker';
        const isTerminal = role === 'terminal';
        const defaultPole = isTerminal ? 'T' : isBreaker ? 'P' : (sym.contactSubType || 'NO');
        if (!s.poles) s.poles = [defaultPole];
        s.poles.push(defaultPole);
        _applyPoles(s, sym);
        saveHistory(isTerminal ? 'Ajouter borne' : isBreaker ? 'Ajouter pôle' : 'Ajouter pôle NO');
        _renderPolesList(); render();
      });
      document.getElementById('pi-poles-add-nf')?.addEventListener('click', (e) => {
        e.stopPropagation(); e.preventDefault();
        if (!s.poles) s.poles = [sym.contactSubType || 'NO'];
        s.poles.push('NF');
        _applyPoles(s, sym);
        saveHistory('Ajouter pôle NF');
        _renderPolesList(); render();
      });
      document.getElementById('pi-poles-remove')?.addEventListener('click', (e) => {
        e.stopPropagation(); e.preventDefault();
        if (!s.poles || s.poles.length <= 1) return;
        s.poles.pop();
        _applyPoles(s, sym);
        saveHistory('Retirer pôle');
        _renderPolesList(); render();
      });
      // Puissance consommateur
      bind('pi-power',e=>{s.power=parseInt(e.target.value)||0;render();});
      document.getElementById('pi-rot')?.addEventListener('change',e=>{s.rotation=parseInt(e.target.value);render();});
      // Taille W/H
      const symOrig = _symbols[s.symId];
      document.getElementById('pe-sym-w')?.addEventListener('change',e=>{
        const nw=Math.max(10,parseInt(e.target.value)||10);
        if(document.getElementById('pe-sym-lock')?.checked && s.w>0) s.h=Math.max(10,Math.round(nw*s.h/s.w));
        s.w=nw; saveHistory('Redimensionner'); render(); updateProps();
      });
      document.getElementById('pe-sym-h')?.addEventListener('change',e=>{
        const nh=Math.max(10,parseInt(e.target.value)||10);
        if(document.getElementById('pe-sym-lock')?.checked && s.h>0) s.w=Math.max(10,Math.round(nh*s.w/s.h));
        s.h=nh; saveHistory('Redimensionner'); render(); updateProps();
      });
      document.getElementById('pe-sym-lock')?.addEventListener('change',e=>{s._lockAspect=e.target.checked;});
      on('pe-sym-reset',()=>{
        if(symOrig){saveHistory('Réinitialiser taille');s.w=symOrig.width;s.h=symOrig.height;render();updateProps();}
      });
      // Champs personnalisés
      document.querySelectorAll('.prop-field').forEach(inp=>{
        const handler=e=>{if(!s.props)s.props={};s.props[e.target.dataset.fid]=e.target.value;};
        inp.addEventListener('change',handler);
        inp.addEventListener('input',handler);
      });
      // Champs de tension
      document.querySelectorAll('.pv-volt').forEach(inp=>{
        const handler=e=>{
          if(!s.voltages)s.voltages={};
          const v=e.target.value.trim().toUpperCase().replace(/\s+/g,'');
          if(v) s.voltages[e.target.dataset.vkey]=v;
          else delete s.voltages[e.target.dataset.vkey];
          markVoltageDirty(); render();
        };
        inp.addEventListener('change',handler);
        inp.addEventListener('input',handler);
      });
      on('pa-rot',()=>{rotateSelected();updateProps();});
      on('pa-flip',flipSelected);
      on('pa-dup',dupSelected);
      on('pa-edit-sym',()=>{const sym=_symbols[s.symId];if(sym)SymbolEditor.open(sym,async()=>{await reloadSymbols(true);buildLibrary();render();},_symbols);});
    }else if(selected.type==='wire'){
      bind('pw-num',e=>{s.num=e.target.value;render();scheduleAutoXrefs();});
      bind('pw-voltage',e=>{s.voltage=e.target.value.trim()||'';markVoltageDirty();render();});
      bind('pw-color',e=>{s.color=e.target.value;render();});
      bind('pw-w',e=>{s.width=parseFloat(e.target.value)||1.8;render();});
      bind('pw-nox',e=>{s.numOffX=parseInt(e.target.value)||0;render();});
      bind('pw-noy',e=>{s.numOffY=parseInt(e.target.value);render();});
      bind('pw-nang',e=>{const v=e.target.value.trim();s.numAngle=v===''?undefined:parseInt(v);render();});
      on('pa-wirenums',openWireNumsModal);
      on('pa-wire-to-shape', ()=>{ convertWireToShape(s); });
      bind('pw-xref-start',e=>{s.xrefStart=e.target.value.trim();render();});
      bind('pw-xref-end',  e=>{s.xrefEnd  =e.target.value.trim();render();});
    }else if(selected.type==='text'){
      const _ptText=document.getElementById('pt-text');
      if(_ptText) _ptText.addEventListener('input',e=>{s.text=e.target.value;render();});
      bind('pt-size',e=>{s.size=parseInt(e.target.value)||13;render();});
      bind('pt-angle',e=>{s.angle=parseInt(e.target.value)||0;render();});
      bind('pt-color',e=>{s.color=e.target.value;render();});
      on('pt-rot-ccw',()=>{s.angle=((s.angle||0)-90+360)%360;document.getElementById('pt-angle').value=s.angle;render();});
      on('pt-rot-cw', ()=>{s.angle=((s.angle||0)+90)%360;document.getElementById('pt-angle').value=s.angle;render();});
      bind('pt-zone-w',e=>{const v=parseInt(e.target.value)||0;s.w=v>0?v:undefined;if(!s.w)delete s.w;render();updateProps();});
      bind('pt-zone-h',e=>{const v=parseInt(e.target.value)||0;s.h=v>0?v:undefined;if(!s.h)delete s.h;render();updateProps();});
    }else if(selected.type==='shape'){
      bind('psh-color',e=>{s.color=e.target.value;render();});
      bind('psh-color2',e=>{s.color2=e.target.value;render();});
      bind('psh-thick',e=>{s.thick=parseFloat(e.target.value)||1.5;render();});
      document.getElementById('psh-fill')?.addEventListener('change',e=>{s.fill=e.target.checked;render();});
      document.getElementById('psh-stroke')?.addEventListener('change',e=>{
        s.stroke=e.target.value;
        const row=document.getElementById('psh-color2-row');
        if(row)row.style.display=e.target.value==='stripe-col'?'':'none';
        render();
      });
      on('pa-shape-to-wire', ()=>{ convertShapeToWire(s); });
      // Geometry bindings
      if(s.t==='rect'||s.t==='textbox'){
        bind('psh-geo-x',e=>{s.x=parseFloat(e.target.value)||0;render();});
        bind('psh-geo-y',e=>{s.y=parseFloat(e.target.value)||0;render();});
        bind('psh-geo-w',e=>{s.w=Math.max(1,parseFloat(e.target.value)||1);render();});
        bind('psh-geo-h',e=>{s.h=Math.max(1,parseFloat(e.target.value)||1);render();});
      } else if(s.t==='circle'){
        bind('psh-geo-cx',e=>{s.cx=parseFloat(e.target.value)||0;render();});
        bind('psh-geo-cy',e=>{s.cy=parseFloat(e.target.value)||0;render();});
        bind('psh-geo-r',e=>{s.r=Math.max(1,parseFloat(e.target.value)||1);render();});
      } else if(s.t==='arc'){
        bind('psh-geo-cx',e=>{s.cx=parseFloat(e.target.value)||0;render();});
        bind('psh-geo-cy',e=>{s.cy=parseFloat(e.target.value)||0;render();});
        bind('psh-geo-r',e=>{s.r=Math.max(1,parseFloat(e.target.value)||1);render();});
        bind('psh-geo-a1',e=>{s.a1=parseFloat(e.target.value)*Math.PI/180;render();});
        bind('psh-geo-a2',e=>{s.a2=parseFloat(e.target.value)*Math.PI/180;render();});
      } else if(s.t==='line'||s.t==='poly'){
        document.querySelectorAll('.psh-pt-x').forEach(inp=>{
          inp.addEventListener('input',e=>{
            const i=parseInt(inp.dataset.pi);
            if(s.pts&&s.pts[i]!==undefined){s.pts[i].x=parseFloat(e.target.value)||0;render();}
          });
        });
        document.querySelectorAll('.psh-pt-y').forEach(inp=>{
          inp.addEventListener('input',e=>{
            const i=parseInt(inp.dataset.pi);
            if(s.pts&&s.pts[i]!==undefined){s.pts[i].y=parseFloat(e.target.value)||0;render();}
          });
        });
      }
      // Textbox properties
      if(s.t==='textbox'){
        document.getElementById('ptb-text')?.addEventListener('input',e=>{s.text=e.target.value;render();});
        bind('ptb-fontsize',e=>{s.fontSize=parseInt(e.target.value)||11;render();});
        bind('ptb-textcolor',e=>{s.textColor=e.target.value;render();});
        document.getElementById('ptb-align')?.addEventListener('change',e=>{s.align=e.target.value;render();});
        document.getElementById('ptb-valign')?.addEventListener('change',e=>{s.valign=e.target.value;render();});
        bind('ptb-padding',e=>{s.padding=parseInt(e.target.value)||4;render();});
        bind('ptb-angle',e=>{s.angle=parseInt(e.target.value)||0;render();});
        on('ptb-rot-ccw',()=>{s.angle=((s.angle||0)-90+360)%360;document.getElementById('ptb-angle').value=s.angle;render();});
        on('ptb-rot-cw', ()=>{s.angle=((s.angle||0)+90)%360;document.getElementById('ptb-angle').value=s.angle;render();});
      }
    }
    if(selected.type==='image'){
      const bindNum=(id,prop,cb)=>{
        document.getElementById(id)?.addEventListener('change',e=>{
          saveHistory('Redimensionner'); s[prop]=Math.max(10,parseInt(e.target.value)||10); if(cb)cb(); render(); updateProps();
        });
      };
      // Largeur avec option proportionnelle
      document.getElementById('pi-w')?.addEventListener('change',e=>{
        const nw=Math.max(10,parseInt(e.target.value)||10);
        saveHistory('Redimensionner');
        if(document.getElementById('pi-lock')?.checked && s.w>0){
          s.h=Math.round(nw*s.h/s.w);
        }
        s.w=nw; render(); updateProps();
      });
      document.getElementById('pi-h')?.addEventListener('change',e=>{
        const nh=Math.max(10,parseInt(e.target.value)||10);
        saveHistory('Redimensionner');
        if(document.getElementById('pi-lock')?.checked && s.h>0){
          s.w=Math.round(nh*s.w/s.h);
        }
        s.h=nh; render(); updateProps();
      });
      document.getElementById('pi-lock')?.addEventListener('change',e=>{ s._lockAspect=e.target.checked; });
      const opEl=document.getElementById('pi-opacity');
      const opVal=document.getElementById('pi-opacity-val');
      opEl?.addEventListener('input',e=>{
        s.opacity=parseFloat(e.target.value);
        if(opVal)opVal.textContent=Math.round(s.opacity*100)+'%';
        render();
      });
      on('pi-replace',()=>{
        const input=document.createElement('input');
        input.type='file';input.accept='image/jpeg,image/png,image/gif,image/svg+xml,image/webp';
        input.onchange=ev=>{
          const file=ev.target.files[0]; if(!file)return;
          const reader=new FileReader();
          reader.onload=re=>{
            saveHistory('Changer image'); s.src=re.target.result; render(); updateProps();
          };
          reader.readAsDataURL(file);
        };
        input.click();
      });
    }
    on('pa-del',delSelected);
  }

  // ─────────────────────────────────────────────────────────
  // TOOLBAR & MODALES
  // ─────────────────────────────────────────────────────────
  function bindToolbar(){
    document.querySelectorAll('.rb.tool,.tb-btn.tool').forEach(b=>b.addEventListener('click',()=>setTool(b.dataset.tool)));

    // ── Barre alignement flottante ──────────────────────────────────────
    document.querySelectorAll('.ab-btn').forEach(btn=>{
      btn.addEventListener('click',()=>{
        if(btn.dataset.align) alignSelected(btn.dataset.align);
        if(btn.dataset.dist)  distributeSelected(btn.dataset.dist);
        updateProps();
      });
    });

    // ── Boutons undo/redo ───────────────────────────────────────────────
    document.getElementById('btn-undo')?.addEventListener('click',undo);
    document.getElementById('btn-redo')?.addEventListener('click',redo);
    document.getElementById('btn-undo-caret')?.addEventListener('click',e=>{
      e.stopPropagation();
      const split=document.getElementById('split-undo');
      const wasOpen=split.classList.contains('tbm-open');
      _closeSplitMenus(); _tbmOpen(null);
      if(!wasOpen && histIdx>0){
        split.classList.add('tbm-open');
        const bd=document.createElement('div'); bd.id='tb-backdrop';
        bd.addEventListener('click',()=>_closeSplitMenus());
        document.body.appendChild(bd);
      }
    });
    document.getElementById('btn-redo-caret')?.addEventListener('click',e=>{
      e.stopPropagation();
      const split=document.getElementById('split-redo');
      const wasOpen=split.classList.contains('tbm-open');
      _closeSplitMenus(); _tbmOpen(null);
      if(!wasOpen && histIdx<history.length-1){
        split.classList.add('tbm-open');
        const bd=document.createElement('div'); bd.id='tb-backdrop';
        bd.addEventListener('click',()=>_closeSplitMenus());
        document.body.appendChild(bd);
      }
    });
    _updateUndoRedo();

    // ── Recherche ───────────────────────────────────────────────────────
    document.getElementById('search-close')?.addEventListener('click',_closeSearch);
    document.getElementById('search-input')?.addEventListener('input',()=>_doSearch());
    document.getElementById('search-all-folios')?.addEventListener('change',()=>_doSearch());
    document.getElementById('search-match-case')?.addEventListener('change',()=>_doSearch());
    document.getElementById('replace-btn')?.addEventListener('click',()=>_doReplace(true));
    document.getElementById('replace-all-btn')?.addEventListener('click',()=>_doReplace(false));
    document.getElementById('replace-input')?.addEventListener('keydown',e=>{if(e.key==='Enter')_doReplace(false);});
    // Échap ferme la palette
    document.addEventListener('keydown',e=>{
      if(e.key==='Escape'&&document.getElementById('search-palette')?.style.display==='block'){
        e.stopPropagation();_closeSearch();
      }
    },true);

    // ── Boutons options mesure ──────────────────────────────────────────
    document.getElementById('measure-clear-all')?.addEventListener('click',()=>{
      _measures=[]; measureIP=null; _measureColorIdx=0;
      LiveSync.broadcast({type:'measure_clear',folioId:currentFolioId});
      render(); setStatus('Mesures effacées');
    });

    document.getElementById('measure-to-text')?.addEventListener('click',()=>{
      // Convertir toutes les mesures figées en annotations texte sur le schéma
      if(!_measures.length&&!measureIP){setStatus('Aucune mesure à annoter');return;}
      const toAnnotate=[..._measures,...(measureIP&&measureIP.frozen?[measureIP]:[])];
      toAnnotate.forEach(m=>{
        const dx=m.p2.x-m.p1.x, dy=m.p2.y-m.p1.y;
        const dist=Math.hypot(dx,dy), adx=Math.abs(dx), ady=Math.abs(dy);
        const isH=ady<0.5, isV=adx<0.5;
        let txt;
        if(isH)      txt=_measureFormat(adx);
        else if(isV) txt=_measureFormat(ady);
        else         txt=`↗${_measureFormat(dist)} (${_measureFormat(adx)}×${_measureFormat(ady)})`;
        const mid={x:(m.p1.x+m.p2.x)/2, y:(m.p1.y+m.p2.y)/2-15};
        state.texts.push({id:'t'+Date.now()+Math.random().toString(36).slice(2),
          x:mid.x,y:mid.y,text:txt,size:11,color:m.color||'#f5a623',angle:0});
      });
      saveHistory('Ajouter mesure'); render(); updateStatus();
      setStatus(`${toAnnotate.length} mesure(s) converties en annotations`);
    });

    document.getElementById('measure-unit')?.addEventListener('change',e=>{
      _measureCfg.unit=e.target.value;
      const su=document.getElementById('measure-scale-unit');
      if(su)su.textContent=e.target.value;
      render();
    });

    document.getElementById('measure-scale')?.addEventListener('input',e=>{
      const v=parseFloat(e.target.value);
      if(v>0)_measureCfg.scale=v;
      render();
    });

    // Clic sur le canvas en mode mesure → copier valeur si mesure figée à proximité
    canvas.addEventListener('click',e=>{
      if(currentTool!=='measure') return;
      const{sx,sy}=cp(e);const{x:wx,y:wy}=s2w(sx,sy);
      const tol=20/view.zoom;
      const all=[..._measures,...(measureIP&&measureIP.frozen?[measureIP]:[])];
      for(const m of all){
        const mid={x:(m.p1.x+m.p2.x)/2,y:(m.p1.y+m.p2.y)/2};
        if(Math.hypot(wx-mid.x,wy-mid.y)<tol){
          const dx=m.p2.x-m.p1.x,dy=m.p2.y-m.p1.y;
          const dist=Math.hypot(dx,dy);
          const txt=_measureFormat(dist);
          navigator.clipboard?.writeText(txt).then(()=>setStatus(`📋 Copié : ${txt}`)).catch(()=>{});
          return;
        }
      }
    });

    // ── Menus déroulants ─────────────────────────────────────────
    function _tbmOpen(id){
      document.querySelectorAll('.tb-menu.tbm-open').forEach(m=>m.classList.remove('tbm-open'));
      _closeSplitMenus();
      document.getElementById('tb-backdrop')?.remove();
      if(!id) return;
      const menu = document.getElementById(id);
      if(!menu) return;
      menu.classList.add('tbm-open');
      const bd = document.createElement('div');
      bd.id='tb-backdrop';
      bd.addEventListener('click', ()=>_tbmOpen(null));
      document.body.appendChild(bd);
    }
    document.querySelectorAll('.tb-menu-trigger').forEach(btn=>{
      btn.addEventListener('click', e=>{
        e.stopPropagation();
        const id = btn.dataset.tbm;
        const already = document.getElementById(id)?.classList.contains('tbm-open');
        _tbmOpen(already ? null : id);
      });
    });
    document.querySelectorAll('.tb-di').forEach(item=>{
      item.addEventListener('click', ()=>_tbmOpen(null));
    });

    // ── Ribbon tabs ──────────────────────────────────────────────
    document.querySelectorAll('.ribbon-tab').forEach(tab=>{
      tab.addEventListener('click',()=>{
        const rid=tab.dataset.ribbon;
        document.querySelectorAll('.ribbon-tab').forEach(t=>t.classList.remove('active'));
        tab.classList.add('active');
        document.querySelectorAll('.ribbon-panel').forEach(p=>p.classList.remove('active'));
        const panel=document.getElementById('rpanel-'+rid);
        if(panel) panel.classList.add('active');
      });
    });

    // ── Fichier ───────────────────────────────────────────────────
    document.getElementById('btn-new')?.addEventListener('click',newSchema);
    document.getElementById('btn-save').addEventListener('click',saveSchema);
    document.getElementById('autosave-switch').addEventListener('change', e => toggleAutoSave(e.target.checked));
    document.getElementById('btn-open-schema')?.addEventListener('click',openProjectModal);
    document.getElementById('btn-export-pdf').addEventListener('click',exportPDF);
    document.getElementById('btn-export-pdf-project').addEventListener('click',exportProjectPDF);
    document.getElementById('btn-export-svg').addEventListener('click',exportSVG);
    document.getElementById('btn-export-dxf').addEventListener('click',exportDXF);
    document.getElementById('btn-export-json')?.addEventListener('click',exportFolioJSON);
    document.getElementById('btn-import-json')?.addEventListener('click',importFolioJSON);

    // ── Projet ────────────────────────────────────────────────────
    document.getElementById('btn-folio').addEventListener('click',openFolioModal);
    document.getElementById('btn-print-zone').addEventListener('click',openPrintZoneModal);
    document.getElementById('btn-grid-settings')?.addEventListener('click',()=>{
      document.querySelectorAll('.ribbon-tab').forEach(t=>t.classList.remove('active'));
      document.querySelector('.ribbon-tab[data-ribbon="accueil"]')?.classList.add('active');
      document.querySelectorAll('.ribbon-panel').forEach(p=>p.classList.remove('active'));
      document.getElementById('rpanel-accueil')?.classList.add('active');
    });
    function _applyGridFromRibbon(){
      GRID=parseInt(document.getElementById('grid-main').value)||20;
      gridSnap=document.getElementById('grid-snap').checked;
      gridVisible=document.getElementById('grid-visible').checked;
      snapLabels=document.getElementById('grid-snap-labels').checked;
      render();saveUserSettings();
    }
    const _gridRange=document.getElementById('grid-main-range');
    const _gridHidden=document.getElementById('grid-main');
    const _gridVal=document.getElementById('grid-main-val');
    _gridRange.addEventListener('input',()=>{
      _gridHidden.value=_gridRange.value;
      _gridVal.textContent=_gridRange.value+'px';
      _applyGridFromRibbon();
    });
    document.getElementById('grid-snap').addEventListener('change',_applyGridFromRibbon);
    document.getElementById('grid-visible').addEventListener('change',_applyGridFromRibbon);
    document.getElementById('grid-snap-labels').addEventListener('change',_applyGridFromRibbon);
    document.getElementById('btn-proj-props')?.addEventListener('click', openProjProps);
    document.getElementById('btn-borniers')?.addEventListener('click', openBorniersModal);
    document.getElementById('btn-coffrets')?.addEventListener('click', openCoffretsModal);
    // ── Bandeau Implantation ─────────────────────────────────────
    document.getElementById('btn-impl-place-rail')?.addEventListener('click', () => _startImplantPlacement('rail', null));
    document.getElementById('btn-impl-place-goulotte')?.addEventListener('click', () => _startImplantPlacement('goulotte', null));
    document.getElementById('btn-impl-rotate')?.addEventListener('click', () => {
      if (!selected.id && !multiSel.size) { setStatus('⚠ Sélectionnez un élément à pivoter'); return; }
      let rotated = 0;
      const rotOne = (key) => {
        const colon = key.indexOf(':'); const t = key.slice(0, colon), id = key.slice(colon + 1);
        if (t === 'element') {
          const el = state.elements.find(e => e.id === id);
          if (el) { el.rotation = ((el.rotation || 0) + 90) % 360; rotated++; }
        } else if (t === 'shape') {
          // Shape implantation (rail/goulotte) → swap orientation H/V
          const sh = state.shapes.find(s => s.id === id);
          if (!sh) return;
          const info = _findImplantEntity(sh.id);
          if (!info) return;
          const cur = info.entity.orientation || ((info.entity.width || 40) >= (info.entity.height || 40) ? 'h' : 'v');
          info.entity.orientation = cur === 'h' ? 'v' : 'h';
          // Pour une goulotte : swap width/height pour préserver la géométrie réelle
          if (info.kind === 'goulotte') {
            const tmp = info.entity.width; info.entity.width = info.entity.height; info.entity.height = tmp;
          }
          _updateImplantCfg(info.cfg);
          rotated++;
        }
      };
      if (multiSel.size) multiSel.forEach(rotOne);
      else if (selected.id) rotOne((selected.type || 'element') + ':' + selected.id);
      if (rotated) { saveHistory('Pivoter'); render(); if (typeof updateProps === 'function') updateProps(); }
      else setStatus('⚠ Rien à pivoter');
    });
    document.getElementById('btn-impl-flip')?.addEventListener('click', () => {
      if (!selected.id && !multiSel.size) { setStatus('⚠ Sélectionnez un élément à retourner'); return; }
      let flipped = 0;
      const flipOne = (key) => {
        const colon = key.indexOf(':'); const t = key.slice(0, colon), id = key.slice(colon + 1);
        if (t === 'element') {
          const el = state.elements.find(e => e.id === id);
          if (el) { el.flipH = !el.flipH; flipped++; }
        }
      };
      if (multiSel.size) multiSel.forEach(flipOne);
      else if (selected.id) flipOne((selected.type || 'element') + ':' + selected.id);
      if (flipped) { saveHistory('Retourner'); render(); }
      else setStatus('⚠ Seul un appareillage peut être retourné');
    });
    document.getElementById('btn-impl-open-settings')?.addEventListener('click', () => {
      const ov = document.getElementById('implant-overlay');
      if (ov) ov.style.display = ov.style.display === 'none' ? 'flex' : 'none';
    });
    document.getElementById('impl-clamp-grid')?.addEventListener('change', e => {
      const c = projectFolios.find(x => x.id === currentFolioId)?.data?.implantation
        || projectFolios.find(x => x.id === currentFolioId)?.implantation;
      if (c) { c.clampToGrid = e.target.checked; _updateImplantCfg(c); }
    });
    document.getElementById('impl-magnet')?.addEventListener('change', e => {
      const c = projectFolios.find(x => x.id === currentFolioId)?.data?.implantation
        || projectFolios.find(x => x.id === currentFolioId)?.implantation;
      if (c) { c.magnetism = e.target.checked; _updateImplantCfg(c); }
    });
    document.getElementById('btn-funcgroups')?.addEventListener('click', openFuncGroupsModal);
    document.getElementById('btn-ai-gen')?.addEventListener('click', openAiGenModal);

    // ── Vue ───────────────────────────────────────────────────────
    document.getElementById('btn-voltage-legend')?.addEventListener('click',()=>{
      toggleVoltageLegend();
      const chk=document.getElementById('chk-vleg');
      if(chk) chk.className='rb-check'+(_legendVisible?' on':'');
    });
    document.getElementById('btn-insert-legend')?.addEventListener('click', insertLegendOnFolio);

    // ── Utilisateur ───────────────────────────────────────────────
    document.getElementById('btn-user-prefs')?.addEventListener('click', openUserPrefs);
    document.getElementById('btn-change-pass')?.addEventListener('click',()=>{
      ['cp-old','cp-new','cp-confirm'].forEach(id=>{const el=document.getElementById(id);if(el)el.value='';});
      const msg=document.getElementById('cp-msg');if(msg)msg.style.display='none';
      openModal('modal-change-pass');
    });
    document.getElementById('cp-save-btn')?.addEventListener('click', _savePassword);
    document.getElementById('pref-save-btn')?.addEventListener('click', _savePrefs);
    document.getElementById('pref-theme-edit-btn')?.addEventListener('click', _openThemeCustomizer);
    document.getElementById('tc-save-btn')?.addEventListener('click', _saveCustomTheme);
    document.getElementById('tc-cancel-btn')?.addEventListener('click', _cancelCustomTheme);
    // Redirige vers le dashboard admin si ?admin=1 dans l'URL
    if(new URLSearchParams(window.location.search).get('admin')==='1'){
      window.history.replaceState({},document.title,window.location.pathname);
      window.location.href='/admin.html';
    }
    TitleBlock.init();

    // ── Callback de persistance cartouche folio ───────────────────────────
    TitleBlock.setFolioSaveCallback(async (tbData) => {
      folio.titleblock = tbData;
      if (currentFolioId) {
        // Persister via saveSchema qui inclut maintenant titleblock au niveau racine
        try { await saveSchema(); } catch(e) {}
      } else if (currentProject) {
        // Pas de folio ouvert → cartouche par défaut du projet
        currentProject.titleblock_default = tbData;
        const pid = currentProject.id;
        fetch(`/api/projects/${pid}`, {
          method:'PUT', credentials:'include',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({
            titleblock_default: currentProject.titleblock_default || null,
            titleblock_cover:   currentProject.titleblock_cover   || null,
          })
        }).catch(()=>{});
      }
    });

    document.getElementById('btn-logout').addEventListener('click',async()=>{
      await fetch('/api/auth/logout',{method:'POST',credentials:'include'});
      window.location.href='/login.html';
    });

    // ── Zoom ──────────────────────────────────────────────────────
    document.getElementById('zoom-in').addEventListener('click',()=>{view.zoom=Math.min(8,view.zoom*1.2);document.getElementById('zoom-val').textContent=Math.round(view.zoom*100)+'%';render();});
    document.getElementById('zoom-out').addEventListener('click',()=>{view.zoom=Math.max(0.08,view.zoom*0.8);document.getElementById('zoom-val').textContent=Math.round(view.zoom*100)+'%';render();});
    document.getElementById('zoom-fit').addEventListener('click',fitView);
    _initZoomInput();
    document.getElementById('sym-search').addEventListener('input',e=>buildLibrary(e.target.value));
  }

  function _initZoomInput(){
    const span=document.getElementById('zoom-val');
    if(!span)return;
    span.style.cursor='text';
    span.title='Cliquer pour saisir un zoom';
    span.addEventListener('click',()=>{
      const inp=document.createElement('input');
      inp.type='text';
      inp.value=Math.round(view.zoom*100).toString();
      inp.style.cssText='width:42px;text-align:center;font-size:10px;background:var(--panel2);border:1px solid var(--accent);color:var(--text);border-radius:3px;padding:2px 0;outline:none;font-family:var(--font)';
      span.replaceWith(inp);
      inp.focus();inp.select();
      const apply=()=>{
        const pct=parseInt(inp.value);
        const newSpan=document.createElement('span');
        newSpan.id='zoom-val';
        if(!isNaN(pct)&&pct>=8&&pct<=800){
          const nz=pct/100;
          const cx=canvas.width/2,cy=canvas.height/2;
          view.panX=cx-(cx-view.panX)*(nz/view.zoom);
          view.panY=cy-(cy-view.panY)*(nz/view.zoom);
          view.zoom=nz;
          newSpan.textContent=Math.round(nz*100)+'%';
          render();
        }else{
          newSpan.textContent=Math.round(view.zoom*100)+'%';
        }
        inp.replaceWith(newSpan);
        _initZoomInput();
      };
      const cancel=()=>{
        const newSpan=document.createElement('span');
        newSpan.id='zoom-val';
        newSpan.textContent=Math.round(view.zoom*100)+'%';
        inp.replaceWith(newSpan);
        _initZoomInput();
      };
      inp.addEventListener('blur',apply);
      inp.addEventListener('keydown',e=>{
        if(e.key==='Enter'){e.preventDefault();inp.removeEventListener('blur',apply);apply();}
        else if(e.key==='Escape'){e.preventDefault();inp.removeEventListener('blur',apply);cancel();}
      });
    },{once:true});
  }

  // ── Guides d'alignement snap ─────────────────────────────────────
  function _computeSnapGuides(){
    if(!drag.active||!drag.ids.length){_snapGuides=[];return;}
    const TOL=4/view.zoom;
    const dragSet=new Set(drag.ids);
    // BBox union des objets en cours de drag
    let dx0=Infinity,dy0=Infinity,dx1=-Infinity,dy1=-Infinity;
    drag.ids.forEach(k=>{
      const[t,id]=k.split(':');const o=getById(t,id);if(!o)return;
      const b=getObjBBox(t,o);
      dx0=Math.min(dx0,b.x);dy0=Math.min(dy0,b.y);
      dx1=Math.max(dx1,b.x+b.w);dy1=Math.max(dy1,b.y+b.h);
    });
    if(dx0===Infinity){_snapGuides=[];return;}
    const dcx=(dx0+dx1)/2,dcy=(dy0+dy1)/2;
    const dV=[dx0,dcx,dx1], dH=[dy0,dcy,dy1];
    const seenV=new Set(),seenH=new Set();
    const guides=[];
    // Comparer avec éléments statiques (non draggés)
    state.elements.filter(el=>!dragSet.has('element:'+el.id)).forEach(el=>{
      const b=getObjBBox('element',el);
      const sV=[b.x,b.x+b.w/2,b.x+b.w],sH=[b.y,b.y+b.h/2,b.y+b.h];
      sV.forEach(sv=>dV.forEach(dv=>{
        if(Math.abs(dv-sv)<TOL){const k=Math.round(sv*10);if(!seenV.has(k)){seenV.add(k);guides.push({type:'v',x:sv});}}
      }));
      sH.forEach(sh=>dH.forEach(dh=>{
        if(Math.abs(dh-sh)<TOL){const k=Math.round(sh*10);if(!seenH.has(k)){seenH.add(k);guides.push({type:'h',y:sh});}}
      }));
    });
    _snapGuides=guides;
  }

  // ── Préférences utilisateur ─────────────────────────────────────
  function openUserPrefs(){
    document.getElementById('pref-name').value = currentUser.name||'';
    document.getElementById('pref-login').textContent = currentUser.login||'—';
    document.getElementById('pref-role').textContent = currentUser.role==='admin'?'Administrateur':'Utilisateur';
    document.getElementById('pref-theme').value = localStorage.getItem('qd-theme')||'dark';
    openModal('modal-user-prefs');
  }
  async function _savePrefs(){
    const name  = document.getElementById('pref-name').value.trim();
    const theme = document.getElementById('pref-theme').value;
    localStorage.setItem('qd-theme', theme);
    _applyTheme(theme);
    if(name && name !== currentUser.name){
      try{
        await fetch(`/api/users/${currentUser.id}`,{method:'PUT',credentials:'include',
          headers:{'Content-Type':'application/json'},body:JSON.stringify({name})});
        currentUser.name = name;
        document.getElementById('user-name').textContent = name;
        const ddun=document.getElementById('dd-uname');if(ddun)ddun.textContent=name;
      }catch(e){/* silent */}
    }
    closeModal('modal-user-prefs');
    setStatus('Préférences enregistrées');
  }
  const THEME_PRESETS = {
    dark:     {'--bg':'#0c0e14','--panel':'#12151c','--panel2':'#191d27','--panel3':'#1f2433','--border':'#242836','--border2':'#2e3447','--text':'#dde1ed','--text2':'#6b7494','--text3':'#404762','--accent':'#3b9eff','--accent2':'#ff6340','--accent3':'#4dff91','--warn':'#ffb340'},
    midnight: {'--bg':'#050709','--panel':'#0d1018','--panel2':'#121620','--panel3':'#171c28','--border':'#1e2535','--border2':'#252c3e','--text':'#d8dce8','--text2':'#9098b8','--text3':'#505870','--accent':'#3b9eff','--accent2':'#ff6340','--accent3':'#4dff91','--warn':'#ffb340'},
    light:    {'--bg':'#e8eaf0','--panel':'#f0f1f5','--panel2':'#e2e4ec','--panel3':'#d8dbe5','--border':'#c0c5d4','--border2':'#b0b6c8','--text':'#1a1e2e','--text2':'#4a506a','--text3':'#8890a8','--accent':'#2b7ed8','--accent2':'#e04e2a','--accent3':'#2ba55e','--warn':'#d49520'},
    warm:     {'--bg':'#1a1612','--panel':'#211c16','--panel2':'#2a231b','--panel3':'#332b22','--border':'#3e352a','--border2':'#4e4437','--text':'#e0d8cc','--text2':'#9a8e7c','--text3':'#5c5244','--accent':'#e8a44a','--accent2':'#e06040','--accent3':'#6ac070','--warn':'#e8a44a'},
    nord:     {'--bg':'#2e3440','--panel':'#3b4252','--panel2':'#434c5e','--panel3':'#4c566a','--border':'#4c566a','--border2':'#5e6779','--text':'#eceff4','--text2':'#d8dee9','--text3':'#81a1c1','--accent':'#88c0d0','--accent2':'#bf616a','--accent3':'#a3be8c','--warn':'#ebcb8b'},
  };
  const THEME_VARS = ['--bg','--panel','--panel2','--panel3','--border','--border2','--text','--text2','--text3','--accent','--accent2','--accent3','--warn'];

  function _applyTheme(t){
    const r = document.documentElement;
    THEME_VARS.forEach(v=>r.style.removeProperty(v));
    if (t === 'custom') {
      const custom = JSON.parse(localStorage.getItem('qd-theme-custom') || '{}');
      Object.entries(custom).forEach(([k,v])=>r.style.setProperty(k,v));
    } else {
      Object.entries(THEME_PRESETS[t]||{}).forEach(([k,v])=>r.style.setProperty(k,v));
    }
  }

  function _openThemeCustomizer() {
    const base = document.getElementById('pref-theme').value;
    // Charger les couleurs de base
    let colors;
    if (base === 'custom') {
      colors = JSON.parse(localStorage.getItem('qd-theme-custom') || JSON.stringify(THEME_PRESETS.dark));
    } else {
      colors = { ...THEME_PRESETS[base] || THEME_PRESETS.dark };
    }

    const modal = document.getElementById('modal-theme-custom');
    const grid = document.getElementById('tc-colors-grid');
    const labels = {
      '--bg':'Arrière-plan','--panel':'Panneau','--panel2':'Panneau 2','--panel3':'Panneau 3',
      '--border':'Bordure','--border2':'Bordure 2',
      '--text':'Texte','--text2':'Texte secondaire','--text3':'Texte tertiaire',
      '--accent':'Accent principal','--accent2':'Accent secondaire','--accent3':'Accent tertiaire','--warn':'Avertissement'
    };
    grid.innerHTML = THEME_VARS.map(v => `
      <div style="display:flex;align-items:center;gap:8px;padding:4px 0">
        <input type="color" id="tc-${v}" value="${colors[v]||'#000000'}" style="width:32px;height:24px;border:1px solid var(--border2);border-radius:3px;cursor:pointer;padding:0;background:transparent">
        <div style="flex:1;min-width:0">
          <div style="font-size:11px;font-weight:500;color:var(--text)">${labels[v]||v}</div>
          <div style="font-size:9px;color:var(--text3);font-family:var(--font)">${v}</div>
        </div>
        <input type="text" id="tc-hex-${v}" value="${colors[v]||'#000000'}" style="width:70px;background:var(--panel2);border:1px solid var(--border);color:var(--text);padding:2px 5px;border-radius:3px;font-family:var(--font);font-size:10px;text-align:center">
      </div>`).join('');

    // Synchroniser color picker ↔ hex input
    THEME_VARS.forEach(v => {
      const picker = document.getElementById('tc-' + v);
      const hex = document.getElementById('tc-hex-' + v);
      picker.addEventListener('input', () => { hex.value = picker.value; _previewCustomTheme(); });
      hex.addEventListener('input', () => { if(/^#[0-9a-f]{6}$/i.test(hex.value)){picker.value=hex.value;_previewCustomTheme();} });
    });

    // Sélecteur de base
    const baseSel = document.getElementById('tc-base-theme');
    baseSel.innerHTML = Object.keys(THEME_PRESETS).map(k =>
      `<option value="${k}"${k===base?' selected':''}>${k.charAt(0).toUpperCase()+k.slice(1)}</option>`).join('');
    baseSel.onchange = () => {
      const preset = THEME_PRESETS[baseSel.value] || THEME_PRESETS.dark;
      THEME_VARS.forEach(v => {
        document.getElementById('tc-' + v).value = preset[v] || '#000000';
        document.getElementById('tc-hex-' + v).value = preset[v] || '#000000';
      });
      _previewCustomTheme();
    };

    openModal('modal-theme-custom');
  }

  function _previewCustomTheme() {
    const r = document.documentElement;
    THEME_VARS.forEach(v => {
      const val = document.getElementById('tc-' + v)?.value;
      if (val) r.style.setProperty(v, val);
    });
  }

  function _saveCustomTheme() {
    const colors = {};
    THEME_VARS.forEach(v => { colors[v] = document.getElementById('tc-' + v)?.value || '#000000'; });
    localStorage.setItem('qd-theme-custom', JSON.stringify(colors));
    localStorage.setItem('qd-theme', 'custom');
    document.getElementById('pref-theme').value = 'custom';
    closeModal('modal-theme-custom');
    setStatus('Thème personnalisé enregistré');
  }

  function _cancelCustomTheme() {
    // Restaurer le thème précédent
    const prev = localStorage.getItem('qd-theme') || 'dark';
    _applyTheme(prev);
    closeModal('modal-theme-custom');
  }
  async function _savePassword(){
    const old_=document.getElementById('cp-old').value;
    const nw  =document.getElementById('cp-new').value;
    const conf=document.getElementById('cp-confirm').value;
    const msg =document.getElementById('cp-msg');
    function _cpMsg(txt,ok){
      msg.textContent=txt;
      msg.style.cssText=`display:block;font-size:10px;padding:6px 10px;border-radius:4px;border-left:3px solid ${ok?'#4dd278':'#ff4444'};background:rgba(${ok?'77,210,120':'255,68,68'},.08);color:${ok?'#4dd278':'#ff6666'}`;
    }
    if(!old_||!nw){_cpMsg('Tous les champs sont requis.',false);return;}
    if(nw.length<6){_cpMsg('Minimum 6 caractères.',false);return;}
    if(nw!==conf){_cpMsg('Les mots de passe ne correspondent pas.',false);return;}
    try{
      const res=await fetch('/api/auth/password',{method:'PUT',credentials:'include',
        headers:{'Content-Type':'application/json'},body:JSON.stringify({oldPassword:old_,newPassword:nw})});
      const d=await res.json();
      if(!res.ok){_cpMsg(d.error||'Erreur',false);return;}
      _cpMsg('✓ Mot de passe modifié.',true);
      setTimeout(()=>closeModal('modal-change-pass'),1400);
    }catch{_cpMsg('Erreur réseau',false);}
  }

  // ── Légende insérée dans le folio ────────────────────────────────
  function insertLegendOnFolio(){
    const voltages = [...new Set(Object.values(_voltageMap).filter(Boolean))];
    const hasConflict = _conflictWires.size>0||_conflictEls.size>0;
    if(!voltages.length && !hasConflict){setStatus('Aucune tension à afficher dans la légende');return;}

    // Tri tensions numériques décroissantes puis alpha
    voltages.sort((a,b)=>{const na=parseFloat(a),nb=parseFloat(b);if(!isNaN(na)&&!isNaN(nb))return nb-na;if(!isNaN(na))return-1;if(!isNaN(nb))return 1;return a.localeCompare(b);});
    if(hasConflict) voltages.push('⚠ Conflit');

    const ROW_H=16, PAD=8, COL_W=90, SWATCH=14, TITLE_H=18;
    const w = PAD*2+SWATCH+6+COL_W;
    const h = TITLE_H + voltages.length*ROW_H + PAD;

    // Construire les paths comme un symbole virtuel
    const paths=[];
    // Bordure + fond titre
    paths.push({t:'rect',x:0,y:0,w,h,color:'#3b9eff',thick:0.8,fill:false});
    paths.push({t:'rect',x:0,y:0,w,h:TITLE_H,color:'#3b9eff',thick:0,fill:true,fillColor:'rgba(59,158,255,.15)'});
    // Texte titre
    paths.push({t:'text',x:PAD,y:TITLE_H/2,text:'⚡ Légende tensions',size:8,bold:true,color:'#e8b84b',align:'left',baseline:'middle'});
    // Séparateur titre
    paths.push({t:'line',x1:0,y1:TITLE_H,x2:w,y2:TITLE_H,color:'#3b9eff',thick:0.5});

    voltages.forEach((v,i)=>{
      const col = v==='⚠ Conflit'?'#ff3c3c':_voltageColorPublic(v);
      const ry = TITLE_H + i*ROW_H;
      // swatch coloré
      paths.push({t:'rect',x:PAD,y:ry+ROW_H/2-3,w:SWATCH,h:6,color:col,thick:0,fill:true,fillColor:col});
      // label
      paths.push({t:'text',x:PAD+SWATCH+6,y:ry+ROW_H/2,text:v,size:8,bold:false,color:v==='⚠ Conflit'?'#ff6666':'#d0d4e8',align:'left',baseline:'middle'});
      // ligne de séparation légère
      if(i<voltages.length-1)
        paths.push({t:'line',x1:PAD,y1:ry+ROW_H,x2:w-PAD,y2:ry+ROW_H,color:'rgba(255,255,255,.07)',thick:0.4});
    });

    // Créer un faux symbole + élément à déposer au centre du viewport
    const fakeSym={id:'_legend_'+uid(),name:'Légende tensions',category:'Annotations',
      width:w,height:h,pins:[],paths,builtin:false,_isLegend:true};
    _symbols[fakeSym.id]=fakeSym;

    const cx=(canvas.width/2-view.panX)/view.zoom;
    const cy=(canvas.height/2-view.panY)/view.zoom;
    saveHistory('Placer image');
    const el={id:uid(),symId:fakeSym.id,x:snapW(cx-w/2),y:snapW(cy-h/2),
      w,h,rotation:0,flipH:false,color:'#3b9eff',label:'',ref:'',
      labelOffX:0,labelOffY:-18,refOffX:0,refOffY:10,_legendSymId:fakeSym.id};
    state.elements.push(el);
    setOnlySel('element',el.id);
    render(); updateProps(); updateStatus();
    setStatus('Légende tensions insérée');
  }


  // ── Modal Propriétés dessin ─────────────────────────────────────
  const _VOLT_LABELS = [
    ['400V','415V'],['230V','240V'],['120V','110V'],['48V'],
    ['24V'],['12V'],['5V'],['3.3V'],['0V','GND'],['VCC']
  ];

  function openProjProps(){
    // Onglet Fils & Bus
    document.getElementById('pp-wire-color').value  = PROJ.wireColor  || '#3b9eff';
    document.getElementById('pp-wire-width').value  = PROJ.wireWidth  || 1.8;
    document.getElementById('pp-bus-color').value   = PROJ.busColor   || '#3b9eff';
    document.getElementById('pp-bus-width').value   = PROJ.busWidth   || 1.8;
    document.getElementById('pp-junc-color').value  = PROJ.junctionColor || '#3b9eff';
    document.getElementById('pp-junc-r').value      = PROJ.junctionRadius || 4;
    document.getElementById('pp-text-color').value  = PROJ.textColor  || '#dde1ed';
    document.getElementById('pp-text-size').value   = PROJ.textSize   || 13;
    // Onglet N° fils
    document.getElementById('pp-num-show').checked  = PROJ.numShow !== false;
    document.getElementById('pp-num-bold').checked  = !!PROJ.numBold;
    document.getElementById('pp-num-color').value   = PROJ.numColor   || '#3b9eff';
    document.getElementById('pp-num-size').value    = PROJ.numSize    || 9;
    // Extract solid color from rgba bg
    const bgHex = _rgbaToHex(PROJ.numBgColor || 'rgba(12,14,22,.92)');
    document.getElementById('pp-num-bg').value      = bgHex;
    const brdHex = _rgbaToHex(PROJ.numBorderColor || 'rgba(59,158,255,.35)');
    document.getElementById('pp-num-brd').value     = brdHex;
    // Onglet Symboles
    document.getElementById('pp-sym-color').value   = PROJ.symColor   || '#3b9eff';
    document.getElementById('pp-label-color').value = PROJ.labelColor || '#dde1ed';
    document.getElementById('pp-ref-color').value   = PROJ.refColor   || '#6b7494';
    document.getElementById('pp-field-color').value = PROJ.fieldColor || '#6b7494';

    // Onglet Tensions
    document.getElementById('pp-blink').checked     = PROJ.conflictBlink !== false;
    const maxEl = document.getElementById('pp-blink-max');
    maxEl.value = PROJ.conflictAlphaMax || 0.4;
    document.getElementById('pp-blink-max-val').textContent = maxEl.value;
    // Grille tensions
    _buildVoltGrid();
    // Onglet Renvois de folio
    document.getElementById('pp-xref-size').value = PROJ.xrefSize || 6;
    // Prévisualisation N° fil + xref
    _updateNumPreview();
    _updateXrefPreview();
    // Bind live preview numéros
    ['pp-num-color','pp-num-bg','pp-num-brd','pp-num-size','pp-num-bold'].forEach(id=>{
      document.getElementById(id)?.addEventListener('change', _updateNumPreview);
      document.getElementById(id)?.addEventListener('input',  _updateNumPreview);
    });
    document.getElementById('pp-xref-size')?.addEventListener('input', _updateXrefPreview);
    // Onglet nommage
    _initPpNaming();
    openModal('modal-proj-props');
    // Tabs
    document.querySelectorAll('.pp-tab').forEach(tab=>{
      tab.onclick = ()=>{
        document.querySelectorAll('.pp-tab').forEach(t=>t.classList.remove('active'));
        document.querySelectorAll('.pp-content').forEach(c=>c.classList.remove('active'));
        tab.classList.add('active');
        document.getElementById(tab.dataset.pp)?.classList.add('active');
      };
    });
    // Blink max label
    document.getElementById('pp-blink-max').addEventListener('input',e=>{
      document.getElementById('pp-blink-max-val').textContent=parseFloat(e.target.value).toFixed(2);
    });
  }

  function _buildVoltGrid(){
    const grid = document.getElementById('pp-volt-grid');
    if(!grid) return;
    grid.innerHTML = '';
    const vc = PROJ.voltColors || {};
    // Show canonical label + one editable color per group
    const groups = [
      {label:'400 / 415 V', key:'400V'},
      {label:'230 / 240 V', key:'230V'},
      {label:'120 / 110 V', key:'120V'},
      {label:'48 V',        key:'48V'},
      {label:'24 V',        key:'24V'},
      {label:'12 V',        key:'12V'},
      {label:'5 V',         key:'5V'},
      {label:'3.3 V',       key:'3.3V'},
      {label:'GND / 0V',    key:'GND'},
      {label:'VCC',         key:'VCC'},
    ];
    const DEFAULTS = {
      '400V':'#ff6b35','230V':'#ffaa00','120V':'#ffcc44','48V':'#c8f560',
      '24V':'#4dd278','12V':'#3bffcc','5V':'#3bd4ff','3.3V':'#3b9eff',
      'GND':'#888888','VCC':'#f06dff'
    };
    groups.forEach(g=>{
      const row = document.createElement('div');
      row.className = 'pp-volt-row';
      const col = vc[g.key] || DEFAULTS[g.key] || '#888888';
      row.innerHTML = `<input type="color" class="pp-color" value="${col}" data-vkey="${g.key}"><span>${g.label}</span>`;
      grid.appendChild(row);
    });
  }

  function _updateNumPreview(){
    const el = document.getElementById('pp-num-preview');
    if(!el) return;
    const col = document.getElementById('pp-num-color')?.value || '#3b9eff';
    const bg  = document.getElementById('pp-num-bg')?.value   || '#0c0e16';
    const brd = document.getElementById('pp-num-brd')?.value  || '#3b9eff';
    const sz  = document.getElementById('pp-num-size')?.value || 9;
    const bold= document.getElementById('pp-num-bold')?.checked;
    el.style.cssText = `font-size:${sz}px;padding:2px 6px;border-radius:2px;border:1px solid ${brd};font-family:monospace;background:${bg};color:${col};font-weight:${bold?'bold':'normal'}`;
  }

  function _updateXrefPreview(){
    const el = document.getElementById('pp-xref-preview');
    if(!el) return;
    const sz = document.getElementById('pp-xref-size')?.value || 6;
    el.style.fontSize = sz+'px';
  }

  function _ppNamePreview(){
    const useFolio = document.getElementById('pp-name-use-folio')?.checked;
    const useType  = document.getElementById('pp-name-use-type')?.checked;
    const useInst  = document.getElementById('pp-name-use-inst')?.checked;
    const sep      = document.getElementById('pp-name-folio-sep')?.value || '';
    const digits   = Math.max(1,Math.min(4,parseInt(document.getElementById('pp-name-digits')?.value)||2));
    const suffix   = document.getElementById('pp-name-suffix')?.value || '';
    const f  = useFolio ? String(folio.num||1) : '';
    const t  = useType  ? 'Q' : '';
    const n  = useInst  ? String(3).padStart(digits,'0') : '';
    const el = document.getElementById('pp-name-preview');
    if(el) el.textContent = `${f}${sep}${t}${n}${suffix}` || '(vide)';
  }

  function _initPpNaming(){
    // Charger les valeurs depuis PROJ
    const onCk = document.getElementById('pp-autoname-on');
    if(onCk){
      onCk.checked = !!PROJ.autoName;
      const detail = document.getElementById('pp-naming-detail');
      if(detail) detail.style.display = onCk.checked ? 'block' : 'none';
      onCk.onchange = () => {
        if(detail) detail.style.display = onCk.checked ? 'block' : 'none';
      };
    }
    const setVal = (id, v) => { const el=document.getElementById(id); if(el) el.value = v; };
    const setChk = (id, v) => { const el=document.getElementById(id); if(el) el.checked = !!v; };
    setChk('pp-name-use-folio', PROJ.nameUseFolio !== false);
    setVal('pp-name-folio-sep', PROJ.nameFolioSep || '');
    setChk('pp-name-use-type',  PROJ.nameUseType  !== false);
    setChk('pp-name-use-inst',  PROJ.nameUseInst  !== false);
    setVal('pp-name-digits',    PROJ.nameDigits   || 2);
    setVal('pp-name-suffix',    PROJ.nameSuffix   || '');
    const scope = PROJ.nameScope || 'folio';
    const radio = document.querySelector(`input[name="pp-name-scope"][value="${scope}"]`);
    if(radio) radio.checked = true;
    _ppNamePreview();
    // Bind live preview
    ['pp-name-use-folio','pp-name-folio-sep','pp-name-use-type','pp-name-use-inst',
     'pp-name-digits','pp-name-suffix'].forEach(id=>{
      const el=document.getElementById(id);
      if(el){ el.removeEventListener('input',_ppNamePreview); el.removeEventListener('change',_ppNamePreview);
              el.addEventListener('input',_ppNamePreview); el.addEventListener('change',_ppNamePreview); }
    });
    document.querySelectorAll('input[name="pp-name-scope"]').forEach(r=>{
      r.removeEventListener('change',_ppNamePreview); r.addEventListener('change',_ppNamePreview);
    });
    // Réassigner
    const reassign = document.getElementById('pp-reassign-refs');
    if(reassign) reassign.onclick = async () => {
      if(!await showConfirm('Réassigner les références de tous les symboles du folio courant ?\nLes références existantes seront écrasées.')) return;
      PROJ._nameCounters = {};
      state.elements.forEach(el=>{
        const sym=_symbols[el.symId]; if(!sym) return;
        el.label = _generateRef(sym);
      });
      render(); updateProps(); setStatus('✓ Références réassignées');
    };
  }

  function _saveProjProps(){
    PROJ.wireColor        = document.getElementById('pp-wire-color').value;
    PROJ.wireWidth        = parseFloat(document.getElementById('pp-wire-width').value)||1.8;
    PROJ.busColor         = document.getElementById('pp-bus-color').value;
    PROJ.busWidth         = parseFloat(document.getElementById('pp-bus-width').value)||1.8;
    PROJ.junctionColor    = document.getElementById('pp-junc-color').value;
    PROJ.junctionRadius   = parseInt(document.getElementById('pp-junc-r').value)||4;
    PROJ.textColor        = document.getElementById('pp-text-color').value;
    PROJ.textSize         = parseInt(document.getElementById('pp-text-size').value)||13;
    PROJ.numShow          = document.getElementById('pp-num-show').checked;
    PROJ.numBold          = document.getElementById('pp-num-bold').checked;
    PROJ.numColor         = document.getElementById('pp-num-color').value;
    PROJ.numSize          = parseInt(document.getElementById('pp-num-size').value)||9;
    PROJ.numBgColor       = document.getElementById('pp-num-bg').value;
    PROJ.numBorderColor   = document.getElementById('pp-num-brd').value;
    PROJ.xrefSize         = parseInt(document.getElementById('pp-xref-size').value)||6;
    PROJ.symColor         = document.getElementById('pp-sym-color').value;
    PROJ.labelColor       = document.getElementById('pp-label-color').value;
    PROJ.refColor         = document.getElementById('pp-ref-color').value;
        PROJ.fieldColor       = document.getElementById('pp-field-color').value;

    PROJ.conflictBlink    = document.getElementById('pp-blink').checked;
    PROJ.conflictAlphaMax = parseFloat(document.getElementById('pp-blink-max').value)||0.4;
    // Tensions custom colors
    document.querySelectorAll('#pp-volt-grid [data-vkey]').forEach(inp=>{
      PROJ.voltColors[inp.dataset.vkey] = inp.value;
      // Sync aliases (400V ↔ 415V etc.)
      const ALIASES = {'400V':'415V','230V':'240V','120V':'110V','0V':'GND','GND':'0V'};
      if(ALIASES[inp.dataset.vkey]) PROJ.voltColors[ALIASES[inp.dataset.vkey]] = inp.value;
    });
    // Nommage
    PROJ.autoName      = document.getElementById('pp-autoname-on')?.checked || false;
    PROJ.nameUseFolio  = document.getElementById('pp-name-use-folio')?.checked !== false;
    PROJ.nameFolioSep  = document.getElementById('pp-name-folio-sep')?.value || '';
    PROJ.nameUseType   = document.getElementById('pp-name-use-type')?.checked !== false;
    PROJ.nameUseInst   = document.getElementById('pp-name-use-inst')?.checked !== false;
    PROJ.nameDigits    = parseInt(document.getElementById('pp-name-digits')?.value)||2;
    PROJ.nameSuffix    = document.getElementById('pp-name-suffix')?.value || '';
    PROJ.nameScope     = document.querySelector('input[name="pp-name-scope"]:checked')?.value || 'folio';
    PROJ._nameCounters = {};
    window._PROJ = PROJ;
    closeModal('modal-proj-props');
    markVoltageDirty();
    render();
    saveUserSettings();
    // Sauvegarder aussi dans le projet courant si actif
    if(currentProject?.id){
      const rules={useFolio:PROJ.nameUseFolio,folioSep:PROJ.nameFolioSep,useType:PROJ.nameUseType,
        useInst:PROJ.nameUseInst,digits:PROJ.nameDigits,suffix:PROJ.nameSuffix,scope:PROJ.nameScope};
      fetch(`/api/projects/${currentProject.id}`,{method:'PUT',credentials:'include',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({settings:{...(currentProject.settings||{}),autoName:PROJ.autoName,nameRules:rules}})
      }).catch(()=>{});
    }
    setStatus('Propriétés du dessin enregistrées');
  }

  async function _resetProjProps(){
    if(!await showConfirm('Réinitialiser toutes les propriétés aux valeurs par défaut ?')) return;
    PROJ.wireColor='#3b9eff';PROJ.wireWidth=1.8;PROJ.busColor='#3b9eff';PROJ.busWidth=1.8;
    PROJ.junctionColor='#3b9eff';PROJ.junctionRadius=4;PROJ.textColor='#dde1ed';PROJ.textSize=13;
    PROJ.numColor='#3b9eff';PROJ.numBgColor='rgba(12,14,22,.92)';PROJ.numBorderColor='rgba(59,158,255,.35)';
    PROJ.numSize=9;PROJ.numBold=false;PROJ.numShow=true;PROJ.xrefSize=6;
    PROJ.symColor='#3b9eff';PROJ.labelColor='#dde1ed';PROJ.refColor='#4dd278';PROJ.fieldColor='#6b7494';
    PROJ.labelOffY=-18;PROJ.refOffY=10;PROJ.conflictAlphaMax=0.4;PROJ.conflictBlink=true;
    PROJ.voltColors={'400V':'#ff6b35','415V':'#ff6b35','230V':'#ffaa00','240V':'#ffaa00',
      '120V':'#ffcc44','110V':'#ffcc44','48V':'#c8f560','24V':'#4dd278',
      '12V':'#3bffcc','5V':'#3bd4ff','3.3V':'#3b9eff','0V':'#888888','GND':'#888888','VCC':'#f06dff'};
    window._PROJ = PROJ;
    closeModal('modal-proj-props');
    markVoltageDirty();render();saveUserSettings();setStatus('Propriétés réinitialisées');
  }

  function _rgbaToHex(rgba){
    // Extract first solid hex-like value from 'rgba(r,g,b,a)' or '#hex'
    if(!rgba) return '#000000';
    if(rgba.startsWith('#')) return rgba.slice(0,7);
    const m = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if(!m) return '#000000';
    return '#'+[m[1],m[2],m[3]].map(x=>parseInt(x).toString(16).padStart(2,'0')).join('');
  }


  // ── Nommage automatique des références ──────────────────────────────
  function _generateRef(sym) {
    const objType = (sym?.objType||'').trim().toUpperCase() || '?';
    const folioKey = PROJ.nameScope === 'global' ? 'global' : `f${folio.num}`;
    const counterKey = `${folioKey}:${objType}`;
    const count = (PROJ._nameCounters[counterKey] || 0) + 1;
    PROJ._nameCounters[counterKey] = count;
    const digits = Math.max(1, Math.min(4, PROJ.nameDigits || 2));
    const instStr = PROJ.nameUseInst ? String(count).padStart(digits, '0') : '';
    const typeStr = PROJ.nameUseType ? objType : '';
    const folioStr = PROJ.nameUseFolio ? String(folio.num) : '';
    const sep = PROJ.nameFolioSep || '';
    const suffix = PROJ.nameSuffix || '';
    return `${folioStr}${sep}${typeStr}${instStr}${suffix}`;
  }

  function _buildNamePreview() {
    const useFolio = document.getElementById('ps-name-use-folio')?.checked;
    const useType  = document.getElementById('ps-name-use-type')?.checked;
    const useInst  = document.getElementById('ps-name-use-inst')?.checked;
    const sep      = document.getElementById('ps-name-folio-sep')?.value || '';
    const digits   = Math.max(1,Math.min(4,parseInt(document.getElementById('ps-name-digits')?.value)||2));
    const suffix   = document.getElementById('ps-name-suffix')?.value || '';
    const scope    = document.querySelector('input[name="ps-name-scope"]:checked')?.value || 'folio';
    const f = useFolio ? String(folio.num||1) : '';
    const t = useType  ? 'Q' : '';
    const n = useInst  ? String(3).padStart(digits,'0') : '';
    document.getElementById('ps-name-preview').textContent = `${f}${sep}${t}${n}${suffix}` || '(vide)';
  }

  function _openNamingTab(p) {
    const s = p.settings || {};
    const nr = s.nameRules || {};
    document.getElementById('ps-autoname-on').checked      = !!s.autoName;
    document.getElementById('ps-name-use-folio').checked   = nr.useFolio  !== false;
    document.getElementById('ps-name-folio-sep').value     = nr.folioSep  || '';
    document.getElementById('ps-name-use-type').checked    = nr.useType   !== false;
    document.getElementById('ps-name-use-inst').checked    = nr.useInst   !== false;
    document.getElementById('ps-name-digits').value        = nr.digits    || 2;
    document.getElementById('ps-name-suffix').value        = nr.suffix    || '';
    const scope = nr.scope || 'folio';
    const radio = document.querySelector(`input[name="ps-name-scope"][value="${scope}"]`);
    if(radio) radio.checked = true;
    _buildNamePreview();
    // Live preview bindings
    ['ps-name-use-folio','ps-name-folio-sep','ps-name-use-type','ps-name-use-inst',
     'ps-name-digits','ps-name-suffix'].forEach(id=>{
      const el=document.getElementById(id);
      if(el){el.removeEventListener('input',_buildNamePreview);el.removeEventListener('change',_buildNamePreview);
             el.addEventListener('input',_buildNamePreview);el.addEventListener('change',_buildNamePreview);}
    });
    document.querySelectorAll('input[name="ps-name-scope"]').forEach(r=>{
      r.removeEventListener('change',_buildNamePreview);r.addEventListener('change',_buildNamePreview);
    });
    // Save button
    document.getElementById('ps-save-naming').onclick = async () => {
      const rules = {
        useFolio:  document.getElementById('ps-name-use-folio').checked,
        folioSep:  document.getElementById('ps-name-folio-sep').value,
        useType:   document.getElementById('ps-name-use-type').checked,
        useInst:   document.getElementById('ps-name-use-inst').checked,
        digits:    parseInt(document.getElementById('ps-name-digits').value)||2,
        suffix:    document.getElementById('ps-name-suffix').value,
        scope:     document.querySelector('input[name="ps-name-scope"]:checked')?.value||'folio',
      };
      const autoName = document.getElementById('ps-autoname-on').checked;
      const existSettings = (await (await fetch(`/api/projects/${p.id}`,{credentials:'include'})).json()).settings||{};
      await fetch(`/api/projects/${p.id}`,{method:'PUT',credentials:'include',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({settings:{...existSettings, autoName, nameRules:rules}})});
      // Apply to PROJ
      Object.assign(PROJ,{autoName,nameUseFolio:rules.useFolio,nameFolioSep:rules.folioSep,
        nameUseType:rules.useType,nameUseInst:rules.useInst,nameDigits:rules.digits,
        nameSuffix:rules.suffix,nameScope:rules.scope});
      window._PROJ = PROJ;
      setStatus('✓ Règles de nommage sauvegardées');
    };
    // Reassign button
    document.getElementById('ps-reassign-refs').onclick = async () => {
      if(!await showConfirm(`Réassigner les références de tous les symboles du folio courant selon les règles actuelles ?\nLes références existantes seront écrasées.`)) return;
      PROJ._nameCounters = {};
      state.elements.forEach(el=>{
        const sym=_symbols[el.symId];if(!sym)return;
        if(PROJ.autoName) el.label=_generateRef(sym);
      });
      render();updateProps();setStatus('✓ Références réassignées');
    };
  }


  function bindModals(){
    document.querySelectorAll('[data-modal]').forEach(btn=>btn.addEventListener('click',()=>closeModal(btn.dataset.modal)));
    document.getElementById('pp-save-btn')?.addEventListener('click', _saveProjProps);
    document.getElementById('pp-reset-btn')?.addEventListener('click', _resetProjProps);
    document.querySelectorAll('.admin-tab').forEach(tab=>tab.addEventListener('click',()=>{
      if(tab.dataset.tab==='tab-clients') refreshClients();
    }));
    // ── Boutons nouveau client ────────────────────────────────────────────
    document.getElementById('btn-new-client')?.addEventListener('click',()=>{
      const f=document.getElementById('new-client-form');
      if(f){ f.style.display=f.style.display==='none'?'flex':'none'; }
    });
    document.getElementById('nc-cancel')?.addEventListener('click',()=>{
      const f=document.getElementById('new-client-form');
      if(f)f.style.display='none';
    });
    document.getElementById('nc-save')?.addEventListener('click',async()=>{
      const name=document.getElementById('nc-name').value.trim();
      const slug=document.getElementById('nc-slug').value.trim();
      const plan=document.getElementById('nc-plan').value;
      if(!name){setStatus('Nom client requis');return;}
      const plans={starter:{maxUsers:5,maxProjects:20},pro:{maxUsers:20,maxProjects:100},enterprise:{maxUsers:100,maxProjects:500}};
      try{
        const res=await fetch('/api/clients',{method:'POST',credentials:'include',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({name,slug:slug||name.toLowerCase().replace(/\s+/g,'_'),plan,settings:plans[plan]||plans.pro})});
        const data=await res.json();
        if(!res.ok)throw new Error(data.error);
        document.getElementById('new-client-form').style.display='none';
        ['nc-name','nc-slug'].forEach(id=>{const el=document.getElementById(id);if(el)el.value='';});
        refreshClients();setStatus('✓ Client créé : '+name);
      }catch(e){setStatus('✕ '+e.message);}
    });

    // ── Bouton retour liste clients ────────────────────────────────────────
    document.getElementById('btn-back-clients')?.addEventListener('click',()=>{
      document.getElementById('client-detail-view').style.display='none';
      document.getElementById('clients-list-view').style.display='flex';
      refreshClients();
    });

    // ── Sous-onglets client detail ────────────────────────────────────────
    document.querySelectorAll('.cd-tab').forEach(tab=>{
      tab.addEventListener('click',()=>_switchCdTab(tab.dataset.cd));
    });

    // ── Sauvegarder infos client ──────────────────────────────────────────
    document.getElementById('cd-save-btn')?.addEventListener('click',async()=>{
      if(!_currentClientId)return;
      const name=document.getElementById('cd-name').value.trim();
      const slug=document.getElementById('cd-slug').value.trim();
      const plan=document.getElementById('cd-plan').value;
      const active=document.getElementById('cd-active').value==='true';
      const maxUsers=parseInt(document.getElementById('cd-maxusers').value)||20;
      const maxProjects=parseInt(document.getElementById('cd-maxprojects').value)||100;
      try{
        const res=await fetch(`/api/clients/${_currentClientId}`,{method:'PUT',credentials:'include',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({name,slug,plan,active,settings:{maxUsers,maxProjects}})});
        const data=await res.json();
        if(!res.ok)throw new Error(data.error);
        document.getElementById('client-detail-name').textContent=name;
        setStatus('✓ Client mis à jour');
        refreshClients();
      }catch(e){setStatus('✕ '+e.message);}
    });

    // ── Désactiver client ────────────────────────────────────────────────
    document.getElementById('cd-delete-btn')?.addEventListener('click',async()=>{
      if(!_currentClientId)return;
      const name=document.getElementById('cd-name').value;
      if(!await showConfirm(`Désactiver le client "${name}" ? Les données sont conservées.`))return;
      await fetch(`/api/clients/${_currentClientId}`,{method:'DELETE',credentials:'include'});
      document.getElementById('client-detail-view').style.display='none';
      document.getElementById('clients-list-view').style.display='flex';
      refreshClients();setStatus('Client désactivé');
    });

    // ── Ajouter utilisateur au client ─────────────────────────────────────
    document.getElementById('cd-add-user-btn')?.addEventListener('click',()=>{
      const f=document.getElementById('cd-add-user-form');
      if(f)f.style.display=f.style.display==='none'?'block':'none';
    });
    document.getElementById('cd-user-add-confirm')?.addEventListener('click',async()=>{
      if(!_currentClientId)return;
      const login=document.getElementById('cd-user-login').value.trim();
      const role=document.getElementById('cd-user-role').value;
      if(!login){setStatus('Login requis');return;}
      try{
        const res=await fetch(`/api/clients/${_currentClientId}/users`,{method:'POST',credentials:'include',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({login,role})});
        const data=await res.json();
        if(!res.ok)throw new Error(data.error);
        document.getElementById('cd-user-login').value='';
        document.getElementById('cd-add-user-form').style.display='none';
        await loadClientUsers(_currentClientId);
        setStatus(data.action==='created'?'✓ Utilisateur créé et ajouté':'✓ Utilisateur ajouté au client');
      }catch(e){setStatus('✕ '+e.message);}
    });

    // ── Créer bibliothèque client ─────────────────────────────────────────
    document.getElementById('cd-new-lib-btn')?.addEventListener('click',async()=>{
      if(!_currentClientId)return;
      const name=prompt('Nom de la bibliothèque :');
      if(!name)return;
      try{
        const res=await fetch('/api/libraries',{method:'POST',credentials:'include',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({name,symbolIds:[]})});
        const data=await res.json();
        if(!res.ok)throw new Error(data.error);
        await loadClientLibs(_currentClientId);
        setStatus('✓ Bibliothèque créée : '+name);
      }catch(e){setStatus('✕ '+e.message);}
    });
    document.querySelectorAll('.admin-tab').forEach(tab=>tab.addEventListener('click',()=>{
      document.querySelectorAll('.admin-tab').forEach(t=>t.classList.remove('active'));
      document.querySelectorAll('.admin-tab-content').forEach(c=>c.classList.add('hidden'));
      tab.classList.add('active');document.getElementById(tab.dataset.tab).classList.remove('hidden');
      if(tab.dataset.tab==='tab-symbols'){ if(!_admsymTabInited){initAdmsymTab();_admsymTabInited=true;}else buildAdmsymGrid(); }
      if(tab.dataset.tab==='tab-polarities'){ loadPolarities(); }
      if(tab.dataset.tab==='tab-users'){
        document.getElementById('user-detail-view').style.display='none';
        document.getElementById('users-list-view').style.display='flex';
        _currentEditUserId=null;
        refreshUsers();
      }
    }));
    // Tabs modal-project-settings
    document.querySelectorAll('[data-ps-tab]').forEach(tab=>tab.addEventListener('click',()=>{
      document.querySelectorAll('[data-ps-tab]').forEach(t=>t.classList.remove('active'));
      document.querySelectorAll('.ps-tab-content').forEach(c=>{c.classList.remove('active');c.style.display='none';});
      tab.classList.add('active');
      const content=document.getElementById('pst-'+tab.dataset.psTab);
      if(content){content.style.display='block';content.classList.add('active');}
    }));
    // Création projet
    document.getElementById('btn-create-project')?.addEventListener('click',()=>{
      const form=document.getElementById('new-project-form');
      form.style.display=form.style.display==='none'?'block':'none';
      if(form.style.display!=='none'){
        document.getElementById('np-name').focus();
        document.getElementById('np-date').value=new Date().toISOString().slice(0,10);
      }
    });
    document.getElementById('np-cancel-btn')?.addEventListener('click',()=>{
      document.getElementById('new-project-form').style.display='none';
    });
    document.getElementById('np-create-btn')?.addEventListener('click',async()=>{
      const name=document.getElementById('np-name').value.trim();
      if(!name){showWarning('Le nom est requis');return;}
      const settings={company:document.getElementById('np-company').value,client:document.getElementById('np-client').value,
        affaire:document.getElementById('np-affaire').value,rev:document.getElementById('np-rev').value,
        author:document.getElementById('np-author').value,date:document.getElementById('np-date').value,
        wireAuto:true,wireStep:1,printZone:{x:0,y:0,w:1587,h:915,format:'A3L',show:true}};
      try{
        const res=await fetch('/api/projects',{method:'POST',credentials:'include',
          headers:{'Content-Type':'application/json'},body:JSON.stringify({name,description:document.getElementById('np-desc').value.trim(),settings})});
        if(!res.ok)throw new Error((await res.json()).error||'Erreur');
        document.getElementById('new-project-form').style.display='none';
        document.getElementById('np-name').value='';document.getElementById('np-desc').value='';
        await loadProjects();setStatus('✓ Projet "'+name+'" créé');
      }catch(e){showWarning('Erreur: '+e.message);}
    });
    // Bouton "Ajouter folio" dans la folio-nav sidebar
    document.getElementById('folio-nav-add')?.addEventListener('click',addFolioToProject);
    document.getElementById('folio-nav-back')?.addEventListener('click',_folioBack);
    document.getElementById('folio-nav-fwd')?.addEventListener('click',_folioForward);
    _bindNewFolioModal();
    _bindBomButtons();
    document.getElementById('ctx-menu')?.addEventListener('click',e=>{
      const action=e.target.dataset.action;
      if(action==='edit-sym'){
        hideCtx();
        const selObj=getSel();
        if(selObj&&selected.type==='element'){
          const sym=_symbols[selObj.symId];
          if(sym) SymbolEditor.open(sym,async()=>{await reloadSymbols(true);buildLibrary();render();},_symbols);
        }
      }
    });
    document.querySelectorAll('[data-action]').forEach(item=>item.addEventListener('click',()=>{
      const a=item.dataset.action;
      if(a==='rotate')rotateSelected();
      else if(a==='flip-h')flipSelected();
      else if(a==='duplicate')dupSelected();
      else if(a==='delete')delSelected();
      else if(a==='wirenum')openWireNumsModal();
      else if(a==='merge'){mergeSelected();}
      else if(a==='merge-wires'){mergeWiresSelected();}
      else if(a==='unmerge'){unmergeSelected();}
      else if(a==='to-symbol'){selectionToSymbol();}
      else if(a==='save-func'){saveSelectionAsFunc();}
      else if(a==='share-schema'){if(schemaId)openShareModal(schemaId);else showWarning('Sauvegardez d\'abord.');}
      else if(a==='select-all-elements'){
        multiSel.clear();selected={type:null,id:null};
        state.elements.forEach(el=>multiSel.add(selKey('element',el.id)));
        if(state.elements.length)selected={type:'element',id:state.elements[state.elements.length-1].id};
        render();updateStatus();setStatus(`${multiSel.size} symbole(s) sélectionné(s)`);}
      else if(a==='select-all-wires'){
        multiSel.clear();selected={type:null,id:null};
        state.wires.forEach(w=>multiSel.add(selKey('wire',w.id)));
        if(state.wires.length)selected={type:'wire',id:state.wires[state.wires.length-1].id};
        render();updateStatus();setStatus(`${multiSel.size} fil(s) sélectionné(s)`);}
      else if(a==='select-all-texts'){
        multiSel.clear();selected={type:null,id:null};
        state.texts.forEach(t=>multiSel.add(selKey('text',t.id)));
        if(state.texts.length)selected={type:'text',id:state.texts[state.texts.length-1].id};
        render();updateStatus();setStatus(`${multiSel.size} texte(s) sélectionné(s)`);}
      hideCtx();updateProps();
    }));

    // Folio
    document.getElementById('folio-save-btn').addEventListener('click',()=>{
      folio.num=parseInt(document.getElementById('folio-num').value)||1;
      folio.wireStart=parseInt(document.getElementById('folio-wire-start').value)||1;
      folio.project=document.getElementById('cart-project').value;
      folio.title=document.getElementById('cart-title').value;
      folio.ref=document.getElementById('cart-ref').value;
      folio.rev=document.getElementById('cart-rev').value;
      folio.author=document.getElementById('cart-author').value;
      folio.checker=document.getElementById('cart-checker').value;
      folio.date=document.getElementById('cart-date').value;
      folio.company=document.getElementById('cart-company').value;
      folio.note=document.getElementById('cart-note').value;
      folio.cartoucheAlign=document.getElementById('folio-cart-align')?.value||'right';
      // Taille cartouche → mettre à jour le TB actif et la print zone
      const _newH=parseInt(document.getElementById('folio-cart-h')?.value)||55;
      const _newW=parseInt(document.getElementById('folio-cart-w')?.value)||420;
      const _activeTB=TitleBlock.getActiveTB();
      if(_activeTB){
        _activeTB.cartoucheH=_newH;
        _activeTB.cartoucheW=_newW;
        _activeTB.cells.forEach(c=>{if(c.id==='border'){c.w=_newW;c.h=_newH;}});
        TitleBlock.saveTB(folio.titleblockType||'default',_activeTB);
      }
      if(printZone.format) applyFormatToPrintZone(printZone.format,{cartoucheH:_newH});
      folio.wireCounter=folio.wireStart;
      // Appliquer le type de cartouche sélectionné
      const _tbType = document.getElementById('folio-tb-type')?.value || 'default';
      folio.titleblockType = _tbType;
      if(_tbType === 'cover') {
        // Utiliser le cartouche page de garde
        folio.titleblock = TitleBlock.getCoverTB() || null;
      } else if(_tbType === 'default') {
        // Utiliser le cartouche projet standard (effacer la surcharge)
        folio.titleblock = null;
      }
      // 'custom' : garder folio.titleblock existant (surcharge manuelle via éditeur)
      closeModal('modal-folio');
      saveSchema().catch(()=>{});
      // Mettre à jour le cache du folio courant (pour le badge nav)
      const _curFolioCache = projectFolios.find(f=>f.id===currentFolioId);
      if(_curFolioCache) {
        if(!_curFolioCache.data) _curFolioCache.data = {};
        if(!_curFolioCache.data.folio) _curFolioCache.data.folio = {};
        _curFolioCache.data.folio.titleblockType = _tbType;
        _curFolioCache.data.folio.cartoucheAlign = folio.cartoucheAlign || 'right';
        _curFolioCache.titleblockType = _tbType;
      }
      updateFolioNav();updateFolioOverlay();render();setStatus('Folio '+folio.num+' configuré');
      // Broadcaster le changement de cartouche aux autres users
      LiveSync.broadcast({ type:'titleblock_update', folioId:currentFolioId,
        titleblock:folio.titleblock, titleblockType:_tbType });
    });

    // Print zone
    document.getElementById('pz-save-btn').addEventListener('click',async()=>{
      const _pzFmt = document.getElementById('pz-format').value;
      // Recalculer depuis le format (source de vérité)
      applyFormatToPrintZone(_pzFmt);
      // Permettre l'override manuel de l'origine
      printZone.x=parseInt(document.getElementById('pz-x').value)||0;
      printZone.y=parseInt(document.getElementById('pz-y').value)||0;
      printZone.show=document.getElementById('pz-show').checked;
      printZone.withCartouche=document.getElementById('pz-cartouche').checked;
      printZone.blackAndWhite=document.getElementById('pz-bw').checked;
      closeModal('modal-printzone');render();
      await saveUserSettings();setStatus('Zone d\'impression sauvegardée dans votre profil');
    });
    document.getElementById('pz-auto-btn').addEventListener('click',()=>{
      let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
      state.elements.forEach(e=>{minX=Math.min(minX,e.x-20);minY=Math.min(minY,e.y-20);maxX=Math.max(maxX,e.x+e.w+20);maxY=Math.max(maxY,e.y+e.h+20);});
      state.wires.forEach(w=>w.points.forEach(p=>{minX=Math.min(minX,p.x-20);minY=Math.min(minY,p.y-20);maxX=Math.max(maxX,p.x+20);maxY=Math.max(maxY,p.y+20);}));
      if(minX===Infinity){minX=0;minY=0;maxX=1200;maxY=800;}
      document.getElementById('pz-x').value=Math.max(0,Math.floor(minX));
      document.getElementById('pz-y').value=Math.max(0,Math.floor(minY));
      document.getElementById('pz-w').value=Math.ceil(maxX-Math.max(0,minX));
      document.getElementById('pz-h').value=Math.ceil(maxY-Math.max(0,minY));
    });
    document.getElementById('pz-show').addEventListener('change',e=>{printZone.show=e.target.checked;render();});
    // Repère orthogonal
    document.getElementById('rg-show')?.addEventListener('change',e=>{
      refGrid.show=e.target.checked;
      const opts=document.getElementById('rg-options');if(opts)opts.style.display=e.target.checked?'flex':'none';
      render();
    });
    document.getElementById('rg-cols')?.addEventListener('change',e=>{refGrid.cols=Math.max(1,parseInt(e.target.value)||20);render();});
    document.getElementById('rg-rows')?.addEventListener('change',e=>{refGrid.rows=Math.max(1,Math.min(26,parseInt(e.target.value)||9));render();});
    document.getElementById('rg-thick')?.addEventListener('change',e=>{refGrid.thickness=Math.max(5,parseInt(e.target.value)||15);render();});

    // Grille
    document.getElementById('grid-save-btn')?.addEventListener('click',async()=>{
      GRID=parseInt(document.getElementById('grid-main').value)||20;
      gridSnap=document.getElementById('grid-snap').checked;
      gridVisible=document.getElementById('grid-visible').checked;
      snapLabels=document.getElementById('grid-snap-labels').checked;
      SymbolEditor.setGrid(parseInt(document.getElementById('grid-sym').value)||10);
      closeModal('modal-grid');render();await saveUserSettings();setStatus('Grille: '+GRID+'px sauvegardée');
    });

    // Wire nums
    document.getElementById('wn-save-btn').addEventListener('click',()=>{
      folio.num=parseInt(document.getElementById('wn-folio').value)||folio.num;
      folio.wireStart=parseInt(document.getElementById('wn-start').value)||1;
      folio.wireStep=parseInt(document.getElementById('wn-step').value)||1;
      folio.wireAuto=document.getElementById('wn-auto').checked;
      folio.wireCounter=folio.wireStart;
      closeModal('modal-wirenums');setStatus('Numérotation: folio '+folio.num+', départ '+folio.wireStart);
    });
    document.getElementById('wn-renumber-btn').addEventListener('click',async()=>{
      if(!await showConfirm('Renuméroter tous les fils ?'))return;
      folio.wireCounter=folio.wireStart;renumberWires();setStatus('Fils renumérotés');
    });
    ['wn-folio','wn-start','wn-step'].forEach(id=>document.getElementById(id)?.addEventListener('input',updateWireNumPreview));

    bindTodoInput();
  }

  function _updateFolioTbHint(val) {
    const hint = document.getElementById('folio-tb-hint');
    if(!hint) return;
    const msgs = {
      default: 'Le cartouche standard du projet (modifiable via Éditeur de cartouche → Standard).',
      cover:   'Le cartouche page de garde (modifiable via Éditeur de cartouche → Page de garde).',
      custom:  "Ce folio a sa propre surcharge. Utiliser l'éditeur de cartouche → Ce folio."
    };
    hint.textContent = msgs[val] || '';
  }

  function openModal(id){document.getElementById(id).classList.remove('hidden');}
  function closeModal(id){document.getElementById(id).classList.add('hidden');}

  function openFolioModal(){
    ['folio-num','folio-wire-start'].forEach((id,i)=>document.getElementById(id).value=[folio.num,folio.wireStart][i]);
    ['cart-project','cart-title','cart-ref','cart-rev','cart-author','cart-checker','cart-date','cart-company','cart-note'].forEach((id,i)=>{
      document.getElementById(id).value=[folio.project,folio.title,folio.ref,folio.rev,folio.author,folio.checker,folio.date,folio.company,folio.note][i];
    });
    // Taille & position cartouche
    const _activeTB = TitleBlock.getActiveTB();
    const _tbFmt = TitleBlock.FORMATS[(_activeTB&&_activeTB.format)||'A3L']||{w:420,h:297};
    document.getElementById('folio-cart-h').value = (_activeTB&&_activeTB.cartoucheH)||55;
    document.getElementById('folio-cart-w').value = (_activeTB&&_activeTB.cartoucheW)||_tbFmt.w;
    const _cartAlignSel = document.getElementById('folio-cart-align');
    if(_cartAlignSel) _cartAlignSel.value = folio.cartoucheAlign || 'right';
    // Charger le type de cartouche du folio
    const tbSel = document.getElementById('folio-tb-type');
    if(tbSel) {
      tbSel.value = folio.titleblockType || 'default';
      _updateFolioTbHint(tbSel.value);
      tbSel.onchange = e => _updateFolioTbHint(e.target.value);
    }
    // Bouton "Éditer…" — ouvre l'éditeur cartouche sur le bon type
    const _tbEditBtn = document.getElementById('folio-tb-edit-btn');
    if(_tbEditBtn) {
      _tbEditBtn.onclick = () => {
        const selVal = document.getElementById('folio-tb-type')?.value || 'default';
        closeModal('modal-folio');
        enterCartoucheEdit(selVal);
      };
    }
    openModal('modal-folio');
  }
  const _PZ_FORMATS = {
    A4P:{w:210,h:297}, A4L:{w:297,h:210},
    A3P:{w:297,h:420}, A3L:{w:420,h:297},
    A2P:{w:420,h:594}, A2L:{w:594,h:420},
    A1P:{w:594,h:841}, A1L:{w:841,h:594},
    A0P:{w:841,h:1189},A0L:{w:1189,h:841},
  };
  const _PZ_MM = 3.7795275591;

  function _pzUpdateFromFormat(fmtKey) {
    const fmt = _PZ_FORMATS[fmtKey];
    if (!fmt) return;
    const tbData = TitleBlock.getActiveTB();
    const cartH  = (tbData && !tbData.isCover) ? (tbData.cartoucheH||55) : 0;
    const zoneH  = fmt.h - cartH;
    document.getElementById('pz-w').value = Math.round(fmt.w  * _PZ_MM);
    document.getElementById('pz-h').value = Math.round(zoneH  * _PZ_MM);
    const info = document.getElementById('pz-format-info');
    if (info) info.textContent =
      `Zone dessin : ${fmt.w} × ${zoneH} mm` +
      (cartH ? ` + cartouche ${cartH} mm = page ${fmt.w} × ${fmt.h} mm` : '');
  }

  function openPrintZoneModal(){
    document.getElementById('pz-x').value=printZone.x;
    document.getElementById('pz-y').value=printZone.y;
    document.getElementById('pz-w').value=printZone.w;
    document.getElementById('pz-h').value=printZone.h;
    document.getElementById('pz-format').value=printZone.format||'A3L';
    document.getElementById('pz-show').checked=printZone.show;
    document.getElementById('pz-cartouche').checked=printZone.withCartouche!==false;
    document.getElementById('pz-bw').checked=printZone.blackAndWhite===true;
    // Repère orthogonal
    const _rgShow=document.getElementById('rg-show');
    if(_rgShow){_rgShow.checked=refGrid.show; document.getElementById('rg-options').style.display=refGrid.show?'flex':'none';}
    const _rgC=document.getElementById('rg-cols');if(_rgC)_rgC.value=refGrid.cols||20;
    const _rgR=document.getElementById('rg-rows');if(_rgR)_rgR.value=refGrid.rows||9;
    const _rgT=document.getElementById('rg-thick');if(_rgT)_rgT.value=refGrid.thickness||15;
    // Mettre à jour l'info selon le format courant
    _pzUpdateFromFormat(printZone.format||'A3L');
    // Listener sur le sélecteur de format
    const sel = document.getElementById('pz-format');
    sel.onchange = (e) => _pzUpdateFromFormat(e.target.value);
    openModal('modal-printzone');
  }
  function openWireNumsModal(){
    document.getElementById('wn-folio').value=folio.num;
    document.getElementById('wn-start').value=folio.wireStart;
    document.getElementById('wn-step').value=folio.wireStep||1;
    document.getElementById('wn-auto').checked=folio.wireAuto;
    updateWireNumPreview();openModal('modal-wirenums');
  }

  // ─────────────────────────────────────────────────────────
  // GESTION DE PROJET
  // ─────────────────────────────────────────────────────────

  // Barre de navigation folios (panneau gauche dans un projet)
  // ── Miniatures de folio ───────────────────────────────────────────────
  const _folioThumbCache={};
  let _thumbPop=null,_thumbTimer=null;

  function _getThumbPop(){
    if(!_thumbPop){
      _thumbPop=document.createElement('div');
      _thumbPop.id='folio-thumb-pop';
      document.body.appendChild(_thumbPop);
    }
    return _thumbPop;
  }

  async function _showFolioThumb(item,folioId,folioName){
    clearTimeout(_thumbTimer);
    _thumbTimer=setTimeout(async()=>{
      const pop=_getThumbPop();
      const rect=item.getBoundingClientRect();
      const top=Math.min(rect.top,window.innerHeight-220);
      pop.style.left=(rect.right+8)+'px';
      pop.style.top=top+'px';
      pop.classList.add('visible');

      // Le folio actif n'est jamais mis en cache (contenu peut avoir changé)
      if(_folioThumbCache[folioId]&&folioId!==currentFolioId){
        pop.innerHTML=_folioThumbCache[folioId];return;
      }

      pop.innerHTML=`<div class="ftp-loading">⋯</div>`;

      try{
        let st;
        if(folioId===currentFolioId){
          st=state; // utiliser l'état courant en mémoire
        }else{
          const res=await fetch(`/api/folios/${folioId}`,{credentials:'include'});
          if(!res.ok)throw new Error();
          const folio=await res.json();
          st=folio.data||{};
        }
        const bb=_folioDataBounds(st);
        const M=15;
        const pz={x:bb.minX-M,y:bb.minY-M,
          w:Math.max(bb.maxX-bb.minX+M*2,80),h:Math.max(bb.maxY-bb.minY+M*2,60),
          withCartouche:false,blackAndWhite:false,bgColor:'#0c0e14'};
        let{svg}=_buildFolioSVG(st,_symbols,pz,null);
        svg=svg.replace('<svg ','<svg style="width:100%;height:auto;display:block" ');
        const label=`<div class="ftp-label">${esc(folioName||'')}</div>`;
        const html=svg+label;
        if(folioId!==currentFolioId)_folioThumbCache[folioId]=html;
        if(pop.classList.contains('visible'))pop.innerHTML=html;
      }catch(e){
        if(pop.classList.contains('visible'))pop.innerHTML='<div class="ftp-loading">—</div>';
      }
    },180);
  }

  function _hideFolioThumb(){
    clearTimeout(_thumbTimer);
    if(_thumbPop)_thumbPop.classList.remove('visible');
  }

  // Invalide le cache d'un folio (appelé après sauvegarde)
  function _invalidateThumb(folioId){delete _folioThumbCache[folioId||currentFolioId];}

  function updateFolioNav(){
    const nav=document.getElementById('folio-nav');
    if(!nav)return;
    if(!currentProject||!projectFolios.length){nav.style.display='none';return;}
    nav.style.display='flex';
    const list=document.getElementById('folio-nav-list');
    if(!list)return;
    list.innerHTML='';
    projectFolios.forEach(f=>{
      const item=document.createElement('div');
      item.className='folio-nav-item'+(f.id===currentFolioId?' active':'');
      item.dataset.id=f.id;
      const _tbTypeF = f.data?.folio?.titleblockType || f.titleblockType || 'default';
      const isBomF = f.data?.folio_type==='bom'||f.folio_type==='bom';
      const isSumF = f.data?.folio_type==='summary'||f.folio_type==='summary';
      const isBornF = f.data?.folio_type==='bornier'||f.folio_type==='bornier';
      const isImplF = f.data?.folio_type==='implantation'||f.folio_type==='implantation';
      const _tbBadge = isSumF ? '☰' : isBomF ? '⊞' : isBornF ? '⊟' : isImplF ? '⬒' : {cover:'🏠', custom:'✏️', default:''}[_tbTypeF] || '';
      const _typeTip = isSumF ? 'Sommaire' : isBomF ? 'Nomenclature' : isBornF ? 'Bornier' : isImplF ? 'Implantation' : {cover:'Page de garde', custom:'Cartouche personnalisé', default:'Cartouche standard'}[_tbTypeF];
      item.innerHTML=`<span class="fni-num">${f.folio_num||'?'}</span><span class="fni-name">${esc(f.name)}</span>${_tbBadge?`<span class="fni-tb-badge" title="${_typeTip}" style="font-size:9px;margin-left:3px;flex-shrink:0;opacity:.8">${_tbBadge}</span>`:''}`;
      item.title=`Folio ${f.folio_num} — ${f.name}${_typeTip?' ('+_typeTip+')':''}`;
      item.addEventListener('click',()=>{if(f.id!==currentFolioId){saveSchema().then(()=>openFolio(f.id));}});
      item.addEventListener('mouseenter',()=>_showFolioThumb(item,f.id,f.name));
      item.addEventListener('mouseleave',_hideFolioThumb);
      if(isBomF){const ic=document.createElement('span');ic.textContent='⊞';ic.style.cssText='font-size:9px;margin-left:4px;opacity:.7;flex-shrink:0';item.appendChild(ic);}
      // ── Drag & drop réordonnancement ──────────────────────
      if(!isReadOnly){
        item.draggable=true;
        item.addEventListener('dragstart',e=>{
          e.dataTransfer.effectAllowed='move';
          e.dataTransfer.setData('folio-id',f.id);
          item.classList.add('dragging');
        });
        item.addEventListener('dragend',()=>item.classList.remove('dragging'));
        item.addEventListener('dragover',e=>{
          e.preventDefault();e.dataTransfer.dropEffect='move';
          list.querySelectorAll('.folio-nav-item').forEach(el=>el.classList.remove('drag-over'));
          item.classList.add('drag-over');
        });
        item.addEventListener('dragleave',()=>item.classList.remove('drag-over'));
        item.addEventListener('drop',async e=>{
          e.preventDefault();
          item.classList.remove('drag-over');
          const srcId=e.dataTransfer.getData('folio-id');
          if(!srcId||srcId===f.id)return;
          const srcIdx=projectFolios.findIndex(x=>x.id===srcId);
          const tgtIdx=projectFolios.findIndex(x=>x.id===f.id);
          if(srcIdx<0||tgtIdx<0)return;
          // Réordonner localement
          const moved=projectFolios.splice(srcIdx,1)[0];
          projectFolios.splice(tgtIdx,0,moved);
          // Réassigner uniquement folio_order — conserver les numéros (y compris les sous-numéros 1.1, 1.2…)
          projectFolios.forEach((pf,i)=>{pf.folio_order=i;});
          updateFolioNav();
          // Persister
          try{
            await fetch(`/api/projects/${currentProject.id}/order`,{
              method:'PUT',credentials:'include',
              headers:{'Content-Type':'application/json'},
              body:JSON.stringify({order:projectFolios.map(pf=>({id:pf.id,folio_order:pf.folio_order,folio_num:pf.folio_num}))})
            });
            setStatus('Folios réordonnés');
          }catch(_){setStatus('⚠ Erreur lors de la sauvegarde de l\'ordre');}
        });
      }
      list.appendChild(item);
    });
    // Bouton ajouter folio (si non lecture seule)
    const addBtn=document.getElementById('folio-nav-add');
    if(addBtn)addBtn.style.display=isReadOnly?'none':'';
    // Nom projet
    const pname=document.getElementById('folio-nav-project');
    if(pname)pname.textContent=currentProject.name||'Projet';
  }

  function _updateFolioNavBtns(){
    const back=document.getElementById('folio-nav-back');
    const fwd=document.getElementById('folio-nav-fwd');
    if(back){back.disabled=_folioHistIdx<=0;back.style.opacity=_folioHistIdx<=0?'.35':'1';}
    if(fwd){fwd.disabled=_folioHistIdx>=_folioHistory.length-1;fwd.style.opacity=_folioHistIdx>=_folioHistory.length-1?'.35':'1';}
  }
  async function _folioBack(){
    if(_folioHistIdx<=0)return;
    _folioNavBusy=true;
    try{await saveSchema();_folioHistIdx--;await openFolio(_folioHistory[_folioHistIdx]);}
    finally{_folioNavBusy=false;_updateFolioNavBtns();}
  }
  async function _folioForward(){
    if(_folioHistIdx>=_folioHistory.length-1)return;
    _folioNavBusy=true;
    try{await saveSchema();_folioHistIdx++;await openFolio(_folioHistory[_folioHistIdx]);}
    finally{_folioNavBusy=false;_updateFolioNavBtns();}
  }

  async function openProjectModal(){
    await loadProjects();
    openModal('modal-projects');
  }

  async function loadProjects(){
    const list=document.getElementById('projects-list');
    if(!list)return;
    list.innerHTML='<div class="proj-loading">Chargement…</div>';
    try{
      const projects=await(await fetch('/api/projects',{credentials:'include'})).json();
      list.innerHTML='';
      if(!projects.length){
        list.innerHTML='<div style="text-align:center;color:var(--text2);padding:30px 0"><div style="font-size:32px;opacity:.3;margin-bottom:8px">📁</div><div>Aucun projet — créez-en un !</div></div>';
        return;
      }
      projects.forEach(p=>list.appendChild(buildProjectCard(p)));
    }catch(e){list.innerHTML=`<div style="color:#ff4444;padding:20px">${esc(e.message)}</div>`;}
  }

  function buildProjectCard(p){
    const div=document.createElement('div');div.className='proj-card';
    const myRole=p.myRole==='owner'?'Propriétaire':p.myRole==='editor'?'Éditeur':'Lecteur';
    const roleCls=p.myRole==='owner'?'owner':p.myRole==='editor'?'editor':'viewer';
    div.innerHTML=`
      <div class="proj-card-header">
        <div class="proj-card-name">${esc(p.name)}</div>
        <span class="proj-role ${roleCls}">${myRole}</span>
      </div>
      ${p.description?`<div class="proj-card-desc">${esc(p.description)}</div>`:''}
      <div class="proj-card-meta">
        <span>👤 ${esc(p.owner_name)}</span>
        <span>📄 ${p.folio_count} folio${p.folio_count!==1?'s':''}</span>
        <span>${p.members?.length?`👥 ${p.members.length} membre${p.members.length>1?'s':''}`:'Privé'}</span>
        <span style="margin-left:auto;color:var(--text3)">${new Date(p.updated_at).toLocaleDateString('fr-FR')}</span>
      </div>
      <div class="proj-card-actions">
        <button class="btn-primary" data-open="${p.id}">📂 Ouvrir</button>
        ${p.isOwner||p.myRole==='editor'?`<button class="btn-secondary" data-manage="${p.id}">⚙ Gérer</button>`:''}
        ${p.isOwner?`<button class="btn-secondary" data-delete="${p.id}">✕ Supprimer</button>`:''}
      </div>`;
    div.querySelector('[data-open]')?.addEventListener('click',()=>openProject(p.id));
    div.querySelector('[data-manage]')?.addEventListener('click',()=>openProjectSettings(p.id));
    div.querySelector('[data-delete]')?.addEventListener('click',async()=>{
      if(!await showConfirm(`Supprimer le projet "${p.name}" et tous ses folios ?`))return;
      await fetch(`/api/projects/${p.id}`,{method:'DELETE',credentials:'include'});
      div.remove();setStatus('Projet supprimé');
    });
    return div;
  }

  async function openProject(id, targetFolioId=null){
    try{
      setStatus('Chargement du projet…');
      const res=await fetch(`/api/projects/${id}`,{credentials:'include'});
      if(!res.ok){const d=await res.json();throw new Error(d.error||'Erreur');}
      currentProject=await res.json();
      projectFolios=currentProject.folios.sort((a,b)=>(a.folio_order||0)-(b.folio_order||0));
      isReadOnly=!currentProject.canWrite;
      closeModal('modal-projects');
      // Bouton retour vers la page projets
      if(!document.getElementById('btn-back-projects')){
        const btn=document.createElement('a');
        btn.id='btn-back-projects';btn.href='/projects.html';
        btn.className='tb-btn';btn.style.textDecoration='none';
        btn.title='Retour aux projets';btn.textContent='← Projets';
        const logo=document.querySelector('.tb-logo');
        if(logo){logo.parentNode.insertBefore(btn,logo.nextSibling);
          const sep=document.createElement('div');sep.className='tb-sep';
          logo.parentNode.insertBefore(sep,btn.nextSibling);}
      }
      // Charger le folio cible ou le premier
      const folioToOpen = targetFolioId
        ? projectFolios.find(f=>f.id===targetFolioId)||projectFolios[0]
        : projectFolios[0];
      if(folioToOpen){
        await openFolio(folioToOpen.id);
      } else {
        newSchema();currentProject=currentProject;
        updateFolioNav();
        setStatus(`Projet "${currentProject.name}" ouvert — aucun folio`);
      }
      // Mettre les paramètres projet dans folio
      if(currentProject.settings){
        const s=currentProject.settings;
        if(s.company)folio.company=s.company;
        if(s.author)folio.author=s.author;
        if(s.rev)folio.rev=s.rev;
        if(s.date)folio.date=s.date;
        if(s.wireAuto!==undefined)folio.wireAuto=s.wireAuto;
        if(s.wireStep)folio.wireStep=s.wireStep;
        // Nommage auto
        if(s.autoName!==undefined) PROJ.autoName=s.autoName;
        if(s.nameRules){
          const r=s.nameRules;
          PROJ.nameUseFolio = r.useFolio  !== false;
          PROJ.nameFolioSep = r.folioSep  || '';
          PROJ.nameUseType  = r.useType   !== false;
          PROJ.nameUseInst  = r.useInst   !== false;
          PROJ.nameDigits   = r.digits    || 2;
          PROJ.nameSuffix   = r.suffix    || '';
          PROJ.nameScope    = r.scope     || 'folio';
          PROJ._nameCounters = {};
        }
        window._PROJ = PROJ;
      }
      updateFolioOverlay();
      updateDxfImportLink();
      // Charger les todos du projet
      try{
        const tr=await fetch(`/api/projects/${currentProject.id}/todos`,{credentials:'include'});
        if(tr.ok){const pt=await tr.json();if(Array.isArray(pt)){todos=pt;renderTodoList();}}
      }catch(e){/* silent */}
      setStatus(`Projet "${currentProject.name}" ouvert — ${projectFolios.length} folio(s)${isReadOnly?' (lecture seule)':''}`);
      // badge projet dans la todo list
      const _tdTitle=document.querySelector('.todo-header span:first-child');
      if(_tdTitle)_tdTitle.textContent=currentProject?.id?'📋 Notes du projet':'📋 Notes & Todo';
    }catch(e){showWarning('Erreur: '+e.message);setStatus('Erreur ouverture projet');}
  }

  async function addFolioToProject(){
    if(!currentProject)return;
    if(!currentProject.canWrite&&currentProject.myRole!=='owner'){showWarning('Accès insuffisant');return;}
    openNewFolioModal();
  }

  // ── Modale nouveau folio ──────────────────────────────────
  function openNewFolioModal(){
    // Numéro auto suggéré : plus grand entier existant + 1 (compatible avec "1, 1.1, 1.2…")
    const maxNum=projectFolios.reduce((m,f)=>{
      const n=Math.floor(parseFloat(f.folio_num))||0;
      return n>m?n:m;
    },0);
    const suggestedNum=maxNum>0?maxNum+1:(currentProject?.folio_counter||projectFolios.length+1);
    const numInput=document.getElementById('nf-num');
    if(numInput) numInput.value=String(suggestedNum);
    const defaultName=`Folio ${suggestedNum}`;
    document.getElementById('nf-name').value=defaultName;
    // Reset type sélection
    document.querySelectorAll('.nf-type-card').forEach(c=>c.classList.toggle('nf-selected',c.dataset.val==='schema'));
    document.getElementById('nf-bom-config').style.display='none';
    document.getElementById('nf-implant-config').style.display='none';
    document.getElementById('nf-multibloc-config').style.display='none';
    // Peupler les colonnes BOM
    _populateBomColsUI();
    openModal('modal-new-folio');
    setTimeout(()=>document.getElementById('nf-name').select(),80);
  }

  // Colonnes BOM standards + champs custom présents dans le projet
  const BOM_STD_COLS=[
    {id:'qty',    label:'Quantité',   checked:true,  required:true},
    {id:'ref',    label:'Référence',  checked:true},
    {id:'label',  label:'Désignation',checked:true},
    {id:'sym',    label:'Symbole',    checked:true},
    {id:'cat',    label:'Catégorie',  checked:true},
    {id:'folio',  label:'Folio(s)',   checked:true},
    {id:'color',  label:'Couleur',    checked:false},
    {id:'size',   label:'Taille',     checked:false},
  ];

  function _getProjectCustomFields(){
    // Regrouper les champs custom par NOM NORMALISÉ
    // → "Calibre" sur un disjoncteur et "Calibre" sur une alim = même colonne
    const nameMap = {}; // normalizedName → {id, label, unit, rawIds[], checked}
    for(const f of projectFolios){
      const d=f._cachedData; if(!d) continue;
      for(const el of (d.elements||[])){
        const sym=_symbols[el.symId];
        if(!sym?.fields) continue;
        if(sym.inBom===false) continue;
        for(const fld of sym.fields){
          const normName = (fld.name||'').toLowerCase().trim();
          if(!normName) continue;
          const inBomByDefault = !sym.bomFields?.length || sym.bomFields.includes(fld.id);
          if(!nameMap[normName]){
            // Construire le label : "Nom (unité)" si unité définie
            const lbl = fld.unit ? `${fld.name} (${fld.unit})` : fld.name;
            // L'id de colonne est basé sur le nom normalisé (stable)
            const colId = 'cfn_' + normName.replace(/[^a-z0-9]/g,'_');
            nameMap[normName] = {
              id: colId,
              label: lbl,
              unit: fld.unit||'',
              rawIds: [fld.id],   // tous les field.id portant ce nom
              checked: inBomByDefault,
              custom: true,
            };
          } else {
            // Ajouter cet ID comme alias
            if(!nameMap[normName].rawIds.includes(fld.id))
              nameMap[normName].rawIds.push(fld.id);
            // Mettre à jour l'unité si pas encore définie
            if(!nameMap[normName].unit && fld.unit) {
              nameMap[normName].unit = fld.unit;
              nameMap[normName].label = `${fld.name} (${fld.unit})`;
            }
            // checked = true si au moins un symbole l'a par défaut
            if(inBomByDefault) nameMap[normName].checked = true;
          }
        }
      }
    }
    return Object.values(nameMap);
  }

  function _populateBomColsUI(){
    const existing=_currentBomConfig()?.columns||null;
    const customFields=_getProjectCustomFields();
    const allCols=[...BOM_STD_COLS,...customFields];
    const container=document.getElementById('nf-bom-cols');
    if(!container)return;
    container.innerHTML=allCols.map(col=>{
      const chk=existing?existing.some(c=>c.id===col.id&&c.checked):col.checked;
      const dis=col.required?'disabled':'';
      // Afficher nb d'alias si champ regroupé
      const aliasHint=col.rawIds?.length>1?` <span style="font-size:9px;opacity:.5">(×${col.rawIds.length})</span>`:'';
      return `<label class="nf-col-check"><input type="checkbox" data-colid="${col.id}" ${chk?'checked':''} ${dis}><span>${col.label}${aliasHint}</span></label>`;
    }).join('');
  }

  function _currentBomConfig(){
    // Lire la config BOM du folio courant si c'est un BOM
    if(!currentFolioId)return null;
    const f=projectFolios.find(x=>x.id===currentFolioId);
    return f?.data?.bomConfig||null;
  }

  async function _confirmNewFolio(){
    const name=document.getElementById('nf-name').value.trim();
    if(!name){document.getElementById('nf-name').focus();return;}
    const rawNum=String(document.getElementById('nf-num')?.value||'').trim();
    if(rawNum && !/^[0-9]+(\.[0-9]+)?$/.test(rawNum)){
      showWarning('Numéro de folio invalide. Format attendu : entier ou décimal (ex: 1, 1.2).');
      document.getElementById('nf-num')?.focus();
      return;
    }
    const selectedType=document.querySelector('.nf-type-card.nf-selected')?.dataset?.val||'schema';
    let bomConfig=null;
    if(selectedType==='bom'){
      // Récupérer les métadonnées complètes (rawIds, unit) depuis les colonnes disponibles
      const _allAvailCols=[...BOM_STD_COLS,..._getProjectCustomFields()];
      const _availMap={}; _allAvailCols.forEach(c=>{ _availMap[c.id]=c; });
      const cols=[...document.querySelectorAll('#nf-bom-cols input[type=checkbox]')].map(cb=>{
        const meta=_availMap[cb.dataset.colid]||{};
        return {
          id:cb.dataset.colid,
          label:cb.closest('label')?.querySelector('span')?.textContent||cb.dataset.colid,
          checked:cb.checked,
          rawIds:meta.rawIds||null,  // aliases pour les champs custom regroupés
          unit:meta.unit||null,
        };
      });
      const group=document.getElementById('nf-bom-group').value;
      bomConfig={columns:cols,group};
    }
    closeModal('modal-new-folio');
    try{
      if(currentFolioId)await saveSchema();
      const body={name};
      if(rawNum) body.folio_num=rawNum;
      if(selectedType==='bom') body.data={elements:[],wires:[],texts:[],shapes:[],
        bomConfig, folio_type:'bom'};
      if(selectedType==='summary') body.data={elements:[],wires:[],texts:[],shapes:[],
        folio_type:'summary'};
      if(selectedType==='bornier') body.data={elements:[],wires:[],texts:[],shapes:[],
        folio_type:'bornier'};
      if(selectedType==='implantation'){
        const cabType=document.getElementById('nf-implant-type')?.value||'coffret';
        let implCfg;
        if(cabType==='armoire_multibloc'){
          const count=parseInt(document.getElementById('nf-multibloc-count')?.value)||2;
          const gap=parseInt(document.getElementById('nf-multibloc-gap')?.value)||0;
          const depth=parseInt(document.getElementById('nf-implant-d')?.value)||200;
          const label=document.getElementById('nf-implant-label')?.value?.trim()||'';
          const blocs=[];
          for(let i=0;i<count;i++){
            blocs.push({id:'bloc_'+i,label:'Bloc '+(i+1),width:400,height:2000,rails:[],goulottes:[]});
          }
          implCfg={cabinetType:'armoire_multibloc',cabinetLabel:label,cabinetDepth:depth,gap,blocs};
        }else{
          const hasGrid=document.getElementById('nf-implant-has-grid')?.checked||false;
          implCfg={
            cabinetW:parseInt(document.getElementById('nf-implant-w')?.value)||600,
            cabinetH:parseInt(document.getElementById('nf-implant-h')?.value)||400,
            cabinetDepth:parseInt(document.getElementById('nf-implant-d')?.value)||200,
            cabinetLabel:document.getElementById('nf-implant-label')?.value?.trim()||'',
            cabinetType:cabType,
            rails:[],goulottes:[],
            hasGrid,
            gridW:parseInt(document.getElementById('nf-implant-gw')?.value)||560,
            gridH:parseInt(document.getElementById('nf-implant-gh')?.value)||360,
            gridDepth:parseInt(document.getElementById('nf-implant-gd')?.value)||150,
            gridCentered:document.getElementById('nf-implant-grid-centered')?.checked!==false,
            gridOffsetX:0,gridOffsetY:0
          };
        }
        body.data={elements:[],wires:[],texts:[],shapes:[],junctions:[],images:[],
          folio_type:'implantation',implantation:implCfg};
      }
      const res=await fetch(`/api/projects/${currentProject.id}/folios`,{method:'POST',credentials:'include',
        headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      if(!res.ok){const d=await res.json();throw new Error(d.error||'Erreur');}
      const newFolio=await res.json();
      const pr=await(await fetch(`/api/projects/${currentProject.id}`,{credentials:'include'})).json();
      currentProject=pr;
      projectFolios=pr.folios.sort((a,b)=>(a.folio_order||0)-(b.folio_order||0));
      await openFolio(newFolio.id);
      setStatus(`✓ Folio "${name}" ${selectedType==='bom'?'(nomenclature)':selectedType==='implantation'?'(implantation)':''} créé`);
    }catch(e){showWarning('Erreur: '+e.message);}
  }

  // ── Modal paramètres projet ───────────────────────────────
  async function openProjectSettings(projectId){
    closeModal('modal-projects');
    // Charger le projet
    const pres=await fetch(`/api/projects/${projectId}`,{credentials:'include'});
    const p=await pres.json();
    // Charger tous les users (admin seulement)
    const users=currentUser.role==='admin'?await(await fetch('/api/users',{credentials:'include'})).json():[];
    document.getElementById('ps-modal-title').textContent='⚙ '+p.name;
    openModal('modal-project-settings');
    // Reset tabs to first
    document.querySelectorAll('[data-ps-tab]').forEach((t,i)=>t.classList.toggle('active',i===0));
    document.querySelectorAll('.ps-tab-content').forEach((c,i)=>{c.style.display=i===0?'block':'none';c.classList.toggle('active',i===0);});

    // Tab: Infos
    document.getElementById('ps-name').value=p.name||'';
    document.getElementById('ps-desc').value=p.description||'';
    const s=p.settings||{};
    document.getElementById('ps-company').value=s.company||'CBI';
    document.getElementById('ps-client').value=s.client||'';
    document.getElementById('ps-affaire').value=s.affaire||'';
    document.getElementById('ps-rev').value=s.rev||'A';
    document.getElementById('ps-author').value=s.author||'';
    document.getElementById('ps-date').value=s.date||new Date().toISOString().slice(0,10);

    // Bouton supprimer projet
    const delBtn=document.getElementById('ps-delete-project');
    if(delBtn){
      delBtn.style.display=p.isOwner||currentUser.role==='admin'?'':'none';
      delBtn.onclick=async()=>{
        if(!await showConfirm(`Supprimer définitivement le projet "${p.name}" et tous ses folios ?`))return;
        if(!await showConfirm('Cette action est irréversible. Confirmer ?'))return;
        const r=await fetch(`/api/projects/${projectId}`,{method:'DELETE',credentials:'include'});
        if(!r.ok){showWarning('Erreur lors de la suppression');return;}
        closeModal('modal-project-settings');
        if(currentProject?.id===projectId){newSchema();currentProject=null;projectFolios=[];updateFolioNav();}
        setStatus('✓ Projet supprimé');
        await loadProjects();
      };
    }

    // Bouton add folio
    const addFolioBtn=document.getElementById('ps-add-folio');
    if(addFolioBtn){
      addFolioBtn.style.display=p.canWrite||p.isOwner?'':'none';
      addFolioBtn.onclick=async()=>{
        const name=prompt('Nom du nouveau folio :',`Folio ${p.folio_counter||((p.folios||[]).length+1)}`);
        if(!name)return;
        const r=await fetch(`/api/projects/${projectId}/folios`,{method:'POST',credentials:'include',
          headers:{'Content-Type':'application/json'},body:JSON.stringify({name})});
        if(!r.ok){showWarning('Erreur création folio');return;}
        const pr=await(await fetch(`/api/projects/${projectId}`,{credentials:'include'})).json();
        if(currentProject?.id===projectId){currentProject=pr;projectFolios=pr.folios.sort((a,b)=>(a.folio_order||0)-(b.folio_order||0));updateFolioNav();}
        refreshFolioSettings(pr.folios,projectId,p.canWrite||p.isOwner);
        setStatus(`✓ Folio "${name}" créé`);
      };
    }

    // Tab: Folios
    refreshFolioSettings(p.folios||[],projectId,p.canWrite||p.isOwner);

    // Tab: Membres
    refreshMembersSettings(p,users);

    // Tab: Partage liens
    refreshShareLinks(projectId);
    // Tab: Nommage
    _openNamingTab(p);

    // Sauvegarder infos
    document.getElementById('ps-save-info').onclick=async()=>{
      await fetch(`/api/projects/${projectId}`,{method:'PUT',credentials:'include',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({name:document.getElementById('ps-name').value,description:document.getElementById('ps-desc').value,
          settings:{company:document.getElementById('ps-company').value,client:document.getElementById('ps-client').value,
            affaire:document.getElementById('ps-affaire').value,rev:document.getElementById('ps-rev').value,
            author:document.getElementById('ps-author').value,date:document.getElementById('ps-date').value,
            wireAuto:folio.wireAuto,wireStep:folio.wireStep,printZone}
        })});
      if(currentProject&&currentProject.id===projectId){
        currentProject.name=document.getElementById('ps-name').value;
        updateFolioNav();
      }
      setStatus('✓ Paramètres projet sauvegardés');closeModal('modal-project-settings');
    };
  }

  function refreshFolioSettings(folios,projectId,canWrite){
    const list=document.getElementById('ps-folios-list');if(!list)return;
    const sorted=folios.slice().sort((a,b)=>(a.folio_order||0)-(b.folio_order||0));
    list.innerHTML=sorted.map((f,i)=>`
      <div class="ps-folio-item" data-id="${f.id}" data-order="${i}">
        <div class="psfi-drag">⠿</div>
        <div class="psfi-num"><input type="text" inputmode="decimal" pattern="^[0-9]+(\\.[0-9]+)?$" title="Entier ou décimal (ex: 1, 1.2)" value="${f.folio_num||i+1}" style="width:50px;background:var(--panel2);border:1px solid var(--border2);color:var(--text);padding:2px 5px;border-radius:3px;font-family:var(--font);font-size:11px;outline:none" data-folio-num="${f.id}"></div>
        <div class="psfi-name">${esc(f.name)}</div>
        <div class="psfi-actions">
          ${canWrite?`<button class="psfi-del" data-del="${f.id}" title="Supprimer ce folio">✕</button>`:''}
        </div>
      </div>`).join('');
    // Suppression
    list.querySelectorAll('[data-del]').forEach(btn=>btn.addEventListener('click',async()=>{
      if(!await showConfirm('Supprimer ce folio ?'))return;
      await fetch(`/api/folios/${btn.dataset.del}`,{method:'DELETE',credentials:'include'});
      btn.closest('.ps-folio-item').remove();
      // Refresh project folios list
      const pr=await(await fetch(`/api/projects/${projectId}`,{credentials:'include'})).json();
      if(currentProject&&currentProject.id===projectId){currentProject=pr;projectFolios=pr.folios.sort((a,b)=>(a.folio_order||0)-(b.folio_order||0));updateFolioNav();}
    }));
    // Drag & Drop pour réordonner
    if(canWrite)initFolioDragDrop(list,projectId);
    // Renuméroter
    document.getElementById('ps-renumber').onclick=async()=>{
      if(!await showConfirm('Renuméroter automatiquement tous les folios ?'))return;
      await fetch(`/api/projects/${projectId}/renumber`,{method:'POST',credentials:'include'});
      const pr=await(await fetch(`/api/projects/${projectId}`,{credentials:'include'})).json();
      if(currentProject&&currentProject.id===projectId){currentProject=pr;projectFolios=pr.folios.sort((a,b)=>(a.folio_order||0)-(b.folio_order||0));updateFolioNav();}
      refreshFolioSettings(pr.folios,projectId,canWrite);
      setStatus('✓ Folios renumérotés');
    };
    document.getElementById('ps-save-order').onclick=async()=>{
      // Sauvegarder les numéros modifiés manuellement
      const items=[...list.querySelectorAll('.ps-folio-item')];
      const order=items.map((el,i)=>{
        const numInput=el.querySelector('[data-folio-num]');
        const rawNum=String(numInput?.value||(i+1)).trim();
        const validNum=/^[0-9]+(\.[0-9]+)?$/.test(rawNum)?rawNum:String(i+1);
        return{id:el.dataset.id,folio_order:i,folio_num:validNum};
      });
      await fetch(`/api/projects/${projectId}/order`,{method:'PUT',credentials:'include',headers:{'Content-Type':'application/json'},body:JSON.stringify({order})});
      if(currentProject&&currentProject.id===projectId){
        const pr=await(await fetch(`/api/projects/${projectId}`,{credentials:'include'})).json();
        currentProject=pr;projectFolios=pr.folios.sort((a,b)=>(a.folio_order||0)-(b.folio_order||0));updateFolioNav();
      }
      setStatus('✓ Ordre des folios sauvegardé');
    };
  }

  function initFolioDragDrop(list,projectId){
    let dragging=null;
    list.querySelectorAll('.ps-folio-item').forEach(item=>{
      item.draggable=true;
      item.addEventListener('dragstart',()=>{dragging=item;item.style.opacity='.4';});
      item.addEventListener('dragend',()=>{dragging=null;item.style.opacity='1';});
      item.addEventListener('dragover',e=>{e.preventDefault();if(dragging&&dragging!==item){
        const r=item.getBoundingClientRect();
        if(e.clientY<r.top+r.height/2)list.insertBefore(dragging,item);
        else list.insertBefore(dragging,item.nextSibling);
      }});
    });
  }

  function refreshMembersSettings(p,allUsers){
    const list=document.getElementById('ps-members-list');if(!list)return;
    const members=p.members||[];
    list.innerHTML='';
    // Propriétaire
    const ownerU=allUsers.find(u=>u.id===p.owner_id)||{name:p.owner_name||'?',login:''};
    const ownerItem=document.createElement('div');ownerItem.className='ps-member-item';
    ownerItem.innerHTML=`<span class="psm-name">${esc(ownerU.name)} <span style="color:var(--text3)">(${esc(ownerU.login||p.owner_id)})</span></span><span class="proj-role owner">Propriétaire</span>`;
    list.appendChild(ownerItem);
    // Autres membres
    members.forEach(m=>{
      const u=allUsers.find(u=>u.id===m.user_id)||{name:m.name||'?',login:m.login||'?'};
      const item=document.createElement('div');item.className='ps-member-item';
      const roleLbl=m.role==='editor'?'Éditeur':'Lecteur';
      const roleCls=m.role==='editor'?'editor':'viewer';
      item.innerHTML=`<span class="psm-name">${esc(u.name)} <span style="color:var(--text3)">(${esc(u.login)})</span></span>
        <div style="display:flex;align-items:center;gap:6px">
          ${p.isOwner?`<select class="psm-role" data-uid="${m.user_id}" style="background:var(--panel2);border:1px solid var(--border2);color:var(--text);padding:3px 6px;border-radius:3px;font-family:var(--font);font-size:10px;outline:none">
            <option value="editor"${m.role==='editor'?' selected':''}>Éditeur</option>
            <option value="viewer"${m.role==='viewer'?' selected':''}>Lecteur</option>
          </select>
          <button class="psm-del" data-uid="${m.user_id}" style="background:none;border:1px solid rgba(255,68,68,.4);color:#ff6666;padding:2px 8px;border-radius:3px;cursor:pointer;font-size:10px;font-family:var(--font)">Retirer</button>`
          :`<span class="proj-role ${roleCls}">${roleLbl}</span>`}
        </div>`;
      item.querySelector('[data-uid]')?.addEventListener('change',async e=>{
        await fetch(`/api/projects/${p.id}/members/${e.target.dataset.uid}`,{method:'PUT',credentials:'include',headers:{'Content-Type':'application/json'},body:JSON.stringify({role:e.target.value})});
      });
      item.querySelector('.psm-del')?.addEventListener('click',async e=>{
        const uid=e.currentTarget.dataset.uid;
        await fetch(`/api/projects/${p.id}/members/${uid}`,{method:'DELETE',credentials:'include'});
        item.remove();setStatus('Membre retiré');
      });
      list.appendChild(item);
    });
    // Ajouter un membre
    if(p.isOwner){
      const available=allUsers.filter(u=>u.id!==p.owner_id&&!members.find(m=>m.user_id===u.id));
      const addRow=document.getElementById('ps-add-member-row');
      if(addRow){addRow.style.display=available.length?'':'none';}
      const sel=document.getElementById('ps-member-select');
      if(sel){sel.innerHTML=available.map(u=>`<option value="${u.id}">${esc(u.name)} (${esc(u.login)})</option>`).join('');}
      document.getElementById('ps-add-member-btn').onclick=async()=>{
        const uid=document.getElementById('ps-member-select').value;
        const role=document.getElementById('ps-member-role').value;
        if(!uid)return;
        await fetch(`/api/projects/${p.id}/members`,{method:'POST',credentials:'include',
          headers:{'Content-Type':'application/json'},body:JSON.stringify({user_id:uid,role})});
        // Recharger
        const pr=await(await fetch(`/api/projects/${p.id}`,{credentials:'include'})).json();
        refreshMembersSettings(pr,allUsers);setStatus('✓ Membre ajouté');
      };
    } else {
      const addRow=document.getElementById('ps-add-member-row');
      if(addRow)addRow.style.display='none';
    }
  }

  async function refreshShareLinks(projectId){
    const list=document.getElementById('ps-share-links-list');if(!list)return;
    list.innerHTML='<div style="color:var(--text2);font-size:11px">Chargement…</div>';
    try{
      const [pLinks,fLinks]=await Promise.all([
        fetch(`/api/projects/${projectId}/sharelinks`,{credentials:'include'}).then(r=>r.json()),
        // Liens folios du projet courant
        Promise.resolve([])
      ]);
      list.innerHTML='';
      if(!pLinks.length){
        list.innerHTML='<div style="color:var(--text3);font-size:11px;padding:8px 0">Aucun lien de partage — générez-en un ci-dessous.</div>';
      } else {
        pLinks.forEach(l=>list.appendChild(buildShareLinkRow(l,projectId,'project')));
      }
    }catch(e){list.innerHTML=`<div style="color:#ff4444">${esc(e.message)}</div>`;}
    // Lien folio courant
    const folioLinkSection=document.getElementById('ps-folio-link-section');
    if(folioLinkSection){folioLinkSection.style.display=currentFolioId&&currentProject?.id===projectId?'':'none';}
    if(currentFolioId&&currentProject?.id===projectId){
      try{
        const fLinks=await fetch(`/api/folios/${currentFolioId}/sharelinks`,{credentials:'include'}).then(r=>r.json());
        const fl=document.getElementById('ps-folio-links-list');if(!fl)return;
        fl.innerHTML='';
        if(!fLinks.length)fl.innerHTML='<div style="color:var(--text3);font-size:11px;padding:4px 0">Aucun lien pour ce folio.</div>';
        else fLinks.forEach(l=>fl.appendChild(buildShareLinkRow(l,currentFolioId,'folio')));
      }catch{}
    }
    // Bouton générer lien projet
    document.getElementById('ps-gen-project-link').onclick=async()=>{
      const label=document.getElementById('ps-link-label').value||'';
      const res=await fetch(`/api/projects/${projectId}/sharelinks`,{method:'POST',credentials:'include',headers:{'Content-Type':'application/json'},body:JSON.stringify({label})});
      if(!res.ok){const err=await res.json().catch(()=>({}));showWarning('Erreur création lien : '+(err.error||res.status));return;}
      const data=await res.json();
      copyToClipboard(data.url);
      setStatus('✓ Lien copié : '+data.url);
      await refreshShareLinks(projectId);
    };
    // Bouton générer lien folio
    document.getElementById('ps-gen-folio-link').onclick=async()=>{
      if(!currentFolioId)return;
      const res=await fetch(`/api/folios/${currentFolioId}/sharelinks`,{method:'POST',credentials:'include',headers:{'Content-Type':'application/json'},body:JSON.stringify({label:'Folio '+folio.num})});
      if(!res.ok){const err=await res.json().catch(()=>({}));showWarning('Erreur création lien folio : '+(err.error||res.status));return;}
      const data=await res.json();
      copyToClipboard(data.url);
      setStatus('✓ Lien folio copié : '+data.url);
      await refreshShareLinks(projectId);
    };
  }

  function buildShareLinkRow(l,id,type){
    const row=document.createElement('div');
    row.className='share-link-row';
    const url=l.url||(window.location.origin+'/view/'+l.token);
    row.innerHTML=`
      <div style="display:flex;gap:12px;align-items:flex-start;flex:1">
        <div style="flex-shrink:0;background:#fff;padding:4px;border-radius:4px;border:1px solid var(--border2)">
          <canvas class="share-qr-canvas" width="72" height="72" style="display:block;border-radius:2px" title="QR code du lien"></canvas>
        </div>
        <div style="flex:1;min-width:0">
          <div style="font-size:11px;font-weight:600;color:var(--text);margin-bottom:4px">${esc(l.label||'Lien sans label')}</div>
          <div class="share-link-url" title="Cliquer pour copier" style="font-size:10px;margin-bottom:6px;display:block">${esc(url)}</div>
          <div style="display:flex;gap:12px;font-size:9px;color:var(--text3)">
            <span>📊 ${l.access_count||0} accès</span>
            <span>📅 ${new Date(l.created_at).toLocaleDateString('fr-FR')}</span>
          </div>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;gap:4px;flex-shrink:0">
        <button class="btn-secondary" data-copy style="font-size:10px;padding:3px 8px">⎘ Copier</button>
        <button class="btn-secondary" data-qr-print style="font-size:10px;padding:3px 8px">⊠ QR</button>
        <button class="btn-secondary danger" data-del-link style="font-size:10px;padding:3px 8px;color:#ff6340;border-color:rgba(255,99,64,.3)">✕</button>
      </div>`;
    row.querySelector('.share-link-url').onclick=()=>{copyToClipboard(url);setStatus('✓ Lien copié !');};
    row.querySelector('[data-copy]').onclick=()=>{copyToClipboard(url);setStatus('✓ Lien copié !');};
    row.querySelector('[data-del-link]').onclick=async()=>{
      const endpoint=type==='project'?`/api/projects/${id}/sharelinks/${l.token}`:`/api/folios/${id}/sharelinks/${l.token}`;
      const r=await fetch(endpoint,{method:'DELETE',credentials:'include'});
      if(!r.ok){showWarning('Erreur suppression : '+r.status);return;}
      row.remove();setStatus('Lien supprimé');
    };
    row.querySelector('[data-qr-print]').onclick=async()=>{
      const printLabel=esc(l.label||'Lien de partage');
      try{
        const dataUrl=await QRCode.toDataURL(url,{width:300,margin:2,color:{dark:'#000000',light:'#ffffff'}});
        const w=window.open('','_blank','width=420,height=540');
        w.document.write('<html><head><meta charset="utf-8"><title>QR Code</title>'
          +'<style>body{font-family:Arial,sans-serif;text-align:center;padding:30px;background:#fff;color:#000}'
          +'h2{font-size:14px;margin-bottom:6px}p{font-size:11px;color:#555;word-break:break-all;margin-bottom:16px}'
          +'img{border:1px solid #eee;border-radius:4px}'
          +'@media print{button{display:none}}</style></head><body>'
          +'<h2>'+printLabel+'</h2>'
          +'<p>'+url+'</p>'
          +'<img src="'+dataUrl+'" width="300" height="300"><br><br>'
          +'<button onclick="window.print()">🖨 Imprimer</button>'
          +'</body></html>');
        w.document.close();
      }catch(err){showWarning('Erreur QR: '+err.message);}
    };
    const canvas=row.querySelector('.share-qr-canvas');
    if(canvas&&window.QRCode){
      QRCode.toCanvas(canvas,url,{width:72,margin:1,color:{dark:'#000000',light:'#ffffff'}})
        .catch(err=>{canvas.style.display='none';console.warn('QR error:',err);});
    }
    return row;
  }

  function copyToClipboard(text){
    navigator.clipboard?.writeText(text).catch(()=>{
      const ta=document.createElement('textarea');ta.value=text;document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);
    });
  }

  // ── Schémas modal ─────────────────────────────────────────
  async function openSchemasModal(){
    openModal('modal-schemas');
    const list=document.getElementById('schemas-list');
    list.innerHTML='<div style="color:var(--text2);text-align:center;padding:20px">Chargement…</div>';
    try{
      const schemas=await(await fetch('/api/schemas',{credentials:'include'})).json();
      if(!schemas.length){list.innerHTML='<div style="color:var(--text2);text-align:center;padding:20px">Aucun schéma</div>';return;}
      list.innerHTML='';
      schemas.forEach(s=>{
        const isOwner=s.owner_id===currentUser.id;
        const item=document.createElement('div');item.className='schema-item';
        item.innerHTML=`<div class="schema-item-info">
          <h3>${esc(s.name)} <span class="schema-badge ${isOwner?'owner':'shared'}">${isOwner?'Propriétaire':'Partagé'}</span>${s.public?'<span class="schema-badge public">Public</span>':''}</h3>
          <p>${esc(s.owner_name||'')} · ${new Date(s.updated_at).toLocaleString('fr-FR')}</p>
        </div>
        <div class="schema-item-actions">
          <button data-open="${s.id}">Ouvrir</button>
          ${isOwner?`<button data-share="${s.id}">Partager</button>`:''}
          ${isOwner||currentUser.role==='admin'?`<button class="danger" data-del="${s.id}">Suppr.</button>`:''}
        </div>`;
        item.querySelector('[data-open]')?.addEventListener('click',()=>openSchema(s.id));
        item.querySelector('[data-share]')?.addEventListener('click',e=>{e.stopPropagation();closeModal('modal-schemas');openShareModal(s.id);});
        item.querySelector('[data-del]')?.addEventListener('click',async e=>{e.stopPropagation();if(!await showConfirm(`Supprimer "${s.name}" ?`))return;await fetch(`/api/schemas/${s.id}`,{method:'DELETE',credentials:'include'});item.remove();});
        list.appendChild(item);
      });
    }catch(e){list.innerHTML=`<div style="color:#ff4444;text-align:center;padding:20px">${e.message}</div>`;}
  }

  // ── Partage ───────────────────────────────────────────────
  async function openShareModal(schId){currentShareId=schId;openModal('modal-share');await refreshShareModal();}
  async function refreshShareModal(){
    try{
      const[sr,ur]=await Promise.all([fetch(`/api/schemas/${currentShareId}/sharing`,{credentials:'include'}),fetch('/api/users',{credentials:'include'})]);
      const sharing=sr.ok?await sr.json():{shared_with:[],public:false};
      const allUsers=ur.ok?await ur.json():[];
      document.getElementById('share-public').checked=sharing.public||false;
      document.getElementById('share-public').onchange=async e=>{await fetch(`/api/schemas/${currentShareId}/share`,{method:'POST',credentials:'include',headers:{'Content-Type':'application/json'},body:JSON.stringify({public:e.target.checked})});};
      const sharedIds=(sharing.shared_with||[]).map(u=>u.id);
      const available=allUsers.filter(u=>u.id!==currentUser.id&&!sharedIds.includes(u.id));
      const sel=document.getElementById('share-user-select');
      sel.innerHTML=available.length?available.map(u=>`<option value="${u.id}">${esc(u.name)} (${esc(u.login)})</option>`).join(''):'<option value="">Aucun disponible</option>';
      document.getElementById('share-add-btn').onclick=async()=>{const uid=sel.value;if(!uid)return;await fetch(`/api/schemas/${currentShareId}/share`,{method:'POST',credentials:'include',headers:{'Content-Type':'application/json'},body:JSON.stringify({user_id:uid})});await refreshShareModal();};
      const sl=document.getElementById('share-users-list');
      if(!(sharing.shared_with||[]).length){sl.innerHTML='<div style="color:var(--text2);font-size:11px">Aucun partage individuel</div>';return;}
      sl.innerHTML=(sharing.shared_with||[]).map(u=>`<div class="share-user-item"><span style="font-size:11px">${esc(u.name)} <span style="color:var(--text2)">(${esc(u.login)})</span></span><button class="btn-danger" data-uid="${u.id}" style="padding:3px 10px;font-size:10px">Retirer</button></div>`).join('');
      sl.querySelectorAll('[data-uid]').forEach(btn=>btn.addEventListener('click',async()=>{await fetch(`/api/schemas/${currentShareId}/share/${btn.dataset.uid}`,{method:'DELETE',credentials:'include'});await refreshShareModal();}));
    }catch(e){console.error(e);}
  }

  // ── Borniers ────────────────────────────────────────────────────
  async function openBorniersModal() {
    if (!currentProject?.id) { showWarning('Ouvrez un projet pour consulter ses borniers.'); return; }
    openModal('modal-borniers');
    document.getElementById('borniers-loading').style.display = '';
    document.getElementById('borniers-content').style.display = 'none';

    try {
      const res = await fetch(`/api/projects/${currentProject.id}/borniers`, { credentials: 'include' });
      if (!res.ok) throw new Error((await res.json()).error || 'Erreur');
      const borniers = await res.json();
      renderBorniersModal(borniers);
    } catch(e) {
      document.getElementById('borniers-loading').textContent = 'Erreur : ' + e.message;
    }
  }

  function renderBorniersModal(borniers) {
    const loading = document.getElementById('borniers-loading');
    const content = document.getElementById('borniers-content');
    loading.style.display = 'none';

    if (!borniers.length) {
      content.innerHTML = '<div style="padding:32px;text-align:center;color:var(--text3);font-size:12px">Aucun bornier déclaré dans ce projet.<br><small>Sélectionnez un élément et renseignez les champs "Bornier" dans le panneau de propriétés.</small></div>';
      content.style.display = '';
      return;
    }

    content.innerHTML = borniers.map(b => {
      const natSort = (a,b) => String(a).localeCompare(String(b), undefined, {numeric:true, sensitivity:'base'});
      b.terminals.sort((a,b) => natSort(a.num||'', b.num||'') || natSort(a.etage||'', b.etage||''));
      const realCount = b.terminals.filter(t => !t.isReserve).length;
      const reserveCount = b.terminals.filter(t => t.isReserve).length;
      const rows = b.terminals.map(t => {
        const isRes = t.isReserve;
        const etage = t.etage ? `<span style="font-size:9px;color:var(--text3);margin-left:4px">[étage ${esc(t.etage)}]</span>` : '';
        const rowStyle = isRes ? 'background:rgba(255,165,0,.08);font-style:italic' : '';
        return `<tr style="${rowStyle}">
          <td style="font-weight:600;color:${isRes?'orange':'var(--accent)'};text-align:center">${esc(t.num)}</td>
          <td>${etage}</td>
          <td style="font-weight:500;color:${isRes?'orange':'var(--text)'}">${isRes?'Réserve':esc(t.label)}</td>
          <td style="color:var(--text2)">${isRes?'':esc(t.ref)}</td>
          <td style="color:var(--text3);font-size:10px">
            ${isRes?'—':`<a href="#" data-folio-id="${t.folioId}" class="bornier-folio-link" style="color:var(--accent);text-decoration:none">F${t.folioNum} – ${esc(t.folioName)}</a>`}
          </td>
        </tr>`;
      }).join('');

      return `<div style="margin-bottom:0;border-bottom:1px solid var(--border)">
        <div style="padding:10px 16px;background:var(--panel2);display:flex;align-items:center;gap:10px;position:sticky;top:0;z-index:1">
          <span style="font-family:var(--font-d);font-size:14px;font-weight:800;color:var(--text)">⊡ ${esc(b.name)}</span>
          <span style="font-size:10px;color:var(--text3)">${realCount} borne${realCount>1?'s':''}${reserveCount?' + '+reserveCount+' réserve'+(reserveCount>1?'s':''):''}</span>
          <button class="modal-bornier-auto-reserve" data-bornier="${esc(b.name)}" style="margin-left:auto;background:var(--panel);border:1px solid var(--warn);color:var(--warn);font-size:9px;padding:2px 8px;border-radius:3px;cursor:pointer;font-family:var(--font)" title="Générer automatiquement les réserves pour les numéros manquants">⚡ Auto-réserves</button>
        </div>
        <table style="width:100%;border-collapse:collapse;font-size:11px">
          <thead>
            <tr style="background:var(--panel3)">
              <th style="padding:5px 10px;text-align:left;color:var(--text2);font-size:9px;text-transform:uppercase;letter-spacing:.5px;width:50px">N°</th>
              <th style="padding:5px 10px;text-align:left;color:var(--text2);font-size:9px;text-transform:uppercase;letter-spacing:.5px;width:60px">Étage</th>
              <th style="padding:5px 10px;text-align:left;color:var(--text2);font-size:9px;text-transform:uppercase;letter-spacing:.5px">Désignation</th>
              <th style="padding:5px 10px;text-align:left;color:var(--text2);font-size:9px;text-transform:uppercase;letter-spacing:.5px">Référence</th>
              <th style="padding:5px 10px;text-align:left;color:var(--text2);font-size:9px;text-transform:uppercase;letter-spacing:.5px">Folio</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`;
    }).join('');

    // Click on folio link → navigate to that folio
    content.querySelectorAll('.bornier-folio-link').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        const fid = a.dataset.folioId;
        if (fid) { closeModal('modal-borniers'); saveSchema().then(() => openFolio(fid)); }
      });
    });

    // Bouton auto-réserves dans la modal
    content.querySelectorAll('.modal-bornier-auto-reserve').forEach(btn => {
      btn.addEventListener('click', async () => {
        const bornierName = btn.dataset.bornier;
        const b = borniers.find(x => x.name === bornierName);
        if (!b || !b.terminals.length) return;

        const realNums = b.terminals.filter(t => !t.isReserve).map(t => parseInt(t.num, 10)).filter(n => !isNaN(n));
        if (realNums.length < 2) { showWarning('Il faut au moins 2 bornes numériques pour générer les réserves.'); return; }

        const min = Math.min(...realNums);
        const max = Math.max(...realNums);
        const allUsed = new Set(b.terminals.map(t => parseInt(t.num, 10)).filter(n => !isNaN(n)));
        const missing = [];
        for (let i = min + 1; i < max; i++) {
          if (!allUsed.has(i)) missing.push({ num: String(i), etage: '' });
        }
        if (!missing.length) { showWarning('Aucune réserve à générer — tous les numéros entre ' + min + ' et ' + max + ' sont utilisés.'); return; }
        if (!await showConfirm('Générer ' + missing.length + ' réserve(s) pour ' + bornierName + ' ?\n\nNuméros : ' + missing.map(r => r.num).join(', '))) return;

        btn.disabled = true;
        btn.textContent = '⏳…';

        try {
          // Chercher le folio bornier existant
          const bornierFolio = projectFolios.find(f => {
            const bn = f.bornierName || f.data?.bornierName;
            const ft = f.folio_type || f.data?.folio_type;
            return bn === bornierName && ft === 'bornier';
          });

          if (bornierFolio) {
            const fullRes = await fetch(`/api/folios/${bornierFolio.id}`, { credentials: 'include' });
            if (fullRes.ok) {
              const fullFolio = await fullRes.json();
              const curData = fullFolio.data || {};
              const existingReserves = curData.reserves || [];
              const existingSet = new Set(existingReserves.map(r => r.num));
              const newReserves = missing.filter(r => !existingSet.has(r.num));
              if (newReserves.length) {
                const combinedReserves = [...existingReserves, ...newReserves];
                const updData = { ...curData, reserves: combinedReserves };
                await fetch(`/api/folios/${bornierFolio.id}`, {
                  method: 'PUT', credentials: 'include',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ data: updData })
                });
                // Synchroniser en mémoire
                if (bornierFolio.data) {
                  bornierFolio.data.reserves = combinedReserves;
                } else {
                  bornierFolio.data = updData;
                }
              }
            }
          } else {
            for (const r of missing) {
              await fetch(`/api/projects/${currentProject.id}/borniers/${encodeURIComponent(bornierName)}/reserves`, {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ num: r.num, etage: r.etage })
              });
            }
          }

          // Recharger la modal
          const res2 = await fetch(`/api/projects/${currentProject.id}/borniers`, { credentials: 'include' });
          const newBorniers = await res2.json();
          renderBorniersModal(newBorniers);
        } catch (e) {
          showWarning('Erreur : ' + e.message);
        } finally {
          btn.disabled = false;
          btn.textContent = '⚡ Auto-réserves';
        }
      });
    });

    content.style.display = '';

    // Bouton génération folios borniers
    const genBtn = document.getElementById('borniers-gen-folios');
    if (genBtn) {
      genBtn.onclick = async () => {
        if (!currentProject?.id) return;
        if (!borniers.length) { showWarning('Aucun bornier à générer.'); return; }

        genBtn.disabled = true;
        genBtn.textContent = '⏳ Analyse…';

        try {
          if (currentFolioId) await saveSchema();

          // Chercher les folios borniers existants via l'API (fiable)
          const allFolios = await (await fetch(`/api/projects/${currentProject.id}`, { credentials: 'include' })).json();
          const foliosList = allFolios.folios || [];

          // Pour chaque folio, vérifier s'il est de type bornier en chargeant son data
          const bornierFolioMap = {}; // bornierName → folioId
          for (const f of foliosList) {
            if (f.folio_type === 'bornier' && f.bornierName) {
              bornierFolioMap[f.bornierName] = f.id;
              continue;
            }
            // Fallback : charger le folio pour vérifier
            if (f.name && f.name.startsWith('Bornier ')) {
              const fRes = await fetch(`/api/folios/${f.id}`, { credentials: 'include' });
              if (fRes.ok) {
                const fd = await fRes.json();
                if (fd.data?.folio_type === 'bornier' && fd.data?.bornierName) {
                  bornierFolioMap[fd.data.bornierName] = f.id;
                }
              }
            }
          }

          const toCreate = borniers.filter(b => !bornierFolioMap[b.name]);
          const toUpdate = borniers.filter(b => !!bornierFolioMap[b.name]);

          const msg = [];
          if (toCreate.length) msg.push(`${toCreate.length} à créer`);
          if (toUpdate.length) msg.push(`${toUpdate.length} à actualiser`);
          if (!msg.length) { showWarning('Aucun bornier à traiter.'); return; }
          if (!await showConfirm(`${msg.join(', ')}. Continuer ?`)) return;

          genBtn.textContent = '⏳ Génération…';

          function _calcMissingReserves(b) {
            const realNums = b.terminals.filter(t => !t.isReserve).map(t => parseInt(t.num, 10)).filter(n => !isNaN(n));
            const existingReserveNums = b.terminals.filter(t => t.isReserve).map(t => parseInt(t.num, 10)).filter(n => !isNaN(n));
            if (realNums.length < 2) return [];
            const min = Math.min(...realNums);
            const max = Math.max(...realNums);
            const allUsed = new Set([...realNums, ...existingReserveNums]);
            const missing = [];
            for (let i = min; i <= max; i++) {
              if (!allUsed.has(i)) missing.push({ num: String(i), etage: '' });
            }
            return missing;
          }

          // Créer les nouveaux folios
          for (const b of toCreate) {
            const reserves = _calcMissingReserves(b);
            await fetch(`/api/projects/${currentProject.id}/folios`, {
              method: 'POST', credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ name: `Bornier ${b.name}`, data: { elements: [], wires: [], texts: [], shapes: [], folio_type: 'bornier', bornierName: b.name, reserves } })
            });
          }

          // Actualiser les folios existants (ajouter réserves manquantes)
          for (const b of toUpdate) {
            const missing = _calcMissingReserves(b);
            const folioId = bornierFolioMap[b.name];
            const fullRes = await fetch(`/api/folios/${folioId}`, { credentials: 'include' });
            if (!fullRes.ok) continue;
            const fullFolio = await fullRes.json();
            const curData = fullFolio.data || {};
            const existingReserves = curData.reserves || [];
            const existingSet = new Set(existingReserves.map(r => r.num));
            const newReserves = missing.filter(r => !existingSet.has(r.num));
            if (!newReserves.length) continue;
            const updData = { ...curData, reserves: [...existingReserves, ...newReserves] };
            await fetch(`/api/folios/${folioId}`, {
              method: 'PUT', credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ data: updData })
            });
          }

          // Recharger le projet
          const pr = await (await fetch(`/api/projects/${currentProject.id}`, { credentials: 'include' })).json();
          currentProject = pr;
          projectFolios = pr.folios.sort((a, b) => (a.folio_order || 0) - (b.folio_order || 0));
          updateFolioNav();

          closeModal('modal-borniers');
          setStatus(`✓ ${toCreate.length} folio(s) bornier créé(s), ${toUpdate.length} existant(s)`);
        } catch (e) {
          showWarning('Erreur : ' + e.message);
        } finally {
          genBtn.disabled = false;
          genBtn.textContent = '⊞ Générer les folios borniers';
        }
      };
    }
  }

  // ── Coffrets / Armoires Modal ─────────────────────────────────────
  async function openCoffretsModal() {
    if (!currentProject?.id) { showWarning('Ouvrez un projet pour gérer ses coffrets.'); return; }
    openModal('modal-coffrets');
    document.getElementById('coffrets-loading').style.display = '';
    document.getElementById('coffrets-content').style.display = 'none';
    document.getElementById('coffrets-add-form').style.display = 'none';
    _loadCoffretsModal();
  }

  async function _loadCoffretsModal() {
    const loading = document.getElementById('coffrets-loading');
    const content = document.getElementById('coffrets-content');
    loading.style.display = '';
    content.style.display = 'none';

    try {
      // Charger le projet à jour pour avoir tous les folios
      const pr = await (await fetch(`/api/projects/${currentProject.id}`, { credentials: 'include' })).json();
      currentProject = pr;
      projectFolios = pr.folios.sort((a, b) => (a.folio_order || 0) - (b.folio_order || 0));
      updateFolioNav();

      // Collecter les coffrets : un coffret = un folio implantation avec cabinetLabel
      const coffrets = [];
      for (const f of projectFolios) {
        const ft = f.folio_type || f.data?.folio_type;
        if (ft !== 'implantation') continue;
        const impl = f.implantation || f.data?.implantation || {};
        coffrets.push({
          folioId: f.id,
          folioName: f.name,
          folioNum: f.folio_num,
          label: impl.cabinetLabel || '',
          type: impl.cabinetType || 'coffret',
          blocs: impl.blocs || null,
          width: impl.cabinetW || null,
          height: impl.cabinetH || null,
          depth: impl.cabinetDepth || 200,
          gap: impl.gap || 0
        });
      }

      _renderCoffretsModal(coffrets);
    } catch(e) {
      loading.textContent = 'Erreur : ' + e.message;
    }
  }

  function _renderCoffretsModal(coffrets) {
    const loading = document.getElementById('coffrets-loading');
    const content = document.getElementById('coffrets-content');
    loading.style.display = 'none';

    if (!coffrets.length) {
      content.innerHTML = '<div style="padding:24px;text-align:center;color:var(--text3);font-size:12px">'
        + 'Aucun coffret ou armoire déclaré dans ce projet.<br>'
        + '<small>Cliquez "+ Ajouter un coffret" pour en créer un.</small></div>';
      content.style.display = '';
      _bindCoffretsModal(coffrets);
      return;
    }

    const typeLabels = { coffret: 'Coffret', armoire: 'Armoire monobloc', armoire_multibloc: 'Armoire multibloc' };

    let html = '<table style="width:100%;border-collapse:collapse;font-size:11px">';
    html += '<thead><tr style="background:var(--panel2)">'
      + '<th style="padding:6px 10px;text-align:left;font-size:9px;color:var(--text2);text-transform:uppercase;letter-spacing:.5px">Repère</th>'
      + '<th style="padding:6px 10px;text-align:left;font-size:9px;color:var(--text2);text-transform:uppercase;letter-spacing:.5px">Type</th>'
      + '<th style="padding:6px 10px;text-align:left;font-size:9px;color:var(--text2);text-transform:uppercase;letter-spacing:.5px">Dimensions</th>'
      + '<th style="padding:6px 10px;text-align:left;font-size:9px;color:var(--text2);text-transform:uppercase;letter-spacing:.5px">Folio</th>'
      + '<th style="padding:6px 10px;text-align:center;font-size:9px;color:var(--text2);text-transform:uppercase;letter-spacing:.5px;width:60px">Actions</th>'
      + '</tr></thead><tbody>';

    coffrets.forEach((c, i) => {
      const bg = i % 2 === 0 ? 'var(--panel)' : 'var(--panel2)';
      let dims;
      if (c.type === 'armoire_multibloc' && c.blocs) {
        dims = c.blocs.length + ' bloc' + (c.blocs.length > 1 ? 's' : '')
          + ' (' + c.blocs.map(b => (b.width||400) + 'x' + (b.height||2000)).join(', ') + ')';
      } else {
        dims = (c.width||600) + ' x ' + (c.height||400) + ' x ' + (c.depth||200) + ' mm';
      }
      html += '<tr style="background:' + bg + '">'
        + '<td style="padding:6px 10px;font-weight:700;color:var(--accent)">' + esc(c.label || '(sans repère)') + '</td>'
        + '<td style="padding:6px 10px;color:var(--text2)">' + (typeLabels[c.type] || c.type) + '</td>'
        + '<td style="padding:6px 10px;color:var(--text3);font-size:10px">' + dims + '</td>'
        + '<td style="padding:6px 10px"><a href="#" class="coffret-goto-folio" data-folio-id="' + c.folioId + '" style="color:var(--accent);text-decoration:none;font-size:10px">F' + (c.folioNum||'?') + ' — ' + esc(c.folioName) + '</a></td>'
        + '<td style="padding:6px 10px;text-align:center"><button class="btn-secondary coffret-del" data-folio-id="' + c.folioId + '" data-label="' + esc(c.label) + '" style="font-size:9px;padding:2px 6px;color:var(--accent2)" title="Supprimer ce coffret et son folio">✕</button></td>'
        + '</tr>';
    });

    html += '</tbody></table>';
    content.innerHTML = html;
    content.style.display = '';
    _bindCoffretsModal(coffrets);
  }

  function _bindCoffretsModal(coffrets) {
    // Naviguer vers un folio
    document.querySelectorAll('.coffret-goto-folio').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        const fid = a.dataset.folioId;
        if (fid) { closeModal('modal-coffrets'); saveSchema().then(() => openFolio(fid)); }
      });
    });

    // Supprimer un coffret (= supprimer son folio)
    document.querySelectorAll('.coffret-del').forEach(btn => {
      btn.addEventListener('click', async () => {
        const fid = btn.dataset.folioId;
        const label = btn.dataset.label || '(sans repère)';
        if (!await showConfirm(`Supprimer le coffret "${label}" et son folio implantation ?`)) return;
        try {
          await fetch(`/api/folios/${fid}`, { method: 'DELETE', credentials: 'include' });
          setStatus(`✓ Coffret "${label}" supprimé`);
          _loadCoffretsModal();
        } catch(e) { showWarning('Erreur : ' + e.message); }
      });
    });

    // Toggle formulaire d'ajout
    const addBtn = document.getElementById('coffrets-add-btn');
    const addForm = document.getElementById('coffrets-add-form');
    if (addBtn && addForm) {
      addBtn.onclick = () => {
        addForm.style.display = addForm.style.display === 'none' ? '' : 'none';
        if (addForm.style.display !== 'none') document.getElementById('cof-new-label')?.focus();
      };
    }

    // Toggle multibloc dans le formulaire d'ajout
    document.getElementById('cof-new-type')?.addEventListener('change', () => {
      const t = document.getElementById('cof-new-type').value;
      const isMb = t === 'armoire_multibloc';
      document.getElementById('cof-new-multibloc').style.display = isMb ? '' : 'none';
      // Masquer largeur/hauteur si multibloc (dimensions par bloc)
      const wEl = document.getElementById('cof-new-w')?.closest('div');
      const hEl = document.getElementById('cof-new-h')?.closest('div');
      if (wEl) wEl.style.display = isMb ? 'none' : '';
      if (hEl) hEl.style.display = isMb ? 'none' : '';
      // La grille globale n'a pas de sens en multibloc (chaque bloc aura sa propre grille)
      document.getElementById('cof-new-grid-section').style.display = isMb ? 'none' : '';
    });

    // Toggle visibilité champs grille selon checkbox
    document.getElementById('cof-new-has-grid')?.addEventListener('change', () => {
      const hasGrid = document.getElementById('cof-new-has-grid').checked;
      document.getElementById('cof-new-grid-dims').style.display = hasGrid ? '' : 'none';
    });

    // Confirmer ajout
    document.getElementById('cof-new-confirm')?.addEventListener('click', async () => {
      const label = document.getElementById('cof-new-label')?.value?.trim();
      if (!label) { document.getElementById('cof-new-label')?.focus(); showWarning('Saisissez un repère pour le coffret.'); return; }
      // Vérifier unicité
      if (coffrets.some(c => c.label === label)) { showWarning(`Le coffret "${label}" existe déjà.`); return; }

      const cabType = document.getElementById('cof-new-type')?.value || 'coffret';
      let implCfg;
      if (cabType === 'armoire_multibloc') {
        const count = parseInt(document.getElementById('cof-new-nbblocs')?.value) || 2;
        const gap = parseInt(document.getElementById('cof-new-gap')?.value) || 0;
        const depth = parseInt(document.getElementById('cof-new-d')?.value) || 200;
        const blocs = [];
        for (let i = 0; i < count; i++) {
          blocs.push({ id: 'bloc_' + i, label: 'Bloc ' + (i + 1), width: 400, height: 2000, rails: [], goulottes: [] });
        }
        implCfg = { cabinetType: 'armoire_multibloc', cabinetLabel: label, cabinetDepth: depth, gap, blocs };
      } else {
        const hasGrid = document.getElementById('cof-new-has-grid')?.checked || false;
        implCfg = {
          cabinetW: parseInt(document.getElementById('cof-new-w')?.value) || 600,
          cabinetH: parseInt(document.getElementById('cof-new-h')?.value) || 400,
          cabinetDepth: parseInt(document.getElementById('cof-new-d')?.value) || 200,
          cabinetLabel: label,
          cabinetType: cabType,
          rails: [], goulottes: [],
          hasGrid,
          gridW: parseInt(document.getElementById('cof-new-gw')?.value) || 560,
          gridH: parseInt(document.getElementById('cof-new-gh')?.value) || 360,
          gridDepth: parseInt(document.getElementById('cof-new-gd')?.value) || 150,
          gridCentered: document.getElementById('cof-new-grid-centered')?.checked !== false,
          gridOffsetX: 0, gridOffsetY: 0
        };
      }

      try {
        const res = await fetch(`/api/projects/${currentProject.id}/folios`, {
          method: 'POST', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: `Implantation ${label}`,
            data: { elements: [], wires: [], texts: [], shapes: [], junctions: [], images: [],
                    folio_type: 'implantation', implantation: implCfg }
          })
        });
        if (!res.ok) { const d = await res.json(); throw new Error(d.error || 'Erreur'); }
        setStatus(`✓ Coffret "${label}" créé`);
        // Réinitialiser le formulaire
        document.getElementById('cof-new-label').value = '';
        document.getElementById('coffrets-add-form').style.display = 'none';
        _loadCoffretsModal();
      } catch(e) { showWarning('Erreur : ' + e.message); }
    });
  }

  // ── AI Folio Generation ─────────────────────────────────────────
  let _aiGenImageData = null;

  function _aiGenSetImage(dataUrl) {
    _aiGenImageData = dataUrl;
    const preview = document.getElementById('ai-gen-image-preview');
    const thumb = document.getElementById('ai-gen-image-thumb');
    const btn = document.getElementById('ai-gen-image-btn');
    if (dataUrl) {
      thumb.src = dataUrl;
      preview.style.display = '';
      btn.style.display = 'none';
    } else {
      _aiGenImageData = null;
      preview.style.display = 'none';
      btn.style.display = 'flex';
    }
  }

  function openAiGenModal() {
    document.getElementById('ai-gen-desc').value = '';
    document.getElementById('ai-gen-status').style.display = 'none';
    document.getElementById('ai-gen-submit').disabled = false;
    document.getElementById('ai-gen-submit').textContent = '✨ Générer';
    _aiGenSetImage(null);
    // Example buttons
    document.querySelectorAll('.ai-example-btn').forEach(btn => {
      btn.onclick = () => { document.getElementById('ai-gen-desc').value = btn.textContent; };
    });
    // Image attachment: click + button
    document.getElementById('ai-gen-image-btn').onclick = () => {
      const inp = document.createElement('input');
      inp.type = 'file';
      inp.accept = 'image/*';
      inp.onchange = e => {
        const f = e.target.files[0];
        if (!f) return;
        const r = new FileReader();
        r.onload = ev => _aiGenSetImage(ev.target.result);
        r.readAsDataURL(f);
      };
      inp.click();
    };
    // Image attachment: remove
    document.getElementById('ai-gen-image-remove').onclick = () => _aiGenSetImage(null);
    // Image attachment: paste in modal
    const desc = document.getElementById('ai-gen-desc');
    desc.onpaste = e => {
      const items = e.clipboardData && e.clipboardData.items;
      if (!items) return;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.startsWith('image/')) {
          e.preventDefault();
          const f = items[i].getAsFile();
          const r = new FileReader();
          r.onload = ev => _aiGenSetImage(ev.target.result);
          r.readAsDataURL(f);
          return;
        }
      }
    };
    // Submit handler
    document.getElementById('ai-gen-submit').onclick = submitAiGen;
    openModal('modal-ai-gen');
  }

  async function submitAiGen() {
    const desc = document.getElementById('ai-gen-desc').value.trim();
    if (!desc) { showWarning('Veuillez saisir une description.'); return; }
    const mode = document.querySelector('input[name="ai-gen-mode"]:checked')?.value || 'append';

    const btn = document.getElementById('ai-gen-submit');
    const statusEl = document.getElementById('ai-gen-status');
    btn.disabled = true;
    btn.textContent = '⏳ Génération…';
    statusEl.style.display = '';

    try {
      const payload = { description: desc };
      if (_aiGenImageData) payload.image = _aiGenImageData;
      const res = await fetch('/api/ai/generate-folio', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur inconnue');

      const { elements: aiEls = [], wires: aiWires = [] } = data;

      if (mode === 'replace') {
        state.elements = []; state.wires = []; state.texts = []; state.shapes = [];
      }

      // Map tempId → real uid
      const idMap = {};

      aiEls.forEach(el => {
        const sym = _symbols[el.symId];
        if (!sym) { console.warn('[AI] symId inconnu:', el.symId); return; }
        const newId = uid();
        if (el.tempId) idMap[el.tempId] = newId;
        state.elements.push({
          id: newId,
          symId: el.symId,
          x: el.x || 80,
          y: el.y || 80,
          w: sym.width,
          h: sym.height,
          rotation: 0,
          flipH: false,
          color: PROJ.symColor || '#3b9eff',
          label: el.label || '',
          ref: el.ref || '',
          labelOffX: sym.defaultLabelOffX ?? 0,
          labelOffY: sym.defaultLabelOffY ?? (PROJ.labelOffY ?? -18),
          refOffX: sym.defaultRefOffX ?? 0,
          refOffY: sym.defaultRefOffY ?? (PROJ.refOffY ?? 10),
        });
      });

      aiWires.forEach(w => {
        if (!w.points || w.points.length < 2) return;
        state.wires.push({
          id: uid(),
          points: w.points,
          color: PROJ.wireColor || '#3b9eff',
          width: PROJ.wireWidth || 1.8,
          isBus: false,
          num: '',
        });
      });

      saveHistory('Générer avec IA');
      render();
      saveSchema();
      closeModal('modal-ai-gen');
      setStatus(`IA: ${aiEls.length} symbole(s), ${aiWires.length} fil(s) générés`);
    } catch (e) {
      showWarning('Erreur de génération IA: ' + e.message);
    } finally {
      btn.disabled = false;
      btn.textContent = '✨ Générer';
      statusEl.style.display = 'none';
    }
  }

  // ══════════════════════════════════════════════════════════════════
  // FONCTIONS RÉUTILISABLES
  // ══════════════════════════════════════════════════════════════════

  // Sauvegarder la sélection courante comme fonction
  async function saveSelectionAsFunc() {
    const keys = multiSel.size > 0 ? [...multiSel] : (selected.id ? [selKey(selected.type, selected.id)] : []);
    if (!keys.length) { setStatus('Rien à enregistrer'); return; }
    // Collecter les objets
    const items = { elements: [], wires: [], texts: [], shapes: [], junctions: [] };
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    keys.forEach(k => {
      const [t, id] = k.split(':');
      const o = getById(t, id);
      if (!o) return;
      const copy = JSON.parse(JSON.stringify(o));
      if (t === 'element') {
        items.elements.push(copy);
        minX = Math.min(minX, copy.x); minY = Math.min(minY, copy.y);
        maxX = Math.max(maxX, copy.x + copy.w); maxY = Math.max(maxY, copy.y + copy.h);
      } else if (t === 'wire') {
        items.wires.push(copy);
        copy.points.forEach(p => { minX = Math.min(minX, p.x); minY = Math.min(minY, p.y); maxX = Math.max(maxX, p.x); maxY = Math.max(maxY, p.y); });
      } else if (t === 'text') {
        items.texts.push(copy);
        minX = Math.min(minX, copy.x); minY = Math.min(minY, copy.y);
        maxX = Math.max(maxX, copy.x + 100); maxY = Math.max(maxY, copy.y + 20);
      } else if (t === 'shape') {
        items.shapes.push(copy);
      }
    });
    // Inclure les jonctions dans la zone
    (state.junctions || []).forEach(j => {
      if (j.x >= minX - 5 && j.x <= maxX + 5 && j.y >= minY - 5 && j.y <= maxY + 5) {
        items.junctions.push(JSON.parse(JSON.stringify(j)));
      }
    });
    const w = maxX - minX, h = maxY - minY;
    // Normaliser les positions (origine 0,0)
    items.elements.forEach(el => { el.x -= minX; el.y -= minY; });
    items.wires.forEach(wr => wr.points.forEach(p => { p.x -= minX; p.y -= minY; }));
    items.texts.forEach(t => { t.x -= minX; t.y -= minY; });
    items.shapes.forEach(sh => { if (sh.x != null) { sh.x -= minX; sh.y -= minY; } if (sh.pts) sh.pts.forEach(p => { p.x -= minX; p.y -= minY; }); });
    items.junctions.forEach(j => { j.x -= minX; j.y -= minY; });

    const name = prompt('Nom de la fonction :');
    if (!name || !name.trim()) return;
    try {
      const res = await fetch('/api/funcgroups', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), ...items, width: Math.round(w), height: Math.round(h) })
      });
      if (!res.ok) throw new Error((await res.json()).error || 'Erreur');
      setStatus(`Fonction "${name.trim()}" enregistrée`);
    } catch (err) { showWarning('Erreur : ' + err.message); }
  }

  // Ouvrir le modal de fonctions
  let _funcGroups = [];
  async function openFuncGroupsModal() {
    document.getElementById('modal-funcgroups').classList.remove('hidden');
    const listEl = document.getElementById('fg-list');
    listEl.innerHTML = '<div style="text-align:center;color:var(--text3);padding:16px">Chargement…</div>';
    try {
      const res = await fetch('/api/funcgroups', { credentials: 'include' });
      _funcGroups = await res.json();
      _renderFuncGroupsList();
    } catch { listEl.innerHTML = '<div style="color:var(--accent2);padding:16px">Erreur de chargement</div>'; }
  }

  function _renderFuncGroupsList() {
    const listEl = document.getElementById('fg-list');
    if (!_funcGroups.length) {
      listEl.innerHTML = '<div style="text-align:center;color:var(--text3);padding:24px;font-size:12px">Aucune fonction enregistrée.<br><small>Sélectionnez des éléments sur le canvas, clic droit → "Enregistrer comme fonction"</small></div>';
      return;
    }
    listEl.innerHTML = _funcGroups.map(fg => `
      <div style="display:flex;align-items:center;gap:10px;padding:8px 10px;border:1px solid var(--border);border-radius:6px;margin-bottom:6px;background:var(--panel2)">
        <div style="flex:1;min-width:0">
          <div style="font-weight:600;font-size:12px;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${_esc(fg.name)}</div>
          <div style="font-size:10px;color:var(--text3)">${fg.elements?.length||0} symboles, ${fg.wires?.length||0} fils — ${fg.width}×${fg.height}px</div>
        </div>
        <button class="btn-secondary fg-rename-btn" data-fgid="${fg.id}" style="font-size:10px;padding:4px 8px" title="Renommer">✏️</button>
        <button class="btn-secondary fg-edit-btn" data-fgid="${fg.id}" style="font-size:10px;padding:4px 8px" title="Modifier le contenu">🔧</button>
        <button class="btn-primary fg-place-btn" data-fgid="${fg.id}" style="font-size:10px;padding:4px 12px">Placer</button>
        <button class="btn-secondary fg-del-btn" data-fgid="${fg.id}" style="font-size:10px;padding:4px 8px;color:var(--accent2)">✕</button>
      </div>`).join('');
    function _esc(s) { return String(s).replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    // Placer
    listEl.querySelectorAll('.fg-place-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const fg = _funcGroups.find(f => f.id === btn.dataset.fgid);
        if (fg) _openPlaceFuncModal(fg);
      });
    });
    // Renommer
    listEl.querySelectorAll('.fg-rename-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const fg = _funcGroups.find(f => f.id === btn.dataset.fgid);
        if (!fg) return;
        const name = prompt('Nouveau nom :', fg.name);
        if (!name || !name.trim() || name.trim() === fg.name) return;
        await fetch(`/api/funcgroups/${fg.id}`, { method: 'PUT', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...fg, name: name.trim() }) });
        fg.name = name.trim();
        _renderFuncGroupsList();
      });
    });
    // Modifier le contenu
    listEl.querySelectorAll('.fg-edit-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const fg = _funcGroups.find(f => f.id === btn.dataset.fgid);
        if (!fg) return;
        _editFuncGroup(fg);
      });
    });
    // Supprimer
    listEl.querySelectorAll('.fg-del-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        if (!await showConfirm('Supprimer cette fonction ?')) return;
        await fetch(`/api/funcgroups/${btn.dataset.fgid}`, { method: 'DELETE', credentials: 'include' });
        _funcGroups = _funcGroups.filter(f => f.id !== btn.dataset.fgid);
        _renderFuncGroupsList();
      });
    });
  }

  // ── Édition d'une fonction réutilisable ──────────────────────────
  let _editingFuncGroup = null;

  function _editFuncGroup(fg) {
    _editingFuncGroup = fg;
    closeModal('modal-funcgroups');

    // Sauvegarder l'état actuel pour pouvoir le restaurer si annulation
    _editingFuncGroup._prevState = JSON.parse(JSON.stringify(state));

    // Vider le canvas et charger les éléments de la fonction
    state.elements = [];
    state.wires = [];
    state.texts = [];
    state.shapes = [];
    state.junctions = [];
    state.images = [];

    // Placer les éléments de la fonction au centre
    (fg.elements || []).forEach(el => {
      const copy = JSON.parse(JSON.stringify(el));
      copy.id = uid();
      state.elements.push(copy);
    });
    (fg.wires || []).forEach(w => {
      const copy = JSON.parse(JSON.stringify(w));
      copy.id = uid();
      state.wires.push(copy);
    });
    (fg.texts || []).forEach(t => {
      const copy = JSON.parse(JSON.stringify(t));
      copy.id = uid();
      state.texts.push(copy);
    });
    (fg.shapes || []).forEach(sh => {
      const copy = JSON.parse(JSON.stringify(sh));
      copy.id = uid();
      state.shapes.push(copy);
    });
    (fg.junctions || []).forEach(j => {
      const copy = JSON.parse(JSON.stringify(j));
      copy.id = uid();
      state.junctions.push(copy);
    });

    render();
    setStatus(`Mode édition de la fonction "${fg.name}" — Modifiez les éléments puis cliquez "Sauvegarder la fonction" dans le menu`);

    // Afficher la barre d'édition de fonction
    _showFuncEditBar(fg.name);
  }

  function _showFuncEditBar(name) {
    let bar = document.getElementById('func-edit-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'func-edit-bar';
      bar.style.cssText = 'position:fixed;top:48px;left:50%;transform:translateX(-50%);z-index:900;background:var(--accent);color:#fff;padding:6px 16px;border-radius:0 0 8px 8px;display:flex;align-items:center;gap:12px;font-size:12px;font-family:var(--font);box-shadow:0 4px 12px rgba(0,0,0,.4)';
      document.body.appendChild(bar);
    }
    bar.innerHTML = `
      <span style="font-weight:600">✏️ Édition fonction : ${name}</span>
      <button id="func-edit-save" style="background:#fff;color:var(--accent);border:none;border-radius:4px;padding:4px 12px;font-size:11px;cursor:pointer;font-weight:600;font-family:var(--font)">✓ Sauvegarder</button>
      <button id="func-edit-cancel" style="background:rgba(255,255,255,.2);color:#fff;border:1px solid rgba(255,255,255,.4);border-radius:4px;padding:4px 12px;font-size:11px;cursor:pointer;font-family:var(--font)">✕ Annuler</button>`;
    bar.style.display = 'flex';

    document.getElementById('func-edit-save').addEventListener('click', _saveFuncGroupEdit);
    document.getElementById('func-edit-cancel').addEventListener('click', _cancelFuncGroupEdit);
  }

  async function _saveFuncGroupEdit() {
    if (!_editingFuncGroup) return;

    // Calculer le bounding box de tous les éléments
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    state.elements.forEach(el => {
      minX = Math.min(minX, el.x); minY = Math.min(minY, el.y);
      maxX = Math.max(maxX, el.x + (el.w || 0)); maxY = Math.max(maxY, el.y + (el.h || 0));
    });
    state.wires.forEach(w => w.points.forEach(p => {
      minX = Math.min(minX, p.x); minY = Math.min(minY, p.y);
      maxX = Math.max(maxX, p.x); maxY = Math.max(maxY, p.y);
    }));
    state.texts.forEach(t => { minX = Math.min(minX, t.x); minY = Math.min(minY, t.y); maxX = Math.max(maxX, t.x + 80); maxY = Math.max(maxY, t.y + 16); });
    if (minX === Infinity) { minX = 0; minY = 0; maxX = 100; maxY = 100; }

    // Normaliser les positions (offset à 0,0)
    const elements = state.elements.map(el => ({ ...el, x: el.x - minX, y: el.y - minY }));
    const wires = state.wires.map(w => ({ ...w, points: w.points.map(p => ({ x: p.x - minX, y: p.y - minY })) }));
    const texts = state.texts.map(t => ({ ...t, x: t.x - minX, y: t.y - minY }));
    const shapes = state.shapes.map(sh => {
      const copy = { ...sh };
      if (copy.x != null) { copy.x -= minX; copy.y -= minY; }
      if (copy.pts) copy.pts = copy.pts.map(p => ({ x: p.x - minX, y: p.y - minY }));
      return copy;
    });
    const junctions = (state.junctions || []).map(j => ({ ...j, x: j.x - minX, y: j.y - minY }));

    const width = Math.round(maxX - minX);
    const height = Math.round(maxY - minY);

    // Sauvegarder via l'API
    try {
      await fetch(`/api/funcgroups/${_editingFuncGroup.id}`, {
        method: 'PUT', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: _editingFuncGroup.name, category: _editingFuncGroup.category,
          elements, wires, texts, shapes, junctions, width, height })
      });
      setStatus(`Fonction "${_editingFuncGroup.name}" mise à jour`);
    } catch (e) { setStatus('Erreur lors de la sauvegarde'); }

    // Restaurer l'état précédent
    _restorePrevState();
  }

  function _cancelFuncGroupEdit() {
    if (!_editingFuncGroup) return;
    _restorePrevState();
    setStatus('Édition de fonction annulée');
  }

  function _restorePrevState() {
    if (_editingFuncGroup?._prevState) {
      Object.assign(state, _editingFuncGroup._prevState);
    }
    _editingFuncGroup = null;
    const bar = document.getElementById('func-edit-bar');
    if (bar) bar.style.display = 'none';
    render(); updateStatus(); updateProps();
  }

  let _placingFunc = null;
  function _openPlaceFuncModal(fg) {
    _placingFunc = fg;
    document.getElementById('modal-funcgroups').classList.add('hidden');
    document.getElementById('modal-place-func').classList.remove('hidden');
    document.getElementById('pf-name').textContent = `Fonction : ${fg.name} (${fg.width}×${fg.height}px)`;
    document.getElementById('pf-count').value = '1';
    document.getElementById('pf-spacing').value = '20';
    // Rebind place button
    const placeBtn = document.getElementById('pf-place-btn');
    const newBtn = placeBtn.cloneNode(true);
    placeBtn.parentNode.replaceChild(newBtn, placeBtn);
    newBtn.addEventListener('click', () => {
      const count = Math.max(1, parseInt(document.getElementById('pf-count').value) || 1);
      const spacing = parseInt(document.getElementById('pf-spacing').value) || 20;
      document.getElementById('modal-place-func').classList.add('hidden');
      _startFuncPlacement(_placingFunc, count, spacing);
    });
  }

  // ── Mode placement interactif (fantôme + clic) ──────────────
  let _funcPlacement = null; // { fg, count, spacing }

  function _startFuncPlacement(fg, count, spacing) {
    _funcPlacement = { fg, count, spacing };
    canvas.style.cursor = 'crosshair';
    setStatus(`Cliquer pour placer "${fg.name}" ×${count} — Echap pour annuler`);
    render();
  }

  function _cancelFuncPlacement() {
    _funcPlacement = null;
    canvas.style.cursor = '';
    setStatus('Placement annulé');
    render();
  }

  function _drawFuncPreview(ctx) {
    if (!_funcPlacement) return;
    const { fg, count, spacing } = _funcPlacement;
    const wx = cursorWorld.x, wy = cursorWorld.y;
    const sx = snapW(wx); const sy = snapW(wy);

    ctx.save();
    ctx.globalAlpha = 0.4;
    for (let n = 0; n < count; n++) {
      const dx = sx + n * (fg.width + spacing);
      const dy = sy;
      // Dessiner les éléments en fantôme
      (fg.elements || []).forEach(el => {
        const sym = _symbols[el.symId]; if (!sym) return;
        const ghost = { ...el, x: el.x + dx, y: el.y + dy };
        Renderer.drawSymbol(ctx, sym, ghost, false, false, false, 0);
      });
      // Dessiner les fils en fantôme
      (fg.wires || []).forEach(wr => {
        const ghost = { ...wr, points: wr.points.map(p => ({ x: p.x + dx, y: p.y + dy })) };
        ctx.strokeStyle = ghost.color || '#3b9eff';
        ctx.lineWidth = ghost.isBus ? 3 : 1.5;
        ctx.beginPath();
        ctx.moveTo(ghost.points[0].x, ghost.points[0].y);
        for (let i = 1; i < ghost.points.length; i++) ctx.lineTo(ghost.points[i].x, ghost.points[i].y);
        ctx.stroke();
      });
      // Dessiner les textes en fantôme
      (fg.texts || []).forEach(t => {
        ctx.fillStyle = t.color || '#dde1ed';
        ctx.font = `${t.size || 13}px "JetBrains Mono",monospace`;
        ctx.textAlign = 'left'; ctx.textBaseline = 'top';
        ctx.fillText(t.text, t.x + dx, t.y + dy);
      });
    }
    // Contour englobant
    ctx.globalAlpha = 0.3;
    ctx.strokeStyle = '#3b9eff'; ctx.lineWidth = 1; ctx.setLineDash([6, 4]);
    const totalW = count * fg.width + (count - 1) * spacing;
    ctx.strokeRect(sx - 2, sy - 2, totalW + 4, fg.height + 4);
    ctx.setLineDash([]);
    ctx.restore();
  }

  function _commitFuncPlacement() {
    if (!_funcPlacement) return;
    const { fg, count, spacing } = _funcPlacement;
    const wx = cursorWorld.x, wy = cursorWorld.y;
    const sx = snapW(wx); const sy = snapW(wy);

    multiSel.clear();
    for (let n = 0; n < count; n++) {
      const dx = sx + n * (fg.width + spacing);
      const dy = sy;
      (fg.elements || []).forEach(el => {
        const copy = JSON.parse(JSON.stringify(el));
        copy.id = uid(); copy.x += dx; copy.y += dy;
        if (PROJ.autoName && copy.symId) {
          const sym = _symbols[copy.symId];
          if (sym) copy.label = _generateRef(sym);
        }
        state.elements.push(copy);
        multiSel.add(selKey('element', copy.id));
      });
      (fg.wires || []).forEach(wr => {
        const copy = JSON.parse(JSON.stringify(wr));
        copy.id = uid();
        copy.points = copy.points.map(p => ({ x: p.x + dx, y: p.y + dy }));
        delete copy.xrefStart; delete copy.xrefEnd;
        state.wires.push(copy);
        multiSel.add(selKey('wire', copy.id));
      });
      (fg.texts || []).forEach(t => {
        const copy = JSON.parse(JSON.stringify(t));
        copy.id = uid(); copy.x += dx; copy.y += dy;
        state.texts.push(copy);
        multiSel.add(selKey('text', copy.id));
      });
      (fg.shapes || []).forEach(sh => {
        const copy = JSON.parse(JSON.stringify(sh));
        copy.id = uid();
        if (copy.x != null) { copy.x += dx; copy.y += dy; }
        if (copy.pts) copy.pts.forEach(p => { p.x += dx; p.y += dy; });
        state.shapes.push(copy);
      });
      (fg.junctions || []).forEach(j => {
        const copy = { ...j, id: uid(), x: j.x + dx, y: j.y + dy };
        state.junctions.push(copy);
      });
    }
    _funcPlacement = null;
    canvas.style.cursor = '';
    saveHistory(`Placer fonction ×${count}`);
    scheduleAutoXrefs();
    render(); updateStatus(); updateProps();
    setStatus(`${count} instance(s) de "${fg.name}" placée(s)`);
  }

  // ════════════════════════════════════════════════════════════════════════
  // MODE ÉDITION CARTOUCHE
  // ════════════════════════════════════════════════════════════════════════

  const _TB_MM = 3.7795275591;

  function _cellsToShapes(cells) {
    const shapes = [];
    const texts  = [];
    for (const c of (cells || [])) {
      const id = c.id || uid();
      if (c.type === 'rect') {
        shapes.push({ id, t:'rect', x:c.x*_TB_MM, y:c.y*_TB_MM, w:c.w*_TB_MM, h:c.h*_TB_MM,
          color:c.color||'#333', thick:1, fill:!!c.bg,
          _cell:{ type:'rect', bg:c.bg, noText:c.noText } });
      } else if (c.type === 'line') {
        shapes.push({ id, t:'line', pts:[{x:c.x*_TB_MM,y:c.y*_TB_MM},{x:(c.x2||c.x)*_TB_MM,y:(c.y2||c.y)*_TB_MM}],
          color:c.color||'#333', thick:c.thick||1,
          _cell:{ type:'line', style:c.style } });
      } else if (c.type === 'circle') {
        shapes.push({ id, t:'circle', cx:c.cx*_TB_MM, cy:c.cy*_TB_MM, r:(c.r||10)*_TB_MM,
          color:c.color||'#333', thick:c.thick||1, fill:!!c.bg,
          _cell:{ type:'circle', bg:c.bg, style:c.style } });
      } else if (c.type === 'poly') {
        shapes.push({ id, t:'poly', pts:(c.pts||[]).map(p=>({x:p.x*_TB_MM,y:p.y*_TB_MM})),
          color:c.color||'#333', thick:c.thick||1, fill:!!c.bg||!!c.fill,
          _cell:{ type:'poly', bg:c.bg, fill:c.fill } });
      } else if (c.type === 'arc') {
        shapes.push({ id, t:'arc', cx:c.cx*_TB_MM, cy:c.cy*_TB_MM, r:(c.r||10)*_TB_MM,
          a1:c.a1||0, a2:c.a2||Math.PI, color:c.color||'#333', thick:c.thick||1,
          _cell:{ type:'arc' } });
      } else if (c.type === 'text' || c.type === 'var') {
        shapes.push({ id, t:'textbox', x:c.x*_TB_MM, y:c.y*_TB_MM, w:(c.w||40)*_TB_MM, h:(c.h||10)*_TB_MM,
          text: c.type === 'var' ? (c.var||'') : (c.text||''),
          fontSize: c.fsize||10, textColor: c.color||'#222', align: c.align||'left', valign:'top',
          padding:2, color: c.bg||'transparent', thick:0.5, stroke:'none',
          _cell:{ type:c.type, bold:c.bold, bg:c.bg, fsize:c.fsize, nobg:c.nobg } });
      } else if (c.type === 'logo') {
        shapes.push({ id, t:'textbox', x:c.x*_TB_MM, y:c.y*_TB_MM, w:(c.w||40)*_TB_MM, h:(c.h||20)*_TB_MM,
          text:'[LOGO]', fontSize:10, textColor:'#999', align:'center', valign:'middle',
          padding:2, color:'#ddd', thick:0.5, stroke:'dash',
          _cell:{ type:'logo' } });
      } else if (c.type === 'revtable') {
        shapes.push({ id, t:'textbox', x:c.x*_TB_MM, y:c.y*_TB_MM, w:(c.w||80)*_TB_MM, h:(c.h||30)*_TB_MM,
          text:'[TABLEAU RÉVISIONS]', fontSize:10, textColor:'#999', align:'center', valign:'middle',
          padding:2, color:'#ddd', thick:0.5, stroke:'dash',
          _cell:{ type:'revtable' } });
      }
    }
    return { shapes, texts };
  }

  function _shapesToCells(shapes) {
    const cells = [];
    for (const sh of (shapes || [])) {
      const ct = sh._cell?.type || sh.t;
      const id = sh.id;
      if (ct === 'rect' || (sh.t === 'rect' && !sh._cell)) {
        cells.push({ id, type:'rect', x:+(sh.x/_TB_MM).toFixed(2), y:+(sh.y/_TB_MM).toFixed(2),
          w:+(sh.w/_TB_MM).toFixed(2), h:+(sh.h/_TB_MM).toFixed(2),
          bg: sh._cell?.bg || (sh.fill ? sh.color : null), color: sh.color||'#333',
          noText: sh._cell?.noText });
      } else if (ct === 'line' || (sh.t === 'line' && !sh._cell)) {
        const p0 = sh.pts?.[0] || {x:0,y:0}, p1 = sh.pts?.[1] || p0;
        cells.push({ id, type:'line', x:+(p0.x/_TB_MM).toFixed(2), y:+(p0.y/_TB_MM).toFixed(2),
          x2:+(p1.x/_TB_MM).toFixed(2), y2:+(p1.y/_TB_MM).toFixed(2),
          color: sh.color||'#333', thick: sh.thick||1, style: sh._cell?.style||'' });
      } else if (ct === 'circle' || (sh.t === 'circle' && !sh._cell)) {
        cells.push({ id, type:'circle', cx:+(sh.cx/_TB_MM).toFixed(2), cy:+(sh.cy/_TB_MM).toFixed(2),
          r:+(sh.r/_TB_MM).toFixed(2), color: sh.color||'#333', thick: sh.thick||1,
          bg: sh._cell?.bg || (sh.fill ? sh.color : null), style: sh._cell?.style||'' });
      } else if (ct === 'poly' || (sh.t === 'poly' && !sh._cell)) {
        cells.push({ id, type:'poly', pts:(sh.pts||[]).map(p=>({x:+(p.x/_TB_MM).toFixed(2),y:+(p.y/_TB_MM).toFixed(2)})),
          color: sh.color||'#333', thick: sh.thick||1,
          fill: sh._cell?.fill || sh.fill, bg: sh._cell?.bg || (sh.fill ? sh.color : null) });
      } else if (ct === 'arc' || (sh.t === 'arc' && !sh._cell)) {
        cells.push({ id, type:'arc', cx:+(sh.cx/_TB_MM).toFixed(2), cy:+(sh.cy/_TB_MM).toFixed(2),
          r:+(sh.r/_TB_MM).toFixed(2), a1:sh.a1||0, a2:sh.a2||Math.PI,
          color: sh.color||'#333', thick: sh.thick||1 });
      } else if (ct === 'text' || ct === 'var') {
        const cell = { id, type:ct, x:+(sh.x/_TB_MM).toFixed(2), y:+(sh.y/_TB_MM).toFixed(2),
          w:+(sh.w/_TB_MM).toFixed(2), h:+(sh.h/_TB_MM).toFixed(2),
          fsize: sh.fontSize||sh._cell?.fsize||10, bold: sh._cell?.bold||0,
          color: sh.textColor||sh.color||'#222', align: sh.align||'left',
          bg: sh._cell?.bg||null };
        if (ct === 'var') cell.var = sh.text||'';
        else cell.text = sh.text||'';
        cells.push(cell);
      } else if (ct === 'logo') {
        cells.push({ id, type:'logo', x:+(sh.x/_TB_MM).toFixed(2), y:+(sh.y/_TB_MM).toFixed(2),
          w:+(sh.w/_TB_MM).toFixed(2), h:+(sh.h/_TB_MM).toFixed(2) });
      } else if (ct === 'revtable') {
        cells.push({ id, type:'revtable', x:+(sh.x/_TB_MM).toFixed(2), y:+(sh.y/_TB_MM).toFixed(2),
          w:+(sh.w/_TB_MM).toFixed(2), h:+(sh.h/_TB_MM).toFixed(2) });
      } else if (sh.t === 'textbox' && !sh._cell) {
        cells.push({ id, type:'text', text:sh.text||'', x:+(sh.x/_TB_MM).toFixed(2), y:+(sh.y/_TB_MM).toFixed(2),
          w:+(sh.w/_TB_MM).toFixed(2), h:+(sh.h/_TB_MM).toFixed(2),
          fsize: sh.fontSize||10, bold:0, color: sh.textColor||'#222', align: sh.align||'left', bg:null });
      }
    }
    return cells;
  }

  function enterCartoucheEdit(which) {
    if (_cartoucheEditMode) return;
    which = which || 'default';

    // Récupérer le cartouche source
    let tbData = TitleBlock.getTB(which);
    if (!tbData) tbData = which === 'cover' ? TitleBlock._coverTB() : TitleBlock._defaultTB();
    tbData = JSON.parse(JSON.stringify(tbData));

    // Sauvegarder l'état actuel du folio
    _cartoucheEditBackup = {
      state:     JSON.parse(JSON.stringify(state)),
      view:      { ...view },
      printZone: { ...printZone },
      selected:  { ...selected },
      tool:      currentTool,
      gridVisible: gridVisible,
    };
    _cartoucheOrigData = JSON.parse(JSON.stringify(tbData));
    _cartoucheEditWhich = which;
    _cartoucheEditMode = true;

    // Convertir les cellules en shapes
    const converted = _cellsToShapes(tbData.cells);
    state.elements  = [];
    state.wires     = [];
    state.texts     = [];
    state.junctions = [];
    state.images    = [];
    state.shapes    = converted.shapes;

    // Historique propre pour le mode cartouche
    history = []; histIdx = -1;
    saveHistory('Ouverture cartouche');

    // Calculer la zone de travail (dimensions du cartouche en px)
    const fmt = TitleBlock.FORMATS[tbData.format] || TitleBlock.FORMATS.A3L;
    const isCover = !!tbData.isCover;
    const tbW = fmt.w * _TB_MM;
    const tbH = (isCover ? fmt.h : (tbData.cartoucheH || 55)) * _TB_MM;
    printZone.x = 0; printZone.y = 0;
    printZone.w = tbW; printZone.h = tbH;
    printZone.show = true;

    // Centrer la vue
    const cw = canvas.width, ch = canvas.height;
    const zx = (cw - 80) / tbW, zy = (ch - 80) / tbH;
    view.zoom = Math.min(zx, zy, 3) * 0.85;
    view.panX = (cw - tbW * view.zoom) / 2;
    view.panY = (ch - tbH * view.zoom) / 2;

    // Sélection/outil
    selected.type = null; selected.id = null;
    multiSel.clear();
    setTool('select');

    // UI : afficher la bannière cartouche, masquer les outils folio
    _showCartoucheBanner(which, tbData);

    function _fitCartouche() {
      resize();
      const cw2 = canvas.width, ch2 = canvas.height;
      const zx2 = (cw2 - 80) / tbW, zy2 = (ch2 - 80) / tbH;
      view.zoom = Math.min(zx2, zy2, 3) * 0.85;
      view.panX = (cw2 - tbW * view.zoom) / 2;
      view.panY = (ch2 - tbH * view.zoom) / 2;
      render();
    }
    _fitCartouche();
    requestAnimationFrame(() => requestAnimationFrame(_fitCartouche));
    setStatus(`Mode cartouche — ${which === 'cover' ? 'Page de garde' : which === 'folio' ? 'Surcharge folio' : 'Standard'}`);
  }

  function exitCartoucheEdit(save) {
    if (!_cartoucheEditMode) return;

    if (save) {
      // Convertir les shapes actuelles en cellules cartouche
      const newCells = _shapesToCells(state.shapes);
      const tbData = JSON.parse(JSON.stringify(_cartoucheOrigData));
      tbData.cells = newCells;
      // Sauvegarder via TitleBlock.saveTB
      TitleBlock.saveTB(_cartoucheEditWhich, tbData);
      setStatus('✓ Cartouche enregistré');
    }

    // Restaurer l'état folio
    if (_cartoucheEditBackup) {
      Object.assign(state, _cartoucheEditBackup.state);
      Object.assign(view, _cartoucheEditBackup.view);
      Object.assign(printZone, _cartoucheEditBackup.printZone);
      Object.assign(selected, _cartoucheEditBackup.selected);
      currentTool = _cartoucheEditBackup.tool;
      gridVisible = _cartoucheEditBackup.gridVisible;
    }

    // Recalculer la zone d'impression (le cartouche a pu changer)
    if (save && printZone.format) {
      applyFormatToPrintZone(printZone.format);
    }

    // Restaurer l'historique
    history = []; histIdx = -1;
    saveHistory('Retour folio');

    _cartoucheEditMode = false;
    _cartoucheEditWhich = null;
    _cartoucheEditBackup = null;
    _cartoucheOrigData = null;

    // UI
    _hideCartoucheBanner();
    setTool(currentTool);

    resize();
    render();
    requestAnimationFrame(() => requestAnimationFrame(() => { resize(); render(); }));
    updateStatus(); updateProps();
    if (!save) setStatus('Édition cartouche annulée');
  }

  // Outils masqués en mode cartouche
  const _CE_HIDDEN_TOOLS = ['wire','bus','text','image','measure','simulate'];

  function _showCartoucheBanner(which, tbData) {
    // Basculer le ribbon sur Accueil
    document.querySelectorAll('.ribbon-tab').forEach(t=>t.classList.remove('active'));
    document.querySelector('.ribbon-tab[data-ribbon="accueil"]')?.classList.add('active');
    document.querySelectorAll('.ribbon-panel').forEach(p=>p.classList.remove('active'));
    document.getElementById('rpanel-accueil')?.classList.add('active');

    // Masquer les outils non pertinents pour le cartouche
    _CE_HIDDEN_TOOLS.forEach(t => {
      const btn = document.querySelector(`.rb.tool[data-tool="${t}"],.tb-btn.tool[data-tool="${t}"]`);
      if (btn) btn.style.display = 'none';
    });
    const mo = document.getElementById('measure-opts');
    if (mo) mo.style.display = 'none';

    // Injecter le bouton « Variable » dans la toolbar si absent
    if (!document.getElementById('ce-btn-var')) {
      const tbxBtn = document.querySelector('.rb.tool[data-tool="textbox"],.tb-btn.tool[data-tool="textbox"]');
      if (tbxBtn) {
        const varBtn = document.createElement('button');
        varBtn.id = 'ce-btn-var';
        varBtn.className = 'rb tool';
        varBtn.dataset.tool = 'ce-var';
        varBtn.title = 'V — Insérer une variable folio ({{titre}}, {{folio}}…)';
        varBtn.innerHTML = '<svg viewBox="0 0 20 20"><text x="2" y="15" style="font-size:13px;font-weight:bold;fill:currentColor;stroke:none">⟪⟫</text></svg><span>Var.</span>';
        tbxBtn.parentNode.insertBefore(varBtn, tbxBtn.nextSibling);
        varBtn.addEventListener('click', () => _ceInsertVariable());
      }
    }
    document.getElementById('ce-btn-var')?.style.setProperty('display', '');

    // Masquer les éléments non essentiels de la tab-bar
    document.getElementById('mode-badge')?.style.setProperty('display','none');
    document.getElementById('schema-name')?.style.setProperty('display','none');
    document.querySelector('.ribbon-tabs')?.style.setProperty('display','none');

    // Créer le bandeau cartouche dans la barre d'onglets
    let banner = document.getElementById('cartouche-edit-banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'cartouche-edit-banner';
      banner.style.cssText = 'display:flex;align-items:center;gap:8px;margin-left:8px;flex-shrink:0';
      const tbRight = document.querySelector('.ribbon-tab-bar .tb-right');
      if (tbRight) tbRight.parentNode.insertBefore(banner, tbRight);
    }
    const label = which === 'cover' ? 'Page de garde' : which === 'folio' ? 'Surcharge folio' : 'Standard';
    const fmtLabel = (TitleBlock.FORMATS[tbData.format]||{}).label || tbData.format;
    banner.innerHTML = `
      <span style="font-size:10px;color:var(--warn);font-weight:600;letter-spacing:.5px">CARTOUCHE</span>
      <span style="font-size:9px;background:rgba(59,158,255,.15);color:var(--accent);padding:2px 7px;border-radius:3px">${label}</span>
      <span style="font-size:9px;color:var(--text3)">${fmtLabel}</span>
      ${tbData.isCover ? '' : `<label style="font-size:9px;color:var(--text3);display:flex;align-items:center;gap:3px">H
        <input id="ce-height" type="number" min="20" max="200" value="${tbData.cartoucheH||55}"
          style="width:48px;background:var(--panel2);border:1px solid var(--border2);color:var(--text);padding:2px 4px;border-radius:3px;font:10px var(--font);outline:none;text-align:right">mm</label>`}
      <select id="ce-which" style="background:var(--panel2);border:1px solid var(--border2);color:var(--text);padding:2px 6px;border-radius:3px;font:10px var(--font);outline:none">
        <option value="default"${which==='default'?' selected':''}>Standard</option>
        <option value="cover"${which==='cover'?' selected':''}>Page de garde</option>
        <option value="folio"${which==='folio'?' selected':''}${!currentFolioId?' disabled':''}>Ce folio</option>
      </select>
      <button id="ce-models" style="background:rgba(59,158,255,.1);border:1px solid var(--accent);color:var(--accent);padding:3px 10px;border-radius:var(--radius);font:600 10px var(--font);cursor:pointer">Mes modèles</button>
      <button id="ce-save" style="background:rgba(77,255,145,.15);border:1px solid var(--accent3);color:var(--accent3);padding:3px 10px;border-radius:var(--radius);font:600 10px var(--font);cursor:pointer">Enregistrer</button>
      <button id="ce-cancel" style="background:transparent;border:1px solid var(--border2);color:var(--text2);padding:3px 10px;border-radius:var(--radius);font:10px var(--font);cursor:pointer">Annuler</button>
    `;
    banner.querySelector('#ce-save').onclick = () => exitCartoucheEdit(true);
    banner.querySelector('#ce-cancel').onclick = () => exitCartoucheEdit(false);
    banner.querySelector('#ce-models').onclick = () => _toggleCeModelsPanel();
    banner.querySelector('#ce-which').onchange = (e) => {
      exitCartoucheEdit(false);
      enterCartoucheEdit(e.target.value);
    };
    const ceHeightInput = banner.querySelector('#ce-height');
    if (ceHeightInput) {
      ceHeightInput.oninput = () => {
        const newH = Math.max(20, Math.min(200, parseInt(ceHeightInput.value) || 55));
        _cartoucheOrigData.cartoucheH = newH;
        const tbH = newH * _TB_MM;
        printZone.h = tbH;
        state.shapes.forEach(s => {
          if (s._cellId === 'border') { s.h = tbH; }
        });
        const cw = canvas.width, ch = canvas.height;
        const tbW = printZone.w;
        const zx = (cw - 80) / tbW, zy = (ch - 80) / tbH;
        view.zoom = Math.min(zx, zy, 3) * 0.85;
        view.panX = (cw - tbW * view.zoom) / 2;
        view.panY = (ch - tbH * view.zoom) / 2;
        const sbCz = document.getElementById('sb-cartouche-zone');
        if(sbCz) sbCz.innerHTML = `Zone cartouche : <b>${Math.round(printZone.w/_TB_MM)} × ${newH} mm</b>`;
        render();
      };
    }

    // Masquer la sidebar (bibliothèque de symboles)
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      sidebar.dataset.ceWasVisible = sidebar.style.display !== 'none' ? '1' : '';
      sidebar.style.display = 'none';
    }

    // Masquer les infos folio dans la barre de statut, afficher zone cartouche
    const sbCursor = document.getElementById('sb-cursor');
    if(sbCursor) sbCursor.parentElement.style.display='none';
    const sbElems = document.getElementById('sb-elems');
    if(sbElems) sbElems.parentElement.style.display='none';
    const sbWires = document.getElementById('sb-wires');
    if(sbWires) sbWires.parentElement.style.display='none';
    const sbFolio = document.getElementById('sb-folio');
    if(sbFolio) sbFolio.parentElement.style.display='none';
    let sbCz = document.getElementById('sb-cartouche-zone');
    if(!sbCz){
      sbCz = document.createElement('span');
      sbCz.id = 'sb-cartouche-zone';
      const sbStatus = document.getElementById('sb-status');
      if(sbStatus && sbStatus.nextElementSibling) sbStatus.nextElementSibling.after(sbCz);
    }
    const czW = Math.round(printZone.w/_TB_MM), czH = Math.round(printZone.h/_TB_MM);
    sbCz.innerHTML = `Zone cartouche : <b>${czW} × ${czH} mm</b>`;
    sbCz.style.display = '';
  }

  function _hideCartoucheBanner() {
    _removeCeModelsPanel();
    const banner = document.getElementById('cartouche-edit-banner');
    if (banner) banner.remove();
    // Restaurer les éléments masqués de la tab-bar
    document.getElementById('mode-badge')?.style.setProperty('display','');
    document.getElementById('schema-name')?.style.setProperty('display','');
    document.querySelector('.ribbon-tabs')?.style.setProperty('display','');
    // Restaurer les boutons outils masqués
    _CE_HIDDEN_TOOLS.forEach(t => {
      const btn = document.querySelector(`.rb.tool[data-tool="${t}"],.tb-btn.tool[data-tool="${t}"]`);
      if (btn) btn.style.display = '';
    });
    // Masquer le bouton variable
    const varBtn = document.getElementById('ce-btn-var');
    if (varBtn) varBtn.style.display = 'none';
    // Restaurer la sidebar
    const sidebar = document.getElementById('sidebar');
    if (sidebar && sidebar.dataset.ceWasVisible === '1') sidebar.style.display = '';
    // Restaurer la barre de statut
    const sbCursor = document.getElementById('sb-cursor');
    if(sbCursor) sbCursor.parentElement.style.display='';
    const sbElems = document.getElementById('sb-elems');
    if(sbElems) sbElems.parentElement.style.display='';
    const sbWires = document.getElementById('sb-wires');
    if(sbWires) sbWires.parentElement.style.display='';
    const sbFolio = document.getElementById('sb-folio');
    if(sbFolio) sbFolio.parentElement.style.display='';
    const sbCz = document.getElementById('sb-cartouche-zone');
    if(sbCz) sbCz.style.display='none';
  }

  // ── Panneau "Mes modèles" dans l'éditeur cartouche inline ──────────
  let _ceModelsPanel = null;

  function _removeCeModelsPanel() {
    if (_ceModelsPanel) { _ceModelsPanel.remove(); _ceModelsPanel = null; }
    const btn = document.getElementById('ce-models');
    if (btn) { btn.style.background = 'rgba(59,158,255,.1)'; }
  }

  function _toggleCeModelsPanel() {
    if (_ceModelsPanel) { _removeCeModelsPanel(); return; }
    const wrap = document.getElementById('canvas-wrap');
    if (!wrap) return;

    const panel = document.createElement('div');
    panel.id = 'ce-models-panel';
    panel.style.cssText = 'position:absolute;top:0;right:0;bottom:0;width:320px;background:var(--panel);border-left:1px solid var(--border2);z-index:20;display:flex;flex-direction:column;box-shadow:-4px 0 20px rgba(0,0,0,.3)';
    panel.innerHTML = `
      <div style="padding:10px 14px;border-bottom:1px solid var(--border2);display:flex;align-items:center;gap:8px;flex-shrink:0">
        <span style="font-size:12px;font-weight:700;color:var(--text);flex:1">Mes modèles</span>
        <span id="cem-count" style="font-size:10px;color:var(--text3)"></span>
        <button id="cem-close" style="background:none;border:none;color:var(--text3);font-size:14px;cursor:pointer;padding:0 4px">✕</button>
      </div>
      <div style="padding:10px 14px;border-bottom:1px solid var(--border2);flex-shrink:0">
        <div style="font-size:9px;color:var(--text3);font-weight:600;letter-spacing:.5px;margin-bottom:6px">SAUVEGARDER LE CARTOUCHE ACTUEL</div>
        <div style="display:flex;gap:6px">
          <input type="text" id="cem-save-name" class="prop-input" placeholder="Nom du modèle…" style="flex:1;font-size:11px;padding:5px 8px">
          <select id="cem-save-type" class="prop-input" style="width:auto;font-size:10px;padding:5px 6px">
            <option value="default">Standard</option>
            <option value="cover">Couverture</option>
          </select>
          <button id="cem-save-btn" class="btn-primary" style="font-size:10px;padding:5px 12px;white-space:nowrap">Sauvegarder</button>
        </div>
      </div>
      <div style="padding:8px 14px;border-bottom:1px solid var(--border2);flex-shrink:0">
        <div style="font-size:9px;color:var(--text3);font-weight:600;letter-spacing:.5px">MODÈLES SYSTÈME</div>
      </div>
      <div id="cem-sys" style="padding:6px 14px;display:flex;flex-direction:column;gap:4px;flex-shrink:0"></div>
      <div style="padding:8px 14px;border-bottom:1px solid var(--border2);border-top:1px solid var(--border2);flex-shrink:0">
        <div style="font-size:9px;color:var(--text3);font-weight:600;letter-spacing:.5px">MODÈLES CLIENT</div>
      </div>
      <div id="cem-list" style="flex:1;overflow-y:auto;padding:6px 14px;display:flex;flex-direction:column;gap:4px">
        <div id="cem-loading" style="color:var(--text3);font-size:11px;text-align:center;padding:20px">Chargement…</div>
      </div>`;
    wrap.appendChild(panel);
    _ceModelsPanel = panel;

    const btn = document.getElementById('ce-models');
    if (btn) btn.style.background = 'rgba(59,158,255,.35)';

    panel.querySelector('#cem-close').onclick = () => _removeCeModelsPanel();
    if (_cartoucheEditWhich === 'cover') panel.querySelector('#cem-save-type').value = 'cover';

    panel.querySelector('#cem-save-btn').onclick = async () => {
      const nameEl = panel.querySelector('#cem-save-name');
      const name = nameEl.value.trim();
      if (!name) { nameEl.style.borderColor = '#ff6340'; return; }
      nameEl.style.borderColor = '';
      const type = panel.querySelector('#cem-save-type').value;
      const tbData = _shapesToCells(state.shapes);
      const fullTB = JSON.parse(JSON.stringify(_cartoucheOrigData));
      fullTB.cells = tbData;
      const clientId = currentUser?.activeClientId;
      if (!clientId) { setStatus('Client introuvable'); return; }
      try {
        const res = await fetch(`/api/clients/${clientId}/titleblocks`, {
          method: 'POST', credentials: 'include',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({ name, type, data: fullTB })
        });
        if (res.ok) { nameEl.value = ''; setStatus(`Modèle "${name}" sauvegardé`); _renderCeModels(panel); }
        else setStatus('Erreur sauvegarde');
      } catch { setStatus('Erreur sauvegarde'); }
    };

    _renderCeModels(panel);
  }

  function _ceEsc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  async function _renderCeModels(panel) {
    const sysEl = panel.querySelector('#cem-sys');
    const listEl = panel.querySelector('#cem-list');
    const countEl = panel.querySelector('#cem-count');
    const loadingEl = panel.querySelector('#cem-loading');

    // Modèles système
    const sysList = [
      { key: 'default', label: 'Standard' },
      { key: 'cover',   label: 'Page de garde' },
      { key: 'empty',   label: 'Vide (bordure seule)' },
    ];
    sysEl.innerHTML = sysList.map(s => `
      <div class="cem-sys" data-key="${s.key}" style="padding:6px 8px;background:var(--panel2);border:1px solid var(--border2);border-radius:4px;cursor:pointer;font-size:11px;display:flex;align-items:center;gap:6px">
        <span style="flex:1">${s.label}</span>
        <span style="font-size:9px;color:var(--accent)">charger</span>
      </div>`).join('');
    sysEl.querySelectorAll('.cem-sys').forEach(el => {
      el.onmouseenter = () => el.style.borderColor = 'var(--accent)';
      el.onmouseleave = () => el.style.borderColor = 'var(--border2)';
      el.onclick = () => {
        const fmt = _cartoucheOrigData?.format || 'A3L';
        const fmtW = (TitleBlock.FORMATS[fmt] || TitleBlock.FORMATS.A3L).w;
        const cH = _cartoucheOrigData?.cartoucheH || 55;
        let tbData;
        if (el.dataset.key === 'cover') tbData = TitleBlock._coverTB(fmt);
        else if (el.dataset.key === 'empty') tbData = { format: fmt, cartoucheH: cH, cartoucheW: fmtW, revisions: [], logo: null,
          cells: [{ id: 'border', type: 'rect', x: 0, y: 0, w: fmtW, h: cH, bg: null, color: '#333', noText: true }] };
        else tbData = TitleBlock._defaultTB(fmt);
        _loadTBIntoCartoucheEdit(tbData);
        setStatus('Modèle système chargé');
      };
    });

    // Modèles client
    if (loadingEl) loadingEl.style.display = 'block';
    listEl.querySelectorAll('.cem-card').forEach(c => c.remove());
    const clientId = currentUser?.activeClientId;
    let models = [];
    if (clientId) {
      try {
        const res = await fetch(`/api/clients/${clientId}/titleblocks`, { credentials: 'include' });
        if (res.ok) models = await res.json();
      } catch {}
    }
    if (loadingEl) loadingEl.style.display = 'none';
    if (countEl) countEl.textContent = models.length + ' modèle' + (models.length > 1 ? 's' : '');

    if (!models.length) {
      const empty = document.createElement('div');
      empty.style.cssText = 'color:var(--text3);font-size:11px;text-align:center;padding:20px';
      empty.textContent = 'Aucun modèle sauvegardé.';
      listEl.appendChild(empty);
      return;
    }

    models.forEach(m => {
      const card = document.createElement('div');
      card.className = 'cem-card';
      card.style.cssText = 'background:var(--panel2);border:1px solid var(--border2);border-radius:4px;padding:8px 10px;display:flex;flex-direction:column;gap:4px;transition:border-color .12s';
      card.onmouseenter = () => card.style.borderColor = 'var(--accent)';
      card.onmouseleave = () => card.style.borderColor = 'var(--border2)';
      const typeBadge = m.type === 'cover'
        ? '<span style="font-size:8px;padding:1px 5px;border-radius:2px;background:rgba(255,99,64,.12);color:#ff6340">couverture</span>'
        : '<span style="font-size:8px;padding:1px 5px;border-radius:2px;background:rgba(59,158,255,.1);color:var(--accent)">standard</span>';
      const fmt = m.data?.format || '';
      const date = m.updated_at ? new Date(m.updated_at).toLocaleDateString('fr-FR') : '';
      card.innerHTML = `
        <div style="display:flex;align-items:center;gap:6px">
          <span style="font-size:11px;font-weight:500;color:var(--text);flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${_ceEsc(m.name)}</span>
          ${typeBadge}
        </div>
        <div style="font-size:9px;color:var(--text3)">${fmt ? fmt + ' · ' : ''}${date}</div>
        <div style="display:flex;gap:4px;margin-top:2px">
          <button class="cem-load btn-primary" style="font-size:9px;padding:3px 8px;flex:1">Charger</button>
          <button class="cem-overwrite btn-secondary" style="font-size:9px;padding:3px 8px" title="Écraser avec le cartouche actuel">Écraser</button>
          <button class="cem-rename btn-secondary" style="font-size:9px;padding:3px 6px" title="Renommer">✏</button>
          <button class="cem-del btn-secondary" style="font-size:9px;padding:3px 6px;color:#ff6340;border-color:rgba(255,99,64,.3)" title="Supprimer">✕</button>
        </div>`;
      listEl.appendChild(card);

      card.querySelector('.cem-load').onclick = () => {
        if (m.data) { _loadTBIntoCartoucheEdit(m.data); setStatus(`Modèle "${m.name}" chargé`); }
      };
      card.querySelector('.cem-overwrite').onclick = async () => {
        if (!await showConfirm(`Écraser "${m.name}" avec le cartouche actuel ?`)) return;
        const cells = _shapesToCells(state.shapes);
        const fullTB = JSON.parse(JSON.stringify(_cartoucheOrigData));
        fullTB.cells = cells;
        try {
          const res = await fetch(`/api/clients/${clientId}/titleblocks/${m.id}`, {
            method: 'PUT', credentials: 'include',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({ data: fullTB })
          });
          if (res.ok) { setStatus(`"${m.name}" mis à jour`); _renderCeModels(panel); }
          else setStatus('Erreur mise à jour');
        } catch { setStatus('Erreur mise à jour'); }
      };
      card.querySelector('.cem-rename').onclick = async () => {
        const newName = prompt('Nouveau nom :', m.name);
        if (!newName || !newName.trim() || newName.trim() === m.name) return;
        try {
          const res = await fetch(`/api/clients/${clientId}/titleblocks/${m.id}`, {
            method: 'PUT', credentials: 'include',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({ name: newName.trim() })
          });
          if (res.ok) { setStatus('Renommé'); _renderCeModels(panel); }
        } catch {}
      };
      card.querySelector('.cem-del').onclick = async () => {
        if (!await showConfirm(`Supprimer "${m.name}" ?`)) return;
        try {
          const res = await fetch(`/api/clients/${clientId}/titleblocks/${m.id}`, {
            method: 'DELETE', credentials: 'include'
          });
          if (res.ok) { setStatus('Modèle supprimé'); _renderCeModels(panel); }
          else setStatus('Erreur suppression');
        } catch { setStatus('Erreur suppression'); }
      };
    });
  }

  function _loadTBIntoCartoucheEdit(tbData) {
    tbData = JSON.parse(JSON.stringify(tbData));
    _cartoucheOrigData = tbData;
    const converted = _cellsToShapes(tbData.cells);
    state.shapes = converted.shapes;
    state.elements = []; state.wires = []; state.texts = []; state.junctions = []; state.images = [];
    selected = { type: null, id: null };
    multiSel = new Set();
    const _TB_MM = 3.7795275591;
    const tbW = (tbData.cartoucheW || 420) * _TB_MM;
    const tbH = (tbData.cartoucheH || 55) * _TB_MM;
    printZone.w = tbW; printZone.h = tbH;
    printZone.x = 0; printZone.y = 0;
    function _fit() {
      resize();
      const cw = canvas.width, ch = canvas.height;
      const zx = (cw - 80) / tbW, zy = (ch - 80) / tbH;
      view.zoom = Math.min(zx, zy, 3) * 0.85;
      view.panX = (cw - tbW * view.zoom) / 2;
      view.panY = (ch - tbH * view.zoom) / 2;
      render();
    }
    _fit();
    requestAnimationFrame(() => requestAnimationFrame(_fit));
  }

  // Insertion d'une variable folio dans le cartouche
  function _ceInsertVariable() {
    const vars = [
      { label:'Titre du projet',     val:'{{titre}}' },
      { label:'Sous-titre / folio',  val:'{{sous_titre}}' },
      { label:'N° de folio',         val:'{{folio}}' },
      { label:'Total folios',        val:'{{total_folios}}' },
      { label:'Date',                val:'{{date}}' },
      { label:'Révision',            val:'{{revision}}' },
      { label:'Dessinateur',         val:'{{dessinateur}}' },
      { label:'Vérificateur',        val:'{{verificateur}}' },
      { label:'Société',             val:'{{societe}}' },
      { label:'Affaire / référence', val:'{{affaire}}' },
      { label:'Format',              val:'{{format}}' },
      { label:'Échelle',             val:'{{echelle}}' },
      { label:'Folio / Total',       val:'{{folio}} / {{total_folios}}' },
      { label:'Champ libre 1',       val:'{{custom_1}}' },
      { label:'Champ libre 2',       val:'{{custom_2}}' },
      { label:'Champ libre 3',       val:'{{custom_3}}' },
    ];

    // Popup de sélection
    let popup = document.getElementById('ce-var-popup');
    if (popup) { popup.remove(); return; }
    popup = document.createElement('div');
    popup.id = 'ce-var-popup';
    popup.style.cssText = 'position:fixed;top:70px;left:50%;transform:translateX(-50%);z-index:950;background:var(--panel,#1a1d2e);border:1px solid var(--border2,#333);border-radius:6px;padding:8px 0;box-shadow:0 8px 24px rgba(0,0,0,.5);min-width:260px;max-height:400px;overflow-y:auto';
    vars.forEach(v => {
      const row = document.createElement('button');
      row.style.cssText = 'display:flex;justify-content:space-between;align-items:center;width:100%;padding:6px 14px;background:none;border:none;color:var(--text,#dde1ed);font:12px var(--font);cursor:pointer;text-align:left';
      row.innerHTML = `<span>${v.label}</span><code style="opacity:.5;font-size:10px">${v.val}</code>`;
      row.onmouseenter = () => row.style.background = 'rgba(59,158,255,.12)';
      row.onmouseleave = () => row.style.background = 'none';
      row.onclick = () => {
        popup.remove();
        _ceAddVarShape(v.val, v.label);
      };
      popup.appendChild(row);
    });
    document.body.appendChild(popup);
    const close = (e) => { if (!popup.contains(e.target)) { popup.remove(); document.removeEventListener('mousedown', close); } };
    setTimeout(() => document.addEventListener('mousedown', close), 0);
  }

  function _ceAddVarShape(varTemplate, label) {
    const sh = {
      id: uid(), t:'textbox',
      x: printZone.x + printZone.w * 0.3,
      y: printZone.y + printZone.h * 0.3,
      w: 80, h: 20,
      text: varTemplate,
      fontSize: 10, textColor: '#222', align: 'left', valign: 'top',
      padding: 2, color: 'transparent', thick: 0.5, stroke: 'none',
      _cell: { type: 'var', bold: 0, bg: null, fsize: 10 }
    };
    state.shapes.push(sh);
    selected.type = 'shape'; selected.id = sh.id;
    multiSel.clear();
    saveHistory('Insérer variable ' + label);
    render(); updateProps();
    setStatus('Variable insérée : ' + varTemplate);
  }


// ═══ app-admin.js ═══
// ── app-admin.js ─────────────────────────────────────────
// Partie du App IIFE — assemblé par build.js
// NOTE: L'administration est maintenant une page dédiée (/admin.html).
// Ce fichier ne contient plus que le menu contextuel et des stubs de compatibilité.

  // Stubs pour compatibilité (code mort dans bindModals, sera nettoyé plus tard)
  let _currentClientId = null;
  let _currentEditUserId = null;
  let _polarities = [];
  async function refreshClients(){}
  async function refreshUsers(){}
  async function loadClientUsers(){}
  async function loadClientStats(){}
  async function loadClientLibs(){}
  async function openClientDetail(){}
  async function openUserDetail(){}
  function _switchCdTab(){}
  function _switchUdTab(){}
  function renderUserMemberships(){}
  function initUserDetailUI(){}
  function initPolaritiesUI(){}
  async function loadPolarities(){}
  function renderPolaritiesTable(){}
  function openPolForm(){}
  function closePolForm(){}
  async function savePolarity(){}

  // ── Ctx menu ──────────────────────────────────────────────
  function showCtx(x,y){
    const m=document.getElementById('ctx-menu');
    const selObj=getSel();
    // Fusionner / décomposer
    const canMerge=multiSel.size>=2&&[...multiSel].some(k=>k.startsWith('shape:')||k.startsWith('wire:')||k.startsWith('text:'));
    const canUnmerge=selected.type==='shape'&&selObj?.t==='group';
    m.querySelector('[data-action="merge"]').style.display=canMerge?'':'none';
    m.querySelector('[data-action="unmerge"]').style.display=canUnmerge?'':'none';
    const canToSymbol=multiSel.size>=1&&[...multiSel].some(k=>k.startsWith('shape:')||k.startsWith('wire:')||k.startsWith('text:'));
    m.querySelector('[data-action="to-symbol"]').style.display=canToSymbol?'':'none';
    // Pivoter / miroir : sur éléments uniquement
    const isElem=selected.type==='element';
    m.querySelector('[data-action="rotate"]').style.display=isElem||multiSel.size>1?'':'none';
    m.querySelector('[data-action="flip-h"]').style.display=isElem?'':'none';
    // N° de fil : sur fils uniquement
    m.querySelector('[data-action="wirenum"]').style.display=selected.type==='wire'?'':'none';
    // Fusionner fils : visible si 2 fils sélectionnés et connectés bout-à-bout
    const selWireIds=[...multiSel].filter(k=>k.startsWith('wire:')).map(k=>k.slice(5));
    const canMergeWires=selWireIds.length===2&&_wiresConnected(
      state.wires.find(w=>w.id===selWireIds[0]),
      state.wires.find(w=>w.id===selWireIds[1])
    );
    m.querySelector('[data-action="merge-wires"]').style.display=canMergeWires?'':'none';
    // Éditer le symbole : visible seulement si sélection = 1 élément ET droits suffisants
    let canEditSym=false;
    if(isElem&&selObj&&multiSel.size<=1){
      const sym=_symbols[selObj.symId];
      canEditSym=!!(sym&&(currentUser.role==='admin'||(!sym.builtin&&sym.created_by===currentUser.id)));
    }
    m.querySelector('[data-action="edit-sym"]').style.display=canEditSym?'':'none';
    // Enregistrer comme fonction : visible si au moins 1 objet sélectionné
    const saveFuncEl = m.querySelector('[data-action="save-func"]');
    if (saveFuncEl) saveFuncEl.style.display = (multiSel.size >= 1 || selected.id) ? '' : 'none';
    m.style.display='block';
    m.style.left=Math.min(x,window.innerWidth-200)+'px';
    m.style.top=Math.min(y,window.innerHeight-260)+'px';
  }
  function hideCtx(){document.getElementById('ctx-menu').style.display='none';}

  // ══════════════════════════════════════════════════════════

// ═══ app-bom.js ═══
  // MODULE NOMENCLATURE (BOM)
  // ══════════════════════════════════════════════════════════

  let _bomVisible = false;

  // Détecte si le folio courant est de type BOM
  function _isBomFolio(){
    if(!currentFolioId)return false;
    const f=projectFolios.find(x=>x.id===currentFolioId);
    return !!(f?.data?.folio_type==='bom'||f?.folio_type==='bom');
  }

  function isSummaryFolio(f){
    return !!(f?.data?.folio_type==='summary'||f?.folio_type==='summary');
  }

  // Cache données des folios pour les champs custom
  async function _cacheProjectFoliosData(){
    for(const f of projectFolios){
      if(f.id===currentFolioId||f._cachedData)continue;
      if(f.data?.folio_type==='bom'||f.data?.folio_type==='summary'||f.data?.folio_type==='implantation')continue; // skip special folios
      try{
        const res=await fetch(`/api/folios/${f.id}`,{credentials:'include'});
        if(res.ok){const s=await res.json();f._cachedData=s.data||{};}
      }catch(e){}
    }
  }

  // Calcule les lignes de nomenclature depuis tous les folios du projet
  async function _computeBomRows(bomConfig){
    await _cacheProjectFoliosData();
    const cols=bomConfig.columns.filter(c=>c.checked).map(c=>c.id);
    const group=bomConfig.group||'ref';
    // Collecter tous les éléments de tous les folios (sauf BOM)
    const rows=[];
    for(const f of projectFolios){
      if(f.id===currentFolioId)continue;
      const isBom=f.data?.folio_type==='bom'||f.folio_type==='bom';
      if(isBom)continue;
      const d=f._cachedData||(f.id===currentFolioId?{elements:state.elements}:{elements:[]});
      const folioLabel=`F${f.folio_num||'?'}`;
      for(const el of (d.elements||[])){
        const sym=_symbols[el.symId];
        // Si le symbole a inBom explicitement à false → exclure
        if(sym && sym.inBom === false) continue;
        rows.push({
          ref:el.ref||'',
          label:el.label||'',
          symId:el.symId,
          symName:sym?.name||el.symId,
          category:sym?.category||'',
          folioNum:f.folio_num||'?',
          folioLabel,
          color:el.color||'#3b9eff',
          w:el.w, h:el.h,
          props:el.props||{},
          sym,
          bomFields:sym?.bomFields||null
        });
      }
    }
    // Groupement
    let grouped=[];
    if(group==='ref'){
      // 1 ligne par ref unique (ou par el si ref vide)
      const map=new Map();
      rows.forEach(r=>{
        const key=r.ref||('__'+r.symId+'__'+Math.random());
        if(r.ref&&map.has(key)){
          const ex=map.get(key);
          if(!ex.folios.includes(r.folioLabel))ex.folios.push(r.folioLabel);
          ex.qty++;
        }else{
          const entry={...r,qty:1,folios:[r.folioLabel]};
          map.set(key,entry);
          grouped.push(entry);
        }
      });
    }else if(group==='sym'){
      const map=new Map();
      rows.forEach(r=>{
        const key=r.symId;
        if(map.has(key)){
          const ex=map.get(key);
          if(!ex.folios.includes(r.folioLabel))ex.folios.push(r.folioLabel);
          ex.qty++;
          if(r.ref)ex.refs.push(r.ref);
        }else{
          const entry={...r,qty:1,folios:[r.folioLabel],refs:[r.ref].filter(Boolean)};
          map.set(key,entry);grouped.push(entry);
        }
      });
    }else if(group==='folio'){
      const map=new Map();
      rows.forEach(r=>{
        const key=r.folioLabel;
        if(!map.has(key)){map.set(key,{folioLabel:key,items:[],qty:0});grouped.push(map.get(key));}
        map.get(key).items.push(r);map.get(key).qty++;
      });
    }else{
      grouped=rows.map(r=>({...r,qty:1,folios:[r.folioLabel]}));
    }
    return{rows:grouped,cols};
  }

  // Génère le HTML du tableau BOM
  function _renderBomTable(rows,cols,config){
    const COL_LABELS={qty:'Qté',ref:'Référence',label:'Désignation',sym:'Symbole',
      cat:'Catégorie',folio:'Folio(s)',color:'Couleur',size:'Taille'};
    // Construire map id→label depuis bomConfig.columns (inclut les labels des champs custom)
    const _colLabelMap={};
    (config?.columns||[]).forEach(c=>{ if(c.label) _colLabelMap[c.id]=c.label; });
    function colLabel(id){
      if(_colLabelMap[id]) return _colLabelMap[id];
      if(id.startsWith('cf_')) return id.slice(3); // fallback : ID brut
      return COL_LABELS[id]||id;
    }
    const thead=`<tr>${cols.map(c=>`<th>${colLabel(c)}</th>`).join('')}</tr>`;
    const tbody=rows.map((r,i)=>{
      const _folioAttr=r.folios?.length ? `data-folio="${r.folios[0]}"` : `data-folio="${r.folioLabel||''}"`;
      const _refAttr=r.ref ? `data-ref="${r.ref.replace(/"/g,'&quot;')}"` : '';
      const _symAttr=r.symId ? `data-symid="${r.symId}"` : '';
      const cells=cols.map(c=>{
        if(c==='qty')return`<td class="bom-qty">${r.qty||1}</td>`;
        if(c==='ref'){
          const refs=r.refs?.length?r.refs.join(', '):(r.ref||'—');
          return`<td>${refs}</td>`;
        }
        if(c==='label')return`<td>${r.label||r.symName||'—'}</td>`;
        if(c==='sym'){
          const canvas=`<canvas class="bom-sym-thumb" id="bom-sym-${i}" width="28" height="28"></canvas>`;
          return`<td style="white-space:nowrap">${canvas}${r.symName}</td>`;
        }
        if(c==='cat')return`<td>${r.category||'—'}</td>`;
        if(c==='folio')return`<td>${(r.folios||[r.folioLabel]).join(', ')}</td>`;
        if(c==='color')return`<td><span style="display:inline-block;width:14px;height:14px;border-radius:3px;background:${r.color};vertical-align:middle;margin-right:4px;border:1px solid rgba(255,255,255,.2)"></span>${r.color}</td>`;
        if(c==='size')return`<td>${Math.round(r.w||0)}×${Math.round(r.h||0)}</td>`;
        // Champ custom — chercher dans tous les rawIds associés à cette colonne
        if(c.startsWith('cf_')||c.startsWith('cfn_')){
          let val='—';
          const colMeta=config?.columns?.find(x=>x.id===c);
          if(colMeta?.rawIds?.length){
            // Chercher la première valeur non vide parmi les rawIds
            for(const rid of colMeta.rawIds){
              const v=r.props?.[rid];
              if(v!==undefined&&v!==null&&v!==''){val=v;break;}
            }
          } else if(c.startsWith('cf_')){
            val=r.props?.[c.slice(3)]||'—';
          }
          return`<td>${val}</td>`;
        }
        return`<td>—</td>`;
      }).join('');
      return`<tr class="bom-row" ${_folioAttr} ${_refAttr} ${_symAttr} style="cursor:pointer" title="Double-clic : aller au folio">${cells}</tr>`;
    }).join('');
    return`<table class="bom-table"><thead>${thead}</thead><tbody>${tbody}</tbody></table>`;
  }

  // Dessine les mini-aperçus symbole dans les canvas du tableau
  function _renderBomSymThumbs(rows,cols){
    if(!cols.includes('sym'))return;
    rows.forEach((r,i)=>{
      const cv=document.getElementById(`bom-sym-${i}`);
      if(!cv||!r.sym)return;
      const ctx2=cv.getContext('2d');
      ctx2.clearRect(0,0,28,28);
      const fakeEl={x:0,y:0,w:28,h:28,rotation:0,flipH:false,color:r.color||'#3b9eff'};
      try{Renderer.drawSymbol(ctx2,r.sym,fakeEl,false,false);}catch(e){}
    });
  }

  // Ouvre/ferme l'overlay BOM
  async function showBomOverlay(){
    const overlay=document.getElementById('bom-overlay');
    const f=projectFolios.find(x=>x.id===currentFolioId);
    const bomConfig=f?.data?.bomConfig;
    if(!bomConfig){overlay.classList.remove('visible');return;}
    overlay.classList.add('visible');
    _bomVisible=true;
    document.getElementById('bom-title').textContent=`Nomenclature — ${f.name||'BOM'}`;
    document.getElementById('bom-content').innerHTML='<div style="color:var(--text3);padding:20px">Calcul en cours…</div>';
    const{rows,cols}=await _computeBomRows(bomConfig);
    if(!rows.length){
      document.getElementById('bom-content').innerHTML='<div style="color:var(--text3);padding:30px;text-align:center;font-size:13px">Aucun composant trouvé dans les folios du projet.</div>';
      return;
    }
    document.getElementById('bom-content').innerHTML=_renderBomTable(rows,cols,bomConfig);
    _renderBomSymThumbs(rows,cols);
  }


  // ═══════════════════════════════════════════════════════════════
  // SOMMAIRE
  // ═══════════════════════════════════════════════════════════════

  function hideSummaryOverlay(){
    const ov = document.getElementById('summary-overlay');
    if(ov) ov.style.display = 'none';
  }

  async function showSummaryOverlay(){
    const ov = document.getElementById('summary-overlay');
    if(!ov) return;
    ov.style.display = 'flex';

    const f = projectFolios.find(x => x.id === currentFolioId);
    document.getElementById('summary-title').textContent = f?.name || 'Sommaire';
    document.getElementById('summary-content').innerHTML =
      '<div style="color:var(--text3);padding:20px;text-align:center">Génération…</div>';

    // Construire le tableau de tous les folios (y compris le sommaire)
    const folios = projectFolios
      .slice()
      .sort((a,b) => (a.folio_order||0) - (b.folio_order||0));

    if(!folios.length){
      document.getElementById('summary-content').innerHTML =
        '<div style="color:var(--text3);padding:30px;text-align:center;font-size:13px">Aucun folio dans le projet.</div>';
      return;
    }

    document.getElementById('summary-content').innerHTML = _renderSummaryTable(folios);
    _bindSummaryActions();
  }

  function _renderSummaryTable(folios){
    const projName = currentProject?.name || '';
    const today = new Date().toLocaleDateString('fr-FR');
    const _ro = isReadOnly;
    const _thSt = 'padding:7px 10px;text-align:left;border:1px solid var(--border2);color:var(--text3);font-weight:700;letter-spacing:.5px;font-size:9px;text-transform:uppercase';

    let html = '<div style="padding:16px 24px">';

    // En-tête
    html += '<div style="display:flex;align-items:center;gap:12px;margin-bottom:16px;border-bottom:1px solid var(--border2);padding-bottom:10px">'
      + '<span style="font-size:13px;font-weight:700;color:var(--text)">' + esc(projName) + '</span>'
      + '<span style="font-size:10px;color:var(--text3);margin-left:auto">Généré le ' + today + '</span>'
      + '</div>';

    // Barre d'actions
    if (!_ro) {
      html += '<div style="display:flex;gap:8px;margin-bottom:12px">'
        + '<button id="sum-add-folio" class="btn-primary" style="font-size:10px;padding:4px 12px">+ Ajouter un folio</button>'
        + '<button id="sum-save-order" class="btn-secondary" style="font-size:10px;padding:4px 12px;display:none">💾 Sauvegarder l\'ordre</button>'
        + '</div>';
    }

    // Tableau
    html += '<table id="sum-table" style="width:100%;border-collapse:collapse;font-size:11px">';
    html += '<thead><tr style="background:var(--panel2)">'
      + (_ro ? '' : '<th style="' + _thSt + ';width:28px"></th>')
      + '<th style="' + _thSt + ';width:64px">N°</th>'
      + '<th style="' + _thSt + '">Titre du folio</th>'
      + '<th style="' + _thSt + '">Description</th>'
      + '<th style="' + _thSt + ';width:80px">Type</th>'
      + '<th style="' + _thSt + ';width:120px">Modifié</th>'
      + (_ro ? '' : '<th style="' + _thSt + ';width:32px"></th>')
      + '</tr></thead>';
    html += '<tbody id="sum-tbody">';

    folios.forEach((f, idx) => {
      const isBom  = f.data?.folio_type==='bom'  || f.folio_type==='bom';
      const isSumm = f.data?.folio_type==='summary' || f.folio_type==='summary';
      const isBorn = f.data?.folio_type==='bornier' || f.folio_type==='bornier';
      const isImpl = f.data?.folio_type==='implantation' || f.folio_type==='implantation';
      const typeLabel = isSumm ? '☰ Sommaire' : isBom ? '⊞ Nomenclature' : isBorn ? '⊟ Bornier' : isImpl ? '⬒ Implantation' : '⬛ Schéma';
      const typeColor = isSumm ? 'var(--text3)' : isBom ? 'var(--accent3)' : isBorn ? 'var(--warn)' : isImpl ? 'var(--accent)' : 'var(--text2)';
      const bg = idx % 2 === 0 ? 'var(--panel)' : 'var(--panel2)';
      const updAt = f.updated_at ? new Date(f.updated_at).toLocaleDateString('fr-FR') + ' ' + new Date(f.updated_at).toLocaleTimeString('fr-FR',{hour:'2-digit',minute:'2-digit'}) : '—';
      const desc = f.description || '';

      html += '<tr data-folio-id="' + f.id + '" data-idx="' + idx + '" style="background:' + bg + ';cursor:pointer;transition:background .12s">';
      if (!_ro) html += '<td style="padding:4px 6px;border:1px solid var(--border2);text-align:center;cursor:grab;color:var(--text3);font-size:11px" class="sum-drag-handle">⠿</td>';
      html += '<td style="padding:6px 10px;border:1px solid var(--border2);text-align:center">'
        + (_ro ? '<span style="font-weight:700;color:var(--accent);font-size:12px">' + (f.folio_num||idx+1) + '</span>'
              : '<input type="text" inputmode="decimal" pattern="^[0-9]+(\\.[0-9]+)?$" title="Entier ou décimal (ex: 1, 1.2)" class="sum-num-input" data-folio-id="' + f.id + '" value="' + (f.folio_num||idx+1) + '" style="width:52px;background:var(--panel);border:1px solid var(--border);color:var(--accent);font-weight:700;font-size:12px;text-align:center;border-radius:3px;padding:2px 4px;font-family:var(--font)">')
        + '</td>'
        + '<td style="padding:6px 10px;border:1px solid var(--border2)">'
        + (_ro ? '<span style="font-weight:600;color:var(--text)">' + esc(f.name) + '</span>'
              : '<input type="text" class="sum-name-input" data-folio-id="' + f.id + '" value="' + esc(f.name) + '" style="width:100%;background:var(--panel);border:1px solid var(--border);color:var(--text);font-weight:600;font-size:11px;border-radius:3px;padding:3px 6px;font-family:var(--font)">')
        + '</td>'
        + '<td style="padding:6px 10px;border:1px solid var(--border2)">'
        + (_ro ? '<span style="color:var(--text2);font-size:10px">' + esc(desc) + '</span>'
              : '<input type="text" class="sum-desc-input" data-folio-id="' + f.id + '" value="' + esc(desc) + '" placeholder="Description…" style="width:100%;background:var(--panel);border:1px solid var(--border);color:var(--text2);font-size:10px;border-radius:3px;padding:3px 6px;font-family:var(--font)">')
        + '</td>'
        + '<td style="padding:6px 10px;border:1px solid var(--border2);color:' + typeColor + ';font-size:10px">' + typeLabel + '</td>'
        + '<td style="padding:6px 10px;border:1px solid var(--border2);color:var(--text3);font-size:10px">' + updAt + '</td>';
      if (!_ro) html += '<td style="padding:4px 6px;border:1px solid var(--border2);text-align:center"><button class="sum-del-btn" data-folio-id="' + f.id + '" data-folio-name="' + esc(f.name) + '" style="background:none;border:none;color:var(--accent2);cursor:pointer;font-size:12px" title="Supprimer">✕</button></td>';
      html += '</tr>';
    });

    html += '</tbody></table>';

    // Total
    html += '<div style="margin-top:10px;font-size:10px;color:var(--text3);text-align:right">'
      + folios.length + ' folio' + (folios.length>1?'s':'') + ' au total</div>';

    html += '</div>';
    return html;
  }

  // ── Bindings sommaire interactif ──────────────────────────────
  function _bindSummaryActions() {
    // Ajouter un folio
    document.getElementById('sum-add-folio')?.addEventListener('click', async () => {
      if (!currentProject?.id) return;
      try {
        const res = await fetch(`/api/projects/${currentProject.id}/folios`, {
          method: 'POST', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: 'Nouveau folio' })
        });
        if (!res.ok) return;
        const f = await res.json();
        projectFolios.push({ id: f.id, name: f.name, folio_num: f.folio_num || projectFolios.length, folio_order: projectFolios.length, description: '', updated_at: new Date().toISOString() });
        updateFolioNav();
        await showSummaryOverlay();
      } catch (e) { console.error(e); }
    });

    // Sauvegarder modifications inline (nom, numéro, description)
    const _debounce = {};
    function _schedSave(fid, field, value) {
      clearTimeout(_debounce[fid + field]);
      _debounce[fid + field] = setTimeout(async () => {
        const body = {};
        const pf = projectFolios.find(f => f.id === fid);
        if (field === 'name') { body.name = value; if (pf) pf.name = value; }
        if (field === 'description') { body.description = value; if (pf) pf.description = value; }
        if (field === 'folio_num') {
          const v = String(value || '').trim();
          if (!/^[0-9]+(\.[0-9]+)?$/.test(v)) return; // format invalide → ignorer
          body.folio_num = v;
          if (pf) pf.folio_num = v;
        }
        await fetch(`/api/folios/${fid}`, { method: 'PUT', credentials: 'include',
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        updateFolioNav();
        document.getElementById('sum-save-order')?.style.setProperty('display', 'none');
      }, 600);
    }

    document.querySelectorAll('.sum-name-input').forEach(inp => {
      inp.addEventListener('input', () => _schedSave(inp.dataset.folioId, 'name', inp.value));
      inp.addEventListener('click', e => e.stopPropagation());
    });
    document.querySelectorAll('.sum-desc-input').forEach(inp => {
      inp.addEventListener('input', () => _schedSave(inp.dataset.folioId, 'description', inp.value));
      inp.addEventListener('click', e => e.stopPropagation());
    });
    document.querySelectorAll('.sum-num-input').forEach(inp => {
      inp.addEventListener('input', () => _schedSave(inp.dataset.folioId, 'folio_num', inp.value));
      inp.addEventListener('click', e => e.stopPropagation());
    });

    // Supprimer un folio
    document.querySelectorAll('.sum-del-btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const fid = btn.dataset.folioId;
        const fname = btn.dataset.folioName;
        if (!await showConfirm(`Supprimer le folio "${fname}" ?`)) return;
        await fetch(`/api/folios/${fid}`, { method: 'DELETE', credentials: 'include' });
        projectFolios.splice(projectFolios.findIndex(f => f.id === fid), 1);
        updateFolioNav();
        await showSummaryOverlay();
      });
    });

    // Drag & drop via poignée uniquement (mousedown/mousemove/mouseup)
    const tbody = document.getElementById('sum-tbody');
    if (!tbody) return;
    let _dragState = null;

    tbody.querySelectorAll('.sum-drag-handle').forEach(handle => {
      handle.addEventListener('mousedown', e => {
        e.preventDefault();
        const row = handle.closest('tr');
        if (!row) return;
        const rows = [...tbody.querySelectorAll('tr[data-folio-id]')];
        const rects = rows.map(r => r.getBoundingClientRect());
        _dragState = { row, rows, rects, startY: e.clientY, moved: false };
        row.style.opacity = '0.5';
        row.style.outline = '2px solid var(--accent)';

        const onMove = (ev) => {
          if (!_dragState) return;
          _dragState.moved = true;
          const y = ev.clientY;
          // Trouver la ligne cible
          let targetIdx = -1;
          for (let i = 0; i < _dragState.rects.length; i++) {
            const r = _dragState.rects[i];
            const mid = r.top + r.height / 2;
            if (y < mid) { targetIdx = i; break; }
          }
          // Retirer les indicateurs
          _dragState.rows.forEach(r => r.style.borderTop = '');
          if (targetIdx >= 0 && _dragState.rows[targetIdx] !== _dragState.row) {
            _dragState.rows[targetIdx].style.borderTop = '3px solid var(--accent)';
            _dragState.targetIdx = targetIdx;
          } else if (targetIdx === -1) {
            // Après le dernier
            _dragState.rows[_dragState.rows.length - 1].style.borderBottom = '3px solid var(--accent)';
            _dragState.targetIdx = _dragState.rows.length;
          }
        };

        const onUp = async () => {
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onUp);
          if (!_dragState) return;
          const { row: dRow, rows: dRows, targetIdx, moved } = _dragState;
          dRow.style.opacity = ''; dRow.style.outline = '';
          dRows.forEach(r => { r.style.borderTop = ''; r.style.borderBottom = ''; });
          _dragState = null;
          if (!moved || targetIdx === undefined) return;

          // Réorganiser dans le DOM
          const currentIdx = dRows.indexOf(dRow);
          if (targetIdx === currentIdx || targetIdx === currentIdx + 1) return;
          if (targetIdx >= dRows.length) {
            tbody.appendChild(dRow);
          } else {
            tbody.insertBefore(dRow, dRows[targetIdx > currentIdx ? targetIdx : targetIdx]);
          }

          // Recalculer l'ordre et sauvegarder
          const newOrder = [];
          tbody.querySelectorAll('tr[data-folio-id]').forEach((tr, i) => {
            const fid = tr.dataset.folioId;
            const pf = projectFolios.find(f => f.id === fid);
            const existingNum = pf?.folio_num;
            if (pf) pf.folio_order = i;
            newOrder.push({ id: fid, folio_order: i, folio_num: existingNum || (i + 1) });
          });
          try {
            await fetch(`/api/projects/${currentProject.id}/renumber`, {
              method: 'POST', credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ folios: newOrder })
            });
            updateFolioNav();
            await showSummaryOverlay();
          } catch (e) { console.error(e); }
        };

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
      });
    });

    // Clic sur ligne → ouvrir folio (sauf si clic sur input/bouton/handle)
    tbody.querySelectorAll('tr[data-folio-id]').forEach(row => {
      row.addEventListener('click', async (e) => {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'BUTTON' || e.target.classList.contains('sum-drag-handle')) return;
        const fid = row.dataset.folioId;
        if (fid) await openFolio(fid);
      });
    });
  }

  function hideBomOverlay(){
    document.getElementById('bom-overlay')?.classList.remove('visible');
    _bomVisible=false;
  }

  // Export CSV
  function _exportBomCsv(rows,cols){
    const COL_LABELS={qty:'Qté',ref:'Référence',label:'Désignation',sym:'Symbole',
      cat:'Catégorie',folio:'Folio(s)',color:'Couleur',size:'Taille'};
    const _csvLabelMap={};(config?.columns||[]).forEach(c=>{if(c.label)_csvLabelMap[c.id]=c.label;});
    function colLabel(id){if(_csvLabelMap[id])return _csvLabelMap[id];if(id.startsWith('cf_'))return id.slice(3);return COL_LABELS[id]||id;}
    const header=cols.map(c=>`"${colLabel(c)}"`).join(';');
    const body=rows.map(r=>cols.map(c=>{
      if(c==='qty')return r.qty||1;
      if(c==='ref')return`"${(r.refs?.join(', ')||r.ref||'').replace(/"/g,'""')}"`;
      if(c==='label')return`"${(r.label||r.symName||'').replace(/"/g,'""')}"`;
      if(c==='sym')return`"${r.symName}"`;
      if(c==='cat')return`"${r.category||''}"`;
      if(c==='folio')return`"${(r.folios||[]).join(', ')}"`;
      if(c==='color')return`"${r.color}"`;
      if(c==='size')return`"${Math.round(r.w||0)}x${Math.round(r.h||0)}"`;
      if(c.startsWith('cf_')||c.startsWith('cfn_')){
        let val='';
        const colMeta=config?.columns?.find(x=>x.id===c);
        if(colMeta?.rawIds?.length){
          for(const rid of colMeta.rawIds){const v=r.props?.[rid];if(v!==undefined&&v!==null&&v!==''){val=v;break;}}
        } else if(c.startsWith('cf_')){ val=r.props?.[c.slice(3)]||''; }
        return`"${String(val).replace(/"/g,'""')}"`;
      }
      return'""';
    }).join(';')).join('\n');
    const csv='\uFEFF'+header+'\n'+body; // BOM UTF-8 pour Excel
    const blob=new Blob([csv],{type:'text/csv;charset=utf-8'});
    const a=document.createElement('a');a.href=URL.createObjectURL(blob);
    const fname=document.getElementById('schema-name')?.value||'nomenclature';
    a.download=fname+'-bom.csv';a.click();URL.revokeObjectURL(a.href);
  }

  // ── Implantation Overlay ─────────────────────────────────────
  function hideImplantOverlay() {
    const ov = document.getElementById('implant-overlay');
    if (ov) ov.style.display = 'none';
  }

  async function showImplantOverlay() {
    const ov = document.getElementById('implant-overlay');
    if (!ov) return;
    ov.style.display = 'flex';

    const curFolio = projectFolios.find(x => x.id === currentFolioId);
    const implCfg = curFolio?.data?.implantation || curFolio?.implantation || {};
    const cabinetLabel = implCfg.cabinetLabel || '';
    document.getElementById('implant-title').textContent = cabinetLabel
      ? `Implantation : ${cabinetLabel}`
      : (curFolio?.name || 'Implantation');

    // Générer le contour coffret sur le canvas
    _generateImplantCanvas(implCfg);

    // Rendre le panneau latéral
    document.getElementById('implant-content').innerHTML = _renderImplantPanel(implCfg);
    _bindImplantActions(implCfg);

    // Recadrer la vue sur le coffret
    if (typeof fitView === 'function') setTimeout(fitView, 50);

    // Resize handle
    _bindImplantResize();
  }

  // Échelle par défaut : 1mm = IMPLANT_SCALE_DEFAULT px sur le canvas
  const IMPLANT_SCALE_DEFAULT = 2;
  function _implantScale(cfg) {
    const s = parseFloat(cfg?.scale);
    return (s && s > 0) ? s : IMPLANT_SCALE_DEFAULT;
  }

  // ── Helpers de migration coffret <-> multibloc ───────────────
  function _migrateToMultibloc(cfg) {
    return {
      cabinetType: 'armoire_multibloc',
      cabinetLabel: cfg.cabinetLabel || '',
      cabinetDepth: cfg.cabinetDepth || 200,
      gap: 0,
      blocs: [{
        id: 'bloc_0', label: 'Bloc 1',
        width: cfg.cabinetW || 600,
        height: cfg.cabinetH || 400,
        rails: cfg.rails || [],
        goulottes: cfg.goulottes || []
      }]
    };
  }

  function _migrateFromMultibloc(cfg, targetType) {
    const blocs = cfg.blocs || [];
    const first = blocs[0] || { width: 600, height: 2000, rails: [], goulottes: [] };
    // Fusionner rails/goulottes de tous les blocs en ajustant les X
    let allRails = [], allGoulottes = [], offsetX = 0;
    blocs.forEach(b => {
      (b.rails || []).forEach(r => allRails.push({ ...r, x: (r.x || 0) + offsetX }));
      (b.goulottes || []).forEach(g => allGoulottes.push({ ...g, x: (g.x || 0) + offsetX }));
      offsetX += (b.width || 400) + (cfg.gap || 0);
    });
    const totalW = blocs.reduce((s, b) => s + (b.width || 400), 0) + Math.max(0, blocs.length - 1) * (cfg.gap || 0);
    const maxH = blocs.reduce((m, b) => Math.max(m, b.height || 2000), 0);
    return {
      cabinetType: targetType || 'coffret',
      cabinetLabel: cfg.cabinetLabel || '',
      cabinetDepth: cfg.cabinetDepth || 200,
      cabinetW: totalW,
      cabinetH: maxH,
      rails: allRails,
      goulottes: allGoulottes
    };
  }

  // ── Génération canvas (rails + goulottes helpers) ────────────
  function _pushRailShapes(rails, cabinetW, offsetX, blocPrefix, S) {
    rails.forEach((r, i) => {
      const orient = r.orientation || 'h';
      const rXmm = r.x || 0;
      const rYmm = r.y || 0;
      const rLenMm = r.width || cabinetW || 600; // longueur (peu importe orientation)
      const railT = 7.5 * S; // épaisseur visuelle du rail DIN (7.5mm)
      if (orient === 'v') {
        // Rail vertical : barre verticale, longueur = rLenMm
        const rX = offsetX + rXmm * S;
        const rY = rYmm * S;
        state.shapes.push({
          id: '__impl_rail_' + blocPrefix + i, t: 'rect',
          x: rX - railT / 2, y: rY, w: railT, h: rLenMm * S,
          color: '#64748b', thick: 1.2, stroke: 'solid', fill: false
        });
        if (r.label) {
          state.texts.push({
            id: '__impl_rlbl_' + blocPrefix + i,
            x: rX - 10, y: rY - 16,
            text: r.label, size: 10, color: '#64748b'
          });
        }
        // Dimension verticale (angle 90° pour suivre l'orientation du rail)
        const _rDimText = rLenMm + ' mm';
        const _rDimLen = _rDimText.length * 5.5;
        state.texts.push({
          id: '__impl_rdim_' + blocPrefix + i,
          x: rX + 4, y: rY + rLenMm * S / 2 - _rDimLen / 2,
          text: _rDimText, size: 9, color: '#334155', angle: 90
        });
      } else {
        // Rail horizontal (défaut)
        const rX = offsetX + rXmm * S;
        const rY = rYmm * S;
        state.shapes.push({
          id: '__impl_rail_' + blocPrefix + i, t: 'rect',
          x: rX, y: rY - railT / 2, w: rLenMm * S, h: railT,
          color: '#64748b', thick: 1.2, stroke: 'solid', fill: false
        });
        if (r.label) {
          state.texts.push({
            id: '__impl_rlbl_' + blocPrefix + i,
            x: rX - 60, y: rY - 6,
            text: r.label, size: 10, color: '#64748b'
          });
        }
        const _rDimText = rLenMm + ' mm';
        const _rDimLen = _rDimText.length * 5.5;
        state.texts.push({
          id: '__impl_rdim_' + blocPrefix + i,
          x: rX + rLenMm * S / 2 - _rDimLen / 2, y: rY - 5,
          text: _rDimText, size: 9, color: '#334155'
        });
      }
    });
  }

  function _pushGoulotteShapes(goulottes, offsetX, blocPrefix, S) {
    goulottes.forEach((g, i) => {
      const gXmm = g.x || 0;
      const gYmm = g.y || 0;
      const gWmm = g.width || 40;
      const gHmm = g.height || 40;
      const gDmm = g.depth || 60;
      const gX = offsetX + gXmm * S;
      const gY = gYmm * S;
      const gWpx = gWmm * S;
      const gHpx = gHmm * S;
      const fillMode = g.fillMode || 'none';
      const fillColor = g.fillColor || '#3b9eff';
      const fillPercent = Math.max(0, Math.min(100, parseInt(g.fillPercent) || 0));

      // Contour de la goulotte
      state.shapes.push({
        id: '__impl_goul_' + blocPrefix + i, t: 'rect',
        x: gX, y: gY, w: gWpx, h: gHpx,
        color: '#475569', thick: 1.2, stroke: 'dash-med', fill: false
      });

      // Remplissage selon fillMode
      if (fillMode === 'solid' && fillPercent > 0) {
        const alpha = (fillPercent / 100).toFixed(2);
        const rgba = _hexToRgba(fillColor, alpha);
        state.shapes.push({
          id: '__impl_goulfill_' + blocPrefix + i, t: 'rect',
          x: gX + 1, y: gY + 1, w: gWpx - 2, h: gHpx - 2,
          color: rgba, thick: 0, stroke: 'solid', fill: true
        });
      } else if (fillMode === 'hatch') {
        // Hachures à 45° — lignes diagonales à intervalle régulier
        const spacing = Math.max(6, 4 * S);
        for (let off = -gHpx; off < gWpx; off += spacing) {
          let x1, y1, x2, y2;
          if (off >= 0) { x1 = off; y1 = 0; } else { x1 = 0; y1 = -off; }
          if (off + gHpx <= gWpx) { x2 = off + gHpx; y2 = gHpx; }
          else { x2 = gWpx; y2 = gWpx - off; }
          state.shapes.push({
            id: '__impl_goulh_' + blocPrefix + i + '_' + Math.round(off), t: 'line',
            pts: [{ x: gX + x1, y: gY + y1 }, { x: gX + x2, y: gY + y2 }],
            color: fillColor, thick: 0.6, stroke: 'solid', fill: false
          });
        }
      }

      // Dimensions centrées : largeur × profondeur ; texte tourné 90° si goulotte verticale
      const orientV = (g.orientation === 'v') || (gHmm > gWmm);
      const dimText = gWmm + '×' + gDmm + ' mm';
      const dimLen = dimText.length * 5.5;
      if (orientV) {
        state.texts.push({
          id: '__impl_gdim_' + blocPrefix + i,
          x: gX + gWpx / 2 - 3, y: gY + gHpx / 2 - dimLen / 2,
          text: dimText, size: 9, color: '#1e293b', angle: 90
        });
      } else {
        state.texts.push({
          id: '__impl_gdim_' + blocPrefix + i,
          x: gX + gWpx / 2 - dimLen / 2, y: gY + gHpx / 2 - 5,
          text: dimText, size: 9, color: '#1e293b'
        });
      }
    });
  }

  // Convertit une couleur hex en rgba avec alpha
  function _hexToRgba(hex, alpha) {
    hex = (hex || '#3b9eff').replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
  }

  // Calcule l'offset global du coffret (en pixels canvas) selon positionMode
  function _implantOffset(cfg) {
    const S = _implantScale(cfg);
    const mode = cfg.positionMode || 'origin';
    if (mode === 'centered') {
      const pz = (typeof printZone !== 'undefined' && printZone) || { x: 0, y: 0, w: 1587, h: 915 };
      let totalW, totalH;
      if (cfg.cabinetType === 'armoire_multibloc') {
        const blocs = cfg.blocs || [];
        const gap = cfg.gap || 0;
        totalW = blocs.reduce((s, b) => s + (b.width || 400), 0) + Math.max(0, blocs.length - 1) * gap;
        totalH = blocs.reduce((m, b) => Math.max(m, b.height || 2000), 0);
      } else {
        totalW = cfg.cabinetW || 600;
        totalH = cfg.cabinetH || 400;
      }
      return {
        x: pz.x + (pz.w - totalW * S) / 2,
        y: pz.y + (pz.h - totalH * S) / 2
      };
    } else if (mode === 'custom') {
      return { x: (cfg.positionX || 0) * S, y: (cfg.positionY || 0) * S };
    }
    return { x: 0, y: 0 };
  }

  function _generateImplantCanvas(cfg) {
    // Nettoyer les formes et textes auto-générés (préfixés __impl_)
    state.shapes = (state.shapes || []).filter(s => !s.id?.startsWith('__impl_'));
    state.texts = (state.texts || []).filter(t => !t.id?.startsWith('__impl_'));

    const S = _implantScale(cfg);
    if (cfg.cabinetType === 'armoire_multibloc') {
      _generateMultiblocCanvas(cfg, S);
    } else {
      _generateSingleCabinetCanvas(cfg, S);
    }

    // Appliquer l'offset global (positionMode : origin/centered/custom)
    const off = _implantOffset(cfg);
    if (off.x !== 0 || off.y !== 0) {
      state.shapes.forEach(s => {
        if (!s.id?.startsWith('__impl_')) return;
        if (s.t === 'rect' || s.t === 'textbox') { s.x += off.x; s.y += off.y; }
        else if (s.t === 'circle') { s.cx += off.x; s.cy += off.y; }
        else if (s.pts) s.pts.forEach(p => { p.x += off.x; p.y += off.y; });
      });
      state.texts.forEach(t => {
        if (!t.id?.startsWith('__impl_')) return;
        t.x += off.x; t.y += off.y;
      });
    }

    // Verrouiller :
    // - Coffret, porte, grille : verrouillés (pas d'édition à la souris)
    // - Labels et dimensions auto-générés : verrouillés (ils suivent rails/goulottes)
    // - Rails et goulottes : DÉVERROUILLÉS (déplaçables à la souris, sync via _syncImplantShapesToCfg)
    state.shapes.forEach(s => {
      if (!s.id?.startsWith('__impl_')) return;
      const isRailOrGoul = s.id.startsWith('__impl_rail_') || s.id.startsWith('__impl_goul_');
      s.locked = !isRailOrGoul;
    });
    state.texts.forEach(t => { if (t.id?.startsWith('__impl_')) t.locked = true; });

    if (typeof render === 'function') render();
  }

  // Dessine la grille (platine de montage) — cW,cH : enveloppe en mm
  function _pushGridShape(cfg, offsetX, cWmm, cHmm, prefix, S) {
    if (!cfg.hasGrid) return;
    const gWmm = cfg.gridW || Math.max(50, cWmm - 40);
    const gHmm = cfg.gridH || Math.max(50, cHmm - 40);
    let gX, gY;
    if (cfg.gridCentered !== false) {
      gX = (cWmm - gWmm) / 2;
      gY = (cHmm - gHmm) / 2;
    } else {
      gX = cfg.gridOffsetX || 0;
      gY = cfg.gridOffsetY || 0;
    }
    state.shapes.push({
      id: '__impl_grid_' + prefix, t: 'rect',
      x: offsetX + gX * S, y: gY * S, w: gWmm * S, h: gHmm * S,
      color: '#475569', thick: 1.2, stroke: 'dash-med', fill: false
    });
  }

  function _generateSingleCabinetCanvas(cfg, S) {
    const cWmm = cfg.cabinetW || 600;
    const cHmm = cfg.cabinetH || 400;
    const cW = cWmm * S;
    const cH = cHmm * S;
    const cType = cfg.cabinetType || 'coffret';

    // Contour du coffret/armoire
    state.shapes.push({
      id: '__impl_cabinet', t: 'rect',
      x: 0, y: 0, w: cW, h: cH,
      color: '#334155', thick: cType === 'armoire' ? 3 : 2, stroke: 'solid', fill: false
    });

    // Label du coffret en haut
    if (cfg.cabinetLabel) {
      state.texts.push({
        id: '__impl_cablbl', x: 0, y: -20,
        text: cfg.cabinetLabel + ' — ' + cWmm + ' x ' + cHmm + ' mm',
        size: 12, color: '#334155'
      });
    }

    // Armoire monobloc : porte en pointillés (inset 10mm)
    if (cType === 'armoire') {
      const inset = 10 * S;
      state.shapes.push({
        id: '__impl_door', t: 'rect',
        x: inset, y: inset, w: cW - 2 * inset, h: cH - 2 * inset,
        color: '#94a3b8', thick: 0.8, stroke: 'dash-large', fill: false
      });
    }

    // Grille (platine de montage)
    _pushGridShape(cfg, 0, cWmm, cHmm, 'main', S);

    // Rails DIN
    _pushRailShapes(cfg.rails || [], cfg.cabinetW || 600, 0, '', S);

    // Goulottes de câblage
    _pushGoulotteShapes(cfg.goulottes || [], 0, '', S);
  }

  function _generateMultiblocCanvas(cfg, S) {
    const blocs = cfg.blocs || [];
    const gap = (cfg.gap || 0) * S;
    let offsetX = 0;

    // Label global de l'armoire
    if (cfg.cabinetLabel) {
      state.texts.push({
        id: '__impl_cablbl', x: 0, y: -30,
        text: cfg.cabinetLabel + ' (' + blocs.length + ' bloc' + (blocs.length > 1 ? 's' : '') + ')',
        size: 13, color: '#334155'
      });
    }

    blocs.forEach((bloc, bi) => {
      const bWmm = bloc.width || 400;
      const bHmm = bloc.height || 2000;
      const bW = bWmm * S;
      const bH = bHmm * S;

      // Contour du bloc
      state.shapes.push({
        id: '__impl_bloc_' + bi, t: 'rect',
        x: offsetX, y: 0, w: bW, h: bH,
        color: '#334155', thick: 2, stroke: 'solid', fill: false
      });

      // Porte en pointillés (inset 10mm)
      const inset = 10 * S;
      state.shapes.push({
        id: '__impl_door_' + bi, t: 'rect',
        x: offsetX + inset, y: inset, w: bW - 2 * inset, h: bH - 2 * inset,
        color: '#94a3b8', thick: 0.8, stroke: 'dash-large', fill: false
      });

      // Label du bloc au-dessus
      if (bloc.label) {
        state.texts.push({
          id: '__impl_blbl_' + bi,
          x: offsetX + 4, y: -14,
          text: bloc.label + ' (' + bWmm + ' x ' + bHmm + ' mm)',
          size: 11, color: '#334155'
        });
      }

      // Grille de bloc (platine de montage)
      _pushGridShape(bloc, offsetX, bWmm, bHmm, 'bloc' + bi, S);

      // Rails et goulottes locaux au bloc
      const prefix = bi + '_';
      _pushRailShapes(bloc.rails || [], bWmm, offsetX, prefix, S);
      _pushGoulotteShapes(bloc.goulottes || [], offsetX, prefix, S);

      offsetX += bW + gap;
    });
  }

  // ── Rendu du panneau (coffret / armoire monobloc) ──────────
  function _renderImplantPanel(cfg) {
    if (cfg.cabinetType === 'armoire_multibloc') return _renderMultiblocPanel(cfg);

    const cW = cfg.cabinetW || 600;
    const cH = cfg.cabinetH || 400;
    const cD = cfg.cabinetDepth || 200;
    const cLabel = cfg.cabinetLabel || '';
    const cType = cfg.cabinetType || 'coffret';
    const rails = cfg.rails || [];
    const goulottes = cfg.goulottes || [];

    let html = '';

    // Section coffret
    html += '<div style="border-bottom:1px solid var(--border2);padding-bottom:10px;margin-bottom:10px">';
    html += '<div style="font-size:10px;font-weight:700;color:var(--text2);letter-spacing:.5px;margin-bottom:8px">COFFRET / ARMOIRE</div>';
    html += '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px;margin-bottom:6px">';
    html += '<div><label style="font-size:9px;color:var(--text3)">Largeur (mm)</label><input id="impl-cab-w" type="number" class="prop-input" style="width:100%;box-sizing:border-box" value="' + cW + '" min="100" max="3000" step="10"></div>';
    html += '<div><label style="font-size:9px;color:var(--text3)">Hauteur (mm)</label><input id="impl-cab-h" type="number" class="prop-input" style="width:100%;box-sizing:border-box" value="' + cH + '" min="100" max="3000" step="10"></div>';
    html += '<div><label style="font-size:9px;color:var(--text3)">Profondeur (mm)</label><input id="impl-cab-d" type="number" class="prop-input" style="width:100%;box-sizing:border-box" value="' + cD + '" min="50" max="1000" step="10"></div>';
    html += '</div>';
    html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px">';
    html += '<div><label style="font-size:9px;color:var(--text3)">Repère</label><input id="impl-cab-label" class="prop-input" style="width:100%;box-sizing:border-box" value="' + esc(cLabel) + '" placeholder="Q1"></div>';
    html += '<div><label style="font-size:9px;color:var(--text3)">Type</label><select id="impl-cab-type" class="prop-select" style="width:100%;box-sizing:border-box"><option value="coffret"' + (cType === 'coffret' ? ' selected' : '') + '>Coffret</option><option value="armoire"' + (cType === 'armoire' ? ' selected' : '') + '>Armoire monobloc</option><option value="armoire_multibloc">Armoire multibloc</option></select></div>';
    html += '</div>';
    html += _renderScaleRow(cfg);
    html += '</div>';

    // Section grille (platine de montage)
    html += _renderGridSection(cfg, cW, cH);

    // Liste unifiée rails + goulottes
    html += _renderItemsSection(rails, goulottes, cW);

    return html;
  }

  // Ligne "échelle" + position affichée dans l'en-tête de l'overlay
  function _renderScaleRow(cfg) {
    const s = _implantScale(cfg);
    const presets = [1, 1.5, 2, 2.5, 3, 4, 5];
    const opts = presets.map(p => '<option value="' + p + '"' + (Math.abs(s - p) < 0.01 ? ' selected' : '') + '>' + p + ' px/mm</option>').join('');
    const mode = cfg.positionMode || 'origin';
    const posX = cfg.positionX || 0;
    const posY = cfg.positionY || 0;
    let html = '<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-top:6px;align-items:end">';
    html += '<div><label style="font-size:9px;color:var(--text3)">Échelle (px/mm)</label><input id="impl-cab-scale" type="number" class="prop-input" style="width:100%;box-sizing:border-box" value="' + s + '" min="0.2" max="10" step="0.1"></div>';
    html += '<div><label style="font-size:9px;color:var(--text3)">Préréglage</label><select id="impl-cab-scale-preset" class="prop-select" style="width:100%;box-sizing:border-box">' + opts + '</select></div>';
    html += '</div>';
    // Position
    html += '<div style="display:grid;grid-template-columns:1fr;gap:6px;margin-top:6px;align-items:end">';
    html += '<div><label style="font-size:9px;color:var(--text3)">Position sur le folio</label>';
    html += '<select id="impl-cab-posmode" class="prop-select" style="width:100%;box-sizing:border-box">';
    html += '<option value="origin"' + (mode === 'origin' ? ' selected' : '') + '>Origine (0, 0)</option>';
    html += '<option value="centered"' + (mode === 'centered' ? ' selected' : '') + '>Centré dans la zone d\'impression</option>';
    html += '<option value="custom"' + (mode === 'custom' ? ' selected' : '') + '>Coordonnées personnalisées</option>';
    html += '</select></div>';
    html += '</div>';
    html += '<div id="impl-cab-pos-coords" style="display:' + (mode === 'custom' ? 'grid' : 'none') + ';grid-template-columns:1fr 1fr;gap:6px;margin-top:6px;align-items:end">';
    html += '<div><label style="font-size:9px;color:var(--text3)">Position X (mm)</label><input id="impl-cab-posx" type="number" class="prop-input" style="width:100%;box-sizing:border-box" value="' + posX + '" step="10"></div>';
    html += '<div><label style="font-size:9px;color:var(--text3)">Position Y (mm)</label><input id="impl-cab-posy" type="number" class="prop-input" style="width:100%;box-sizing:border-box" value="' + posY + '" step="10"></div>';
    html += '</div>';
    return html;
  }

  // Section grille (réutilisable pour coffret ou bloc)
  function _renderGridSection(entity, entityW, entityH, blocIdx) {
    const prefix = blocIdx !== undefined ? 'b' + blocIdx + '-' : '';
    const dataBloc = blocIdx !== undefined ? ' data-bloc="' + blocIdx + '"' : '';
    const hasGrid = !!entity.hasGrid;
    const gW = entity.gridW || Math.max(50, (entityW || 600) - 40);
    const gH = entity.gridH || Math.max(50, (entityH || 400) - 40);
    const gD = entity.gridDepth || 150;
    const gCentered = entity.gridCentered !== false;
    const gOX = entity.gridOffsetX || 0;
    const gOY = entity.gridOffsetY || 0;

    let html = '<div style="border-bottom:1px solid var(--border2);padding-bottom:10px;margin-bottom:10px">';
    html += '<label style="display:flex;align-items:center;gap:6px;font-size:10px;font-weight:700;color:var(--text2);letter-spacing:.5px;margin-bottom:6px;cursor:pointer">';
    html += '<input type="checkbox" class="impl-grid-enable"' + dataBloc + (hasGrid ? ' checked' : '') + ' style="margin:0">';
    html += '<span>GRILLE (PLATINE DE MONTAGE)</span></label>';
    html += '<div class="impl-grid-dims"' + dataBloc + ' style="' + (hasGrid ? '' : 'display:none') + '">';
    html += '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px;margin-bottom:6px">';
    html += '<div><label style="font-size:8px;color:var(--text3)">Largeur (mm)</label><input type="number" class="prop-input impl-grid-w"' + dataBloc + ' style="width:100%;box-sizing:border-box;font-size:10px" value="' + gW + '" min="50" step="10"></div>';
    html += '<div><label style="font-size:8px;color:var(--text3)">Hauteur (mm)</label><input type="number" class="prop-input impl-grid-h"' + dataBloc + ' style="width:100%;box-sizing:border-box;font-size:10px" value="' + gH + '" min="50" step="10"></div>';
    html += '<div><label style="font-size:8px;color:var(--text3)">Prof. (mm)</label><input type="number" class="prop-input impl-grid-d"' + dataBloc + ' style="width:100%;box-sizing:border-box;font-size:10px" value="' + gD + '" min="10" step="10"></div>';
    html += '</div>';
    html += '<label style="display:flex;align-items:center;gap:6px;font-size:10px;color:var(--text2);cursor:pointer;margin-bottom:4px">';
    html += '<input type="checkbox" class="impl-grid-centered"' + dataBloc + (gCentered ? ' checked' : '') + ' style="margin:0"> <span>Centrer la grille</span></label>';
    html += '<div class="impl-grid-offsets"' + dataBloc + ' style="' + (gCentered ? 'display:none' : '') + ';display:' + (gCentered ? 'none' : 'grid') + ';grid-template-columns:1fr 1fr;gap:6px;margin-top:4px">';
    html += '<div><label style="font-size:8px;color:var(--text3)">Offset X (mm)</label><input type="number" class="prop-input impl-grid-ox"' + dataBloc + ' style="width:100%;box-sizing:border-box;font-size:10px" value="' + gOX + '" step="5"></div>';
    html += '<div><label style="font-size:8px;color:var(--text3)">Offset Y (mm)</label><input type="number" class="prop-input impl-grid-oy"' + dataBloc + ' style="width:100%;box-sizing:border-box;font-size:10px" value="' + gOY + '" step="5"></div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    return html;
  }

  // ── Section unifiée : rails DIN + goulottes fusionnées ───────
  function _renderItemsSection(rails, goulottes, cabinetW, blocIdx) {
    const dataBloc = blocIdx !== undefined ? ' data-bloc="' + blocIdx + '"' : '';
    const blocPrefix = blocIdx !== undefined ? (blocIdx + '_') : '';
    const total = (rails?.length || 0) + (goulottes?.length || 0);
    let html = '<div style="padding-bottom:10px">';
    html += '<div style="font-size:10px;font-weight:700;color:var(--text2);letter-spacing:.5px;margin-bottom:6px">ÉLÉMENTS (' + total + ')</div>';

    if (!total) {
      html += '<div style="color:var(--text3);font-size:10px;padding:6px 0">Aucun élément. Utilisez le bandeau Implantation (Rail DIN / Goulotte) pour en placer sur le canvas.</div>';
      html += '</div>';
      return html;
    }

    // Construire un tableau unifié d'items
    const items = [];
    (rails || []).forEach((r, i) => {
      items.push({
        kind: 'rail', idx: i, entity: r,
        shapeId: '__impl_rail_' + blocPrefix + i,
        label: r.label || ('Rail ' + (i + 1)),
        typeLabel: 'Rail DIN', typeIcon: '▭',
        orient: r.orientation || 'h'
      });
    });
    (goulottes || []).forEach((g, i) => {
      const gW = g.width || 40, gH = g.height || 40;
      items.push({
        kind: 'goulotte', idx: i, entity: g,
        shapeId: '__impl_goul_' + blocPrefix + i,
        label: 'Goulotte ' + (i + 1),
        typeLabel: 'Goulotte', typeIcon: '▥',
        orient: g.orientation || (gW >= gH ? 'h' : 'v')
      });
    });

    items.forEach(it => {
      const orientStr = it.orient === 'v' ? '↕ V' : '↔ H';
      const delClass = it.kind === 'rail' ? 'impl-del-rail' : 'impl-del-goul';
      const itemClass = it.kind === 'rail' ? 'impl-rail-item' : 'impl-goul-item';
      html += '<div class="impl-list-item ' + itemClass + '" data-idx="' + it.idx + '"' + dataBloc + ' data-shape-id="' + it.shapeId + '" ' +
        'style="display:grid;grid-template-columns:18px 1fr 80px 30px 24px;gap:6px;align-items:center;padding:5px 6px;border:1px solid var(--border2);border-radius:4px;margin-bottom:3px;cursor:pointer;background:rgba(100,116,139,.05);transition:background .15s" ' +
        'onmouseover="this.style.background=\'rgba(59,158,255,.12)\'" onmouseout="this.style.background=\'rgba(100,116,139,.05)\'">';
      html += '<span style="font-size:12px;color:var(--accent);text-align:center" title="' + it.typeLabel + '">' + it.typeIcon + '</span>';
      html += '<span style="font-size:11px;color:var(--text);font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" title="' + esc(it.label) + '">' + esc(it.label) + '</span>';
      html += '<span style="font-size:10px;color:var(--text3)">' + it.typeLabel + '</span>';
      html += '<span style="font-size:10px;color:var(--text3);text-align:center">' + orientStr + '</span>';
      html += '<button class="btn-secondary ' + delClass + '" data-idx="' + it.idx + '"' + dataBloc + ' style="font-size:9px;padding:2px 4px;color:var(--accent2);height:22px" title="Supprimer" onclick="event.stopPropagation()">✕</button>';
      html += '</div>';
    });
    html += '</div>';
    return html;
  }

  // ── Rendu du panneau multibloc ───────────────────────────────
  function _renderMultiblocPanel(cfg) {
    const cLabel = cfg.cabinetLabel || '';
    const cD = cfg.cabinetDepth || 200;
    const gap = cfg.gap || 0;
    const blocs = cfg.blocs || [];

    let html = '';

    // En-tête armoire
    html += '<div style="border-bottom:1px solid var(--border2);padding-bottom:10px;margin-bottom:10px">';
    html += '<div style="font-size:10px;font-weight:700;color:var(--text2);letter-spacing:.5px;margin-bottom:8px">ARMOIRE MULTIBLOC</div>';
    html += '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px;margin-bottom:6px">';
    html += '<div><label style="font-size:9px;color:var(--text3)">Repère</label><input id="impl-cab-label" class="prop-input" style="width:100%;box-sizing:border-box" value="' + esc(cLabel) + '" placeholder="Q1"></div>';
    html += '<div><label style="font-size:9px;color:var(--text3)">Profondeur (mm)</label><input id="impl-cab-d" type="number" class="prop-input" style="width:100%;box-sizing:border-box" value="' + cD + '" min="50" max="1000" step="10"></div>';
    html += '<div><label style="font-size:9px;color:var(--text3)">Ecart blocs (mm)</label><input id="impl-mb-gap" type="number" class="prop-input" style="width:100%;box-sizing:border-box" value="' + gap + '" min="0" max="100" step="1"></div>';
    html += '</div>';
    html += '<div><label style="font-size:9px;color:var(--text3)">Type</label><select id="impl-cab-type" class="prop-select" style="width:100%;box-sizing:border-box"><option value="coffret">Coffret</option><option value="armoire">Armoire monobloc</option><option value="armoire_multibloc" selected>Armoire multibloc</option></select></div>';
    html += _renderScaleRow(cfg);
    html += '</div>';

    // Bouton ajouter bloc
    html += '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">';
    html += '<span style="font-size:10px;font-weight:700;color:var(--text2);letter-spacing:.5px">' + blocs.length + ' BLOC' + (blocs.length > 1 ? 'S' : '') + '</span>';
    html += '<button id="impl-add-bloc" class="btn-secondary" style="font-size:9px;padding:2px 8px">+ Bloc</button>';
    html += '</div>';

    // Chaque bloc
    blocs.forEach((bloc, bi) => {
      const bLabel = bloc.label || ('Bloc ' + (bi + 1));
      const bW = bloc.width || 400;
      const bH = bloc.height || 2000;
      html += '<details class="impl-bloc-details" data-bloc="' + bi + '" ' + (bi === 0 ? 'open' : '') + ' style="border:1px solid var(--border2);border-radius:6px;margin-bottom:8px;background:var(--panel2)">';
      html += '<summary style="padding:6px 10px;cursor:pointer;font-size:10px;font-weight:700;color:var(--text2);display:flex;align-items:center;gap:6px;user-select:none">';
      html += '<span style="flex:1">' + esc(bLabel) + ' (' + bW + ' x ' + bH + ' mm)</span>';
      // Boutons déplacer / supprimer
      if (bi > 0) html += '<button class="btn-secondary impl-bloc-left" data-bloc="' + bi + '" style="font-size:8px;padding:1px 4px" title="Déplacer à gauche">◀</button>';
      if (bi < blocs.length - 1) html += '<button class="btn-secondary impl-bloc-right" data-bloc="' + bi + '" style="font-size:8px;padding:1px 4px" title="Déplacer à droite">▶</button>';
      if (blocs.length > 1) html += '<button class="btn-secondary impl-del-bloc" data-bloc="' + bi + '" style="font-size:8px;padding:1px 4px;color:var(--accent2)" title="Supprimer ce bloc">✕</button>';
      html += '</summary>';
      html += '<div style="padding:8px 10px">';
      // Dimensions du bloc
      html += '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px;margin-bottom:8px">';
      html += '<div><label style="font-size:8px;color:var(--text3)">Label</label><input class="prop-input impl-bloc-label" data-bloc="' + bi + '" style="width:100%;box-sizing:border-box;font-size:10px" value="' + esc(bLabel) + '"></div>';
      html += '<div><label style="font-size:8px;color:var(--text3)">Largeur (mm)</label><input type="number" class="prop-input impl-bloc-w" data-bloc="' + bi + '" style="width:100%;box-sizing:border-box;font-size:10px" value="' + bW + '" min="100" max="2000" step="10"></div>';
      html += '<div><label style="font-size:8px;color:var(--text3)">Hauteur (mm)</label><input type="number" class="prop-input impl-bloc-h" data-bloc="' + bi + '" style="width:100%;box-sizing:border-box;font-size:10px" value="' + bH + '" min="100" max="3000" step="10"></div>';
      html += '</div>';
      // Grille du bloc
      html += _renderGridSection(bloc, bW, bH, bi);
      // Liste unifiée rails + goulottes du bloc
      html += _renderItemsSection(bloc.rails || [], bloc.goulottes || [], bW, bi);
      html += '</div></details>';
    });

    return html;
  }

  // ── Lecture config depuis DOM ────────────────────────────────
  function _getImplantCfgFromOverlay() {
    const curFolio = projectFolios.find(x => x.id === currentFolioId);
    const oldCfg = curFolio?.data?.implantation || curFolio?.implantation || {};
    if (oldCfg.cabinetType === 'armoire_multibloc') return _getMultiblocCfgFromOverlay(oldCfg);
    return {
      cabinetW: parseInt(document.getElementById('impl-cab-w')?.value) || oldCfg.cabinetW || 600,
      cabinetH: parseInt(document.getElementById('impl-cab-h')?.value) || oldCfg.cabinetH || 400,
      cabinetDepth: parseInt(document.getElementById('impl-cab-d')?.value) || oldCfg.cabinetDepth || 200,
      cabinetLabel: document.getElementById('impl-cab-label')?.value?.trim() || '',
      cabinetType: document.getElementById('impl-cab-type')?.value || 'coffret',
      scale: parseFloat(document.getElementById('impl-cab-scale')?.value) || oldCfg.scale || IMPLANT_SCALE_DEFAULT,
      rails: oldCfg.rails || [],
      goulottes: oldCfg.goulottes || [],
      // Préserver les champs grille (gérés en direct via _bindGridActions)
      hasGrid: !!oldCfg.hasGrid,
      gridW: oldCfg.gridW,
      gridH: oldCfg.gridH,
      gridDepth: oldCfg.gridDepth,
      gridCentered: oldCfg.gridCentered !== false,
      gridOffsetX: oldCfg.gridOffsetX || 0,
      gridOffsetY: oldCfg.gridOffsetY || 0
    };
  }

  function _getMultiblocCfgFromOverlay(oldCfg) {
    return {
      cabinetType: document.getElementById('impl-cab-type')?.value || 'armoire_multibloc',
      cabinetLabel: document.getElementById('impl-cab-label')?.value?.trim() || '',
      cabinetDepth: parseInt(document.getElementById('impl-cab-d')?.value) || oldCfg.cabinetDepth || 200,
      gap: parseInt(document.getElementById('impl-mb-gap')?.value) || 0,
      scale: parseFloat(document.getElementById('impl-cab-scale')?.value) || oldCfg.scale || IMPLANT_SCALE_DEFAULT,
      blocs: oldCfg.blocs || []
    };
  }

  function _updateImplantCfg(cfg) {
    const curFolio = projectFolios.find(x => x.id === currentFolioId);
    if (curFolio) {
      if (!curFolio.data) curFolio.data = {};
      // Garantir le type + la config à chaque update (évite les pertes au save)
      curFolio.data.folio_type = 'implantation';
      curFolio.data.implantation = cfg;
      curFolio.folio_type = 'implantation';
      curFolio.implantation = cfg;
    }
    _generateImplantCanvas(cfg);
  }

  // ── Helper pour re-render + re-bind le panel ─────────────────
  function _refreshImplantPanel(c) {
    document.getElementById('implant-content').innerHTML = _renderImplantPanel(c);
    _bindImplantActions(c);
  }

  // Bindings pour les champs grille (applicable à une entité : coffret ou bloc)
  // getEntity() → retourne l'objet à modifier (cfg ou bloc)
  function _bindGridActions(blocIdx, getEntity) {
    const selBloc = blocIdx !== undefined ? '[data-bloc="' + blocIdx + '"]' : ':not([data-bloc])';
    // Toggle grille
    document.querySelectorAll('.impl-grid-enable' + selBloc).forEach(cb => {
      cb.addEventListener('change', () => {
        const entity = getEntity();
        if (!entity) return;
        entity.hasGrid = cb.checked;
        const dims = document.querySelector('.impl-grid-dims' + selBloc);
        if (dims) dims.style.display = cb.checked ? '' : 'none';
        const c = _rootCfg(); _updateImplantCfg(c);
      });
    });
    // Centrer
    document.querySelectorAll('.impl-grid-centered' + selBloc).forEach(cb => {
      cb.addEventListener('change', () => {
        const entity = getEntity();
        if (!entity) return;
        entity.gridCentered = cb.checked;
        const off = document.querySelector('.impl-grid-offsets' + selBloc);
        if (off) off.style.display = cb.checked ? 'none' : 'grid';
        const c = _rootCfg(); _updateImplantCfg(c);
      });
    });
    // Dimensions grille + offsets
    const bindInput = (cls, prop, parseFn) => {
      document.querySelectorAll(cls + selBloc).forEach(inp => {
        inp.addEventListener('change', () => {
          const entity = getEntity();
          if (!entity) return;
          entity[prop] = parseFn(inp.value);
          const c = _rootCfg(); _updateImplantCfg(c);
        });
      });
    };
    bindInput('.impl-grid-w', 'gridW', v => parseInt(v) || 0);
    bindInput('.impl-grid-h', 'gridH', v => parseInt(v) || 0);
    bindInput('.impl-grid-d', 'gridDepth', v => parseInt(v) || 0);
    bindInput('.impl-grid-ox', 'gridOffsetX', v => parseFloat(v) || 0);
    bindInput('.impl-grid-oy', 'gridOffsetY', v => parseFloat(v) || 0);
  }

  function _rootCfg() {
    const f = projectFolios.find(x => x.id === currentFolioId);
    return f?.data?.implantation || f?.implantation || {};
  }

  // Trouve l'entité parente (rail ou goulotte) à partir d'un ID de shape __impl_*
  function _findImplantEntity(shapeId) {
    const c = _rootCfg();
    if (!c) return null;
    const isMb = c.cabinetType === 'armoire_multibloc';
    const mR = shapeId.match(/^__impl_rail_(?:(\d+)_)?(\d+)$/);
    const mG = shapeId.match(/^__impl_goul_(?:(\d+)_)?(\d+)$/);
    if (!mR && !mG) return null;
    const [, biStr, iStr] = (mR || mG);
    const bi = biStr !== undefined ? parseInt(biStr) : null;
    const idx = parseInt(iStr);
    const parent = isMb ? (c.blocs || [])[bi] : c;
    if (!parent) return null;
    const list = mR ? parent.rails : parent.goulottes;
    if (!list || !list[idx]) return null;
    return { kind: mR ? 'rail' : 'goulotte', entity: list[idx], parent, cfg: c, blocIdx: bi, idx };
  }

  // Panneau de propriétés à droite pour un rail ou une goulotte
  function _renderImplantShapeProps(sh) {
    const info = _findImplantEntity(sh.id);
    if (!info) return '<div class="prop-group"><span style="color:var(--accent2)">Élément implantation introuvable</span></div>';
    const { kind, entity, blocIdx } = info;
    const blocStr = blocIdx !== null ? 'Bloc ' + (blocIdx + 1) + ' — ' : '';

    if (kind === 'rail') {
      const r = entity;
      const orient = r.orientation || 'h';
      return `
      <div class="prop-group"><span class="prop-label">Rail DIN</span>
        <div style="font-size:11px;color:var(--text2)">${blocStr}#${info.idx + 1}</div>
      </div>
      <div class="prop-group"><span class="prop-label">Label</span>
        <input class="prop-input" id="pir-label" value="${esc(r.label || '')}" placeholder="Rail ${info.idx + 1}">
      </div>
      <div class="prop-group"><span class="prop-label">Orientation</span>
        <select class="prop-input" id="pir-orient">
          <option value="h"${orient === 'h' ? ' selected' : ''}>↔ Horizontal</option>
          <option value="v"${orient === 'v' ? ' selected' : ''}>↕ Vertical</option>
        </select>
      </div>
      <div class="prop-group"><span class="prop-label">Position (mm)</span>
        <div style="display:grid;grid-template-columns:auto 1fr auto 1fr;gap:4px 6px;align-items:center">
          <label style="font-size:10px;color:var(--text2)">X</label><input class="prop-input" type="number" id="pir-x" value="${r.x || 0}" step="5">
          <label style="font-size:10px;color:var(--text2)">Y</label><input class="prop-input" type="number" id="pir-y" value="${r.y || 0}" step="5">
        </div>
      </div>
      <div class="prop-group"><span class="prop-label">Longueur (mm)</span>
        <input class="prop-input" type="number" id="pir-len" value="${r.width || 0}" step="10" min="10">
      </div>
      <div class="prop-group"><button class="prop-btn danger" id="pa-del">✕ Supprimer</button></div>`;
    } else {
      const g = entity;
      const gW = g.width || 40, gH = g.height || 40;
      const orient = g.orientation || (gW >= gH ? 'h' : 'v');
      const fillMode = g.fillMode || 'none';
      const fillPercent = g.fillPercent || 50;
      const fillColor = g.fillColor || '#3b9eff';
      const depth = g.depth || 60;
      return `
      <div class="prop-group"><span class="prop-label">Goulotte</span>
        <div style="font-size:11px;color:var(--text2)">${blocStr}#${info.idx + 1}</div>
      </div>
      <div class="prop-group"><span class="prop-label">Orientation</span>
        <select class="prop-input" id="pig-orient">
          <option value="h"${orient === 'h' ? ' selected' : ''}>↔ Horizontal</option>
          <option value="v"${orient === 'v' ? ' selected' : ''}>↕ Vertical</option>
        </select>
      </div>
      <div class="prop-group"><span class="prop-label">Position (mm)</span>
        <div style="display:grid;grid-template-columns:auto 1fr auto 1fr;gap:4px 6px;align-items:center">
          <label style="font-size:10px;color:var(--text2)">X</label><input class="prop-input" type="number" id="pig-x" value="${g.x || 0}" step="5">
          <label style="font-size:10px;color:var(--text2)">Y</label><input class="prop-input" type="number" id="pig-y" value="${g.y || 0}" step="5">
        </div>
      </div>
      <div class="prop-group"><span class="prop-label">Dimensions (mm)</span>
        <div style="display:grid;grid-template-columns:auto 1fr auto 1fr;gap:4px 6px;align-items:center">
          <label style="font-size:10px;color:var(--text2)">L</label><input class="prop-input" type="number" id="pig-w" value="${gW}" step="5" min="5">
          <label style="font-size:10px;color:var(--text2)">H</label><input class="prop-input" type="number" id="pig-h" value="${gH}" step="5" min="5">
          <label style="font-size:10px;color:var(--text2)">P</label><input class="prop-input" type="number" id="pig-d" value="${depth}" step="5" min="5">
        </div>
      </div>
      <div class="prop-group"><span class="prop-label">Remplissage</span>
        <select class="prop-input" id="pig-fillmode">
          <option value="none"${fillMode === 'none' ? ' selected' : ''}>Aucun</option>
          <option value="hatch"${fillMode === 'hatch' ? ' selected' : ''}>Hachuré</option>
          <option value="solid"${fillMode === 'solid' ? ' selected' : ''}>Plein</option>
        </select>
      </div>
      <div class="prop-group"><span class="prop-label">Opacité %</span>
        <input class="prop-input" type="number" id="pig-fillpct" value="${fillPercent}" min="0" max="100" step="5">
      </div>
      <div class="prop-group"><span class="prop-label">Couleur remplissage</span>
        <input class="prop-color" type="color" id="pig-fillcol" value="${fillColor}">
      </div>
      <div class="prop-group"><button class="prop-btn danger" id="pa-del">✕ Supprimer</button></div>`;
    }
  }

  // Bindings pour le panneau props rail/goulotte
  function _bindImplantShapeProps(sh, mR, mG) {
    const applyRail = () => {
      const info = _findImplantEntity(sh.id);
      if (!info) return;
      const r = info.entity;
      const newOrient = document.getElementById('pir-orient')?.value || 'h';
      r.label = document.getElementById('pir-label')?.value || '';
      r.orientation = newOrient;
      r.x = parseFloat(document.getElementById('pir-x')?.value) || 0;
      r.y = parseFloat(document.getElementById('pir-y')?.value) || 0;
      r.width = parseFloat(document.getElementById('pir-len')?.value) || 100;
      _updateImplantCfg(info.cfg);
    };
    const applyGoul = () => {
      const info = _findImplantEntity(sh.id);
      if (!info) return;
      const g = info.entity;
      const newOrient = document.getElementById('pig-orient')?.value || 'h';
      const prevOrient = g.orientation || ((g.width || 40) >= (g.height || 40) ? 'h' : 'v');
      // Swap W/H si orientation change
      if (newOrient !== prevOrient) {
        const w = document.getElementById('pig-w');
        const h = document.getElementById('pig-h');
        if (w && h) { const tmp = w.value; w.value = h.value; h.value = tmp; }
      }
      g.orientation = newOrient;
      g.x = parseFloat(document.getElementById('pig-x')?.value) || 0;
      g.y = parseFloat(document.getElementById('pig-y')?.value) || 0;
      g.width = parseFloat(document.getElementById('pig-w')?.value) || 40;
      g.height = parseFloat(document.getElementById('pig-h')?.value) || 40;
      g.depth = parseFloat(document.getElementById('pig-d')?.value) || 60;
      g.fillMode = document.getElementById('pig-fillmode')?.value || 'none';
      g.fillPercent = parseInt(document.getElementById('pig-fillpct')?.value) || 50;
      g.fillColor = document.getElementById('pig-fillcol')?.value || '#3b9eff';
      _updateImplantCfg(info.cfg);
    };
    if (mR) {
      ['pir-label', 'pir-orient', 'pir-x', 'pir-y', 'pir-len'].forEach(id => {
        document.getElementById(id)?.addEventListener('change', applyRail);
      });
    } else if (mG) {
      ['pig-orient', 'pig-x', 'pig-y', 'pig-w', 'pig-h', 'pig-d', 'pig-fillmode', 'pig-fillpct', 'pig-fillcol'].forEach(id => {
        document.getElementById(id)?.addEventListener('change', applyGoul);
      });
    }
  }

  // Sélectionne une shape sur le canvas (rail/goulotte) + centre la vue + highlight 3s
  function _selectImplantShape(shapeId) {
    if (!shapeId) return;
    const sh = state.shapes.find(s => s.id === shapeId);
    if (!sh) { setStatus('⚠ Shape introuvable'); return; }
    // Nettoyer anciens blinks
    state.shapes.forEach(s => { delete s._blink; });
    state.texts.forEach(t => { delete t._blink; });
    // Sélectionner la shape
    selected = { type: 'shape', id: shapeId };
    multiSel.clear();
    multiSel.add('shape:' + shapeId);
    // Highlight temporaire
    sh._blink = true;
    // Centrer la vue sur le centre de la shape si besoin
    let cx, cy;
    if (sh.t === 'rect') { cx = sh.x + sh.w / 2; cy = sh.y + sh.h / 2; }
    else if (sh.t === 'circle') { cx = sh.cx; cy = sh.cy; }
    else if (sh.pts?.length) { cx = sh.pts[0].x; cy = sh.pts[0].y; }
    if (cx != null && cy != null && typeof canvas !== 'undefined' && canvas) {
      // Si le centre de la shape n'est pas visible, recentrer
      const sx = cx * view.zoom + view.panX;
      const sy = cy * view.zoom + view.panY;
      if (sx < 100 || sx > canvas.width - 100 || sy < 100 || sy > canvas.height - 100) {
        view.panX = canvas.width / 2 - cx * view.zoom;
        view.panY = canvas.height / 2 - cy * view.zoom;
      }
    }
    render();
    if (typeof updateProps === 'function') updateProps();
    // Retirer le blink après 3s
    setTimeout(() => {
      const cur = state.shapes.find(s => s.id === shapeId);
      if (cur) delete cur._blink;
      render();
    }, 3000);
  }

  // Synchronise les positions des shapes __impl_rail_* et __impl_goul_* vers la config
  // Appelé après un drag/drop pour que les textes/dimensions suivent
  function _syncImplantShapesToCfg() {
    const c = _rootCfg();
    if (!c || !c.cabinetType) return;
    const S = _implantScale(c);
    const isMb = c.cabinetType === 'armoire_multibloc';
    const railTpx = 7.5 * S;
    const globalOff = _implantOffset(c);

    // Calcule l'offsetX en px pour chaque bloc (multibloc)
    let blocOffsets = [];
    if (isMb) {
      const gap = (c.gap || 0) * S;
      let off = 0;
      for (const b of (c.blocs || [])) {
        blocOffsets.push(off);
        off += (b.width || 400) * S + gap;
      }
    }

    let changed = false;
    for (const sh of state.shapes) {
      if (!sh.id || sh.t !== 'rect') continue;
      // ── Rails ────────────────────────────────────────
      const railMatch = sh.id.match(/^__impl_rail_(?:(\d+)_)?(\d+)$/);
      if (railMatch) {
        const bi = railMatch[1] !== undefined ? parseInt(railMatch[1]) : null;
        const ri = parseInt(railMatch[2]);
        const entity = isMb ? (c.blocs || [])[bi] : c;
        if (!entity) continue;
        const rail = (entity.rails || [])[ri];
        if (!rail) continue;
        const offsetXpx = (isMb ? (blocOffsets[bi] || 0) : 0) + globalOff.x;
        const offsetYpx = globalOff.y;
        const orient = rail.orientation || 'h';
        let newX, newY, newLen;
        if (orient === 'v') {
          newX = (sh.x + sh.w / 2 - offsetXpx) / S;
          newY = (sh.y - offsetYpx) / S;
          newLen = sh.h / S;
        } else {
          newX = (sh.x - offsetXpx) / S;
          newY = (sh.y + sh.h / 2 - offsetYpx) / S;
          newLen = sh.w / S;
        }
        newX = Math.round(newX);
        newY = Math.round(newY);
        newLen = Math.round(newLen);
        if (rail.x !== newX || rail.y !== newY || rail.width !== newLen) {
          rail.x = newX; rail.y = newY; rail.width = newLen;
          changed = true;
        }
        continue;
      }
      // ── Goulottes ────────────────────────────────────
      const goulMatch = sh.id.match(/^__impl_goul_(?:(\d+)_)?(\d+)$/);
      if (goulMatch) {
        const bi = goulMatch[1] !== undefined ? parseInt(goulMatch[1]) : null;
        const gi = parseInt(goulMatch[2]);
        const entity = isMb ? (c.blocs || [])[bi] : c;
        if (!entity) continue;
        const goul = (entity.goulottes || [])[gi];
        if (!goul) continue;
        const offsetXpx = (isMb ? (blocOffsets[bi] || 0) : 0) + globalOff.x;
        const offsetYpx = globalOff.y;
        const newX = Math.round((sh.x - offsetXpx) / S);
        const newY = Math.round((sh.y - offsetYpx) / S);
        const newW = Math.round(sh.w / S);
        const newH = Math.round(sh.h / S);
        if (goul.x !== newX || goul.y !== newY || goul.width !== newW || goul.height !== newH) {
          goul.x = newX; goul.y = newY; goul.width = newW; goul.height = newH;
          changed = true;
        }
        continue;
      }
    }

    if (changed) {
      // Magnétisme : snap sur les bords des autres éléments
      if (c.magnetism !== false) _snapImplantBorders(c);
      // Clamp à la grille si option active
      if (c.clampToGrid) _clampImplantToGrid(c);
      // Regénère le canvas : shapes repositionnées exactement + textes/dimensions suivent
      _generateImplantCanvas(c);
      // Rafraîchir le panel aussi pour voir les nouvelles coordonnées
      if (document.getElementById('implant-overlay')?.style.display !== 'none') {
        _refreshImplantPanel(c);
      }
    }
    return changed;
  }

  // Magnétisme : snap chaque rail/goulotte aux bords proches des autres éléments + zone grille
  // Tolérance : 8mm autour de chaque bord
  function _snapImplantBorders(c) {
    const TOL = 8; // mm
    const isMb = c.cabinetType === 'armoire_multibloc';
    const entities = isMb ? (c.blocs || []) : [c];
    entities.forEach(ent => {
      const entW = isMb ? (ent.width || 400) : (c.cabinetW || 600);
      const entH = isMb ? (ent.height || 2000) : (c.cabinetH || 400);
      const zone = _gridZone(ent, entW, entH);
      // Collecte des bords candidats (zones + rails + goulottes)
      const xEdges = [zone.x, zone.x + zone.w];
      const yEdges = [zone.y, zone.y + zone.h];
      (ent.rails || []).forEach(r => {
        const orient = r.orientation || 'h';
        if (orient === 'h') {
          yEdges.push(r.y || 0);
          xEdges.push(r.x || 0, (r.x || 0) + (r.width || 0));
        } else {
          xEdges.push(r.x || 0);
          yEdges.push(r.y || 0, (r.y || 0) + (r.width || 0));
        }
      });
      (ent.goulottes || []).forEach(g => {
        xEdges.push(g.x || 0, (g.x || 0) + (g.width || 40));
        yEdges.push(g.y || 0, (g.y || 0) + (g.height || 40));
      });
      const snap1D = (v, edges) => {
        let best = v, bestD = TOL + 1;
        edges.forEach(e => {
          const d = Math.abs(e - v);
          if (d < bestD) { bestD = d; best = e; }
        });
        return bestD <= TOL ? best : v;
      };
      // Snap pour chaque rail (sans inclure ses propres bords)
      (ent.rails || []).forEach((r, i) => {
        const orient = r.orientation || 'h';
        const selfX = [r.x || 0, (r.x || 0) + (r.width || 0)];
        const selfY = [r.y || 0];
        const xs = xEdges.filter(e => !selfX.includes(e));
        const ys = yEdges.filter(e => !selfY.includes(e));
        if (orient === 'h') {
          const newX1 = snap1D(r.x || 0, xs);
          const newX2 = snap1D((r.x || 0) + (r.width || 0), xs);
          if (newX1 !== (r.x || 0) || newX2 !== (r.x || 0) + (r.width || 0)) {
            r.x = Math.round(newX1);
            r.width = Math.max(10, Math.round(newX2 - newX1));
          }
          const newY = snap1D(r.y || 0, ys);
          if (newY !== (r.y || 0)) r.y = Math.round(newY);
        } else {
          const newY1 = snap1D(r.y || 0, ys);
          const newY2 = snap1D((r.y || 0) + (r.width || 0), ys);
          if (newY1 !== (r.y || 0) || newY2 !== (r.y || 0) + (r.width || 0)) {
            r.y = Math.round(newY1);
            r.width = Math.max(10, Math.round(newY2 - newY1));
          }
          const newX = snap1D(r.x || 0, xs);
          if (newX !== (r.x || 0)) r.x = Math.round(newX);
        }
      });
      // Snap pour chaque goulotte
      (ent.goulottes || []).forEach((g, i) => {
        const selfX = [g.x || 0, (g.x || 0) + (g.width || 40)];
        const selfY = [g.y || 0, (g.y || 0) + (g.height || 40)];
        const xs = xEdges.filter(e => !selfX.includes(e));
        const ys = yEdges.filter(e => !selfY.includes(e));
        const newX1 = snap1D(g.x || 0, xs);
        const newX2 = snap1D((g.x || 0) + (g.width || 40), xs);
        const newY1 = snap1D(g.y || 0, ys);
        const newY2 = snap1D((g.y || 0) + (g.height || 40), ys);
        g.x = Math.round(newX1);
        g.width = Math.max(10, Math.round(newX2 - newX1));
        g.y = Math.round(newY1);
        g.height = Math.max(10, Math.round(newY2 - newY1));
      });
    });
  }

  // Nettoie les orphelins sur un folio implantation :
  // - Si le shape d'un rail/goulotte a été supprimé → supprime l'entrée config + régénère
  //   (ce qui supprime aussi textes, hachures, fills associés)
  // - Si un auxiliaire (texte, hachure) se retrouve sans parent → régénère (le clean sera fait)
  function _cleanupImplantOrphans() {
    const c = _rootCfg();
    if (!c?.cabinetType) return;
    const isMb = c.cabinetType === 'armoire_multibloc';

    // Collecte des IDs shape principaux encore présents (rail et goulotte seulement)
    const existingRailIds = new Set();
    const existingGoulIds = new Set();
    for (const sh of state.shapes) {
      if (!sh.id) continue;
      // Rail principal : __impl_rail_<prefix>i (pas __impl_rlbl, __impl_rdim)
      const rm = sh.id.match(/^__impl_rail_(?:(\d+)_)?(\d+)$/);
      if (rm) existingRailIds.add(sh.id);
      // Goulotte principale : __impl_goul_<prefix>i (pas __impl_goulh, __impl_goulfill, __impl_gdim)
      const gm = sh.id.match(/^__impl_goul_(?:(\d+)_)?(\d+)$/);
      if (gm) existingGoulIds.add(sh.id);
    }

    let changed = false;
    const checkEntity = (entity, bi) => {
      const prefix = bi !== null ? (bi + '_') : '';
      if (entity.rails) {
        const orig = entity.rails.length;
        entity.rails = entity.rails.filter((r, i) => existingRailIds.has('__impl_rail_' + prefix + i));
        if (entity.rails.length !== orig) changed = true;
      }
      if (entity.goulottes) {
        const orig = entity.goulottes.length;
        entity.goulottes = entity.goulottes.filter((g, i) => existingGoulIds.has('__impl_goul_' + prefix + i));
        if (entity.goulottes.length !== orig) changed = true;
      }
    };

    if (isMb) {
      (c.blocs || []).forEach((b, bi) => checkEntity(b, bi));
    } else {
      checkEntity(c, null);
    }

    // Quoi qu'il arrive, régénérer assure que tous les auxiliaires sont synchronisés
    // avec la config (supprime les orphelins éventuels, recrée ce qui est nécessaire)
    _generateImplantCanvas(c);
    if (changed && document.getElementById('implant-overlay')?.style.display !== 'none') {
      _refreshImplantPanel(c);
    }
  }

  // Clampe les éléments (appareillage) pour qu'ils ne dépassent pas la zone grille
  function _clampImplantElementsToGrid() {
    const c = _rootCfg();
    if (!c?.clampToGrid) return;
    const S = _implantScale(c);
    const isMb = c.cabinetType === 'armoire_multibloc';
    const globalOff = _implantOffset(c);

    // Zones en coordonnées CANVAS (px) pour chaque bloc (ou coffret seul)
    let zonesPx = [];
    if (isMb) {
      const gap = (c.gap || 0) * S;
      let off = 0;
      for (const b of (c.blocs || [])) {
        const bW = (b.width || 400) * S;
        const bH = (b.height || 2000) * S;
        const zMm = _gridZone(b, b.width || 400, b.height || 2000);
        zonesPx.push({
          x: globalOff.x + off + zMm.x * S, y: globalOff.y + zMm.y * S,
          w: zMm.w * S, h: zMm.h * S,
          blocRight: globalOff.x + off + bW
        });
        off += bW + gap;
      }
    } else {
      const zMm = _gridZone(c, c.cabinetW || 600, c.cabinetH || 400);
      zonesPx.push({
        x: globalOff.x + zMm.x * S, y: globalOff.y + zMm.y * S,
        w: zMm.w * S, h: zMm.h * S,
        blocRight: globalOff.x + (c.cabinetW || 600) * S
      });
    }

    // Pour chaque élément, trouver le bloc qui le contient (par centre X) et le clamp
    state.elements.forEach(el => {
      const centerX = el.x + (el.w || 0) / 2;
      let zone = zonesPx[0];
      for (const z of zonesPx) {
        if (centerX < z.blocRight) { zone = z; break; }
      }
      if (!zone) return;
      const ew = el.w || 40, eh = el.h || 40;
      el.x = Math.max(zone.x, Math.min(zone.x + zone.w - ew, el.x));
      el.y = Math.max(zone.y, Math.min(zone.y + zone.h - eh, el.y));
    });
  }

  // Cherche l'extension HORIZONTALE libre pour un rail placé à (y, xClic) dans la zone
  // Retourne { x, w } en mm
  function _findFreeHorizontalExtent(entity, zone, y, xClic, kind) {
    let xMin = zone.x;
    let xMax = zone.x + zone.w;
    // Goulottes verticales qui traversent la ligne y
    (entity.goulottes || []).forEach(g => {
      const gx = g.x || 0, gy = g.y || 0, gw = g.width || 40, gh = g.height || 40;
      if (y >= gy && y <= gy + gh) {
        const gRight = gx + gw;
        if (gRight <= xClic && gRight > xMin) xMin = gRight;
        if (gx >= xClic && gx < xMax) xMax = gx;
      }
    });
    // Autres rails horizontaux à la même hauteur → pas de restriction (ils peuvent être sur la même ligne)
    return { x: Math.round(xMin), w: Math.max(50, Math.round(xMax - xMin)) };
  }

  // Cherche l'extension VERTICALE libre pour une goulotte placée à (x, yClic) dans la zone
  // Retourne { y, h } en mm
  function _findFreeVerticalExtent(entity, zone, gx, gw, yClic) {
    let yMin = zone.y;
    let yMax = zone.y + zone.h;
    // Rails horizontaux qui traversent la colonne gx..gx+gw
    (entity.rails || []).forEach(r => {
      const orient = r.orientation || 'h';
      if (orient !== 'h') return;
      const rX = r.x || 0, rW = r.width || 0, rY = r.y || 0;
      if (rX + rW < gx || rX > gx + gw) return; // pas de chevauchement horizontal
      if (rY <= yClic && rY > yMin) yMin = rY + 1;
      if (rY >= yClic && rY < yMax) yMax = rY - 1;
    });
    // Autres goulottes qui partagent la colonne (même bande X)
    (entity.goulottes || []).forEach(g => {
      const x2 = g.x || 0, y2 = g.y || 0, w2 = g.width || 40, h2 = g.height || 40;
      if (x2 + w2 <= gx || x2 >= gx + gw) return;
      const bottom = y2 + h2;
      if (bottom <= yClic && bottom > yMin) yMin = bottom;
      if (y2 >= yClic && y2 < yMax) yMax = y2;
    });
    return { y: Math.round(yMin), h: Math.max(50, Math.round(yMax - yMin)) };
  }

  // Clampe tous les rails/goulottes dans la zone grille
  function _clampImplantToGrid(c) {
    const isMb = c.cabinetType === 'armoire_multibloc';
    const entities = isMb ? (c.blocs || []) : [c];
    entities.forEach(ent => {
      const entW = isMb ? (ent.width || 400) : (c.cabinetW || 600);
      const entH = isMb ? (ent.height || 2000) : (c.cabinetH || 400);
      const zone = _gridZone(ent, entW, entH);
      (ent.rails || []).forEach(r => {
        if ((r.orientation || 'h') === 'v') {
          r.x = Math.max(zone.x, Math.min(zone.x + zone.w, r.x || 0));
          r.y = Math.max(zone.y, Math.min(zone.y + zone.h - (r.width || 100), r.y || 0));
          r.width = Math.min(r.width || 100, zone.h);
        } else {
          r.x = Math.max(zone.x, Math.min(zone.x + zone.w - (r.width || 100), r.x || 0));
          r.y = Math.max(zone.y, Math.min(zone.y + zone.h, r.y || 0));
          r.width = Math.min(r.width || 100, zone.w);
        }
      });
      (ent.goulottes || []).forEach(g => {
        g.width = Math.min(g.width || 40, zone.w);
        g.height = Math.min(g.height || 40, zone.h);
        g.x = Math.max(zone.x, Math.min(zone.x + zone.w - g.width, g.x || 0));
        g.y = Math.max(zone.y, Math.min(zone.y + zone.h - g.height, g.y || 0));
      });
    });
  }

  // ── Mode placement manuel (clic sur canvas) ──────────────────
  let _implantPlacing = null; // { type: 'rail'|'goulotte', blocIdx: number|null }
  let _implantPlaceHandler = null;

  function _startImplantPlacement(type, blocIdx) {
    if (_implantPlacing) _stopImplantPlacement();
    _implantPlacing = { type, blocIdx };
    const canvasEl = document.getElementById('canvas') || document.querySelector('canvas');
    if (!canvasEl) return;
    canvasEl.style.cursor = 'crosshair';
    setStatus('📍 Cliquez sur le canvas pour placer ' + (type === 'rail' ? 'le rail' : 'la goulotte') + ' (Échap pour annuler)');

    _implantPlaceHandler = (e) => {
      if (e.button !== 0) return;
      e.stopPropagation();
      e.preventDefault();
      const r = canvasEl.getBoundingClientRect();
      const sx = e.clientX - r.left, sy = e.clientY - r.top;
      // Convertir en coordonnées canvas (monde)
      const wx = (sx - view.panX) / view.zoom;
      const wy = (sy - view.panY) / view.zoom;
      _commitImplantPlacement(wx, wy);
    };
    // Capture : s'exécute avant onDown de l'éditeur
    canvasEl.addEventListener('mousedown', _implantPlaceHandler, true);

    // Échap pour annuler
    const escHandler = (ev) => {
      if (ev.key === 'Escape') { _stopImplantPlacement(); document.removeEventListener('keydown', escHandler); }
    };
    document.addEventListener('keydown', escHandler);
  }

  function _stopImplantPlacement() {
    const canvasEl = document.getElementById('canvas') || document.querySelector('canvas');
    if (canvasEl && _implantPlaceHandler) {
      canvasEl.removeEventListener('mousedown', _implantPlaceHandler, true);
      canvasEl.style.cursor = '';
    }
    _implantPlacing = null;
    _implantPlaceHandler = null;
  }

  function _commitImplantPlacement(wx, wy) {
    const placing = _implantPlacing;
    _stopImplantPlacement();
    if (!placing) return;

    const c = _rootCfg();
    const S = _implantScale(c);
    const isMb = c.cabinetType === 'armoire_multibloc';
    const globalOff = _implantOffset(c);

    // Retirer l'offset global (coordonnées relatives au coffret)
    const wxRel = wx - globalOff.x;
    const wyRel = wy - globalOff.y;

    // Trouver le bloc visé (coordonnées relatives au coffret)
    let targetBloc = null, targetBlocIdx = null, offsetXpx = 0;
    if (isMb) {
      const blocs = c.blocs || [];
      const gap = (c.gap || 0) * S;
      let cursor = 0;
      for (let i = 0; i < blocs.length; i++) {
        const bW = (blocs[i].width || 400) * S;
        if (wxRel < cursor + bW + gap / 2) { targetBloc = blocs[i]; targetBlocIdx = i; offsetXpx = cursor; break; }
        cursor += bW + gap;
      }
      if (!targetBloc && blocs.length) {
        targetBloc = blocs[blocs.length - 1]; targetBlocIdx = blocs.length - 1;
        offsetXpx = blocs.slice(0, -1).reduce((s, b) => s + (b.width || 400) * S + gap, 0);
      }
    }

    // Coordonnées en mm relatives au bloc/coffret
    const localXmm = Math.max(0, (wxRel - offsetXpx) / S);
    const localYmm = Math.max(0, wyRel / S);
    const entity = isMb ? targetBloc : c;
    if (!entity) { setStatus('❌ Aucun bloc trouvé'); return; }
    const entityW = isMb ? (targetBloc.width || 400) : (c.cabinetW || 600);
    const entityH = isMb ? (targetBloc.height || 2000) : (c.cabinetH || 400);
    const zone = _gridZone(entity, entityW, entityH);

    if (placing.type === 'rail') {
      const rails = entity.rails || [];
      let y = Math.round(localYmm);
      if (c.clampToGrid) y = Math.max(zone.y, Math.min(zone.y + zone.h, y));
      // Anti-chevauchement horizontal : si une goulotte verticale est présente à cette hauteur,
      // limiter la largeur du rail pour ne pas passer par-dessus
      const freeX = _findFreeHorizontalExtent(entity, zone, y, localXmm, 'rail');
      rails.push({
        label: '', orientation: 'h',
        y, x: freeX.x, width: freeX.w
      });
      entity.rails = rails;
      setStatus('✓ Rail placé à Y=' + y + ' mm (largeur ' + freeX.w + ' mm)');
    } else {
      const goulottes = entity.goulottes || [];
      const gW = 40;
      let gx = localXmm - gW / 2;
      // Anti-chevauchement vertical : trouver l'extension verticale libre autour du clic
      const freeY = _findFreeVerticalExtent(entity, zone, gx, gW, localYmm);
      let gy = freeY.y;
      let gh = freeY.h;
      if (c.clampToGrid) {
        const clamped = _clampToZone(c, entityW, entityH, entity, { x: gx, y: gy, w: gW, h: gh });
        gx = clamped.x; gy = clamped.y; gh = clamped.h;
      }
      goulottes.push({
        x: Math.round(gx), y: Math.round(gy),
        width: gW, height: Math.round(gh),
        depth: 60, fillMode: 'none', fillPercent: 50, fillColor: '#3b9eff'
      });
      entity.goulottes = goulottes;
      setStatus('✓ Goulotte placée');
    }

    _updateImplantCfg(c);
    _refreshImplantPanel(c);
  }

  // Retourne la zone utile (grille si activée, sinon enveloppe) en mm
  // entity = coffret ou bloc, entityW/H = dimensions enveloppe en mm
  function _gridZone(entity, entityW, entityH) {
    if (!entity.hasGrid) return { x: 0, y: 0, w: entityW, h: entityH };
    const gW = entity.gridW || Math.max(50, entityW - 40);
    const gH = entity.gridH || Math.max(50, entityH - 40);
    let gX, gY;
    if (entity.gridCentered !== false) {
      gX = (entityW - gW) / 2; gY = (entityH - gH) / 2;
    } else {
      gX = entity.gridOffsetX || 0; gY = entity.gridOffsetY || 0;
    }
    return { x: gX, y: gY, w: gW, h: gH };
  }

  // Clampe x,y,w,h dans la zone si clampToGrid actif
  // Retourne { x, y, w, h } ajusté
  function _clampToZone(cfg, entityW, entityH, entity, obj) {
    if (!cfg?.clampToGrid) return obj;
    const zone = _gridZone(entity || cfg, entityW, entityH);
    let { x = 0, y = 0, w = obj.w || 40, h = obj.h || 40 } = obj;
    // Ne pas dépasser en taille
    w = Math.min(w, zone.w);
    h = Math.min(h, zone.h);
    // Clamp dans la zone
    x = Math.max(zone.x, Math.min(zone.x + zone.w - w, x));
    y = Math.max(zone.y, Math.min(zone.y + zone.h - h, y));
    return { x, y, w, h };
  }

  // Binding du champ échelle + préréglage + position
  function _bindScaleActions() {
    const inp = document.getElementById('impl-cab-scale');
    const sel = document.getElementById('impl-cab-scale-preset');
    const applyScale = (val) => {
      const v = parseFloat(val);
      if (!v || v <= 0) return;
      const c = _rootCfg();
      c.scale = v;
      _updateImplantCfg(c);
      if (inp && inp.value !== String(v)) inp.value = v;
      if (sel) {
        const opt = [...sel.options].find(o => Math.abs(parseFloat(o.value) - v) < 0.01);
        if (opt) sel.value = opt.value;
      }
    };
    inp?.addEventListener('change', () => applyScale(inp.value));
    sel?.addEventListener('change', () => applyScale(sel.value));

    // Position (mode + coordonnées)
    const modeSel = document.getElementById('impl-cab-posmode');
    const coordsBox = document.getElementById('impl-cab-pos-coords');
    const posX = document.getElementById('impl-cab-posx');
    const posY = document.getElementById('impl-cab-posy');
    modeSel?.addEventListener('change', () => {
      const c = _rootCfg();
      c.positionMode = modeSel.value;
      if (coordsBox) coordsBox.style.display = (c.positionMode === 'custom') ? 'grid' : 'none';
      _updateImplantCfg(c);
    });
    const applyPos = () => {
      const c = _rootCfg();
      c.positionX = parseFloat(posX?.value) || 0;
      c.positionY = parseFloat(posY?.value) || 0;
      _updateImplantCfg(c);
    };
    posX?.addEventListener('change', applyPos);
    posY?.addEventListener('change', applyPos);
  }

  // ── Binding actions (coffret / armoire monobloc) ─────────────
  function _bindImplantActions(cfg) {
    if (cfg.cabinetType === 'armoire_multibloc') { _bindMultiblocActions(cfg); return; }

    // Coffret dimensions + type change
    ['impl-cab-w', 'impl-cab-h', 'impl-cab-d', 'impl-cab-label'].forEach(id => {
      document.getElementById(id)?.addEventListener('change', () => {
        const newCfg = _getImplantCfgFromOverlay();
        _updateImplantCfg(newCfg);
      });
    });

    // Grille (mono coffret)
    _bindGridActions(undefined, () => _rootCfg());

    // Changement de type (avec migration si multibloc)
    document.getElementById('impl-cab-type')?.addEventListener('change', () => {
      const newType = document.getElementById('impl-cab-type').value;
      const curFolio = projectFolios.find(x => x.id === currentFolioId);
      let c = curFolio?.data?.implantation || curFolio?.implantation || {};
      if (newType === 'armoire_multibloc') {
        c = _migrateToMultibloc(c);
      } else {
        c.cabinetType = newType;
      }
      _updateImplantCfg(c);
      _refreshImplantPanel(c);
    });

    // Échelle + préréglage
    _bindScaleActions();

    // Ajouter rail
    document.querySelectorAll('.impl-add-rail').forEach(btn => {
      if (btn.dataset.bloc !== undefined) return; // multibloc handled separately
      btn.addEventListener('click', () => {
        const c = _rootCfg();
        const rails = c.rails || [];
        const zone = _gridZone(c, c.cabinetW || 600, c.cabinetH || 400);
        const nextY = rails.length ? Math.max(...rails.map(r => r.y || 0)) + 80 : Math.round(zone.y + zone.h * 0.2);
        rails.push({ label: '', y: Math.min(nextY, zone.y + zone.h - 20), width: zone.w, x: zone.x });
        c.rails = rails;
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // Supprimer rail
    document.querySelectorAll('.impl-del-rail').forEach(btn => {
      if (btn.dataset.bloc !== undefined) return;
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.idx);
        const curFolio = projectFolios.find(x => x.id === currentFolioId);
        const c = curFolio?.data?.implantation || curFolio?.implantation || {};
        c.rails = (c.rails || []).filter((_, i) => i !== idx);
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // Clic sur item rail → sélection shape + highlight sur le canvas
    document.querySelectorAll('.impl-rail-item, .impl-goul-item').forEach(item => {
      if (item.dataset.bloc !== undefined) return; // coffret simple seulement
      item.addEventListener('click', () => _selectImplantShape(item.dataset.shapeId));
    });

    // Ajouter goulotte
    document.querySelectorAll('.impl-add-goulotte').forEach(btn => {
      if (btn.dataset.bloc !== undefined) return;
      btn.addEventListener('click', () => {
        const c = _rootCfg();
        const goulottes = c.goulottes || [];
        const zone = _gridZone(c, c.cabinetW || 600, c.cabinetH || 400);
        // Goulotte verticale à droite de la zone, bornée à la zone
        goulottes.push({
          x: zone.x + zone.w - 50, y: zone.y,
          width: 40, height: zone.h,
          depth: 60, fillMode: 'none', fillPercent: 50, fillColor: '#3b9eff'
        });
        c.goulottes = goulottes;
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // Supprimer goulotte
    document.querySelectorAll('.impl-del-goul').forEach(btn => {
      if (btn.dataset.bloc !== undefined) return;
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.idx);
        const curFolio = projectFolios.find(x => x.id === currentFolioId);
        const c = curFolio?.data?.implantation || curFolio?.implantation || {};
        c.goulottes = (c.goulottes || []).filter((_, i) => i !== idx);
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // (édition des rails/goulottes → dans le panneau de propriétés à droite via updateProps)

    // Boutons placement manuel (rail + goulotte)
    document.querySelectorAll('.impl-place-rail').forEach(btn => {
      if (btn.dataset.bloc !== undefined) return;
      btn.addEventListener('click', () => _startImplantPlacement('rail', null));
    });
    document.querySelectorAll('.impl-place-goul').forEach(btn => {
      if (btn.dataset.bloc !== undefined) return;
      btn.addEventListener('click', () => _startImplantPlacement('goulotte', null));
    });

    // Boutons header
    document.getElementById('implant-btn-refresh')?.addEventListener('click', () => showImplantOverlay());
    document.getElementById('implant-btn-close')?.addEventListener('click', () => hideImplantOverlay());
  }

  // ── Binding actions multibloc ────────────────────────────────
  function _bindMultiblocActions(cfg) {
    // Helper pour récupérer la config courante
    function _getCfg() {
      const f = projectFolios.find(x => x.id === currentFolioId);
      return f?.data?.implantation || f?.implantation || cfg;
    }

    // En-tête (repère, profondeur, gap)
    ['impl-cab-label', 'impl-cab-d', 'impl-mb-gap'].forEach(id => {
      document.getElementById(id)?.addEventListener('change', () => {
        const c = _getCfg();
        c.cabinetLabel = document.getElementById('impl-cab-label')?.value?.trim() || '';
        c.cabinetDepth = parseInt(document.getElementById('impl-cab-d')?.value) || 200;
        c.gap = parseInt(document.getElementById('impl-mb-gap')?.value) || 0;
        _updateImplantCfg(c);
      });
    });

    // Échelle + préréglage
    _bindScaleActions();

    // Changement de type (migration vers coffret/armoire)
    document.getElementById('impl-cab-type')?.addEventListener('change', () => {
      const newType = document.getElementById('impl-cab-type').value;
      if (newType === 'armoire_multibloc') return;
      const c = _getCfg();
      const migrated = _migrateFromMultibloc(c, newType);
      _updateImplantCfg(migrated);
      _refreshImplantPanel(migrated);
    });

    // Ajouter bloc
    document.getElementById('impl-add-bloc')?.addEventListener('click', () => {
      const c = _getCfg();
      const blocs = c.blocs || [];
      const newIdx = blocs.length;
      blocs.push({ id: 'bloc_' + newIdx, label: 'Bloc ' + (newIdx + 1), width: 400, height: 2000, rails: [], goulottes: [] });
      c.blocs = blocs;
      _updateImplantCfg(c);
      _refreshImplantPanel(c);
    });

    // Supprimer bloc
    document.querySelectorAll('.impl-del-bloc').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const bi = parseInt(btn.dataset.bloc);
        const c = _getCfg();
        c.blocs = (c.blocs || []).filter((_, i) => i !== bi);
        // Re-index IDs
        c.blocs.forEach((b, i) => { b.id = 'bloc_' + i; });
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // Déplacer bloc à gauche
    document.querySelectorAll('.impl-bloc-left').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const bi = parseInt(btn.dataset.bloc);
        if (bi <= 0) return;
        const c = _getCfg();
        const blocs = c.blocs || [];
        [blocs[bi - 1], blocs[bi]] = [blocs[bi], blocs[bi - 1]];
        blocs.forEach((b, i) => { b.id = 'bloc_' + i; });
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // Déplacer bloc à droite
    document.querySelectorAll('.impl-bloc-right').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const bi = parseInt(btn.dataset.bloc);
        const c = _getCfg();
        const blocs = c.blocs || [];
        if (bi >= blocs.length - 1) return;
        [blocs[bi], blocs[bi + 1]] = [blocs[bi + 1], blocs[bi]];
        blocs.forEach((b, i) => { b.id = 'bloc_' + i; });
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // Modifier dimensions / label d'un bloc
    document.querySelectorAll('.impl-bloc-label, .impl-bloc-w, .impl-bloc-h').forEach(inp => {
      inp.addEventListener('change', () => {
        const bi = parseInt(inp.dataset.bloc);
        const c = _getCfg();
        const bloc = (c.blocs || [])[bi];
        if (!bloc) return;
        const det = inp.closest('.impl-bloc-details');
        if (!det) return;
        bloc.label = det.querySelector('.impl-bloc-label')?.value || '';
        bloc.width = parseInt(det.querySelector('.impl-bloc-w')?.value) || 400;
        bloc.height = parseInt(det.querySelector('.impl-bloc-h')?.value) || 2000;
        _updateImplantCfg(c);
        // Re-render summary text
        const summary = det.querySelector('summary span');
        if (summary) summary.textContent = bloc.label + ' (' + bloc.width + ' x ' + bloc.height + ' mm)';
      });
    });

    // Grille par bloc — bind séparé pour chaque bloc existant
    (cfg.blocs || []).forEach((_b, bi) => {
      _bindGridActions(bi, () => {
        const c = _getCfg();
        return (c.blocs || [])[bi];
      });
    });

    // Rails par bloc
    document.querySelectorAll('.impl-add-rail[data-bloc]').forEach(btn => {
      btn.addEventListener('click', () => {
        const bi = parseInt(btn.dataset.bloc);
        const c = _getCfg();
        const bloc = (c.blocs || [])[bi];
        if (!bloc) return;
        const rails = bloc.rails || [];
        const zone = _gridZone(bloc, bloc.width || 400, bloc.height || 2000);
        const nextY = rails.length ? Math.max(...rails.map(r => r.y || 0)) + 80 : Math.round(zone.y + zone.h * 0.15);
        rails.push({ label: '', y: Math.min(nextY, zone.y + zone.h - 20), width: zone.w, x: zone.x });
        bloc.rails = rails;
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    document.querySelectorAll('.impl-del-rail[data-bloc]').forEach(btn => {
      btn.addEventListener('click', () => {
        const bi = parseInt(btn.dataset.bloc);
        const ri = parseInt(btn.dataset.idx);
        const c = _getCfg();
        const bloc = (c.blocs || [])[bi];
        if (!bloc) return;
        bloc.rails = (bloc.rails || []).filter((_, i) => i !== ri);
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // Clic sur item rail/goulotte d'un bloc → sélection shape
    document.querySelectorAll('.impl-rail-item[data-bloc], .impl-goul-item[data-bloc]').forEach(item => {
      item.addEventListener('click', () => _selectImplantShape(item.dataset.shapeId));
    });

    // Goulottes par bloc
    document.querySelectorAll('.impl-add-goulotte[data-bloc]').forEach(btn => {
      btn.addEventListener('click', () => {
        const bi = parseInt(btn.dataset.bloc);
        const c = _getCfg();
        const bloc = (c.blocs || [])[bi];
        if (!bloc) return;
        const goulottes = bloc.goulottes || [];
        const zone = _gridZone(bloc, bloc.width || 400, bloc.height || 2000);
        goulottes.push({
          x: zone.x + zone.w - 50, y: zone.y,
          width: 40, height: zone.h,
          depth: 60, fillMode: 'none', fillPercent: 50, fillColor: '#3b9eff'
        });
        bloc.goulottes = goulottes;
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    document.querySelectorAll('.impl-del-goul[data-bloc]').forEach(btn => {
      btn.addEventListener('click', () => {
        const bi = parseInt(btn.dataset.bloc);
        const gi = parseInt(btn.dataset.idx);
        const c = _getCfg();
        const bloc = (c.blocs || [])[bi];
        if (!bloc) return;
        bloc.goulottes = (bloc.goulottes || []).filter((_, i) => i !== gi);
        _updateImplantCfg(c);
        _refreshImplantPanel(c);
      });
    });

    // (édition rails/goulottes → dans le panneau propriétés à droite)

    // Boutons placement manuel par bloc
    document.querySelectorAll('.impl-place-rail[data-bloc]').forEach(btn => {
      btn.addEventListener('click', () => _startImplantPlacement('rail', parseInt(btn.dataset.bloc)));
    });
    document.querySelectorAll('.impl-place-goul[data-bloc]').forEach(btn => {
      btn.addEventListener('click', () => _startImplantPlacement('goulotte', parseInt(btn.dataset.bloc)));
    });

    // Boutons header
    document.getElementById('implant-btn-refresh')?.addEventListener('click', () => showImplantOverlay());
    document.getElementById('implant-btn-close')?.addEventListener('click', () => hideImplantOverlay());
  }

  let _implantResizeBound = false;
  function _bindImplantResize() {
    if (_implantResizeBound) return;
    _implantResizeBound = true;
    const handle = document.getElementById('implant-resize-handle');
    const ov = document.getElementById('implant-overlay');
    if (!handle || !ov) return;
    let startX, startW;
    handle.addEventListener('mousedown', e => {
      e.preventDefault();
      startX = e.clientX; startW = ov.offsetWidth;
      const onMove = ev => { const diff = startX - ev.clientX; ov.style.width = Math.max(260, startW + diff) + 'px'; };
      const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  }

  // ── Bornier Overlay ────────────────────────────────────────
  function hideBornierOverlay() {
    const ov = document.getElementById('bornier-overlay');
    if (ov) ov.style.display = 'none';
  }

  let _bornierCables = []; // cache câbles du projet

  async function showBornierOverlay() {
    const ov = document.getElementById('bornier-overlay');
    if (!ov) return;
    ov.style.display = 'flex';

    const curFolio = projectFolios.find(x => x.id === currentFolioId);
    const curBornierName = curFolio?.bornierName || curFolio?.data?.bornierName || null;
    document.getElementById('bornier-title').textContent = curBornierName
      ? `Bornier : ${curBornierName}`
      : (curFolio?.name || 'Bornier');
    document.getElementById('bornier-content').innerHTML =
      '<div style="color:var(--text3);padding:20px;text-align:center">Chargement…</div>';

    if (!currentProject?.id) return;

    try {
      const [borRes, cabRes] = await Promise.all([
        fetch(`/api/projects/${currentProject.id}/borniers`, { credentials: 'include' }),
        fetch(`/api/projects/${currentProject.id}/cables`, { credentials: 'include' })
      ]);
      const allBorniers = await borRes.json();
      _bornierCables = await cabRes.json();

      if (!allBorniers.length) {
        document.getElementById('bornier-content').innerHTML =
          '<div style="color:var(--text3);padding:30px;text-align:center;font-size:12px">Aucun bornier déclaré dans ce projet.<br><small>Placez des symboles de type "Bornier" sur vos schémas et renseignez les propriétés bornier.</small></div>';
        return;
      }

      // Si ce folio a un bornierName, n'afficher que ce bornier
      let borniers = allBorniers;
      if (curBornierName) {
        borniers = allBorniers.filter(b => b.name === curBornierName);
      }

      // Auto-générer les symboles bornier sur le canvas (seulement ceux du folio)
      _generateBornierCanvas(borniers);

      // Panneau latéral : table du bornier courant + bouton pour créer les folios manquants
      let headerHtml = '';
      // Vérifier quels borniers n'ont pas encore de folio dédié
      const existingBornierFolios = projectFolios.filter(f =>
        f.bornierName || f.data?.bornierName
      ).map(f => f.bornierName || f.data?.bornierName);
      const missingBorniers = allBorniers.filter(b => !existingBornierFolios.includes(b.name));
      if (missingBorniers.length) {
        headerHtml += '<div style="padding:8px 0;border-bottom:1px solid var(--border2);margin-bottom:8px">'
          + '<button id="bornier-btn-gen-folios" class="btn-primary" style="font-size:10px;padding:4px 10px;width:100%">'
          + '⊞ Créer ' + missingBorniers.length + ' folio(s) bornier manquant(s)</button></div>';
      }

      try {
        document.getElementById('bornier-content').innerHTML =
          headerHtml + _renderBornierView(borniers);
        _bindBornierActions();
      } catch(renderErr) {
        console.error('[BORNIER] Erreur rendu:', renderErr);
        document.getElementById('bornier-content').innerHTML =
          '<div style="color:var(--accent2);padding:20px">Erreur rendu bornier : ' + renderErr.message + '</div>';
      }

      // Binding création de folios
      document.getElementById('bornier-btn-gen-folios')?.addEventListener('click', async () => {
        await _createBornierFolios(missingBorniers);
      });
    } catch (e) {
      document.getElementById('bornier-content').innerHTML =
        '<div style="color:var(--accent2);padding:20px">Erreur : ' + e.message + '</div>';
    }
  }

  // Créer un folio bornier par bornier manquant
  async function _createBornierFolios(missingBorniers) {
    for (const b of missingBorniers) {
      try {
        const res = await fetch(`/api/projects/${currentProject.id}/folios`, {
          method: 'POST', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: `Bornier ${b.name}`,
            data: { elements: [], wires: [], texts: [], shapes: [], junctions: [], images: [],
                    folio_type: 'bornier', bornierName: b.name }
          })
        });
        if (res.ok) {
          const newFolio = await res.json();
          newFolio.folio_type = 'bornier';
          newFolio.bornierName = b.name;
          newFolio.data = { folio_type: 'bornier', bornierName: b.name };
          projectFolios.push(newFolio);
        }
      } catch (e) { console.error('Erreur création folio bornier:', e); }
    }
    updateFolioNav();
    setStatus(`${missingBorniers.length} folio(s) bornier créé(s)`);
    showBornierOverlay(); // Rafraîchir
  }

  function _generateBornierCanvas(borniers) {
    // Trouver le symbole bornier le plus approprié (préférer le custom, sinon le builtin)
    const termSyms = Object.values(_symbols).filter(s => s.elementRole === 'terminal');
    if (!termSyms.length) return;
    // Prioriser : non-builtin d'abord, sinon le plus grand
    const termSym = termSyms.find(s => !s.builtin) || termSyms.sort((a, b) => (b.width * b.height) - (a.width * a.height))[0];
    if (!termSym) return;

    // Vider le canvas
    state.elements = [];
    state.wires = [];
    state.texts = [];
    state.shapes = [];
    state.junctions = [];
    state.images = [];

    const BORNIER_GAP = 80; // espace vertical entre chaque bornier
    const WIRE_LEN = 80;    // longueur du fil de renvoi

    // Calculer le positionnement centré dans la zone d'impression
    const pz = printZone || { x: 0, y: 0, w: 1200, h: 800 };
    const pzCenterX = pz.x + pz.w / 2;

    // Calculer la hauteur totale pour centrer verticalement
    let totalH = 0;
    borniers.forEach(b => {
      if (!b.terminals.length) return;
      totalH += termSym.height + BORNIER_GAP;
    });
    totalH -= BORNIER_GAP; // retirer le dernier gap
    const startY = Math.max(pz.y + 40, pz.y + (pz.h - totalH - WIRE_LEN * 2) / 2);

    let curY = startY;

    borniers.forEach(b => {
      const nbTerminals = b.terminals.length;
      if (!nbTerminals) return;

      // Centrer ce bornier horizontalement dans la zone d'impression
      const bornierWidth = termSym.width * nbTerminals;
      const startX = pzCenterX - bornierWidth / 2;

      // Titre du bornier (texte)
      state.texts.push({
        id: uid(), x: startX, y: curY - 18,
        text: b.name, size: 14, color: PROJ.textColor || '#3b9eff'
      });

      // Placer le symbole bornier multi-pôle
      const poles = [];
      for (let i = 0; i < nbTerminals; i++) poles.push('T');

      const el = {
        id: uid(), symId: termSym.id,
        x: startX, y: curY,
        w: termSym.width * nbTerminals, h: termSym.height,
        rotation: 0, flipH: false,
        color: PROJ.symColor || '#dde1ed',
        label: b.name, ref: '',
        labelOffX: termSym.defaultLabelOffX || 0,
        labelOffY: termSym.defaultLabelOffY || (PROJ.labelOffY ?? -18),
        refOffX: termSym.defaultRefOffX || 0,
        refOffY: termSym.defaultRefOffY || (PROJ.refOffY ?? 10),
        poles: poles,
        bornierName: b.name,
      };
      state.elements.push(el);

      // Pour chaque borne : ajouter le numéro, un fil côté schéma (gauche) avec renvoi de folio,
      // et un texte côté câble (droite)
      const pins = termSym.pins || [];
      const pinT = pins.find(p => p.name === 'T' || p.name === 'L') || pins[0];
      const pinB = pins.find(p => p.name === 'B' || p.name === 'R') || pins[1] || pins[0];

      // ── Côté schéma (haut) : fils individuels + renvois de folio ──
      b.terminals.forEach((t, i) => {
        const poleOffX = i * termSym.width;
        const pinTopX = el.x + poleOffX + (pinT ? pinT.x * termSym.width : termSym.width / 2);
        const pinTopY = el.y + (pinT ? pinT.y * termSym.height : 0);

        const wireSchemaEndY = pinTopY - WIRE_LEN;
        state.wires.push({
          id: uid(),
          points: [{ x: pinTopX, y: wireSchemaEndY }, { x: pinTopX, y: pinTopY }],
          color: PROJ.wireColor || '#3b9eff',
          width: PROJ.wireWidth || 1.5,
          isBus: false,
          num: t.label || '',
          numAngle: 90,
          numOffX: -12, // décaler à gauche du fil
          numOffY: 0,
          xrefStart: t.folioNum ? 'F' + t.folioNum : '',
          xrefEnd: '',
        });
      });

      // ── Numéros de bornes (vertical, centré dans chaque borne) ──
      b.terminals.forEach((t, i) => {
        const poleOffX = i * termSym.width;
        const poleCenterX = el.x + poleOffX + termSym.width / 2;
        const poleCenterY = el.y + termSym.height / 2;
        state.texts.push({
          id: uid(), x: poleCenterX, y: poleCenterY,
          text: t.num || String(i + 1), size: 10,
          color: PROJ.textColor || '#dde1ed',
          angle: 90,
        });
      });

      // ── Côté câble (bas) : regrouper les fils par câble ──
      const CABLE_START_Y = el.y + termSym.height + 24; // début des fils câble
      const CABLE_BRANCH_LEN = 40; // longueur du fil individuel avant regroupement
      const CABLE_BUS_Y = CABLE_START_Y + CABLE_BRANCH_LEN + 10; // Y du bus horizontal de regroupement
      const CABLE_EXIT_LEN = 50; // longueur du câble après regroupement

      // Grouper les bornes par câble
      const cableGroups = {};
      b.terminals.forEach((t, i) => {
        if (!t.cableId) return;
        if (!cableGroups[t.cableId]) cableGroups[t.cableId] = [];
        cableGroups[t.cableId].push({ t, i });
      });

      Object.entries(cableGroups).forEach(([cableId, entries]) => {
        const cable = _bornierCables.find(c => c.id === cableId);
        if (!cable) return;

        // Dessiner chaque fil individuel (borne → point de regroupement)
        const branchXs = [];
        entries.forEach(({ t, i }) => {
          const poleOffX = i * termSym.width;
          const pinBotX = el.x + poleOffX + (pinB ? pinB.x * termSym.width : termSym.width / 2);
          const pinBotY = el.y + (pinB ? pinB.y * termSym.height : termSym.height);

          branchXs.push(pinBotX);

          // Fil vertical : borne → bus horizontal
          state.wires.push({
            id: uid(),
            points: [{ x: pinBotX, y: pinBotY }, { x: pinBotX, y: CABLE_BUS_Y }],
            color: '#ff6340', width: 1.5, isBus: false,
            num: t.conductor || '',
            numAngle: 90,
            numOffX: 8, // décaler à droite du fil conducteur
            numOffY: 0,
          });

          // Jonction au point de raccordement
          state.junctions.push({ id: uid(), x: pinBotX, y: CABLE_BUS_Y });
        });

        // Bus horizontal regroupant les fils du câble
        const minX = Math.min(...branchXs);
        const maxX = Math.max(...branchXs);
        if (branchXs.length > 1) {
          state.wires.push({
            id: uid(),
            points: [{ x: minX, y: CABLE_BUS_Y }, { x: maxX, y: CABLE_BUS_Y }],
            color: '#ff6340', width: 3, isBus: true, num: '',
          });
        }

        // Fil de sortie câble (vers le bas, centré)
        const cableCenterX = (minX + maxX) / 2;
        const cableExitY = CABLE_BUS_Y + CABLE_EXIT_LEN;
        state.wires.push({
          id: uid(),
          points: [{ x: cableCenterX, y: CABLE_BUS_Y }, { x: cableCenterX, y: cableExitY }],
          color: '#ff6340', width: 3, isBus: true, num: '',
        });

        // Jonction au centre
        state.junctions.push({ id: uid(), x: cableCenterX, y: CABLE_BUS_Y });

        // Nom du câble en vertical à côté du fil de sortie (décalé à droite)
        state.texts.push({
          id: uid(), x: cableCenterX + 12, y: CABLE_BUS_Y + 8,
          text: cable.name, size: 11, color: '#ff6340',
          angle: 90,
        });
      });

      // Bornes sans câble : juste un trait court
      b.terminals.forEach((t, i) => {
        if (t.cableId) return;
        const poleOffX = i * termSym.width;
        const pinBotX = el.x + poleOffX + (pinB ? pinB.x * termSym.width : termSym.width / 2);
        const pinBotY = el.y + (pinB ? pinB.y * termSym.height : termSym.height);
        state.wires.push({
          id: uid(),
          points: [{ x: pinBotX, y: pinBotY }, { x: pinBotX, y: pinBotY + 20 }],
          color: '#666', width: 1, isBus: false, num: '',
        });
      });

      curY += termSym.height + BORNIER_GAP + CABLE_EXIT_LEN + 30;
    });

    render();
  }

  function _renderBornierView(borniers) {
    const natSort = (a,b) => String(a).localeCompare(String(b), undefined, {numeric:true, sensitivity:'base'});
    borniers.forEach(b => b.terminals.sort((a,b) => natSort(a.num||'', b.num||'') || natSort(a.etage||'', b.etage||'')));
    let html = '<style>@keyframes blink-conflict{0%,100%{background:rgba(255,68,68,.08)}50%{background:rgba(255,68,68,.25)}}</style>';
    const thSt = 'padding:6px 10px;text-align:left;border:1px solid var(--border2);color:var(--text3);font-weight:700;font-size:9px;text-transform:uppercase;letter-spacing:.5px';

    // Construire la map des conducteurs déjà affectés : cableId → { conductorNum → terminalId }
    const _usedConds = {}; // cableId → Map<condNum, [elId1, elId2, ...]>
    const _conflicts = new Set(); // elIds en conflit
    borniers.forEach(b => b.terminals.forEach(t => {
      if (!t.cableId || !t.conductor) return;
      if (!_usedConds[t.cableId]) _usedConds[t.cableId] = {};
      if (!_usedConds[t.cableId][t.conductor]) _usedConds[t.cableId][t.conductor] = [];
      _usedConds[t.cableId][t.conductor].push(t.id);
    }));
    // Détecter les doublons
    Object.values(_usedConds).forEach(condMap => {
      Object.values(condMap).forEach(ids => {
        if (ids.length > 1) ids.forEach(id => _conflicts.add(id));
      });
    });

    borniers.forEach(b => {
      const realCount = b.terminals.filter(t => !t.isReserve).length;
      const reserveCount = b.terminals.filter(t => t.isReserve).length;
      html += '<div style="margin-bottom:28px">';
      html += '<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
        + '<span style="font-size:15px;font-weight:700;color:var(--accent)">⊟ ' + esc(b.name) + '</span>'
        + '<span style="font-size:10px;color:var(--text3)">' + realCount + ' borne' + (realCount > 1 ? 's' : '')
        + (reserveCount ? ' + ' + reserveCount + ' réserve' + (reserveCount > 1 ? 's' : '') : '') + '</span>'
        + '<button class="bornier-auto-reserve" data-bornier="' + esc(b.name) + '" style="margin-left:auto;background:var(--panel2);border:1px solid var(--warn);color:var(--warn);font-size:9px;padding:2px 8px;border-radius:3px;cursor:pointer;font-family:var(--font)" title="Générer automatiquement les réserves pour les numéros manquants entre la première et la dernière borne">⚡ Auto-réserves</button>'
        + '<button class="bornier-add-reserve" data-bornier="' + esc(b.name) + '" style="background:var(--panel2);border:1px solid var(--border);color:var(--accent);font-size:9px;padding:2px 8px;border-radius:3px;cursor:pointer;font-family:var(--font)" title="Ajouter une borne de réserve">+ Réserve</button>'
        + '</div>';

      html += '<table style="width:100%;border-collapse:collapse;font-size:11px">';
      html += '<thead><tr style="background:var(--panel2)">'
        + '<th style="' + thSt + ';width:48px">N°</th>'
        + '<th style="' + thSt + '">Étage</th>'
        + '<th style="' + thSt + '">Désignation</th>'
        + '<th style="' + thSt + '">Référence</th>'
        + '<th style="' + thSt + ';width:80px">Folio</th>'
        + '<th style="' + thSt + '">Câble</th>'
        + '<th style="' + thSt + '">Conducteur</th>'
        + '</tr></thead><tbody>';

      b.terminals.forEach((t, idx) => {
        const isReserve = t.isReserve;
        const isConflict = _conflicts.has(t.id);
        const bg = isReserve ? 'rgba(255,165,0,.08)' : isConflict ? 'rgba(255,68,68,.15)' : (idx % 2 === 0 ? 'var(--panel)' : 'var(--panel2)');
        const cableId = t.cableId || '';
        const conductor = t.conductor || '';
        const cable = _bornierCables.find(c => c.id === cableId);

        if (isReserve) {
          html += '<tr data-el-id="' + t.id + '" style="background:' + bg + ';font-style:italic;opacity:.7">'
            + '<td style="padding:6px 10px;border:1px solid var(--border2);text-align:center;font-weight:700;color:orange">' + esc(t.num) + '</td>'
            + '<td style="padding:6px 10px;border:1px solid var(--border2);color:var(--text3);font-size:10px">' + esc(t.etage) + '</td>'
            + '<td style="padding:6px 10px;border:1px solid var(--border2);color:orange;font-size:10px" colspan="3">Réserve</td>'
            + '<td style="padding:6px 10px;border:1px solid var(--border2)" colspan="2" align="right">'
            + '<button class="bornier-del-reserve" data-bornier="' + esc(b.name) + '" data-num="' + esc(t.num) + '" data-etage="' + esc(t.etage) + '" style="background:none;border:1px solid var(--border);color:var(--text3);font-size:9px;padding:1px 6px;border-radius:3px;cursor:pointer;font-family:var(--font)" title="Supprimer cette réserve">✕</button></td>'
            + '</tr>';
          return;
        }

        // Select câble
        let cableOpts = '<option value="">—</option>';
        _bornierCables.forEach(c => {
          cableOpts += '<option value="' + c.id + '"' + (c.id === cableId ? ' selected' : '') + '>' + esc(c.name) + '</option>';
        });

        // Conducteurs déjà pris sur ce câble (sauf celui de cette borne)
        const takenOnCable = cableId && _usedConds[cableId] ? _usedConds[cableId] : {};

        // Select conducteur (basé sur le câble sélectionné)
        let condOpts = '<option value="">—</option>';
        if (cable && cable.conductors) {
          cable.conductors.forEach(cn => {
            const cNum = typeof cn === 'object' ? cn.num : cn;
            const cCol = typeof cn === 'object' ? (cn.colorName || '') : '';
            const cHex = typeof cn === 'object' ? cn.color : '';
            const label = cNum + (cCol ? ' (' + cCol + ')' : '');
            // Masquer les conducteurs déjà pris (sauf celui affecté à cette borne)
            const owners = takenOnCable[cNum] || [];
            const takenByOther = owners.some(id => id !== t.id);
            if (takenByOther && cNum !== conductor) return; // ne pas proposer
            const disabledAttr = takenByOther ? ' style="color:var(--accent2);font-style:italic"' : '';
            condOpts += '<option value="' + esc(cNum) + '"' + (cNum === conductor ? ' selected' : '') + disabledAttr + '>' + esc(label) + (takenByOther ? ' ⚠ doublon' : '') + '</option>';
          });
        }

        const conflictBadge = isConflict ? '<span style="color:#ff4444;font-weight:700;font-size:11px;margin-left:4px;animation:blink-conflict 1s infinite" title="Conducteur déjà affecté">⚠</span>' : '';

        html += '<tr data-el-id="' + t.id + '" style="background:' + bg + (isConflict ? ';animation:blink-conflict 1.2s infinite' : '') + '">'
          + '<td style="padding:6px 10px;border:1px solid var(--border2);text-align:center;font-weight:700;color:var(--accent)">' + esc(t.num) + '</td>'
          + '<td style="padding:6px 10px;border:1px solid var(--border2);color:var(--text2);font-size:10px">' + esc(t.etage) + '</td>'
          + '<td style="padding:6px 10px;border:1px solid var(--border2);font-weight:600;color:var(--text)">' + esc(t.label) + '</td>'
          + '<td style="padding:6px 10px;border:1px solid var(--border2);color:var(--text2)">' + esc(t.ref) + '</td>'
          + '<td style="padding:6px 10px;border:1px solid var(--border2)"><a href="#" class="bornier-folio-link" data-folio-id="' + t.folioId + '" style="color:var(--accent);text-decoration:none;font-size:10px">F' + t.folioNum + ' – ' + esc(t.folioName) + '</a></td>'
          + '<td style="padding:6px 10px;border:1px solid var(--border2)"><select class="born-cable-sel" data-el-id="' + t.id + '" data-folio-id="' + t.folioId + '" style="background:var(--panel2);border:1px solid var(--border);color:var(--text);font-size:10px;padding:2px 4px;border-radius:3px;font-family:var(--font);width:100%">' + cableOpts + '</select></td>'
          + '<td style="padding:6px 10px;border:1px solid var(--border2)">' + conflictBadge + '<select class="born-cond-sel" data-el-id="' + t.id + '" data-folio-id="' + t.folioId + '" data-cable-id="' + cableId + '" style="background:var(--panel2);border:1px solid ' + (isConflict ? '#ff4444' : 'var(--border)') + ';color:' + (isConflict ? '#ff4444' : 'var(--text)') + ';font-size:10px;padding:2px 4px;border-radius:3px;font-family:var(--font);width:calc(100% - 20px)">' + condOpts + '</select></td>'
          + '</tr>';
      });

      html += '</tbody></table></div>';
    });

    return html;
  }

  function _bindBornierActions() {
    // Lien folio
    document.querySelectorAll('.bornier-folio-link').forEach(a => {
      a.addEventListener('click', async (e) => {
        e.preventDefault();
        const fid = a.dataset.folioId;
        if (fid) { hideBornierOverlay(); await openFolio(fid); }
      });
    });

    // Sélection câble → mettre à jour les conducteurs et sauvegarder
    document.querySelectorAll('.born-cable-sel').forEach(sel => {
      sel.addEventListener('change', () => {
        const elId = sel.dataset.elId;
        const folioId = sel.dataset.folioId;
        const cableId = sel.value;
        const cable = _bornierCables.find(c => c.id === cableId);

        // Mettre à jour le select conducteur adjacent
        const tr = sel.closest('tr');
        const condSel = tr?.querySelector('.born-cond-sel');
        if (condSel) {
          condSel.innerHTML = '<option value="">—</option>';
          condSel.dataset.cableId = cableId;
          if (cable && cable.conductors) {
            // Trouver les conducteurs déjà pris sur ce câble
            const takenConds = new Set();
            document.querySelectorAll('.born-cond-sel').forEach(other => {
              if (other === condSel) return;
              if (other.dataset.cableId === cableId && other.value) takenConds.add(other.value);
            });
            cable.conductors.forEach(cn => {
              const cNum = typeof cn === 'object' ? cn.num : cn;
              const cCol = typeof cn === 'object' ? (cn.colorName || '') : '';
              const label = cNum + (cCol ? ' (' + cCol + ')' : '');
              if (takenConds.has(cNum)) return; // ne pas proposer
              condSel.innerHTML += '<option value="' + esc(cNum) + '">' + esc(label) + '</option>';
            });
          }
        }

        // Sauvegarder sur l'élément
        _saveBornierField(folioId, elId, 'cableId', cableId);
        // Rafraîchir tous les selects conducteur
        _refreshAllCondSelects();
      });
    });

    // Sélection conducteur
    document.querySelectorAll('.born-cond-sel').forEach(sel => {
      sel.addEventListener('change', () => {
        _saveBornierField(sel.dataset.folioId, sel.dataset.elId, 'conductor', sel.value);
        _refreshAllCondSelects();
      });
    });

    // Ajouter réserve
    document.querySelectorAll('.bornier-add-reserve').forEach(btn => {
      btn.addEventListener('click', () => _promptAddReserve(btn.dataset.bornier));
    });

    // Auto-réserves
    document.querySelectorAll('.bornier-auto-reserve').forEach(btn => {
      btn.addEventListener('click', () => _autoGenerateReserves(btn.dataset.bornier));
    });

    // Supprimer réserve
    document.querySelectorAll('.bornier-del-reserve').forEach(btn => {
      btn.addEventListener('click', () => _deleteReserve(btn.dataset.bornier, btn.dataset.num, btn.dataset.etage));
    });
  }

  function _refreshAllCondSelects() {
    // Recalculer les conducteurs disponibles pour chaque select
    const allCondSels = [...document.querySelectorAll('.born-cond-sel')];

    // Construire la map des conducteurs pris : cableId → Set<condNum>
    const taken = {}; // cableId → { condNum → elId }
    allCondSels.forEach(sel => {
      const cableId = sel.dataset.cableId;
      if (!cableId || !sel.value) return;
      if (!taken[cableId]) taken[cableId] = {};
      taken[cableId][sel.value] = sel.dataset.elId;
    });

    allCondSels.forEach(sel => {
      const cableId = sel.dataset.cableId;
      if (!cableId) return;
      const cable = _bornierCables.find(c => c.id === cableId);
      if (!cable || !cable.conductors) return;
      const currentVal = sel.value;
      const elId = sel.dataset.elId;
      const takenOnCable = taken[cableId] || {};

      sel.innerHTML = '<option value="">—</option>';
      cable.conductors.forEach(cn => {
        const cNum = typeof cn === 'object' ? cn.num : cn;
        const cCol = typeof cn === 'object' ? (cn.colorName || '') : '';
        const label = cNum + (cCol ? ' (' + cCol + ')' : '');
        // Ce conducteur est pris par une autre borne ?
        const ownerId = takenOnCable[cNum];
        if (ownerId && ownerId !== elId) return; // masquer
        const isSelected = cNum === currentVal;
        sel.innerHTML += '<option value="' + cNum + '"' + (isSelected ? ' selected' : '') + '>' + label + '</option>';
      });

      // Mettre à jour le style conflit
      const tr = sel.closest('tr');
      const isConflict = currentVal && takenOnCable[currentVal] && takenOnCable[currentVal] !== elId;
      if (tr) {
        tr.style.animation = isConflict ? 'blink-conflict 1.2s infinite' : '';
        tr.style.background = isConflict ? 'rgba(255,68,68,.15)' : '';
      }
      sel.style.borderColor = isConflict ? '#ff4444' : 'var(--border)';
      sel.style.color = isConflict ? '#ff4444' : 'var(--text)';
    });
  }

  async function _saveBornierField(folioId, elId, field, value) {
    try {
      const res = await fetch(`/api/folios/${folioId}`, { credentials: 'include' });
      const schema = await res.json();
      const data = schema.data || {};
      const el = (data.elements || []).find(e => e.id === elId);
      if (!el) return;
      el[field] = value;
      await fetch(`/api/folios/${folioId}`, {
        method: 'PUT', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data })
      });
    } catch (e) { console.error('Erreur sauvegarde bornier:', e); }
  }

  async function _promptAddReserve(bornierName) {
    const num = prompt('Numéro de la borne de réserve :');
    if (!num) return;
    const etage = prompt('Étage (laisser vide si non applicable) :', '') || '';
    try {
      const res = await fetch(`/api/projects/${currentProject.id}/borniers/${encodeURIComponent(bornierName)}/reserves`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ num, etage })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        setStatus(err.error || 'Erreur ajout réserve', 'error');
        return;
      }
      const pf = projectFolios.find(x => x.id === currentFolioId);
      if (pf && pf.data) {
        if (!pf.data.reserves) pf.data.reserves = [];
        pf.data.reserves.push({ num, etage: etage || '' });
      }
      setStatus('Réserve ajoutée : ' + bornierName + ' n°' + num);
      showBornierOverlay();
    } catch (e) { console.error('Erreur ajout réserve:', e); }
  }

  async function _deleteReserve(bornierName, num, etage) {
    try {
      const res = await fetch(`/api/projects/${currentProject.id}/borniers/${encodeURIComponent(bornierName)}/reserves`, {
        method: 'DELETE', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ num, etage: etage || '' })
      });
      if (!res.ok) return;
      const pf = projectFolios.find(x => x.id === currentFolioId);
      if (pf && pf.data && pf.data.reserves) {
        pf.data.reserves = pf.data.reserves.filter(r => !(r.num === num && (r.etage || '') === (etage || '')));
      }
      setStatus('Réserve supprimée : ' + bornierName + ' n°' + num);
      showBornierOverlay();
    } catch (e) { console.error('Erreur suppression réserve:', e); }
  }

  async function _autoGenerateReserves(bornierName) {
    if (!currentProject?.id) return;
    try {
      // Récupérer les données du bornier
      const borRes = await fetch(`/api/projects/${currentProject.id}/borniers`, { credentials: 'include' });
      const allBorniers = await borRes.json();
      const b = allBorniers.find(x => x.name === bornierName);
      if (!b || !b.terminals.length) { setStatus('Aucune borne trouvée pour ' + bornierName, 'error'); return; }

      // Identifier les numéros numériques des bornes réelles (non réserves)
      const realNums = b.terminals.filter(t => !t.isReserve).map(t => parseInt(t.num, 10)).filter(n => !isNaN(n));
      if (realNums.length < 2) { setStatus('Il faut au moins 2 bornes numériques pour générer les réserves.', 'error'); return; }

      const min = Math.min(...realNums);
      const max = Math.max(...realNums);
      const allUsed = new Set(b.terminals.map(t => parseInt(t.num, 10)).filter(n => !isNaN(n)));
      const missing = [];
      for (let i = min + 1; i < max; i++) {
        if (!allUsed.has(i)) missing.push({ num: String(i), etage: '' });
      }

      if (!missing.length) { setStatus('Aucune réserve à générer — tous les numéros entre ' + min + ' et ' + max + ' sont utilisés.'); return; }

      if (!await showConfirm('Générer ' + missing.length + ' réserve(s) pour ' + bornierName + ' ?\n\nNuméros : ' + missing.map(r => r.num).join(', '))) return;

      // Trouver le folio bornier et mettre à jour ses réserves en bulk
      const allFolios = projectFolios;
      const bornierFolio = allFolios.find(f => {
        const bn = f.bornierName || f.data?.bornierName;
        const ft = f.folio_type || f.data?.folio_type;
        return bn === bornierName && ft === 'bornier';
      });

      if (bornierFolio) {
        // Charger les données complètes du folio
        const fullRes = await fetch(`/api/folios/${bornierFolio.id}`, { credentials: 'include' });
        if (fullRes.ok) {
          const fullFolio = await fullRes.json();
          const curData = fullFolio.data || {};
          const existingReserves = curData.reserves || [];
          const existingSet = new Set(existingReserves.map(r => r.num));
          const newReserves = missing.filter(r => !existingSet.has(r.num));
          if (newReserves.length) {
            const combinedReserves = [...existingReserves, ...newReserves];
            const updData = { ...curData, reserves: combinedReserves };
            await fetch(`/api/folios/${bornierFolio.id}`, {
              method: 'PUT', credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ data: updData })
            });
            // Synchroniser en mémoire pour que saveSchema() ne les écrase pas
            if (bornierFolio.data) {
              bornierFolio.data.reserves = combinedReserves;
            } else {
              bornierFolio.data = updData;
            }
          }
        }
      } else {
        // Pas de folio bornier, créer les réserves une par une (le POST crée le folio auto)
        for (const r of missing) {
          await fetch(`/api/projects/${currentProject.id}/borniers/${encodeURIComponent(bornierName)}/reserves`, {
            method: 'POST', credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ num: r.num, etage: r.etage })
          });
        }
        // Recharger les infos du folio bornier créé automatiquement
        const pf = projectFolios.find(x => x.id === currentFolioId);
        if (pf) {
          const reloadRes = await fetch(`/api/folios/${currentFolioId}`, { credentials: 'include' });
          if (reloadRes.ok) {
            const reloaded = await reloadRes.json();
            pf.data = reloaded.data || pf.data;
          }
        }
      }

      setStatus('✓ ' + missing.length + ' réserve(s) générée(s) pour ' + bornierName);
      showBornierOverlay();
    } catch (e) {
      console.error('Erreur auto-réserves:', e);
      setStatus('Erreur génération réserves', 'error');
    }
  }

  // Gestion des câbles (modal)
  // ── Couleurs standard des conducteurs par type ───────────
  const CABLE_TYPES = {
    G:  { label:'Avec terre (PE)', hasMasse:false, groupSize:0,
          colors: n => { const c = []; for(let i=0;i<n-1;i++) c.push({num:String(i+1),color:'#111',colorName:'Noir'}); c.push({num:'PE',color:'#a0a020',colorName:'Jaune/Vert'}); return c; }},
    X:  { label:'Sans terre', hasMasse:false, groupSize:0,
          colors: n => { const c = []; for(let i=0;i<n;i++) c.push({num:String(i+1),color:'#111',colorName:'Noir'}); return c; }},
    IP: { label:'Paires (2+masse)', hasMasse:true, groupSize:2,
          colors: n => {
            const c=[]; let g=1;
            for(let i=0;i<n;){
              c.push({num:g+'a',color:'#cc2222',colorName:'Rouge'});i++;
              if(i<n){c.push({num:g+'b',color:'#eee',colorName:'Blanc'});i++;}
              g++;
            }
            return c;
          }},
    IT: { label:'Triades (3+masse)', hasMasse:true, groupSize:3,
          colors: n => {
            const c=[]; let g=1;
            for(let i=0;i<n;){
              c.push({num:g+'a',color:'#cc2222',colorName:'Rouge'});i++;
              if(i<n){c.push({num:g+'b',color:'#eee',colorName:'Blanc'});i++;}
              if(i<n){c.push({num:g+'c',color:'#2266cc',colorName:'Bleu'});i++;}
              g++;
            }
            return c;
          }},
    IQ: { label:'Quarts (4+masse)', hasMasse:true, groupSize:4,
          colors: n => {
            const c=[]; let g=1;
            for(let i=0;i<n;){
              c.push({num:g+'a',color:'#cc2222',colorName:'Rouge'});i++;
              if(i<n){c.push({num:g+'b',color:'#eee',colorName:'Blanc'});i++;}
              if(i<n){c.push({num:g+'c',color:'#2266cc',colorName:'Bleu'});i++;}
              if(i<n){c.push({num:g+'d',color:'#cccc22',colorName:'Jaune'});i++;}
              g++;
            }
            return c;
          }},
  };

  function _generateConductors(type, nb, hasScreen) {
    const def = CABLE_TYPES[type] || CABLE_TYPES.X;
    const conds = def.colors(nb);
    if (def.hasMasse) conds.push({num:'M', color:'#c0a070', colorName:'Fil nu (masse)'});
    if (hasScreen) conds.push({num:'ECR', color:'#888', colorName:'Écran (blindage)'});
    return conds;
  }

  function _autoName(type, nb, section) {
    return nb + type + (section ? section : '');
  }

  function _updateCablePreview() {
    const type = document.getElementById('cable-new-type')?.value || 'G';
    const nb = parseInt(document.getElementById('cable-new-nb')?.value) || 3;
    const section = document.getElementById('cable-new-section')?.value.trim();
    const screen = document.getElementById('cable-new-screen')?.checked;
    const conds = _generateConductors(type, nb, screen);
    const preview = document.getElementById('cable-preview');
    if (!preview) return;
    const name = _autoName(type, nb, section);
    preview.innerHTML = '<strong style="color:var(--text)">' + esc(name) + '</strong> → '
      + conds.map(c => '<span style="display:inline-flex;align-items:center;gap:2px;margin-right:4px">'
        + '<span style="width:10px;height:10px;border-radius:50%;border:1px solid var(--border2);background:' + c.color + ';display:inline-block"></span>'
        + '<span>' + esc(c.num) + '</span></span>').join('');
  }

  async function _openCablesModal() {
    if (!currentProject?.id) return;
    openModal('modal-cables');
    _updateCablePreview();
    // Bind preview update
    ['cable-new-type','cable-new-nb','cable-new-section'].forEach(id => {
      document.getElementById(id)?.addEventListener('input', _updateCablePreview);
      document.getElementById(id)?.addEventListener('change', _updateCablePreview);
    });
    document.getElementById('cable-new-screen')?.addEventListener('change', _updateCablePreview);
    await _refreshCablesList();
  }

  async function _refreshCablesList() {
    const list = document.getElementById('cables-list');
    list.innerHTML = '<div style="color:var(--text3);text-align:center;padding:16px">Chargement…</div>';
    try {
      const res = await fetch(`/api/projects/${currentProject.id}/cables`, { credentials: 'include' });
      _bornierCables = await res.json();
    } catch { _bornierCables = []; }

    if (!_bornierCables.length) {
      list.innerHTML = '<div style="color:var(--text3);text-align:center;padding:24px;font-size:11px">Aucun câble. Ajoutez-en avec le formulaire ci-dessus.</div>';
      return;
    }

    list.innerHTML = _bornierCables.map(c => {
      const conds = (c.conductors || []);
      const condsHtml = conds.map(cn => {
        const col = typeof cn === 'object' ? cn.color : '#888';
        const num = typeof cn === 'object' ? cn.num : cn;
        const colName = typeof cn === 'object' ? cn.colorName : '';
        return '<span style="display:inline-flex;align-items:center;gap:2px;margin-right:3px" title="' + esc(colName) + '">'
          + '<span style="width:8px;height:8px;border-radius:50%;border:1px solid var(--border2);background:' + col + ';display:inline-block"></span>'
          + '<span style="font-size:9px">' + esc(num) + '</span></span>';
      }).join('');
      const typeLabel = CABLE_TYPES[c.cableType]?.label || c.cableType || '';
      return '<div style="display:flex;align-items:center;gap:8px;padding:8px 10px;border:1px solid var(--border);border-radius:5px;margin-bottom:6px;background:var(--panel2)">'
        + '<div style="flex:1;min-width:0">'
        + '<div style="font-weight:600;font-size:12px;color:var(--text)">' + esc(c.name) + '</div>'
        + '<div style="font-size:10px;color:var(--text3)">'
        + 'Type: ' + esc(typeLabel) + ' · Section: ' + esc(c.section || '—') + ' mm²'
        + (c.hasScreen ? ' · <span style="color:var(--accent)">Écranté</span>' : '')
        + '</div>'
        + '<div style="margin-top:3px">' + condsHtml + '</div>'
        + '</div>'
        + '<button class="btn-secondary cable-del-btn" data-id="' + c.id + '" style="font-size:10px;padding:3px 8px;color:var(--accent2)">✕</button>'
        + '</div>';
    }).join('');

    list.querySelectorAll('.cable-del-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        if (!await showConfirm('Supprimer ce câble ?')) return;
        await fetch(`/api/cables/${btn.dataset.id}`, { method: 'DELETE', credentials: 'include' });
        await _refreshCablesList();
      });
    });
  }

  async function _addCable() {
    if (!currentProject?.id) return;
    const type = document.getElementById('cable-new-type')?.value || 'G';
    const section = document.getElementById('cable-new-section')?.value.trim();
    const nb = parseInt(document.getElementById('cable-new-nb')?.value) || 3;
    const hasScreen = document.getElementById('cable-new-screen')?.checked || false;
    const nameInput = document.getElementById('cable-new-name')?.value.trim();
    const name = nameInput || _autoName(type, nb, section);
    const conductors = _generateConductors(type, nb, hasScreen);

    await fetch(`/api/projects/${currentProject.id}/cables`, {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, section, cableType: type, nbConductors: nb, conductors, hasScreen })
    });
    document.getElementById('cable-new-name').value = '';
    await _refreshCablesList();
  }

  // ── Binder les boutons BOM ────────────────────────────────
  function _bindBomButtons(){
    document.getElementById('bom-btn-refresh')?.addEventListener('click',showBomOverlay);

    // Boutons overlay bornier
    document.getElementById('bornier-btn-refresh')?.addEventListener('click', showBornierOverlay);
    document.getElementById('bornier-btn-cables')?.addEventListener('click', _openCablesModal);
    document.getElementById('bornier-btn-close')?.addEventListener('click', hideBornierOverlay);

    // Resize handle pour le panneau bornier
    const _bResizeHandle = document.getElementById('bornier-resize-handle');
    if (_bResizeHandle) {
      _bResizeHandle.addEventListener('mousedown', e => {
        e.preventDefault();
        const overlay = document.getElementById('bornier-overlay');
        const startX = e.clientX;
        const startW = overlay.offsetWidth;
        const onMove = ev => {
          const delta = startX - ev.clientX;
          const newW = Math.max(280, Math.min(window.innerWidth - 200, startW + delta));
          overlay.style.width = newW + 'px';
        };
        const onUp = () => {
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onUp);
          document.body.style.cursor = '';
          document.body.style.userSelect = '';
        };
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
      });
    }
    document.getElementById('cable-add-btn')?.addEventListener('click', _addCable);
    document.getElementById('bornier-btn-print')?.addEventListener('click', () => {
      const content = document.getElementById('bornier-content')?.innerHTML || '';
      const projName = currentProject?.name || 'Bornier';
      const w = window.open('', '_blank');
      w.document.write('<html><head><meta charset="utf-8"><title>' + projName + ' — Bornier</title>'
        + '<style>body{font-family:Arial,sans-serif;font-size:11px;padding:20px}'
        + 'table{border-collapse:collapse;width:100%}th,td{border:1px solid #ccc;padding:6px 10px}'
        + 'th{background:#f0f0f0;font-weight:700}tr:nth-child(even){background:#f9f9f9}'
        + 'select{display:none}@media print{body{padding:10px}}</style></head><body>'
        + '<h2>' + projName + ' — Bornier</h2>'
        + content + '</body></html>');
      w.document.close(); w.print();
    });

    // Boutons overlay sommaire
    document.getElementById('summary-btn-close')?.addEventListener('click', hideSummaryOverlay);
    document.getElementById('summary-btn-refresh')?.addEventListener('click', showSummaryOverlay);
    document.getElementById('summary-btn-print')?.addEventListener('click', () => {
      const content = document.getElementById('summary-content')?.innerHTML || '';
      const projName = currentProject?.name || 'Sommaire';
      const w = window.open('', '_blank');
      w.document.write('<html><head><meta charset="utf-8"><title>' + projName + ' — Sommaire</title>'
        + '<style>body{font-family:Arial,sans-serif;font-size:11px;padding:20px}'
        + 'table{border-collapse:collapse;width:100%}th,td{border:1px solid #ccc;padding:7px 10px}'
        + 'th{background:#f0f0f0;font-weight:700}tr:nth-child(even){background:#f9f9f9}'
        + 'h2{margin-bottom:4px}@media print{body{padding:10px}}</style></head><body>'
        + '<h2>' + projName + ' — Sommaire</h2>'
        + content + '</body></html>');
      w.document.close();
      w.print();
    });

    // Double-clic sur une ligne → naviguer vers le folio et faire clignoter le symbole
    document.getElementById('bom-content')?.addEventListener('dblclick', async (e) => {
      const tr = e.target.closest('tr.bom-row');
      if (!tr) return;
      const folioLabel = tr.dataset.folio;   // ex: "F1"
      const ref        = tr.dataset.ref;
      const symId      = tr.dataset.symid;
      if (!folioLabel) return;

      // Trouver le folio par son label (F1, F2…)
      const targetFolio = projectFolios.find(f => {
        const lbl = 'F' + (f.folio_num || f.folio_order || '?');
        return lbl === folioLabel || f.name === folioLabel;
      });
      if (!targetFolio) { setStatus('Folio introuvable : ' + folioLabel); return; }

      // Naviguer vers ce folio
      if (targetFolio.id !== currentFolioId) {
        await saveSchema();
        await openFolio(targetFolio.id);
      }
      hideBomOverlay();

      // Trouver l'élément par ref ou symId et le faire clignoter
      setTimeout(() => {
        const el = state.elements.find(e2 =>
          (ref && e2.ref === ref) || (!ref && e2.symId === symId)
        );
        if (!el) return;

        // Centrer la vue sur l'élément
        const cx = el.x + (el.w || 60) / 2;
        const cy = el.y + (el.h || 40) / 2;
        view.panX = canvas.width  / 2 - cx * view.zoom;
        view.panY = canvas.height / 2 - cy * view.zoom;

        // Sélectionner l'élément
        selected = { type: 'element', id: el.id };
        render(); updateProps();

        // Clignotement pendant 5 secondes
        let _blinkCount = 0;
        const _blinkEl = el;
        const _blinkInt = setInterval(() => {
          _blinkEl._blink = !_blinkEl._blink;
          render();
          _blinkCount++;
          if (_blinkCount >= 20) { // 10 cycles = 5s à 500ms
            clearInterval(_blinkInt);
            _blinkEl._blink = false;
            render();
          }
        }, 250);
      }, 150);
    });
    document.getElementById('bom-btn-config')?.addEventListener('click',()=>{
      _populateBomColsUI();openModal('modal-new-folio');
      // Forcer sélection BOM
      document.querySelectorAll('.nf-type-card').forEach(c=>c.classList.toggle('nf-selected',c.dataset.val==='bom'));
      document.getElementById('nf-bom-config').style.display='block';
      document.getElementById('nf-name').value=projectFolios.find(x=>x.id===currentFolioId)?.name||'';
      // Changer le titre
      document.querySelector('#modal-new-folio .modal-header h2').textContent='⚙ Configurer la nomenclature';
    });
    document.getElementById('bom-btn-export-csv')?.addEventListener('click',async()=>{
      const f=projectFolios.find(x=>x.id===currentFolioId);
      if(!f?.data?.bomConfig)return;
      const{rows,cols}=await _computeBomRows(f.data.bomConfig);
      _exportBomCsv(rows,cols);
    });
    document.getElementById('bom-btn-export-pdf')?.addEventListener('click',async()=>{
      const f=projectFolios.find(x=>x.id===currentFolioId);
      const bomConfig=f?.data?.bomConfig;
      if(!bomConfig) return;
      const {rows,cols}=await _computeBomRows(bomConfig);
      const tableHtml=_renderBomTable(rows,cols,bomConfig);
      const folioName=f?.name||'Nomenclature';
      const projectName=currentProject?.name||'Projet';
      const html=`<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8">
        <title>${projectName} — ${folioName}</title>
        <style>
          *{margin:0;padding:0;box-sizing:border-box}
          body{font-family:Arial,sans-serif;font-size:11px;padding:12mm;background:#fff;color:#111}
          h1{font-size:14px;margin-bottom:4px}
          h2{font-size:11px;color:#555;font-weight:normal;margin-bottom:10px}
          table{width:100%;border-collapse:collapse;margin-top:8px}
          th{background:#1a3a6b;color:#fff;padding:5px 8px;text-align:left;font-size:10px;font-weight:bold}
          td{padding:4px 8px;border-bottom:1px solid #ddd;vertical-align:middle}
          tr:nth-child(even) td{background:#f5f8ff}
          .bom-qty{text-align:center;font-weight:bold;color:#1a3a6b}
          canvas{display:none}
          @page{size:A4;margin:10mm}
          @media print{body{padding:0}}
        </style>
      </head><body>
        <h1>${projectName}</h1>
        <h2>${folioName} — ${new Date().toLocaleDateString('fr-FR')}</h2>
        ${tableHtml}
      </body></html>`;
      const win=window.open('','_blank');
      if(!win){showWarning('Autorisez les popups');return;}
      win.document.write(html);
      win.document.close();
      win.addEventListener('load',()=>setTimeout(()=>{win.focus();win.print();},300));
    });
  }

  // ── Binder la modale nouveau folio ───────────────────────
  function _bindNewFolioModal(){
    // Toggle type de folio
    document.querySelectorAll('.nf-type-card').forEach(card=>{
      card.addEventListener('click',()=>{
        document.querySelectorAll('.nf-type-card').forEach(c=>c.classList.remove('nf-selected'));
        card.classList.add('nf-selected');
        const isBom=card.dataset.val==='bom';
        const isImpl=card.dataset.val==='implantation';
        document.getElementById('nf-bom-config').style.display=isBom?'block':'none';
        document.getElementById('nf-implant-config').style.display=isImpl?'block':'none';
        if(!isImpl) document.getElementById('nf-multibloc-config').style.display='none';
        if(isImpl) _updateNfMultiblocVisibility();
        if(isBom)_populateBomColsUI();
      });
    });
    // Toggle multibloc config quand le type implant change
    document.getElementById('nf-implant-type')?.addEventListener('change', _updateNfMultiblocVisibility);
    // Toggle visibilité des dimensions grille selon la checkbox
    document.getElementById('nf-implant-has-grid')?.addEventListener('change', () => {
      const hasGrid = document.getElementById('nf-implant-has-grid').checked;
      document.getElementById('nf-implant-grid-dims').style.display = hasGrid ? '' : 'none';
    });
    // Confirmer
    document.getElementById('nf-confirm')?.addEventListener('click',_confirmNewFolio);
  }

  function _updateNfMultiblocVisibility(){
    const t=document.getElementById('nf-implant-type')?.value||'coffret';
    const isMb=t==='armoire_multibloc';
    document.getElementById('nf-multibloc-config').style.display=isMb?'block':'none';
    // Masquer W/H individuels si multibloc (chaque bloc a ses propres dimensions)
    const whRow=document.getElementById('nf-implant-w')?.closest('div')?.parentElement;
    if(whRow){
      document.getElementById('nf-implant-w').closest('div').style.display=isMb?'none':'';
      document.getElementById('nf-implant-h').closest('div').style.display=isMb?'none':'';
    }
    // La grille globale n'a pas de sens en multibloc (chaque bloc a sa propre grille dans l'overlay)
    const gridSection=document.getElementById('nf-implant-grid-section');
    if(gridSection) gridSection.style.display=isMb?'none':'';
  }


// ═══ app-export.js ═══
  // ── Export PDF BOM simple ─────────────────────────────────

  // ══════════════════════════════════════════════════════════

  // ── Export PDF ────────────────────────────────────────────
  // ── Export DXF ─────────────────────────────────────────────────────
  async function exportDXF() {
    // Vérifier qu'un folio est chargé
    const folioId = currentFolioId;
    if (!folioId) { showWarning('Aucun folio ouvert. Ouvrez un folio depuis un projet pour exporter en DXF.'); return; }

    // Sauvegarder d'abord pour s'assurer que le serveur a la version courante
    await saveSchema();
    setStatus('Génération DXF…');

    // Afficher une mini-modale de choix d'échelle
    const scale = await askDXFScale();
    if (scale === null) return; // annulé

    try {
      const url = `/api/folios/${folioId}/export-dxf?scale=${scale}`;
      const res = await fetch(url, { credentials: 'include' });
      if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
      const blob = await res.blob();
      const filename = res.headers.get('Content-Disposition')?.match(/filename="([^"]+)"/)?.[1]
        || (document.getElementById('schema-name')?.value || 'schema') + '.dxf';
      const objUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objUrl; a.download = filename; a.click();
      URL.revokeObjectURL(objUrl);
      setStatus('✓ Export DXF : ' + filename);
    } catch(err) {
      setStatus('Erreur export DXF : ' + err.message);
      showWarning('Erreur export DXF : ' + err.message);
    }
  }

  function askDXFScale() {
    return new Promise(resolve => {
      // Modale légère inline
      const overlay = document.createElement('div');
      overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:9999;display:flex;align-items:center;justify-content:center';
      overlay.innerHTML = `
        <div style="background:var(--panel);border:1px solid var(--border);border-radius:10px;padding:24px;width:320px;font-family:var(--font)">
          <div style="font-size:13px;font-weight:600;margin-bottom:14px">⬇ Export DXF</div>
          <div style="font-size:11px;color:var(--text2);margin-bottom:12px">Facteur d'échelle : 1 px QuickDraw = <b id="scale-val">1</b> unité DXF</div>
          <div style="display:flex;flex-direction:column;gap:6px;margin-bottom:16px">
            <label style="font-size:10px;color:var(--text2)">Échelle</label>
            <select id="dxf-scale-sel" style="background:var(--panel2);border:1px solid var(--border2);color:var(--text);padding:5px 8px;border-radius:4px;font-family:var(--font);font-size:11px">
              <option value="0.1">1 px = 0.1 mm (schéma électrique standard)</option>
              <option value="0.5">1 px = 0.5 mm</option>
              <option value="1" selected>1 px = 1 mm</option>
              <option value="2">1 px = 2 mm</option>
              <option value="5">1 px = 5 mm</option>
              <option value="custom">Personnalisé…</option>
            </select>
            <input type="number" id="dxf-scale-custom" value="1" min="0.01" max="100" step="0.1"
              style="display:none;background:var(--panel2);border:1px solid var(--border2);color:var(--text);padding:5px 8px;border-radius:4px;font-family:var(--font);font-size:11px" placeholder="Valeur personnalisée">
          </div>
          <div style="font-size:10px;color:var(--text3);margin-bottom:14px">Le fichier DXF sera compatible AutoCAD R12+, QCAD, LibreCAD, Draftsight.</div>
          <div style="display:flex;gap:8px;justify-content:flex-end">
            <button id="dxf-cancel" style="padding:7px 14px;font-size:11px;background:var(--panel2);border:1px solid var(--border2);color:var(--text2);border-radius:4px;cursor:pointer;font-family:var(--font)">Annuler</button>
            <button id="dxf-ok" style="padding:7px 16px;font-size:11px;background:var(--accent);border:none;color:#fff;border-radius:4px;cursor:pointer;font-family:var(--font);font-weight:600">⬇ Télécharger</button>
          </div>
        </div>`;
      document.body.appendChild(overlay);
      const sel = overlay.querySelector('#dxf-scale-sel');
      const custom = overlay.querySelector('#dxf-scale-custom');
      sel.addEventListener('change', () => { custom.style.display = sel.value==='custom'?'block':'none'; });
      overlay.querySelector('#dxf-cancel').addEventListener('click', () => { document.body.removeChild(overlay); resolve(null); });
      overlay.querySelector('#dxf-ok').addEventListener('click', () => {
        const v = sel.value==='custom' ? parseFloat(custom.value)||1 : parseFloat(sel.value);
        document.body.removeChild(overlay); resolve(v);
      });
    });
  }

  // ── Calcule le bounding box du contenu d'un folio ────────────────────
  function _folioDataBounds(st){
    let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
    const add=(x,y)=>{if(x<minX)minX=x;if(y<minY)minY=y;if(x>maxX)maxX=x;if(y>maxY)maxY=y;};
    (st.elements||[]).forEach(e=>{add(e.x,e.y);add(e.x+(e.w||60),e.y+(e.h||60));});
    (st.wires||[]).forEach(w=>(w.points||[]).forEach(p=>add(p.x,p.y)));
    (st.texts||[]).forEach(t=>add(t.x,t.y));
    (st.shapes||[]).forEach(sh=>{
      if(sh.pts)sh.pts.forEach(p=>add(p.x,p.y));
      if(sh.cx!==undefined){add(sh.cx-(sh.r||0),sh.cy-(sh.r||0));add(sh.cx+(sh.r||0),sh.cy+(sh.r||0));}
      if(sh.x!==undefined){add(sh.x,sh.y);add(sh.x+(sh.w||0),sh.y+(sh.h||0));}
    });
    if(!isFinite(minX)){minX=0;minY=0;maxX=800;maxY=600;}
    return{minX,minY,maxX,maxY};
  }

  // ── Générateur SVG central (paramétrique) ────────────────────────────
  // pz : {x,y,w,h,format,blackAndWhite,withCartouche}
  // tbData : données TitleBlock (ou null)
  // Retourne {svg, pageSize}
  function _buildFolioSVG(st, symLib, pz, tbData, voltMap, folioAnchors){
    const pzX=pz.x||0, pzY=pz.y||0;
    const pzW=Math.max(pz.w||800,100), pzH=Math.max(pz.h||600,100);
    const withCartouche=pz.withCartouche!==false;
    const bw=pz.blackAndWhite===true;
    const CARTO=withCartouche?((tbData&&tbData.cartoucheH?Math.round(tbData.cartoucheH*TitleBlock.MM):0)||60):0;
    const totalH=pzH+CARTO;
    const fmtMap={A4L:'A4 landscape',A4P:'A4 portrait',A3L:'A3 landscape',A3P:'A3 portrait',A2L:'A2 landscape'};
    const pageSize=fmtMap[pz.format]||'A3 landscape';

    const _PROJ=window._PROJ||{};
    const _vMap=voltMap||{};
    function C(hex,fallback='#1a3a6b'){return bw?'#000000':((hex&&hex.startsWith('#')&&hex.length>=7)?hex:fallback);}
    function _voltCol(v){
      if(!v)return null;
      const DEFAULTS={'400V':'#ff6b35','415V':'#ff6b35','230V':'#ffaa00','240V':'#ffaa00',
        '120V':'#ffcc44','110V':'#ffcc44','48V':'#c8f560','24V':'#4dd278',
        '12V':'#3bffcc','5V':'#3bd4ff','3.3V':'#3b9eff','0V':'#888888','GND':'#888888','VCC':'#f06dff'};
      const custom=_PROJ.voltColors||{};
      const FIXED=Object.assign({},DEFAULTS,custom);
      const key=v.toUpperCase().replace(/\s+/g,'');
      if(FIXED[key])return FIXED[key];
      let h=0;for(let i=0;i<v.length;i++)h=(h*31+v.charCodeAt(i))&0xffff;
      return `hsl(${h%360},80%,60%)`;
    }
    const COL_WIRE=C('#1a6ab0'),COL_BUS=C('#333333'),COL_JUNC=C('#1a6ab0'),COL_LABEL=C('#333333'),COL_REF=C('#777777');

    const parts=[];
    parts.push(`<rect width="${pzW}" height="${totalH}" fill="${pz.bgColor||'white'}"/>`);

    // ── Repère orthogonal (si activé) ────────────────────────
    if(refGrid.show){
      const rg=refGrid, t=rg.thickness||15, nc=rg.cols||20, nr=rg.rows||9;
      const cw=pzW/nc, rh=pzH/nr;
      const fz=Math.min(t*0.7, cw*0.5, rh*0.5);
      parts.push('<g class="ref-grid">');
      // Bandes haut/bas (chiffres)
      parts.push(`<rect x="0" y="${-t}" width="${pzW}" height="${t}" fill="#f0f0f0" stroke="#888" stroke-width="0.3"/>`);
      parts.push(`<rect x="0" y="${pzH}" width="${pzW}" height="${t}" fill="#f0f0f0" stroke="#888" stroke-width="0.3"/>`);
      for(let c=0;c<nc;c++){
        const cx=c*cw+cw/2;
        parts.push(`<text x="${cx}" y="${-t/2}" fill="#333" font-size="${fz}" text-anchor="middle" dominant-baseline="central" font-family="monospace" font-weight="bold">${c+1}</text>`);
        parts.push(`<text x="${cx}" y="${pzH+t/2}" fill="#333" font-size="${fz}" text-anchor="middle" dominant-baseline="central" font-family="monospace" font-weight="bold">${c+1}</text>`);
        if(c>0){parts.push(`<line x1="${c*cw}" y1="${-t}" x2="${c*cw}" y2="0" stroke="#888" stroke-width="0.3"/>`);
                parts.push(`<line x1="${c*cw}" y1="${pzH}" x2="${c*cw}" y2="${pzH+t}" stroke="#888" stroke-width="0.3"/>`);}
      }
      // Bandes gauche/droite (lettres)
      parts.push(`<rect x="${-t}" y="0" width="${t}" height="${pzH}" fill="#f0f0f0" stroke="#888" stroke-width="0.3"/>`);
      parts.push(`<rect x="${pzW}" y="0" width="${t}" height="${pzH}" fill="#f0f0f0" stroke="#888" stroke-width="0.3"/>`);
      for(let r=0;r<nr;r++){
        const cy=r*rh+rh/2;const letter=String.fromCharCode(65+r);
        parts.push(`<text x="${-t/2}" y="${cy}" fill="#333" font-size="${fz}" text-anchor="middle" dominant-baseline="central" font-family="monospace" font-weight="bold">${letter}</text>`);
        parts.push(`<text x="${pzW+t/2}" y="${cy}" fill="#333" font-size="${fz}" text-anchor="middle" dominant-baseline="central" font-family="monospace" font-weight="bold">${letter}</text>`);
        if(r>0){parts.push(`<line x1="${-t}" y1="${r*rh}" x2="0" y2="${r*rh}" stroke="#888" stroke-width="0.3"/>`);
                parts.push(`<line x1="${pzW}" y1="${r*rh}" x2="${pzW+t}" y2="${r*rh}" stroke="#888" stroke-width="0.3"/>`);}
      }
      // Coins
      parts.push(`<rect x="${-t}" y="${-t}" width="${t}" height="${t}" fill="#f0f0f0" stroke="#888" stroke-width="0.3"/>`);
      parts.push(`<rect x="${pzW}" y="${-t}" width="${t}" height="${t}" fill="#f0f0f0" stroke="#888" stroke-width="0.3"/>`);
      parts.push(`<rect x="${-t}" y="${pzH}" width="${t}" height="${t}" fill="#f0f0f0" stroke="#888" stroke-width="0.3"/>`);
      parts.push(`<rect x="${pzW}" y="${pzH}" width="${t}" height="${t}" fill="#f0f0f0" stroke="#888" stroke-width="0.3"/>`);
      parts.push('</g>');
    }

    parts.push(`<g transform="translate(${-pzX},${-pzY})">`);

    // Fils
    (st.wires||[]).forEach(w=>{
      if(!w.points||w.points.length<2)return;
      const volt=_vMap[w.id]||null;
      const voltC=volt?_voltCol(volt):null;
      const col=w.isBus?COL_BUS:(voltC?C(voltC,'#1a6ab0'):C(w.color,'#1a6ab0'));
      const lw=w.isBus?3.5:1.8;
      const d=w.points.map((p,i)=>`${i===0?'M':'L'}${p.x},${p.y}`).join(' ');
      parts.push(`<path d="${d}" stroke="${col}" stroke-width="${lw}" fill="none" stroke-linecap="round" stroke-linejoin="round"/>`);
      if(w.num && !w._numHidden && (_PROJ.numShow!==false)){
        const pts=w.points;
        const midIdx=Math.max(0,Math.floor((pts.length-1)/2));
        const p1=pts[midIdx], p2=pts[Math.min(midIdx+1,pts.length-1)];
        const mx=(p1.x+p2.x)/2, my=(p1.y+p2.y)/2;
        let segAngle=w.numAngle!==undefined
          ? w.numAngle*Math.PI/180
          : Math.atan2(p2.y-p1.y, p2.x-p1.x);
        if(segAngle>Math.PI/2) segAngle-=Math.PI;
        if(segAngle<-Math.PI/2) segAngle+=Math.PI;
        const offX=w._numAdjX!==undefined?w._numAdjX:(w.numOffX||0);
        const offY=w._numAdjY!==undefined?w._numAdjY:(w.numOffY!==undefined?w.numOffY:-10);
        const nSz=_PROJ.numSize||9;
        const nBold=_PROJ.numBold?'font-weight="bold"':'';
        const approxW=w.num.length*nSz*0.62;
        const angleDeg=segAngle*180/Math.PI;
        parts.push(`<g transform="translate(${mx+offX},${my+offY}) rotate(${angleDeg})">`);
        parts.push(`<rect x="${-approxW/2-3}" y="${-8}" width="${approxW+6}" height="${11}" fill="white" stroke="#000" stroke-width="0.6" rx="1"/>`);
        parts.push(`<text x="0" y="-2" fill="#000" font-size="${nSz}" ${nBold} text-anchor="middle" dominant-baseline="central" font-family="monospace">${esc(w.num)}</text>`);
        parts.push('</g>');
      }
    });

    // Renvois de folio (xrefs)
    const _fAnchors=folioAnchors||{};
    (st.wires||[]).forEach(w=>{
      if(!w.points||w.points.length<2)return;
      const _pts=w.points;
      const _drawXrefSVG=(pt,innerPt,label)=>{
        if(!label)return;
        let refPt=innerPt;
        if(Math.abs(pt.x-refPt.x)<1&&Math.abs(pt.y-refPt.y)<1){
          for(let i=0;i<_pts.length;i++){if(Math.abs(pt.x-_pts[i].x)>1||Math.abs(pt.y-_pts[i].y)>1){refPt=_pts[i];break;}}
        }
        const outAngle=Math.atan2(pt.y-refPt.y, pt.x-refPt.x);
        const angleDeg=outAngle*180/Math.PI;
        const xparts=label.split(' ');
        const folioTxt=xparts[0]||label;
        let repY='',repX='';
        if(xparts[1]){const m=xparts[1].match(/^([A-Z])(\d+)$/);if(m){repY=m[1];repX=m[2];}else{repY=xparts[1];}}
        const sections=[folioTxt];
        if(repY)sections.push(repY);
        if(repX)sections.push(repX);
        const fSz=_PROJ.xrefSize||6, gap=2, sepW=1, pad=2, P=fSz*0.6, H=fSz*0.85;
        const secWidths=sections.map(s=>s.length*fSz*0.65);
        let totalTxtW=0;
        for(let i=0;i<secWidths.length;i++){totalTxtW+=secWidths[i];if(i<secWidths.length-1)totalTxtW+=gap+sepW+gap;}
        const W=P+pad+totalTxtW+pad;
        const anchorId=_fAnchors[folioTxt]||null;
        if(anchorId) parts.push(`<a href="#${anchorId}">`);
        parts.push(`<g transform="translate(${pt.x},${pt.y}) rotate(${angleDeg})">`);
        parts.push(`<path d="M0,0 L${P},${-H} L${W},${-H} L${W},${H} L${P},${H} Z" fill="white" stroke="#000" stroke-width="0.4"/>`);
        const deg=((angleDeg%360)+360)%360;
        const flipText=deg>90&&deg<270;
        if(flipText){
          parts.push(`<g transform="translate(${(W+P)/2},0) rotate(180)">`);
        }else{
          parts.push(`<g transform="translate(${(W+P)/2},0)">`);
        }
        let cx=-totalTxtW/2;
        for(let i=0;i<sections.length;i++){
          parts.push(`<text x="${cx}" y="0" fill="#000" font-size="${fSz}" font-weight="bold" font-family="monospace" text-anchor="start" dominant-baseline="central">${esc(sections[i])}</text>`);
          cx+=secWidths[i];
          if(i<sections.length-1){
            cx+=gap;
            parts.push(`<line x1="${cx-0.5}" y1="-4" x2="${cx-0.5}" y2="4" stroke="#999" stroke-width="${sepW}"/>`);
            cx+=sepW+gap;
          }
        }
        parts.push('</g></g>');
        if(anchorId) parts.push('</a>');
      };
      if(w.xrefStart||w.xrefEnd){
        if(_pts.length>=2){
          _drawXrefSVG(_pts[0],_pts[1],w.xrefStart);
          _drawXrefSVG(_pts[_pts.length-1],_pts[_pts.length-2],w.xrefEnd);
        }
      }
    });

    // Jonctions
    (st.junctions||[]).forEach(j=>{parts.push(`<circle cx="${j.x}" cy="${j.y}" r="4" fill="${COL_JUNC}"/>`);});

    // Shapes
    function shapeGeomSVG(sh){
      if((sh.t==='line'||sh.t==='poly')&&sh.pts?.length){return `<path d="${sh.pts.map((p,i)=>`${i===0?'M':'L'}${p.x},${p.y}`).join(' ')}""`;}
      if(sh.t==='rect'||sh.t==='textbox')return `<rect x="${sh.x}" y="${sh.y}" width="${sh.w}" height="${sh.h}"`;
      if(sh.t==='circle')return `<circle cx="${sh.cx}" cy="${sh.cy}" r="${sh.r}"`;
      if(sh.t==='arc'){const a1=sh.a1||0,a2=sh.a2||Math.PI,x1=sh.cx+sh.r*Math.cos(a1),y1=sh.cy+sh.r*Math.sin(a1),x2=sh.cx+sh.r*Math.cos(a2),y2=sh.cy+sh.r*Math.sin(a2),large=Math.abs(a2-a1)>Math.PI?1:0;return `<path d="M${x1},${y1} A${sh.r},${sh.r} 0 ${large},1 ${x2},${y2}"`;}
      return null;
    }
    function svgDashArray(style,thick){
      const t=thick||1.5;
      if(style==='dash-fine')return `stroke-dasharray="${t*2} ${t*2}"`;
      if(style==='dash-med')return `stroke-dasharray="${t*4} ${t*2}"`;
      if(style==='dash-large')return `stroke-dasharray="${t*8} ${t*3}"`;
      if(style==='dot')return `stroke-dasharray="${t*0.5} ${t*2.5}"`;
      if(style==='axis')return `stroke-dasharray="${t*6} ${t*2} ${t} ${t*2}"`;
      return '';
    }
    function renderShapeSVG(sh){
      if(sh.t==='group'){sh.children.forEach(c=>renderShapeSVG(c));return;}
      if(sh.t==='textbox'){
        const col=C(sh.color,'#1a3a6b'),lw=sh.thick||0.5;
        const fillBg=sh.fill?col:'none';
        const noBorder=(sh.stroke||'solid')==='none';
        if(!noBorder||sh.fill) parts.push(`<rect x="${sh.x}" y="${sh.y}" width="${sh.w}" height="${sh.h}" stroke="${noBorder?'none':col}" stroke-width="${lw}" fill="${fillBg}"/>`);
        if(sh.text){
          const pad=sh.padding||4, fs=sh.fontSize||11;
          const tc=C(sh.textColor||sh.color,'#333333');
          const anchor=sh.align==='center'?'middle':sh.align==='right'?'end':'start';
          let textX=sh.x+pad; if(sh.align==='center')textX=sh.x+sh.w/2; else if(sh.align==='right')textX=sh.x+sh.w-pad;
          const lineH=fs*1.3;
          const lines=sh.text.split('\n');
          // Alignement vertical
          const totalH=lines.length*lineH;
          let startY=sh.y+pad+fs;
          if(sh.valign==='middle')startY=sh.y+(sh.h-totalH)/2+fs;
          else if(sh.valign==='bottom')startY=sh.y+sh.h-totalH-pad+fs;
          lines.forEach((line,i)=>{
            parts.push(`<text x="${textX}" y="${startY+i*lineH}" font-size="${fs}" fill="${tc}" font-family="monospace" text-anchor="${anchor}" dominant-baseline="auto">${esc(line)}</text>`);
          });
        }
        return;
      }
      const geom=shapeGeomSVG(sh);if(!geom)return;
      const col=C(sh.color,'#1a3a6b'),lw=sh.thick||1.5,fill=sh.fill?col:'none',style=sh.stroke||'solid';
      const isStripe=style==='stripe-bw'||style==='stripe-col';
      const common=`stroke-width="${lw}" stroke-linecap="round" stroke-linejoin="round"`;
      if(isStripe){
        const col2=bw?'#ffffff':(style==='stripe-col'?(sh.color2||'#ff4444'):'#ffffff');
        parts.push(`${geom} stroke="${col}" fill="${fill}" ${common}/>`);
        parts.push(`${geom} stroke="${col2}" fill="none" stroke-dasharray="${lw*3} ${lw*3}" ${common}/>`);
      }else{parts.push(`${geom} stroke="${col}" fill="${fill}" ${svgDashArray(style,lw)} ${common}/>`);}
    }
    (st.shapes||[]).forEach(sh=>renderShapeSVG(sh));

    // Helper : rendre les paths d'un symbole en SVG
    function _renderSymPathsSVG(paths, elCol, bw) {
      const out = [];
      (paths || []).forEach(p => {
        const col = C(p.color || elCol, '#1a3a6b') || elCol, lw = p.thick || 1.5;
        const dash = p.dash ? ` stroke-dasharray="${p.dash.join(',')}"` : '';
        switch (p.t) {
          case 'L': if (!p.pts?.length) break; { const d = p.pts.map((pt, i) => `${i === 0 ? 'M' : 'L'}${pt.x},${pt.y}`).join(' '); out.push(`<path d="${d}" stroke="${col}" stroke-width="${lw}" fill="none" stroke-linecap="round" stroke-linejoin="round"${dash}/>`); break; }
          case 'R': out.push(`<rect x="${p.x||0}" y="${p.y||0}" width="${p.w||0}" height="${p.h||0}" stroke="${col}" stroke-width="${lw}" fill="${p.fill ? col : 'none'}"${dash}/>`); break;
          case 'C': out.push(`<circle cx="${p.cx||0}" cy="${p.cy||0}" r="${p.r||0}" stroke="${col}" stroke-width="${lw}" fill="${p.fill ? col : 'none'}"${dash}/>`); break;
          case 'A': { const r=p.r||1, a1=p.a1||0, a2=p.a2||Math.PI, x1=(p.cx||0)+r*Math.cos(a1), y1=(p.cy||0)+r*Math.sin(a1), x2=(p.cx||0)+r*Math.cos(a2), y2=(p.cy||0)+r*Math.sin(a2), large=Math.abs(a2-a1)>Math.PI?1:0; out.push(`<path d="M${x1},${y1} A${r},${r} 0 ${large},1 ${x2},${y2}" stroke="${col}" stroke-width="${lw}" fill="none" stroke-linecap="round"${dash}/>`); break; }
          case 'T': { const sz=p.size||10, anchor=p.align==='center'?'middle':p.align==='right'?'end':'start'; out.push(`<text x="${p.x||0}" y="${p.y||0}" font-size="${sz}" fill="${col}" font-family="monospace" text-anchor="${anchor}" dominant-baseline="middle">${esc(p.text||'')}</text>`); break; }
          case 'TB': {
            if(!p.noBorder) out.push(`<rect x="${p.x||0}" y="${p.y||0}" width="${p.w||0}" height="${p.h||0}" stroke="${col}" stroke-width="${lw}" fill="none"/>`);
            if(p.text){
              const fs2=p.fontSize||8, anchor2=p.align==='center'?'middle':p.align==='right'?'end':'start', pd=p.padding||2;
              let tx2=p.x+pd; if(p.align==='center')tx2=p.x+p.w/2; else if(p.align==='right')tx2=p.x+p.w-pd;
              const lns2=p.text.split('\n'), lH2=fs2*1.3;
              let sy2=p.y+pd+fs2; if(p.valign==='middle')sy2=p.y+(p.h-lns2.length*lH2)/2+fs2;
              lns2.forEach((l,i)=>out.push(`<text x="${tx2}" y="${sy2+i*lH2}" font-size="${fs2}" fill="${col}" font-family="monospace" text-anchor="${anchor2}">${esc(l)}</text>`));
            }
            break; }
        }
      });
      return out.join('');
    }

    // Éléments (symboles)
    (st.elements||[]).forEach(el=>{
      const sym=symLib[el.symId];if(!sym)return;
      const poles = el.poles || null;
      const mpRoles = ['contact','breaker','terminal'];
      const isMultiPole = mpRoles.includes(sym.elementRole) && poles && poles.length > 1;
      const elCol=C(el.color,'#1a3a6b');

      if (isMultiPole) {
        // Multi-pôle : rotation/flip appliquée au GROUPE ENTIER
        // Identique au canvas : translate(centre) → rotate → flip → translate(coin)
        // Chaque pôle est dessiné 1:1 (taille originale du symbole), côte à côte
        {
          const gcx = el.x + el.w / 2, gcy = el.y + el.h / 2;
          const gt = [`translate(${gcx},${gcy})`];
          if (el.rotation) gt.push(`rotate(${el.rotation})`);
          if (el.flipH) gt.push(`scale(-1,1)`);
          gt.push(`translate(${-el.w / 2},${-el.h / 2})`);
          parts.push(`<g transform="${gt.join(' ')}">`);

          for (let pi = 0; pi < poles.length; pi++) {
            let polePaths = sym.paths;
            if (poles[pi] === 'NF' && sym.pathsNF) polePaths = sym.pathsNF;
            else if (poles[pi] === 'NO' && sym.pathsNO) polePaths = sym.pathsNO;
            else if (poles[pi] === 'NF' && !sym.pathsNF && sym.contactSubType === 'NO') {
              const nfSym = Object.values(symLib).find(s => s.elementRole === sym.elementRole && s.contactSubType === 'NF');
              if (nfSym) polePaths = nfSym.paths;
            }

            parts.push(`<g transform="translate(${pi * sym.width},0)">`);
            parts.push(_renderSymPathsSVG(polePaths, elCol, bw));
            parts.push('</g>');

            if (pi < poles.length - 1) {
              const lx = (pi + 1) * sym.width;
              const ly = sym.height / 2;
              parts.push(`<line x1="${lx - 2}" y1="${ly}" x2="${lx + 2}" y2="${ly}" stroke="${elCol}" stroke-width="1" stroke-dasharray="2,2"/>`);
            }
          }
          parts.push('</g>');
        }
      } else {
        // Pôle unique : rendu classique
        const singlePole = poles && poles.length === 1 ? poles[0] : null;
        let usePaths = sym.paths;
        if (singlePole === 'NF' && sym.pathsNF) usePaths = sym.pathsNF;
        else if (singlePole === 'NF' && !sym.pathsNF) {
          const nfSym = Object.values(symLib).find(s => s.elementRole === sym.elementRole && s.contactSubType === 'NF');
          if (nfSym) usePaths = nfSym.paths;
        }

        const scX = el.w / sym.width, scY = el.h / sym.height;
        const cx = el.x + el.w / 2, cy = el.y + el.h / 2;
        // Identique au canvas : translate(centre) → rotate → flip → translate(coin) → scale
        // Les paths sont en coordonnées symbole (0→sym.width, 0→sym.height)
        // Le scale les adapte à la taille de l'élément
        const transforms = [`translate(${cx},${cy})`];
        if (el.rotation) transforms.push(`rotate(${el.rotation})`);
        if (el.flipH) transforms.push(`scale(-1,1)`);
        transforms.push(`translate(${-el.w/2},${-el.h/2})`);
        transforms.push(`scale(${scX},${scY})`);
        parts.push(`<g transform="${transforms.join(' ')}">`);
        parts.push(_renderSymPathsSVG(usePaths, elCol, bw));
        parts.push('</g>');
      }

      // Champs de symboles (showOnSymbol)
      const _symFields=sym.fields||[];
      const _elProps=el.props||{};
      const _nPoles=isMultiPole?poles.length:1;
      const scX_f=isMultiPole?1:(el.w/sym.width);
      const scY_f=isMultiPole?1:(el.h/sym.height);
      _symFields.filter(f=>f.showOnSymbol).forEach(f=>{
        for(let pi=0;pi<_nPoles;pi++){
          const poleKey=f.id+':'+pi;
          const val=isMultiPole&&_elProps[poleKey]!==undefined?_elProps[poleKey]
            :_elProps[f.id]!==undefined?_elProps[f.id]
            :(f.default||'');
          if(val===''&&!f.default)continue;
          const display=val!==''?String(val)+(f.unit?' '+f.unit:''):(f.name+'?');
          const poleOffX=isMultiPole?pi*sym.width:0;
          const fx=poleOffX+(f.symX??sym.width/2)*(isMultiPole?1:scX_f);
          const fy=(f.symY??sym.height/2)*(isMultiPole?1:scY_f);
          const fColor=bw?'#000000':(_PROJ.fieldColor||'#6b7494');
          const localScX=isMultiPole?1:scX_f;
          const localScY=isMultiPole?1:scY_f;
          const zw=(f.symZoneW||0)*localScX;
          const zh=(f.symZoneH||0)*localScY;
          const isTB=f.type==='textbox';
          const tbFamily='monospace';
          const tbBold=isTB&&f.tbBold?'font-weight="bold"':'';
          const tbItalic=isTB&&f.tbItalic?'font-style="italic"':'';
          const tbColor=isTB&&f.tbColor?C(f.tbColor,'#6b7494'):fColor;
          const lines=display.split('\n');
          const tbAlign=isTB&&f.tbAlign?f.tbAlign:'center';
          const anchor=tbAlign==='center'?'middle':tbAlign==='right'?'end':'start';

          if(zw>0&&zh>0){
            let fsz;
            if(isTB&&f.tbFontSize){
              fsz=f.tbFontSize*Math.min(localScX,localScY);
              const approxMaxLineW=Math.max(...lines.map(l=>l.length*fsz*0.62));
              if(approxMaxLineW>zw*0.95) fsz=zw*0.9/(Math.max(...lines.map(l=>l.length))*0.62||1);
            }else{
              let fitSize=Math.max(2,zh*0.75);
              const maxLineLen=Math.max(...lines.map(l=>l.length))||1;
              const byW=zw*0.9/(maxLineLen*0.62);
              const byH=zh*0.95/(lines.length*1.2);
              fsz=Math.min(fitSize,byW,byH);
              fsz=Math.max(2,fsz);
            }
            const lineH=fsz*1.2;
            const totalH=lineH*lines.length;
            let textX=fx+zw/2;
            if(tbAlign==='left')textX=fx+2;
            else if(tbAlign==='right')textX=fx+zw-2;
            const startY=fy+zh/2-totalH/2+lineH/2;
            // Render inside the element transform group
            const gcx=el.x+el.w/2, gcy=el.y+el.h/2;
            const gt=[`translate(${gcx},${gcy})`];
            if(el.rotation)gt.push(`rotate(${el.rotation})`);
            if(el.flipH)gt.push(`scale(-1,1)`);
            gt.push(`translate(${-el.w/2},${-el.h/2})`);
            parts.push(`<g transform="${gt.join(' ')}">`);
            lines.forEach((line,i)=>{
              parts.push(`<text x="${textX}" y="${startY+i*lineH}" fill="${tbColor}" font-size="${fsz}" ${tbBold} ${tbItalic} font-family="${tbFamily}" text-anchor="${anchor}" dominant-baseline="central">${esc(line)}</text>`);
            });
            parts.push('</g>');
          }else{
            const fsz=(isTB&&f.tbFontSize?f.tbFontSize:(f.symSize||9))*Math.min(localScX,localScY);
            const lineH=fsz*1.2;
            const startY=fy-lineH*(lines.length-1)/2;
            const gcx=el.x+el.w/2, gcy=el.y+el.h/2;
            const gt=[`translate(${gcx},${gcy})`];
            if(el.rotation)gt.push(`rotate(${el.rotation})`);
            if(el.flipH)gt.push(`scale(-1,1)`);
            gt.push(`translate(${-el.w/2},${-el.h/2})`);
            parts.push(`<g transform="${gt.join(' ')}">`);
            lines.forEach((line,i)=>{
              parts.push(`<text x="${fx}" y="${startY+i*lineH}" fill="${tbColor}" font-size="${fsz}" ${tbBold} ${tbItalic} font-family="${tbFamily}" text-anchor="${f.symAlign==='center'?'middle':f.symAlign==='right'?'end':'start'}" dominant-baseline="central">${esc(line)}</text>`);
            });
            parts.push('</g>');
          }
        }
      });

      // Label et Référence (alignement left + rotation, comme le canvas)
      const lox=el.labelOffX||0,loy=el.labelOffY||-18,rox=el.refOffX||0,roy=el.refOffY||10;
      const labelCol=bw?'#000000':(_PROJ.labelColor||'#dde1ed');
      const refCol=bw?'#000000':(_PROJ.refColor||'#6b7494');
      if(el.label){
        const lx=el.x+el.w/2+lox, ly=el.y+loy;
        const lang=el.labelAngle||0;
        const lt=lang?` transform="rotate(${lang},${lx},${ly})"`:'';
        parts.push(`<text x="${lx}" y="${ly}" fill="${labelCol}" font-size="11" font-weight="bold" font-family="monospace" text-anchor="start" dominant-baseline="auto"${lt}>${esc(el.label)}</text>`);
      }
      if(el.ref){
        const rx=el.x+el.w/2+rox, ry=el.y+el.h+roy;
        const rang=el.refAngle||0;
        const rt=rang?` transform="rotate(${rang},${rx},${ry})"`:''
        parts.push(`<text x="${rx}" y="${ry}" fill="${refCol}" font-size="9" font-family="monospace" text-anchor="start" dominant-baseline="hanging"${rt}>${esc(el.ref)}</text>`);
      }
    });

    // Textes libres
    (st.texts||[]).forEach(t=>{
      const col=C(t.color,'#333333'),angle=t.angle||0;
      const transform=angle?` transform="rotate(${angle},${t.x},${t.y})"`:'';
      parts.push(`<text x="${t.x}" y="${t.y}" fill="${col}" font-size="${t.size||13}" font-family="monospace" dominant-baseline="hanging"${transform}>${esc(t.text||'')}</text>`);
    });

    // Images
    (st.images||[]).forEach(img=>{const op=img.opacity??1;parts.push(`<image href="${img.src}" x="${img.x}" y="${img.y}" width="${img.w}" height="${img.h}" opacity="${op}" preserveAspectRatio="xMidYMid meet"/>`);});

    parts.push('</g>');

    // Cartouche
    if(withCartouche){const tbSvg=TitleBlock.toSVG(tbData||TitleBlock.getActiveTB(),pzW,pzH,false,{cartoucheAlign:pz.cartoucheAlign||'right'});if(tbSvg)parts.push(tbSvg);}

    // Ajuster le viewBox si le repère est activé (ajouter l'épaisseur des bandes)
    const rgT = refGrid.show ? (refGrid.thickness || 15) : 0;
    const svgW = pzW + rgT*2, svgH = totalH + rgT*2;
    const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="${svgW}" height="${svgH}" viewBox="${-rgT} ${-rgT} ${svgW} ${svgH}">${parts.join('')}</svg>`;
    return{svg,pageSize,pzW:svgW,totalH:svgH};
  }

  function exportPDF(){
    setStatus('Génération PDF…');
    const name=document.getElementById('schema-name').value.trim()||'schema';
    const html=buildPrintHTML(name);
    printFallback(html,name);
  }

  function buildPrintHTML(name){
    const pzX=printZone.x,pzY=printZone.y;
    const pz={x:pzX,y:pzY,w:Math.max(printZone.w,100),h:Math.max(printZone.h,100),
      format:printZone.format,blackAndWhite:printZone.blackAndWhite,withCartouche:printZone.withCartouche!==false,
      cartoucheAlign:folio.cartoucheAlign||'right'};
    const tbData=pz.withCartouche?TitleBlock.getActiveTB():null;
    const{svg,pageSize}=_buildFolioSVG(state,_symbols,pz,tbData,typeof _voltageMap!=='undefined'?_voltageMap:null);
    return `<!DOCTYPE html><html><head><title>${esc(name)}</title><style>
*{margin:0;padding:0;box-sizing:border-box}
body{background:white}
svg{display:block;width:100%;height:auto}
@media print{@page{size:${pageSize};margin:6mm}body{margin:0}svg{width:100%;height:100vh}}
</style></head><body>${svg}</body></html>`;
  }

  // ── Export PDF Projet (tous les folios) ───────────────────────────────
  async function exportProjectPDF(){
    if(!currentProject||!projectFolios.length){showWarning('Aucun projet ouvert.');return;}
    await saveSchema();
    const opts=await _askProjectPDFOptions();
    if(!opts)return;

    const{format,bw,withCartouche,folioIds}=opts;
    const folioList=folioIds.length?projectFolios.filter(f=>folioIds.includes(f.id)):[...projectFolios];
    if(!folioList.length){setStatus('Aucun folio sélectionné.');return;}

    setStatus('Génération PDF projet…');
    try{
      // Construire la map folioNum → ancre pour les liens inter-pages
      const folioAnchors={};
      folioList.forEach((f,i)=>{
        const num=f.folio_num||String(i+1);
        folioAnchors['F'+num]='folio-'+num;
        folioAnchors['f'+num]='folio-'+num;
      });

      const svgs=[];
      for(let i=0;i<folioList.length;i++){
        const f=folioList[i];
        setStatus(`Folio ${i+1}/${folioList.length} : ${f.name||''}…`);
        const res=await fetch(`/api/folios/${f.id}`,{credentials:'include'});
        if(!res.ok)throw new Error(`Folio "${f.name}" inaccessible`);
        const folio=await res.json();
        const st=folio.data||{};
        const _fMeta=st.folio||{};
        const pz={x:printZone.x,y:printZone.y,
          w:Math.max(printZone.w,100),h:Math.max(printZone.h,100),
          format,blackAndWhite:bw,withCartouche,
          cartoucheAlign:_fMeta.cartoucheAlign||'right'};
        const tbData=withCartouche?TitleBlock.getActiveTB():null;
        const{svg,pageSize}=_buildFolioSVG(st,_symbols,pz,tbData,null,folioAnchors);
        const anchorId='folio-'+(f.folio_num||String(i+1));
        svgs.push({svg,pageSize,anchorId});
      }

      const pageSize=svgs[0]?.pageSize||'A3 landscape';
      const projectName=currentProject.name||'projet';
      const html=`<!DOCTYPE html><html><head><title>${esc(projectName)}</title><style>
*{margin:0;padding:0;box-sizing:border-box}body{background:white}
.page{display:block;page-break-after:always}.page:last-child{page-break-after:avoid}
svg{display:block;width:100%;height:100vh}
@media print{@page{size:${pageSize};margin:6mm}body{margin:0}}</style></head><body>${
  svgs.map(p=>`<div class="page" id="${p.anchorId}">${p.svg}</div>`).join('')
}</body></html>`;

      setStatus('Envoi au serveur PDF…');
      const filename=(projectName).replace(/[^a-zA-Z0-9_\-]/g,'_');
      const r=await fetch('/api/export/pdf',{method:'POST',credentials:'include',
        headers:{'Content-Type':'application/json'},body:JSON.stringify({html,filename})});
      if(!r.ok){
        const e=await r.json();
        if(e.fallback){printFallback(html,filename);return;}
        throw new Error(e.error||'Erreur serveur');
      }
      const blob=await r.blob();
      const url=URL.createObjectURL(blob);
      const a=document.createElement('a');
      a.href=url;a.download=filename+'.pdf';a.click();
      URL.revokeObjectURL(url);
      setStatus(`✓ PDF projet : ${svgs.length} folio(s) — ${filename}.pdf`);
    }catch(err){
      setStatus('Erreur PDF projet : '+err.message);
      showWarning('Erreur export PDF projet : '+err.message);
    }
  }

  function _askProjectPDFOptions(){
    return new Promise(resolve=>{
      const overlay=document.createElement('div');
      overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:9999;display:flex;align-items:center;justify-content:center';
      const folioRows=projectFolios.map(f=>
        `<label style="display:flex;align-items:center;gap:6px;font-size:10px;cursor:pointer;padding:2px 0">
          <input type="checkbox" value="${f.id}" checked> F${f.folio_num||'?'} — ${esc(f.name||'')}
        </label>`).join('');
      overlay.innerHTML=`
        <div style="background:var(--panel);border:1px solid var(--border);border-radius:10px;padding:24px;width:360px;font-family:var(--font);max-height:85vh;overflow-y:auto">
          <div style="font-size:13px;font-weight:600;margin-bottom:14px">⬇ Export PDF — Projet</div>
          <div style="font-size:10px;color:var(--text2);margin-bottom:6px">Folios à inclure</div>
          <div id="ppdf-folio-list" style="display:flex;flex-direction:column;gap:2px;max-height:140px;overflow-y:auto;border:1px solid var(--border2);border-radius:4px;padding:6px;margin-bottom:8px">${folioRows}</div>
          <div style="display:flex;gap:6px;margin-bottom:14px">
            <button id="ppdf-all" style="font-size:9px;padding:2px 8px;background:var(--panel2);border:1px solid var(--border2);color:var(--text2);border-radius:3px;cursor:pointer;font-family:var(--font)">Tout</button>
            <button id="ppdf-none" style="font-size:9px;padding:2px 8px;background:var(--panel2);border:1px solid var(--border2);color:var(--text2);border-radius:3px;cursor:pointer;font-family:var(--font)">Aucun</button>
          </div>
          <div style="display:flex;gap:10px;margin-bottom:12px">
            <div style="flex:1">
              <div style="font-size:10px;color:var(--text2);margin-bottom:4px">Format</div>
              <select id="ppdf-fmt" style="width:100%;background:var(--panel2);border:1px solid var(--border2);color:var(--text);padding:4px 6px;border-radius:4px;font-family:var(--font);font-size:10px">
                <option value="A4L">A4 paysage</option><option value="A4P">A4 portrait</option>
                <option value="A3L" selected>A3 paysage</option><option value="A3P">A3 portrait</option><option value="A2L">A2 paysage</option>
              </select>
            </div>
            <div style="flex:1">
              <div style="font-size:10px;color:var(--text2);margin-bottom:4px">Couleur</div>
              <select id="ppdf-color" style="width:100%;background:var(--panel2);border:1px solid var(--border2);color:var(--text);padding:4px 6px;border-radius:4px;font-family:var(--font);font-size:10px">
                <option value="color" selected>Couleurs</option><option value="bw">Noir &amp; blanc</option>
              </select>
            </div>
          </div>
          <label style="display:flex;align-items:center;gap:8px;margin-bottom:14px;font-size:10px;cursor:pointer">
            <input type="checkbox" id="ppdf-carto" checked> Inclure le cartouche
          </label>
          <div style="font-size:9px;color:var(--text3);margin-bottom:14px">Un folio par page PDF. Nécessite Puppeteer côté serveur — sinon impression navigateur.</div>
          <div style="display:flex;gap:8px;justify-content:flex-end">
            <button id="ppdf-cancel" style="padding:7px 14px;font-size:11px;background:var(--panel2);border:1px solid var(--border2);color:var(--text2);border-radius:4px;cursor:pointer;font-family:var(--font)">Annuler</button>
            <button id="ppdf-ok" style="padding:7px 16px;font-size:11px;background:var(--accent);border:none;color:#fff;border-radius:4px;cursor:pointer;font-family:var(--font);font-weight:600">⬇ Générer PDF</button>
          </div>
        </div>`;
      document.body.appendChild(overlay);
      const cbs=()=>overlay.querySelectorAll('#ppdf-folio-list input[type=checkbox]');
      overlay.querySelector('#ppdf-all').addEventListener('click',()=>cbs().forEach(c=>c.checked=true));
      overlay.querySelector('#ppdf-none').addEventListener('click',()=>cbs().forEach(c=>c.checked=false));
      overlay.querySelector('#ppdf-cancel').addEventListener('click',()=>{document.body.removeChild(overlay);resolve(null);});
      overlay.querySelector('#ppdf-ok').addEventListener('click',()=>{
        const folioIds=[...cbs()].filter(c=>c.checked).map(c=>c.value);
        const format=overlay.querySelector('#ppdf-fmt').value;
        const bw=overlay.querySelector('#ppdf-color').value==='bw';
        const withCartouche=overlay.querySelector('#ppdf-carto').checked;
        document.body.removeChild(overlay);
        resolve({folioIds,format,bw,withCartouche});
      });
    });
  }
  // ── Export SVG du folio courant ───────────────────────────────────────
  function exportSVG(){
    if(!currentFolioId){showWarning('Aucun folio ouvert.');return;}
    const name=(document.getElementById('schema-name')?.value.trim()||'schema');
    const pz={
      x:printZone.x,y:printZone.y,
      w:Math.max(printZone.w,100),h:Math.max(printZone.h,100),
      format:printZone.format,
      blackAndWhite:printZone.blackAndWhite,
      withCartouche:printZone.withCartouche!==false,
      cartoucheAlign:folio.cartoucheAlign||'right'
    };
    const tbData=pz.withCartouche?TitleBlock.getActiveTB():null;
    const{svg}=_buildFolioSVG(state,_symbols,pz,tbData,typeof _voltageMap!=='undefined'?_voltageMap:null);
    // Ajouter la déclaration XML et l'encodage
    const full='<?xml version="1.0" encoding="UTF-8"?>\n'+svg;
    const blob=new Blob([full],{type:'image/svg+xml;charset=utf-8'});
    const url=URL.createObjectURL(blob);
    const a=document.createElement('a');
    a.href=url;
    a.download=name.replace(/[^a-zA-Z0-9_\-]/g,'_')+'.svg';
    a.click();
    URL.revokeObjectURL(url);
    setStatus('✓ Export SVG : '+a.download);
  }

  // ── Export folio JSON ────────────────────────────────────────
  async function exportFolioJSON() {
    const name = document.getElementById('schema-name')?.value?.trim() || 'folio';
    const includeSymbols = await showConfirm('Inclure la bibliothèque de symboles dans l\'export ?\n\n✓ OK = Oui (fichier plus gros, autonome)\n✕ Annuler = Non (léger, nécessite les symboles sur le serveur cible)');

    const dump = {
      _format: 'quickdraw-folio',
      _version: '1.0',
      _exportedAt: new Date().toISOString(),
      folio: {
        name: document.getElementById('schema-name')?.value || 'Sans titre',
        description: document.getElementById('schema-desc')?.value || '',
        folio_num: folio.num || 1,
        data: JSON.parse(JSON.stringify(state)),
      },
      project: currentProject ? {
        name: currentProject.name,
        settings: currentProject.settings,
      } : null,
    };

    if (includeSymbols) {
      // Collecter uniquement les symboles utilisés dans ce folio
      const usedSymIds = new Set();
      (state.elements || []).forEach(el => { if (el.symId) usedSymIds.add(el.symId); });
      const symbols = {};
      usedSymIds.forEach(id => { if (_symbols[id]) symbols[id] = _symbols[id]; });
      dump.symbols = symbols;
      dump._includesSymbols = true;
    }

    const json = JSON.stringify(dump, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${name.replace(/[^a-zA-Z0-9_\-àéèêëùûüôîïç ]/g, '_')}.qdraw.json`;
    a.click();
    URL.revokeObjectURL(url);
    setStatus('✓ Export JSON : ' + a.download);
  }

  // ── Import folio JSON ────────────────────────────────────────
  async function importFolioJSON() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json,.qdraw.json';
    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;
      try {
        const text = await file.text();
        const dump = JSON.parse(text);
        if (dump._format !== 'quickdraw-folio') {
          showWarning('Ce fichier n\'est pas un export de folio QuickDraw.');
          return;
        }

        // Importer les symboles si inclus
        if (dump._includesSymbols && dump.symbols) {
          const symCount = Object.keys(dump.symbols).length;
          const doImport = await showConfirm(`Ce fichier contient ${symCount} symbole(s).\nImporter les symboles manquants dans la bibliothèque ?`);
          if (doImport) {
            let imported = 0;
            for (const [id, sym] of Object.entries(dump.symbols)) {
              if (!_symbols[id]) {
                // Sauvegarder le symbole sur le serveur
                try {
                  const res = await fetch('/api/symbols', {
                    method: 'POST', credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(sym),
                  });
                  if (res.ok) { const saved = await res.json(); _symbols[saved.id] = saved; imported++; }
                } catch {}
              }
            }
            if (imported) setStatus(`${imported} symbole(s) importé(s)`);
          }
          // Ajouter les symboles en cache local (même si pas sauvegardés sur le serveur)
          for (const [id, sym] of Object.entries(dump.symbols)) {
            if (!_symbols[id]) _symbols[id] = sym;
          }
        }

        // Options d'import
        const mode = await showConfirm('Remplacer le contenu du folio actuel ?\n\n✓ OK = Remplacer tout\n✕ Annuler = Fusionner (ajouter au contenu existant)');

        const d = dump.folio.data;
        if (mode) {
          // Remplacer
          state.elements = d.elements || [];
          state.wires = d.wires || [];
          state.texts = d.texts || [];
          state.shapes = d.shapes || [];
          state.junctions = d.junctions || [];
          state.images = d.images || [];
        } else {
          // Fusionner (ajouter sans écraser)
          (d.elements || []).forEach(el => { el.id = uid(); state.elements.push(el); });
          (d.wires || []).forEach(w => { w.id = uid(); state.wires.push(w); });
          (d.texts || []).forEach(t => { t.id = uid(); state.texts.push(t); });
          (d.shapes || []).forEach(s => { s.id = uid(); state.shapes.push(s); });
          (d.junctions || []).forEach(j => { j.id = uid(); state.junctions.push(j); });
          (d.images || []).forEach(img => { img.id = uid(); state.images.push(img); });
        }

        saveHistory('Import JSON');
        render();
        updateStatus();
        setStatus(`✓ Folio importé depuis ${file.name} (${(d.elements||[]).length} éléments, ${(d.wires||[]).length} fils)`);
      } catch (e) {
        showWarning('Erreur import : ' + e.message);
      }
    };
    input.click();
  }

  function printFallback(html,name){
    const win=window.open('','_blank');if(!win){showWarning('Autorisez les popups');return;}
    win.document.write(html);win.document.close();
    win.addEventListener('load',()=>setTimeout(()=>{win.focus();win.print();},300));
    setStatus('Impression navigateur');
  }

  // ── Status ────────────────────────────────────────────────
  // ── Journal des actions ─────────────────────────────────────────────
  const _logHistory = []; // {time, msg}
  const _LOG_MAX = 200;


// ═══ app-status.js ═══
  function setStatus(msg) {
    document.getElementById('sb-status').textContent = msg;
    // Ajouter au journal
    const now = new Date();
    const ts = now.toTimeString().slice(0,8);
    _logHistory.unshift({ time: ts, msg: String(msg) });
    if (_logHistory.length > _LOG_MAX) _logHistory.length = _LOG_MAX;
    _renderLogPanel();
  }

  // ── Modal avertissement (remplace alert()) ──────────────
  let _warnOverlay = null, _warnMsg = null;
  function _ensureWarnModal() {
    if (_warnOverlay) return;
    _warnOverlay = document.createElement('div');
    _warnOverlay.className = 'modal-overlay hidden';
    _warnOverlay.id = 'modal-warning';
    _warnOverlay.style.zIndex = '9999';
    _warnOverlay.innerHTML =
      '<div class="modal" style="width:420px">' +
        '<div class="modal-header">' +
          '<h2>Avertissement</h2>' +
          '<button class="modal-close" id="warn-close-btn">\u2715</button>' +
        '</div>' +
        '<div class="modal-body-warn" style="padding:18px 22px;color:var(--text);font-size:12px;line-height:1.6;max-height:60vh;overflow-y:auto;white-space:pre-wrap"></div>' +
        '<div class="modal-footer">' +
          '<button class="btn-primary" id="warn-ok-btn">OK</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(_warnOverlay);
    _warnMsg = _warnOverlay.querySelector('.modal-body-warn');
    function _closeWarn() { _warnOverlay.classList.add('hidden'); }
    _warnOverlay.querySelector('#warn-close-btn').addEventListener('click', _closeWarn);
    _warnOverlay.querySelector('#warn-ok-btn').addEventListener('click', _closeWarn);
    _warnOverlay.addEventListener('click', function (e) { if (e.target === _warnOverlay) _closeWarn(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && _warnOverlay && !_warnOverlay.classList.contains('hidden')) _closeWarn();
    });
  }
  function showWarning(msg) {
    _ensureWarnModal();
    _warnMsg.textContent = msg;
    _warnOverlay.classList.remove('hidden');
    setStatus(msg);
  }

  // ── Modal confirmation (remplace confirm()) ────────────
  let _cfmOverlay = null, _cfmMsg = null, _cfmResolve = null;
  function _ensureCfmModal() {
    if (_cfmOverlay) return;
    _cfmOverlay = document.createElement('div');
    _cfmOverlay.className = 'modal-overlay hidden';
    _cfmOverlay.id = 'modal-confirm';
    _cfmOverlay.style.zIndex = '9999';
    _cfmOverlay.innerHTML =
      '<div class="modal" style="width:440px">' +
        '<div class="modal-header">' +
          '<h2>Confirmation</h2>' +
          '<button class="modal-close" id="cfm-close-btn">\u2715</button>' +
        '</div>' +
        '<div class="modal-body-warn" style="padding:18px 22px;color:var(--text);font-size:12px;line-height:1.6;max-height:60vh;overflow-y:auto;white-space:pre-wrap"></div>' +
        '<div class="modal-footer">' +
          '<button class="btn-secondary" id="cfm-cancel-btn">Annuler</button>' +
          '<button class="btn-primary" id="cfm-ok-btn">OK</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(_cfmOverlay);
    _cfmMsg = _cfmOverlay.querySelector('.modal-body-warn');
    function _resolve(val) {
      _cfmOverlay.classList.add('hidden');
      if (_cfmResolve) { _cfmResolve(val); _cfmResolve = null; }
    }
    _cfmOverlay.querySelector('#cfm-ok-btn').addEventListener('click', () => _resolve(true));
    _cfmOverlay.querySelector('#cfm-cancel-btn').addEventListener('click', () => _resolve(false));
    _cfmOverlay.querySelector('#cfm-close-btn').addEventListener('click', () => _resolve(false));
    _cfmOverlay.addEventListener('click', e => { if (e.target === _cfmOverlay) _resolve(false); });
    document.addEventListener('keydown', e => {
      if (_cfmOverlay && !_cfmOverlay.classList.contains('hidden')) {
        if (e.key === 'Escape') _resolve(false);
        if (e.key === 'Enter')  _resolve(true);
      }
    });
  }
  function showConfirm(msg) {
    _ensureCfmModal();
    _cfmMsg.textContent = msg;
    _cfmOverlay.classList.remove('hidden');
    setStatus(msg);
    return new Promise(resolve => { _cfmResolve = resolve; });
  }

  function _renderLogPanel() {
    const list = document.getElementById('log-list');
    if (!list) return;
    list.innerHTML = _logHistory.map((e, i) =>
      `<div class="log-entry">` +
      `<span class="log-time">${e.time}</span>` +
      `<span class="log-msg">${e.msg.replace(/</g,'&lt;')}</span>` +
      `</div>`
    ).join('');
  }

  function _initLogPanel() {
    const statusbar = document.getElementById('statusbar');
    const panel     = document.getElementById('log-panel');
    const hint      = document.getElementById('log-toggle-hint');
    const clearBtn  = document.getElementById('log-clear-btn');
    let open = false;

    function toggle() {
      open = !open;
      panel.className = open ? 'log-panel-open' : 'log-panel-hidden';
      statusbar.classList.toggle('log-open', open);
      if (hint) hint.textContent = open ? '▼ JOURNAL' : '▲ JOURNAL';
      if (open) _renderLogPanel();
    }

    statusbar.addEventListener('click', toggle);
    if (clearBtn) clearBtn.addEventListener('click', e => {
      e.stopPropagation();
      _logHistory.length = 0;
      _renderLogPanel();
    });
  }

  function updateDxfImportLink() {
    const btn = document.getElementById('btn-import-dxf');
    if (!btn) return;
    const pid = currentProject?.id || urlProject;
    const fid = currentFolioId;
    let href = '/dxf-import.html';
    if (pid) href += `?project=${pid}`;
    if (fid) href += `${pid?'&':'?'}folio=${fid}`;
    btn.href = href;
  }
  function updateStatus(){document.getElementById('sb-elems').textContent=state.elements.length;document.getElementById('sb-wires').textContent=state.wires.length;}

  // ── Utils ─────────────────────────────────────────────────
  let _u=0;function uid(){return 'e'+Date.now()+'_'+(++_u);}
  function esc(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
  function escHTML(s){const d=document.createElement('div');d.textContent=s||'';return d.innerHTML;}

  // Exposer PROJ pour renderer.js
  function _syncProj(){ window._PROJ = PROJ; }
  return{init,reloadSymbols,buildLibrary,get _symbols(){return _symbols;},get PROJ(){return PROJ;},syncProj:_syncProj};

})();

window.addEventListener('DOMContentLoaded', () => App.init());
